import { openBlock as v, createElementBlock as x, renderSlot as ne, createElementVNode as C, createTextVNode as Xe, toDisplayString as ze, withModifiers as we, createCommentVNode as I, resolveDirective as Bl, normalizeClass as pe, normalizeProps as Ye, guardReactiveProps as Ge, Fragment as ve, renderList as Re, createBlock as fe, resolveDynamicComponent as Pn, mergeProps as Be, toHandlers as fd, withDirectives as _t, vShow as Fn, createVNode as He, Transition as Yn, withCtx as _e, reactive as la, ref as ee, defineComponent as pt, useSlots as ar, toRef as $a, onMounted as Dt, nextTick as Ln, computed as X, onUnmounted as bi, watch as gn, unref as D, isRef as lo, createSlots as St, Teleport as pd, h as md, render as uo, withKeys as De, normalizeStyle as zt, onBeforeUpdate as hd, getCurrentScope as vd, onScopeDispose as yd, inject as $n, vModelText as Zs, resolveComponent as ct, vModelRadio as gd, vModelCheckbox as wd, vModelDynamic as bd, provide as Wl, mergeModels as kd, useModel as _d } from "vue";
function jl(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Td } = Object.prototype, { getPrototypeOf: ki } = Object, es = /* @__PURE__ */ ((t) => (e) => {
  const n = Td.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Kt = (t) => (t = t.toLowerCase(), (e) => es(e) === t), ts = (t) => (e) => typeof e === t, { isArray: Pr } = Array, ea = ts("undefined");
function Od(t) {
  return t !== null && !ea(t) && t.constructor !== null && !ea(t.constructor) && Et(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Hl = Kt("ArrayBuffer");
function Sd(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Hl(t.buffer), e;
}
const Dd = ts("string"), Et = ts("function"), ql = ts("number"), ns = (t) => t !== null && typeof t == "object", Cd = (t) => t === !0 || t === !1, Aa = (t) => {
  if (es(t) !== "object")
    return !1;
  const e = ki(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, xd = Kt("Date"), Md = Kt("File"), Ad = Kt("Blob"), Ed = Kt("FileList"), Pd = (t) => ns(t) && Et(t.pipe), Fd = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Et(t.append) && ((e = es(t)) === "formdata" || // detect form-data instance
  e === "object" && Et(t.toString) && t.toString() === "[object FormData]"));
}, Nd = Kt("URLSearchParams"), [Rd, Vd, Id, Ld] = ["ReadableStream", "Request", "Response", "Headers"].map(Kt), $d = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ua(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, a;
  if (typeof t != "object" && (t = [t]), Pr(t))
    for (r = 0, a = t.length; r < a; r++)
      e.call(null, t[r], r, t);
  else {
    const s = n ? Object.getOwnPropertyNames(t) : Object.keys(t), i = s.length;
    let o;
    for (r = 0; r < i; r++)
      o = s[r], e.call(null, t[o], o, t);
  }
}
function zl(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], e === a.toLowerCase())
      return a;
  return null;
}
const Zn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Zl = (t) => !ea(t) && t !== Zn;
function Gs() {
  const { caseless: t } = Zl(this) && this || {}, e = {}, n = (r, a) => {
    const s = t && zl(e, a) || a;
    Aa(e[s]) && Aa(r) ? e[s] = Gs(e[s], r) : Aa(r) ? e[s] = Gs({}, r) : Pr(r) ? e[s] = r.slice() : e[s] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && ua(arguments[r], n);
  return e;
}
const Yd = (t, e, n, { allOwnKeys: r } = {}) => (ua(e, (a, s) => {
  n && Et(a) ? t[s] = jl(a, n) : t[s] = a;
}, { allOwnKeys: r }), t), Ud = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Bd = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Wd = (t, e, n, r) => {
  let a, s, i;
  const o = {};
  if (e = e || {}, t == null) return e;
  do {
    for (a = Object.getOwnPropertyNames(t), s = a.length; s-- > 0; )
      i = a[s], (!r || r(i, t, e)) && !o[i] && (e[i] = t[i], o[i] = !0);
    t = n !== !1 && ki(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, jd = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, Hd = (t) => {
  if (!t) return null;
  if (Pr(t)) return t;
  let e = t.length;
  if (!ql(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, qd = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && ki(Uint8Array)), zd = (t, e) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const s = a.value;
    e.call(t, s[0], s[1]);
  }
}, Zd = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, Gd = Kt("HTMLFormElement"), Jd = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, a) {
    return r.toUpperCase() + a;
  }
), co = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), Xd = Kt("RegExp"), Gl = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  ua(n, (a, s) => {
    let i;
    (i = e(a, s, t)) !== !1 && (r[s] = i || a);
  }), Object.defineProperties(t, r);
}, Qd = (t) => {
  Gl(t, (e, n) => {
    if (Et(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (Et(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Kd = (t, e) => {
  const n = {}, r = (a) => {
    a.forEach((s) => {
      n[s] = !0;
    });
  };
  return Pr(t) ? r(t) : r(String(t).split(e)), n;
}, ef = () => {
}, tf = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, gs = "abcdefghijklmnopqrstuvwxyz", fo = "0123456789", Jl = {
  DIGIT: fo,
  ALPHA: gs,
  ALPHA_DIGIT: gs + gs.toUpperCase() + fo
}, nf = (t = 16, e = Jl.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = e;
  for (; t--; )
    n += e[Math.random() * r | 0];
  return n;
};
function rf(t) {
  return !!(t && Et(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const af = (t) => {
  const e = new Array(10), n = (r, a) => {
    if (ns(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[a] = r;
        const s = Pr(r) ? [] : {};
        return ua(r, (i, o) => {
          const l = n(i, a + 1);
          !ea(l) && (s[o] = l);
        }), e[a] = void 0, s;
      }
    }
    return r;
  };
  return n(t, 0);
}, sf = Kt("AsyncFunction"), of = (t) => t && (ns(t) || Et(t)) && Et(t.then) && Et(t.catch), Xl = ((t, e) => t ? setImmediate : e ? ((n, r) => (Zn.addEventListener("message", ({ source: a, data: s }) => {
  a === Zn && s === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Zn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Et(Zn.postMessage)
), lf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Zn) : typeof process < "u" && process.nextTick || Xl, U = {
  isArray: Pr,
  isArrayBuffer: Hl,
  isBuffer: Od,
  isFormData: Fd,
  isArrayBufferView: Sd,
  isString: Dd,
  isNumber: ql,
  isBoolean: Cd,
  isObject: ns,
  isPlainObject: Aa,
  isReadableStream: Rd,
  isRequest: Vd,
  isResponse: Id,
  isHeaders: Ld,
  isUndefined: ea,
  isDate: xd,
  isFile: Md,
  isBlob: Ad,
  isRegExp: Xd,
  isFunction: Et,
  isStream: Pd,
  isURLSearchParams: Nd,
  isTypedArray: qd,
  isFileList: Ed,
  forEach: ua,
  merge: Gs,
  extend: Yd,
  trim: $d,
  stripBOM: Ud,
  inherits: Bd,
  toFlatObject: Wd,
  kindOf: es,
  kindOfTest: Kt,
  endsWith: jd,
  toArray: Hd,
  forEachEntry: zd,
  matchAll: Zd,
  isHTMLForm: Gd,
  hasOwnProperty: co,
  hasOwnProp: co,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Gl,
  freezeMethods: Qd,
  toObjectSet: Kd,
  toCamelCase: Jd,
  noop: ef,
  toFiniteNumber: tf,
  findKey: zl,
  global: Zn,
  isContextDefined: Zl,
  ALPHABET: Jl,
  generateString: nf,
  isSpecCompliantForm: rf,
  toJSONObject: af,
  isAsyncFn: sf,
  isThenable: of,
  setImmediate: Xl,
  asap: lf
};
function xe(t, e, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), a && (this.response = a, this.status = a.status ? a.status : null);
}
U.inherits(xe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: U.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ql = xe.prototype, Kl = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Kl[t] = { value: t };
});
Object.defineProperties(xe, Kl);
Object.defineProperty(Ql, "isAxiosError", { value: !0 });
xe.from = (t, e, n, r, a, s) => {
  const i = Object.create(Ql);
  return U.toFlatObject(t, i, function(l) {
    return l !== Error.prototype;
  }, (o) => o !== "isAxiosError"), xe.call(i, t.message, e, n, r, a), i.cause = t, i.name = t.name, s && Object.assign(i, s), i;
};
const uf = null;
function Js(t) {
  return U.isPlainObject(t) || U.isArray(t);
}
function eu(t) {
  return U.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function po(t, e, n) {
  return t ? t.concat(e).map(function(a, s) {
    return a = eu(a), !n && s ? "[" + a + "]" : a;
  }).join(n ? "." : "") : e;
}
function cf(t) {
  return U.isArray(t) && !t.some(Js);
}
const df = U.toFlatObject(U, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function rs(t, e, n) {
  if (!U.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = U.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(O, g) {
    return !U.isUndefined(g[O]);
  });
  const r = n.metaTokens, a = n.visitor || c, s = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && U.isSpecCompliantForm(e);
  if (!U.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(h) {
    if (h === null) return "";
    if (U.isDate(h))
      return h.toISOString();
    if (!l && U.isBlob(h))
      throw new xe("Blob is not supported. Use a Buffer instead.");
    return U.isArrayBuffer(h) || U.isTypedArray(h) ? l && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, O, g) {
    let b = h;
    if (h && !g && typeof h == "object") {
      if (U.endsWith(O, "{}"))
        O = r ? O : O.slice(0, -2), h = JSON.stringify(h);
      else if (U.isArray(h) && cf(h) || (U.isFileList(h) || U.endsWith(O, "[]")) && (b = U.toArray(h)))
        return O = eu(O), b.forEach(function(M, T) {
          !(U.isUndefined(M) || M === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? po([O], T, s) : i === null ? O : O + "[]",
            u(M)
          );
        }), !1;
    }
    return Js(h) ? !0 : (e.append(po(g, O, s), u(h)), !1);
  }
  const d = [], p = Object.assign(df, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Js
  });
  function m(h, O) {
    if (!U.isUndefined(h)) {
      if (d.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + O.join("."));
      d.push(h), U.forEach(h, function(b, w) {
        (!(U.isUndefined(b) || b === null) && a.call(
          e,
          b,
          U.isString(w) ? w.trim() : w,
          O,
          p
        )) === !0 && m(b, O ? O.concat(w) : [w]);
      }), d.pop();
    }
  }
  if (!U.isObject(t))
    throw new TypeError("data must be an object");
  return m(t), e;
}
function mo(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function _i(t, e) {
  this._pairs = [], t && rs(t, this, e);
}
const tu = _i.prototype;
tu.append = function(e, n) {
  this._pairs.push([e, n]);
};
tu.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, mo);
  } : mo;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function ff(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nu(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || ff;
  U.isFunction(n) && (n = {
    serialize: n
  });
  const a = n && n.serialize;
  let s;
  if (a ? s = a(e, n) : s = U.isURLSearchParams(e) ? e.toString() : new _i(e, n).toString(r), s) {
    const i = t.indexOf("#");
    i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return t;
}
class ho {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    U.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const ru = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, pf = typeof URLSearchParams < "u" ? URLSearchParams : _i, mf = typeof FormData < "u" ? FormData : null, hf = typeof Blob < "u" ? Blob : null, vf = {
  isBrowser: !0,
  classes: {
    URLSearchParams: pf,
    FormData: mf,
    Blob: hf
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ti = typeof window < "u" && typeof document < "u", Xs = typeof navigator == "object" && navigator || void 0, yf = Ti && (!Xs || ["ReactNative", "NativeScript", "NS"].indexOf(Xs.product) < 0), gf = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", wf = Ti && window.location.href || "http://localhost", bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ti,
  hasStandardBrowserEnv: yf,
  hasStandardBrowserWebWorkerEnv: gf,
  navigator: Xs,
  origin: wf
}, Symbol.toStringTag, { value: "Module" })), yt = {
  ...bf,
  ...vf
};
function kf(t, e) {
  return rs(t, new yt.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, s) {
      return yt.isNode && U.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function _f(t) {
  return U.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Tf(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const a = n.length;
  let s;
  for (r = 0; r < a; r++)
    s = n[r], e[s] = t[s];
  return e;
}
function au(t) {
  function e(n, r, a, s) {
    let i = n[s++];
    if (i === "__proto__") return !0;
    const o = Number.isFinite(+i), l = s >= n.length;
    return i = !i && U.isArray(a) ? a.length : i, l ? (U.hasOwnProp(a, i) ? a[i] = [a[i], r] : a[i] = r, !o) : ((!a[i] || !U.isObject(a[i])) && (a[i] = []), e(n, r, a[i], s) && U.isArray(a[i]) && (a[i] = Tf(a[i])), !o);
  }
  if (U.isFormData(t) && U.isFunction(t.entries)) {
    const n = {};
    return U.forEachEntry(t, (r, a) => {
      e(_f(r), a, n, 0);
    }), n;
  }
  return null;
}
function Of(t, e, n) {
  if (U.isString(t))
    try {
      return (e || JSON.parse)(t), U.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(t);
}
const ca = {
  transitional: ru,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", a = r.indexOf("application/json") > -1, s = U.isObject(e);
    if (s && U.isHTMLForm(e) && (e = new FormData(e)), U.isFormData(e))
      return a ? JSON.stringify(au(e)) : e;
    if (U.isArrayBuffer(e) || U.isBuffer(e) || U.isStream(e) || U.isFile(e) || U.isBlob(e) || U.isReadableStream(e))
      return e;
    if (U.isArrayBufferView(e))
      return e.buffer;
    if (U.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return kf(e, this.formSerializer).toString();
      if ((o = U.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return rs(
          o ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return s || a ? (n.setContentType("application/json", !1), Of(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || ca.transitional, r = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (U.isResponse(e) || U.isReadableStream(e))
      return e;
    if (e && U.isString(e) && (r && !this.responseType || a)) {
      const i = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (i)
          throw o.name === "SyntaxError" ? xe.from(o, xe.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: yt.classes.FormData,
    Blob: yt.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
U.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ca.headers[t] = {};
});
const Sf = U.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Df = (t) => {
  const e = {};
  let n, r, a;
  return t && t.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), r = i.substring(a + 1).trim(), !(!n || e[n] && Sf[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, vo = Symbol("internals");
function $r(t) {
  return t && String(t).trim().toLowerCase();
}
function Ea(t) {
  return t === !1 || t == null ? t : U.isArray(t) ? t.map(Ea) : String(t);
}
function Cf(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const xf = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function ws(t, e, n, r, a) {
  if (U.isFunction(r))
    return r.call(this, e, n);
  if (a && (e = n), !!U.isString(e)) {
    if (U.isString(r))
      return e.indexOf(r) !== -1;
    if (U.isRegExp(r))
      return r.test(e);
  }
}
function Mf(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function Af(t, e) {
  const n = U.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(a, s, i) {
        return this[r].call(this, e, a, s, i);
      },
      configurable: !0
    });
  });
}
class Ct {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const a = this;
    function s(o, l, u) {
      const c = $r(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = U.findKey(a, c);
      (!d || a[d] === void 0 || u === !0 || u === void 0 && a[d] !== !1) && (a[d || l] = Ea(o));
    }
    const i = (o, l) => U.forEach(o, (u, c) => s(u, c, l));
    if (U.isPlainObject(e) || e instanceof this.constructor)
      i(e, n);
    else if (U.isString(e) && (e = e.trim()) && !xf(e))
      i(Df(e), n);
    else if (U.isHeaders(e))
      for (const [o, l] of e.entries())
        s(l, o, r);
    else
      e != null && s(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = $r(e), e) {
      const r = U.findKey(this, e);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return Cf(a);
        if (U.isFunction(n))
          return n.call(this, a, r);
        if (U.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = $r(e), e) {
      const r = U.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || ws(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let a = !1;
    function s(i) {
      if (i = $r(i), i) {
        const o = U.findKey(r, i);
        o && (!n || ws(r, r[o], o, n)) && (delete r[o], a = !0);
      }
    }
    return U.isArray(e) ? e.forEach(s) : s(e), a;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const s = n[r];
      (!e || ws(this, this[s], s, e, !0)) && (delete this[s], a = !0);
    }
    return a;
  }
  normalize(e) {
    const n = this, r = {};
    return U.forEach(this, (a, s) => {
      const i = U.findKey(r, s);
      if (i) {
        n[i] = Ea(a), delete n[s];
        return;
      }
      const o = e ? Mf(s) : String(s).trim();
      o !== s && delete n[s], n[o] = Ea(a), r[o] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return U.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = e && U.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(e) {
    const r = (this[vo] = this[vo] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function s(i) {
      const o = $r(i);
      r[o] || (Af(a, i), r[o] = !0);
    }
    return U.isArray(e) ? e.forEach(s) : s(e), this;
  }
}
Ct.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
U.reduceDescriptors(Ct.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
U.freezeMethods(Ct);
function bs(t, e) {
  const n = this || ca, r = e || n, a = Ct.from(r.headers);
  let s = r.data;
  return U.forEach(t, function(o) {
    s = o.call(n, s, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), s;
}
function su(t) {
  return !!(t && t.__CANCEL__);
}
function Fr(t, e, n) {
  xe.call(this, t ?? "canceled", xe.ERR_CANCELED, e, n), this.name = "CanceledError";
}
U.inherits(Fr, xe, {
  __CANCEL__: !0
});
function iu(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new xe(
    "Request failed with status code " + n.status,
    [xe.ERR_BAD_REQUEST, xe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Ef(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Pf(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let a = 0, s = 0, i;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), c = r[s];
    i || (i = u), n[a] = l, r[a] = u;
    let d = s, p = 0;
    for (; d !== a; )
      p += n[d++], d = d % t;
    if (a = (a + 1) % t, a === s && (s = (s + 1) % t), u - i < e)
      return;
    const m = c && u - c;
    return m ? Math.round(p * 1e3 / m) : void 0;
  };
}
function Ff(t, e) {
  let n = 0, r = 1e3 / e, a, s;
  const i = (u, c = Date.now()) => {
    n = c, a = null, s && (clearTimeout(s), s = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - n;
    d >= r ? i(u, c) : (a = u, s || (s = setTimeout(() => {
      s = null, i(a);
    }, r - d)));
  }, () => a && i(a)];
}
const Ya = (t, e, n = 3) => {
  let r = 0;
  const a = Pf(50, 250);
  return Ff((s) => {
    const i = s.loaded, o = s.lengthComputable ? s.total : void 0, l = i - r, u = a(l), c = i <= o;
    r = i;
    const d = {
      loaded: i,
      total: o,
      progress: o ? i / o : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && o && c ? (o - i) / u : void 0,
      event: s,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(d);
  }, n);
}, yo = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: r
  }), e[1]];
}, go = (t) => (...e) => U.asap(() => t(...e)), Nf = yt.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, yt.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(yt.origin),
  yt.navigator && /(msie|trident)/i.test(yt.navigator.userAgent)
) : () => !0, Rf = yt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, a, s) {
      const i = [t + "=" + encodeURIComponent(e)];
      U.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), U.isString(r) && i.push("path=" + r), U.isString(a) && i.push("domain=" + a), s === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Vf(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function If(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function ou(t, e) {
  return t && !Vf(e) ? If(t, e) : e;
}
const wo = (t) => t instanceof Ct ? { ...t } : t;
function er(t, e) {
  e = e || {};
  const n = {};
  function r(u, c, d, p) {
    return U.isPlainObject(u) && U.isPlainObject(c) ? U.merge.call({ caseless: p }, u, c) : U.isPlainObject(c) ? U.merge({}, c) : U.isArray(c) ? c.slice() : c;
  }
  function a(u, c, d, p) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(u))
        return r(void 0, u, d, p);
    } else return r(u, c, d, p);
  }
  function s(u, c) {
    if (!U.isUndefined(c))
      return r(void 0, c);
  }
  function i(u, c) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, c);
  }
  function o(u, c, d) {
    if (d in e)
      return r(u, c);
    if (d in t)
      return r(void 0, u);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: o,
    headers: (u, c, d) => a(wo(u), wo(c), d, !0)
  };
  return U.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const d = l[c] || a, p = d(t[c], e[c], c);
    U.isUndefined(p) && d !== o || (n[c] = p);
  }), n;
}
const lu = (t) => {
  const e = er({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: s, headers: i, auth: o } = e;
  e.headers = i = Ct.from(i), e.url = nu(ou(e.baseURL, e.url), t.params, t.paramsSerializer), o && i.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let l;
  if (U.isFormData(n)) {
    if (yt.hasStandardBrowserEnv || yt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (yt.hasStandardBrowserEnv && (r && U.isFunction(r) && (r = r(e)), r || r !== !1 && Nf(e.url))) {
    const u = a && s && Rf.read(s);
    u && i.set(a, u);
  }
  return e;
}, Lf = typeof XMLHttpRequest < "u", $f = Lf && function(t) {
  return new Promise(function(n, r) {
    const a = lu(t);
    let s = a.data;
    const i = Ct.from(a.headers).normalize();
    let { responseType: o, onUploadProgress: l, onDownloadProgress: u } = a, c, d, p, m, h;
    function O() {
      m && m(), h && h(), a.cancelToken && a.cancelToken.unsubscribe(c), a.signal && a.signal.removeEventListener("abort", c);
    }
    let g = new XMLHttpRequest();
    g.open(a.method.toUpperCase(), a.url, !0), g.timeout = a.timeout;
    function b() {
      if (!g)
        return;
      const M = Ct.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), E = {
        data: !o || o === "text" || o === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: M,
        config: t,
        request: g
      };
      iu(function(V) {
        n(V), O();
      }, function(V) {
        r(V), O();
      }, E), g = null;
    }
    "onloadend" in g ? g.onloadend = b : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, g.onabort = function() {
      g && (r(new xe("Request aborted", xe.ECONNABORTED, t, g)), g = null);
    }, g.onerror = function() {
      r(new xe("Network Error", xe.ERR_NETWORK, t, g)), g = null;
    }, g.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || ru;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), r(new xe(
        T,
        E.clarifyTimeoutError ? xe.ETIMEDOUT : xe.ECONNABORTED,
        t,
        g
      )), g = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in g && U.forEach(i.toJSON(), function(T, E) {
      g.setRequestHeader(E, T);
    }), U.isUndefined(a.withCredentials) || (g.withCredentials = !!a.withCredentials), o && o !== "json" && (g.responseType = a.responseType), u && ([p, h] = Ya(u, !0), g.addEventListener("progress", p)), l && g.upload && ([d, m] = Ya(l), g.upload.addEventListener("progress", d), g.upload.addEventListener("loadend", m)), (a.cancelToken || a.signal) && (c = (M) => {
      g && (r(!M || M.type ? new Fr(null, t, g) : M), g.abort(), g = null);
    }, a.cancelToken && a.cancelToken.subscribe(c), a.signal && (a.signal.aborted ? c() : a.signal.addEventListener("abort", c)));
    const w = Ef(a.url);
    if (w && yt.protocols.indexOf(w) === -1) {
      r(new xe("Unsupported protocol " + w + ":", xe.ERR_BAD_REQUEST, t));
      return;
    }
    g.send(s || null);
  });
}, Yf = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r = new AbortController(), a;
    const s = function(u) {
      if (!a) {
        a = !0, o();
        const c = u instanceof Error ? u : this.reason;
        r.abort(c instanceof xe ? c : new Fr(c instanceof Error ? c.message : c));
      }
    };
    let i = e && setTimeout(() => {
      i = null, s(new xe(`timeout ${e} of ms exceeded`, xe.ETIMEDOUT));
    }, e);
    const o = () => {
      t && (i && clearTimeout(i), i = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(s) : u.removeEventListener("abort", s);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", s));
    const { signal: l } = r;
    return l.unsubscribe = () => U.asap(o), l;
  }
}, Uf = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + e, yield t.slice(r, a), r = a;
}, Bf = async function* (t, e) {
  for await (const n of Wf(t))
    yield* Uf(n, e);
}, Wf = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await e.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, bo = (t, e, n, r) => {
  const a = Bf(t, e);
  let s = 0, i, o = (l) => {
    i || (i = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await a.next();
        if (u) {
          o(), l.close();
          return;
        }
        let d = c.byteLength;
        if (n) {
          let p = s += d;
          n(p);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw o(u), u;
      }
    },
    cancel(l) {
      return o(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, as = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", uu = as && typeof ReadableStream == "function", jf = as && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), cu = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Hf = uu && cu(() => {
  let t = !1;
  const e = new Request(yt.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), ko = 64 * 1024, Qs = uu && cu(() => U.isReadableStream(new Response("").body)), Ua = {
  stream: Qs && ((t) => t.body)
};
as && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Ua[e] && (Ua[e] = U.isFunction(t[e]) ? (n) => n[e]() : (n, r) => {
      throw new xe(`Response type '${e}' is not supported`, xe.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const qf = async (t) => {
  if (t == null)
    return 0;
  if (U.isBlob(t))
    return t.size;
  if (U.isSpecCompliantForm(t))
    return (await new Request(yt.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (U.isArrayBufferView(t) || U.isArrayBuffer(t))
    return t.byteLength;
  if (U.isURLSearchParams(t) && (t = t + ""), U.isString(t))
    return (await jf(t)).byteLength;
}, zf = async (t, e) => {
  const n = U.toFiniteNumber(t.getContentLength());
  return n ?? qf(e);
}, Zf = as && (async (t) => {
  let {
    url: e,
    method: n,
    data: r,
    signal: a,
    cancelToken: s,
    timeout: i,
    onDownloadProgress: o,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = lu(t);
  u = u ? (u + "").toLowerCase() : "text";
  let m = Yf([a, s && s.toAbortSignal()], i), h;
  const O = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let g;
  try {
    if (l && Hf && n !== "get" && n !== "head" && (g = await zf(c, r)) !== 0) {
      let E = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), $;
      if (U.isFormData(r) && ($ = E.headers.get("content-type")) && c.setContentType($), E.body) {
        const [V, Q] = yo(
          g,
          Ya(go(l))
        );
        r = bo(E.body, ko, V, Q);
      }
    }
    U.isString(d) || (d = d ? "include" : "omit");
    const b = "credentials" in Request.prototype;
    h = new Request(e, {
      ...p,
      signal: m,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: b ? d : void 0
    });
    let w = await fetch(h);
    const M = Qs && (u === "stream" || u === "response");
    if (Qs && (o || M && O)) {
      const E = {};
      ["status", "statusText", "headers"].forEach((W) => {
        E[W] = w[W];
      });
      const $ = U.toFiniteNumber(w.headers.get("content-length")), [V, Q] = o && yo(
        $,
        Ya(go(o), !0)
      ) || [];
      w = new Response(
        bo(w.body, ko, V, () => {
          Q && Q(), O && O();
        }),
        E
      );
    }
    u = u || "text";
    let T = await Ua[U.findKey(Ua, u) || "text"](w, t);
    return !M && O && O(), await new Promise((E, $) => {
      iu(E, $, {
        data: T,
        headers: Ct.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: t,
        request: h
      });
    });
  } catch (b) {
    throw O && O(), b && b.name === "TypeError" && /fetch/i.test(b.message) ? Object.assign(
      new xe("Network Error", xe.ERR_NETWORK, t, h),
      {
        cause: b.cause || b
      }
    ) : xe.from(b, b && b.code, t, h);
  }
}), Ks = {
  http: uf,
  xhr: $f,
  fetch: Zf
};
U.forEach(Ks, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const _o = (t) => `- ${t}`, Gf = (t) => U.isFunction(t) || t === null || t === !1, du = {
  getAdapter: (t) => {
    t = U.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    const a = {};
    for (let s = 0; s < e; s++) {
      n = t[s];
      let i;
      if (r = n, !Gf(n) && (r = Ks[(i = String(n)).toLowerCase()], r === void 0))
        throw new xe(`Unknown adapter '${i}'`);
      if (r)
        break;
      a[i || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(a).map(
        ([o, l]) => `adapter ${o} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? s.length > 1 ? `since :
` + s.map(_o).join(`
`) : " " + _o(s[0]) : "as no adapter specified";
      throw new xe(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Ks
};
function ks(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Fr(null, t);
}
function To(t) {
  return ks(t), t.headers = Ct.from(t.headers), t.data = bs.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), du.getAdapter(t.adapter || ca.adapter)(t).then(function(r) {
    return ks(t), r.data = bs.call(
      t,
      t.transformResponse,
      r
    ), r.headers = Ct.from(r.headers), r;
  }, function(r) {
    return su(r) || (ks(t), r && r.response && (r.response.data = bs.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = Ct.from(r.response.headers))), Promise.reject(r);
  });
}
const fu = "1.7.9", ss = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ss[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Oo = {};
ss.transitional = function(e, n, r) {
  function a(s, i) {
    return "[Axios v" + fu + "] Transitional option '" + s + "'" + i + (r ? ". " + r : "");
  }
  return (s, i, o) => {
    if (e === !1)
      throw new xe(
        a(i, " has been removed" + (n ? " in " + n : "")),
        xe.ERR_DEPRECATED
      );
    return n && !Oo[i] && (Oo[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(s, i, o) : !0;
  };
};
ss.spelling = function(e) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function Jf(t, e, n) {
  if (typeof t != "object")
    throw new xe("options must be an object", xe.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let a = r.length;
  for (; a-- > 0; ) {
    const s = r[a], i = e[s];
    if (i) {
      const o = t[s], l = o === void 0 || i(o, s, t);
      if (l !== !0)
        throw new xe("option " + s + " must be " + l, xe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new xe("Unknown option " + s, xe.ERR_BAD_OPTION);
  }
}
const Pa = {
  assertOptions: Jf,
  validators: ss
}, rn = Pa.validators;
class Jn {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new ho(),
      response: new ho()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const s = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = er(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: s } = n;
    r !== void 0 && Pa.assertOptions(r, {
      silentJSONParsing: rn.transitional(rn.boolean),
      forcedJSONParsing: rn.transitional(rn.boolean),
      clarifyTimeoutError: rn.transitional(rn.boolean)
    }, !1), a != null && (U.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Pa.assertOptions(a, {
      encode: rn.function,
      serialize: rn.function
    }, !0)), Pa.assertOptions(n, {
      baseUrl: rn.spelling("baseURL"),
      withXsrfToken: rn.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = s && U.merge(
      s.common,
      s[n.method]
    );
    s && U.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete s[h];
      }
    ), n.headers = Ct.concat(i, s);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(O) {
      typeof O.runWhen == "function" && O.runWhen(n) === !1 || (l = l && O.synchronous, o.unshift(O.fulfilled, O.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(O) {
      u.push(O.fulfilled, O.rejected);
    });
    let c, d = 0, p;
    if (!l) {
      const h = [To.bind(this), void 0];
      for (h.unshift.apply(h, o), h.push.apply(h, u), p = h.length, c = Promise.resolve(n); d < p; )
        c = c.then(h[d++], h[d++]);
      return c;
    }
    p = o.length;
    let m = n;
    for (d = 0; d < p; ) {
      const h = o[d++], O = o[d++];
      try {
        m = h(m);
      } catch (g) {
        O.call(this, g);
        break;
      }
    }
    try {
      c = To.call(this, m);
    } catch (h) {
      return Promise.reject(h);
    }
    for (d = 0, p = u.length; d < p; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(e) {
    e = er(this.defaults, e);
    const n = ou(e.baseURL, e.url);
    return nu(n, e.params, e.paramsSerializer);
  }
}
U.forEach(["delete", "get", "head", "options"], function(e) {
  Jn.prototype[e] = function(n, r) {
    return this.request(er(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
U.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(s, i, o) {
      return this.request(er(o || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  Jn.prototype[e] = n(), Jn.prototype[e + "Form"] = n(!0);
});
class Oi {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners) return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let s;
      const i = new Promise((o) => {
        r.subscribe(o), s = o;
      }).then(a);
      return i.cancel = function() {
        r.unsubscribe(s);
      }, i;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Fr(s, i, o), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Oi(function(a) {
        e = a;
      }),
      cancel: e
    };
  }
}
function Xf(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function Qf(t) {
  return U.isObject(t) && t.isAxiosError === !0;
}
const ei = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ei).forEach(([t, e]) => {
  ei[e] = t;
});
function pu(t) {
  const e = new Jn(t), n = jl(Jn.prototype.request, e);
  return U.extend(n, Jn.prototype, e, { allOwnKeys: !0 }), U.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(a) {
    return pu(er(t, a));
  }, n;
}
const st = pu(ca);
st.Axios = Jn;
st.CanceledError = Fr;
st.CancelToken = Oi;
st.isCancel = su;
st.VERSION = fu;
st.toFormData = rs;
st.AxiosError = xe;
st.Cancel = st.CanceledError;
st.all = function(e) {
  return Promise.all(e);
};
st.spread = Xf;
st.isAxiosError = Qf;
st.mergeConfig = er;
st.AxiosHeaders = Ct;
st.formToJSON = (t) => au(U.isHTMLForm(t) ? new FormData(t) : t);
st.getAdapter = du.getAdapter;
st.HttpStatusCode = ei;
st.default = st;
class sr extends Error {
}
class Kf extends sr {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class ep extends sr {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class tp extends sr {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class gr extends sr {
}
class mu extends sr {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class vt extends sr {
}
class Sn extends sr {
  constructor() {
    super("Zone is an abstract class");
  }
}
const se = "numeric", Qt = "short", Pt = "long", Ba = {
  year: se,
  month: se,
  day: se
}, hu = {
  year: se,
  month: Qt,
  day: se
}, np = {
  year: se,
  month: Qt,
  day: se,
  weekday: Qt
}, vu = {
  year: se,
  month: Pt,
  day: se
}, yu = {
  year: se,
  month: Pt,
  day: se,
  weekday: Pt
}, gu = {
  hour: se,
  minute: se
}, wu = {
  hour: se,
  minute: se,
  second: se
}, bu = {
  hour: se,
  minute: se,
  second: se,
  timeZoneName: Qt
}, ku = {
  hour: se,
  minute: se,
  second: se,
  timeZoneName: Pt
}, _u = {
  hour: se,
  minute: se,
  hourCycle: "h23"
}, Tu = {
  hour: se,
  minute: se,
  second: se,
  hourCycle: "h23"
}, Ou = {
  hour: se,
  minute: se,
  second: se,
  hourCycle: "h23",
  timeZoneName: Qt
}, Su = {
  hour: se,
  minute: se,
  second: se,
  hourCycle: "h23",
  timeZoneName: Pt
}, Du = {
  year: se,
  month: se,
  day: se,
  hour: se,
  minute: se
}, Cu = {
  year: se,
  month: se,
  day: se,
  hour: se,
  minute: se,
  second: se
}, xu = {
  year: se,
  month: Qt,
  day: se,
  hour: se,
  minute: se
}, Mu = {
  year: se,
  month: Qt,
  day: se,
  hour: se,
  minute: se,
  second: se
}, rp = {
  year: se,
  month: Qt,
  day: se,
  weekday: Qt,
  hour: se,
  minute: se
}, Au = {
  year: se,
  month: Pt,
  day: se,
  hour: se,
  minute: se,
  timeZoneName: Qt
}, Eu = {
  year: se,
  month: Pt,
  day: se,
  hour: se,
  minute: se,
  second: se,
  timeZoneName: Qt
}, Pu = {
  year: se,
  month: Pt,
  day: se,
  weekday: Pt,
  hour: se,
  minute: se,
  timeZoneName: Pt
}, Fu = {
  year: se,
  month: Pt,
  day: se,
  weekday: Pt,
  hour: se,
  minute: se,
  second: se,
  timeZoneName: Pt
};
class da {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Sn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Sn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Sn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new Sn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new Sn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new Sn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new Sn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Sn();
  }
}
let _s = null;
class is extends da {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return _s === null && (_s = new is()), _s;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return Bu(e, n, r);
  }
  /** @override **/
  formatOffset(e, n) {
    return Zr(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let Fa = {};
function ap(t) {
  return Fa[t] || (Fa[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Fa[t];
}
const sp = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function ip(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, a, s, i, o, l, u, c] = r;
  return [i, a, s, o, l, u, c];
}
function op(t, e) {
  const n = t.formatToParts(e), r = [];
  for (let a = 0; a < n.length; a++) {
    const { type: s, value: i } = n[a], o = sp[s];
    s === "era" ? r[o] = i : Te(o) || (r[o] = parseInt(i, 10));
  }
  return r;
}
let ba = {};
class wn extends da {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return ba[e] || (ba[e] = new wn(e)), ba[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ba = {}, Fa = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = wn.isValidZone(e);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, { format: n, locale: r }) {
    return Bu(e, n, r, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Zr(this.offset(e), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const r = ap(this.name);
    let [a, s, i, o, l, u, c] = r.formatToParts ? op(r, n) : ip(r, n);
    o === "BC" && (a = -Math.abs(a) + 1);
    const p = ls({
      year: a,
      month: s,
      day: i,
      hour: l === 24 ? 0 : l,
      minute: u,
      second: c,
      millisecond: 0
    });
    let m = +n;
    const h = m % 1e3;
    return m -= h >= 0 ? h : 1e3 + h, (p - m) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let So = {};
function lp(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = So[n];
  return r || (r = new Intl.ListFormat(t, e), So[n] = r), r;
}
let ti = {};
function ni(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = ti[n];
  return r || (r = new Intl.DateTimeFormat(t, e), ti[n] = r), r;
}
let ri = {};
function up(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = ri[n];
  return r || (r = new Intl.NumberFormat(t, e), ri[n] = r), r;
}
let ai = {};
function cp(t, e = {}) {
  const { base: n, ...r } = e, a = JSON.stringify([t, r]);
  let s = ai[a];
  return s || (s = new Intl.RelativeTimeFormat(t, e), ai[a] = s), s;
}
let qr = null;
function dp() {
  return qr || (qr = new Intl.DateTimeFormat().resolvedOptions().locale, qr);
}
let Do = {};
function fp(t) {
  let e = Do[t];
  if (!e) {
    const n = new Intl.Locale(t);
    e = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, Do[t] = e;
  }
  return e;
}
function pp(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const n = t.indexOf("-u-");
  if (n === -1)
    return [t];
  {
    let r, a;
    try {
      r = ni(t).resolvedOptions(), a = t;
    } catch {
      const l = t.substring(0, n);
      r = ni(l).resolvedOptions(), a = l;
    }
    const { numberingSystem: s, calendar: i } = r;
    return [a, s, i];
  }
}
function mp(t, e, n) {
  return (n || e) && (t.includes("-u-") || (t += "-u"), n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function hp(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const r = ke.utc(2009, n, 1);
    e.push(t(r));
  }
  return e;
}
function vp(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const r = ke.utc(2016, 11, 13 + n);
    e.push(t(r));
  }
  return e;
}
function ka(t, e, n, r) {
  const a = t.listingMode();
  return a === "error" ? null : a === "en" ? n(e) : r(e);
}
function yp(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class gp {
  constructor(e, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: a, floor: s, ...i } = r;
    if (!n || Object.keys(i).length > 0) {
      const o = { useGrouping: !1, ...r };
      r.padTo > 0 && (o.minimumIntegerDigits = r.padTo), this.inf = up(e, o);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : Mi(e, 3);
      return ot(n, this.padTo);
    }
  }
}
class wp {
  constructor(e, n, r) {
    this.opts = r, this.originalZone = void 0;
    let a;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const i = -1 * (e.offset / 60), o = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`;
      e.offset !== 0 && wn.create(o).valid ? (a = o, this.dt = e) : (a = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, a = e.zone.name) : (a = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const s = { ...this.opts };
    s.timeZone = s.timeZone || a, this.dtf = ni(n, s);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((n) => {
      if (n.type === "timeZoneName") {
        const r = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: r
        };
      } else
        return n;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class bp {
  constructor(e, n, r) {
    this.opts = { style: "long", ...r }, !n && Yu() && (this.rtf = cp(e, r));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : Wp(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
const kp = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class je {
  static fromOpts(e) {
    return je.create(
      e.locale,
      e.numberingSystem,
      e.outputCalendar,
      e.weekSettings,
      e.defaultToEN
    );
  }
  static create(e, n, r, a, s = !1) {
    const i = e || tt.defaultLocale, o = i || (s ? "en-US" : dp()), l = n || tt.defaultNumberingSystem, u = r || tt.defaultOutputCalendar, c = si(a) || tt.defaultWeekSettings;
    return new je(o, l, u, c, i);
  }
  static resetCache() {
    qr = null, ti = {}, ri = {}, ai = {};
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: r, weekSettings: a } = {}) {
    return je.create(e, n, r, a);
  }
  constructor(e, n, r, a, s) {
    const [i, o, l] = pp(e);
    this.locale = i, this.numberingSystem = n || o || null, this.outputCalendar = r || l || null, this.weekSettings = a, this.intl = mp(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = s, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = yp(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : je.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      si(e.weekSettings) || this.weekSettings,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1) {
    return ka(this, e, Hu, () => {
      const r = n ? { month: e, day: "numeric" } : { month: e }, a = n ? "format" : "standalone";
      return this.monthsCache[a][e] || (this.monthsCache[a][e] = hp((s) => this.extract(s, r, "month"))), this.monthsCache[a][e];
    });
  }
  weekdays(e, n = !1) {
    return ka(this, e, Zu, () => {
      const r = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, a = n ? "format" : "standalone";
      return this.weekdaysCache[a][e] || (this.weekdaysCache[a][e] = vp(
        (s) => this.extract(s, r, "weekday")
      )), this.weekdaysCache[a][e];
    });
  }
  meridiems() {
    return ka(
      this,
      void 0,
      () => Gu,
      () => {
        if (!this.meridiemCache) {
          const e = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [ke.utc(2016, 11, 13, 9), ke.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, e, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e) {
    return ka(this, e, Ju, () => {
      const n = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [ke.utc(-40, 1, 1), ke.utc(2017, 1, 1)].map(
        (r) => this.extract(r, n, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, r) {
    const a = this.dtFormatter(e, n), s = a.formatToParts(), i = s.find((o) => o.type.toLowerCase() === r);
    return i ? i.value : null;
  }
  numberFormatter(e = {}) {
    return new gp(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new wp(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new bp(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return lp(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Uu() ? fp(this.locale) : kp;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Ts = null;
class Ot extends da {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Ts === null && (Ts = new Ot(0)), Ts;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? Ot.utcInstance : new Ot(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new Ot(us(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Zr(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Zr(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Zr(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class _p extends da {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function An(t, e) {
  if (Te(t) || t === null)
    return e;
  if (t instanceof da)
    return t;
  if (xp(t)) {
    const n = t.toLowerCase();
    return n === "default" ? e : n === "local" || n === "system" ? is.instance : n === "utc" || n === "gmt" ? Ot.utcInstance : Ot.parseSpecifier(n) || wn.create(t);
  } else return Nn(t) ? Ot.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new _p(t);
}
const Si = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Co = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Tp = Si.hanidec.replace(/[\[|\]]/g, "").split("");
function Op(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const r = t.charCodeAt(n);
      if (t[n].search(Si.hanidec) !== -1)
        e += Tp.indexOf(t[n]);
      else
        for (const a in Co) {
          const [s, i] = Co[a];
          r >= s && r <= i && (e += r - s);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
let vr = {};
function Sp() {
  vr = {};
}
function Wt({ numberingSystem: t }, e = "") {
  const n = t || "latn";
  return vr[n] || (vr[n] = {}), vr[n][e] || (vr[n][e] = new RegExp(`${Si[n]}${e}`)), vr[n][e];
}
let xo = () => Date.now(), Mo = "system", Ao = null, Eo = null, Po = null, Fo = 60, No, Ro = null;
class tt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return xo;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    xo = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    Mo = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return An(Mo, is.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Ao;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    Ao = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Eo;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    Eo = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Po;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    Po = e;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Ro;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(e) {
    Ro = si(e);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return Fo;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(e) {
    Fo = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return No;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    No = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    je.resetCache(), wn.resetCache(), ke.resetCache(), Sp();
  }
}
class Zt {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const Nu = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Ru = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function It(t, e) {
  return new Zt(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function Di(t, e, n) {
  const r = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const a = r.getUTCDay();
  return a === 0 ? 7 : a;
}
function Vu(t, e, n) {
  return n + (fa(t) ? Ru : Nu)[e - 1];
}
function Iu(t, e) {
  const n = fa(t) ? Ru : Nu, r = n.findIndex((s) => s < e), a = e - n[r];
  return { month: r + 1, day: a };
}
function Ci(t, e) {
  return (t - e + 7) % 7 + 1;
}
function Wa(t, e = 4, n = 1) {
  const { year: r, month: a, day: s } = t, i = Vu(r, a, s), o = Ci(Di(r, a, s), n);
  let l = Math.floor((i - o + 14 - e) / 7), u;
  return l < 1 ? (u = r - 1, l = ta(u, e, n)) : l > ta(r, e, n) ? (u = r + 1, l = 1) : u = r, { weekYear: u, weekNumber: l, weekday: o, ...cs(t) };
}
function Vo(t, e = 4, n = 1) {
  const { weekYear: r, weekNumber: a, weekday: s } = t, i = Ci(Di(r, 1, e), n), o = br(r);
  let l = a * 7 + s - i - 7 + e, u;
  l < 1 ? (u = r - 1, l += br(u)) : l > o ? (u = r + 1, l -= br(r)) : u = r;
  const { month: c, day: d } = Iu(u, l);
  return { year: u, month: c, day: d, ...cs(t) };
}
function Os(t) {
  const { year: e, month: n, day: r } = t, a = Vu(e, n, r);
  return { year: e, ordinal: a, ...cs(t) };
}
function Io(t) {
  const { year: e, ordinal: n } = t, { month: r, day: a } = Iu(e, n);
  return { year: e, month: r, day: a, ...cs(t) };
}
function Lo(t, e) {
  if (!Te(t.localWeekday) || !Te(t.localWeekNumber) || !Te(t.localWeekYear)) {
    if (!Te(t.weekday) || !Te(t.weekNumber) || !Te(t.weekYear))
      throw new gr(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Te(t.localWeekday) || (t.weekday = t.localWeekday), Te(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), Te(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: e.getMinDaysInFirstWeek(),
      startOfWeek: e.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function Dp(t, e = 4, n = 1) {
  const r = os(t.weekYear), a = Lt(
    t.weekNumber,
    1,
    ta(t.weekYear, e, n)
  ), s = Lt(t.weekday, 1, 7);
  return r ? a ? s ? !1 : It("weekday", t.weekday) : It("week", t.weekNumber) : It("weekYear", t.weekYear);
}
function Cp(t) {
  const e = os(t.year), n = Lt(t.ordinal, 1, br(t.year));
  return e ? n ? !1 : It("ordinal", t.ordinal) : It("year", t.year);
}
function Lu(t) {
  const e = os(t.year), n = Lt(t.month, 1, 12), r = Lt(t.day, 1, ja(t.year, t.month));
  return e ? n ? r ? !1 : It("day", t.day) : It("month", t.month) : It("year", t.year);
}
function $u(t) {
  const { hour: e, minute: n, second: r, millisecond: a } = t, s = Lt(e, 0, 23) || e === 24 && n === 0 && r === 0 && a === 0, i = Lt(n, 0, 59), o = Lt(r, 0, 59), l = Lt(a, 0, 999);
  return s ? i ? o ? l ? !1 : It("millisecond", a) : It("second", r) : It("minute", n) : It("hour", e);
}
function Te(t) {
  return typeof t > "u";
}
function Nn(t) {
  return typeof t == "number";
}
function os(t) {
  return typeof t == "number" && t % 1 === 0;
}
function xp(t) {
  return typeof t == "string";
}
function Mp(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Yu() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Uu() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Ap(t) {
  return Array.isArray(t) ? t : [t];
}
function $o(t, e, n) {
  if (t.length !== 0)
    return t.reduce((r, a) => {
      const s = [e(a), a];
      return r && n(r[0], s[0]) === r[0] ? r : s;
    }, null)[1];
}
function Ep(t, e) {
  return e.reduce((n, r) => (n[r] = t[r], n), {});
}
function _r(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function si(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new vt("Week settings must be an object");
  if (!Lt(t.firstDay, 1, 7) || !Lt(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some((e) => !Lt(e, 1, 7)))
    throw new vt("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function Lt(t, e, n) {
  return os(t) && t >= e && t <= n;
}
function Pp(t, e) {
  return t - e * Math.floor(t / e);
}
function ot(t, e = 2) {
  const n = t < 0;
  let r;
  return n ? r = "-" + ("" + -t).padStart(e, "0") : r = ("" + t).padStart(e, "0"), r;
}
function Mn(t) {
  if (!(Te(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function jn(t) {
  if (!(Te(t) || t === null || t === ""))
    return parseFloat(t);
}
function xi(t) {
  if (!(Te(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function Mi(t, e, n = !1) {
  const r = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * r) / r;
}
function fa(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function br(t) {
  return fa(t) ? 366 : 365;
}
function ja(t, e) {
  const n = Pp(e - 1, 12) + 1, r = t + (e - n) / 12;
  return n === 2 ? fa(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function ls(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function Yo(t, e, n) {
  return -Ci(Di(t, 1, e), n) + e - 1;
}
function ta(t, e = 4, n = 1) {
  const r = Yo(t, e, n), a = Yo(t + 1, e, n);
  return (br(t) - r + a) / 7;
}
function ii(t) {
  return t > 99 ? t : t > tt.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function Bu(t, e, n, r = null) {
  const a = new Date(t), s = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (s.timeZone = r);
  const i = { timeZoneName: e, ...s }, o = new Intl.DateTimeFormat(n, i).formatToParts(a).find((l) => l.type.toLowerCase() === "timezonename");
  return o ? o.value : null;
}
function us(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(e, 10) || 0, a = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + a;
}
function Wu(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new vt(`Invalid unit value ${t}`);
  return e;
}
function Ha(t, e) {
  const n = {};
  for (const r in t)
    if (_r(t, r)) {
      const a = t[r];
      if (a == null) continue;
      n[e(r)] = Wu(a);
    }
  return n;
}
function Zr(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), r = Math.trunc(Math.abs(t % 60)), a = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${a}${ot(n, 2)}:${ot(r, 2)}`;
    case "narrow":
      return `${a}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${a}${ot(n, 2)}${ot(r, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function cs(t) {
  return Ep(t, ["hour", "minute", "second", "millisecond"]);
}
const Fp = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], ju = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Np = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Hu(t) {
  switch (t) {
    case "narrow":
      return [...Np];
    case "short":
      return [...ju];
    case "long":
      return [...Fp];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const qu = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], zu = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Rp = ["M", "T", "W", "T", "F", "S", "S"];
function Zu(t) {
  switch (t) {
    case "narrow":
      return [...Rp];
    case "short":
      return [...zu];
    case "long":
      return [...qu];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Gu = ["AM", "PM"], Vp = ["Before Christ", "Anno Domini"], Ip = ["BC", "AD"], Lp = ["B", "A"];
function Ju(t) {
  switch (t) {
    case "narrow":
      return [...Lp];
    case "short":
      return [...Ip];
    case "long":
      return [...Vp];
    default:
      return null;
  }
}
function $p(t) {
  return Gu[t.hour < 12 ? 0 : 1];
}
function Yp(t, e) {
  return Zu(e)[t.weekday - 1];
}
function Up(t, e) {
  return Hu(e)[t.month - 1];
}
function Bp(t, e) {
  return Ju(e)[t.year < 0 ? 0 : 1];
}
function Wp(t, e, n = "always", r = !1) {
  const a = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, s = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && s) {
    const d = t === "days";
    switch (e) {
      case 1:
        return d ? "tomorrow" : `next ${a[t][0]}`;
      case -1:
        return d ? "yesterday" : `last ${a[t][0]}`;
      case 0:
        return d ? "today" : `this ${a[t][0]}`;
    }
  }
  const i = Object.is(e, -0) || e < 0, o = Math.abs(e), l = o === 1, u = a[t], c = r ? l ? u[1] : u[2] || u[1] : l ? a[t][0] : t;
  return i ? `${o} ${c} ago` : `in ${o} ${c}`;
}
function Uo(t, e) {
  let n = "";
  for (const r of t)
    r.literal ? n += r.val : n += e(r.val);
  return n;
}
const jp = {
  D: Ba,
  DD: hu,
  DDD: vu,
  DDDD: yu,
  t: gu,
  tt: wu,
  ttt: bu,
  tttt: ku,
  T: _u,
  TT: Tu,
  TTT: Ou,
  TTTT: Su,
  f: Du,
  ff: xu,
  fff: Au,
  ffff: Pu,
  F: Cu,
  FF: Mu,
  FFF: Eu,
  FFFF: Fu
};
class gt {
  static create(e, n = {}) {
    return new gt(e, n);
  }
  static parseFormat(e) {
    let n = null, r = "", a = !1;
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const o = e.charAt(i);
      o === "'" ? (r.length > 0 && s.push({ literal: a || /^\s+$/.test(r), val: r }), n = null, r = "", a = !a) : a || o === n ? r += o : (r.length > 0 && s.push({ literal: /^\s+$/.test(r), val: r }), r = o, n = o);
    }
    return r.length > 0 && s.push({ literal: a || /^\s+$/.test(r), val: r }), s;
  }
  static macroTokenToFormatOpts(e) {
    return jp[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  dtFormatter(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n });
  }
  formatDateTime(e, n) {
    return this.dtFormatter(e, n).format();
  }
  formatDateTimeParts(e, n) {
    return this.dtFormatter(e, n).formatToParts();
  }
  formatInterval(e, n) {
    return this.dtFormatter(e.start, n).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, n) {
    return this.dtFormatter(e, n).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return ot(e, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(e);
  }
  formatDateTimeFromString(e, n) {
    const r = this.loc.listingMode() === "en", a = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", s = (m, h) => this.loc.extract(e, m, h), i = (m) => e.isOffsetFixed && e.offset === 0 && m.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, m.format) : "", o = () => r ? $p(e) : s({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (m, h) => r ? Up(e, m) : s(h ? { month: m } : { month: m, day: "numeric" }, "month"), u = (m, h) => r ? Yp(e, m) : s(
      h ? { weekday: m } : { weekday: m, month: "long", day: "numeric" },
      "weekday"
    ), c = (m) => {
      const h = gt.macroTokenToFormatOpts(m);
      return h ? this.formatWithSystemDefault(e, h) : m;
    }, d = (m) => r ? Bp(e, m) : s({ era: m }, "era"), p = (m) => {
      switch (m) {
        case "S":
          return this.num(e.millisecond);
        case "u":
        case "SSS":
          return this.num(e.millisecond, 3);
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        case "Z":
          return i({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return i({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return i({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return e.zoneName;
        case "a":
          return o();
        case "d":
          return a ? s({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return a ? s({ day: "2-digit" }, "day") : this.num(e.day, 2);
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        case "L":
          return a ? s({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return a ? s({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        case "M":
          return a ? s({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return a ? s({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        case "y":
          return a ? s({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return a ? s({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return a ? s({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return a ? s({ year: "numeric" }, "year") : this.num(e.year, 6);
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "n":
          return this.num(e.localWeekNumber);
        case "nn":
          return this.num(e.localWeekNumber, 2);
        case "ii":
          return this.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(e.localWeekYear, 4);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return c(m);
      }
    };
    return Uo(gt.parseFormat(n), p);
  }
  formatDurationFromString(e, n) {
    const r = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, a = (l) => (u) => {
      const c = r(u);
      return c ? this.num(l.get(c), u.length) : u;
    }, s = gt.parseFormat(n), i = s.reduce(
      (l, { literal: u, val: c }) => u ? l : l.concat(c),
      []
    ), o = e.shiftTo(...i.map(r).filter((l) => l));
    return Uo(s, a(o));
  }
}
const Xu = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Nr(...t) {
  const e = t.reduce((n, r) => n + r.source, "");
  return RegExp(`^${e}$`);
}
function Rr(...t) {
  return (e) => t.reduce(
    ([n, r, a], s) => {
      const [i, o, l] = s(e, a);
      return [{ ...n, ...i }, o || r, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Vr(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, r] of e) {
    const a = n.exec(t);
    if (a)
      return r(a);
  }
  return [null, null];
}
function Qu(...t) {
  return (e, n) => {
    const r = {};
    let a;
    for (a = 0; a < t.length; a++)
      r[t[a]] = Mn(e[n + a]);
    return [r, null, n + a];
  };
}
const Ku = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Hp = `(?:${Ku.source}?(?:\\[(${Xu.source})\\])?)?`, Ai = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, ec = RegExp(`${Ai.source}${Hp}`), Ei = RegExp(`(?:T${ec.source})?`), qp = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, zp = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Zp = /(\d{4})-?(\d{3})/, Gp = Qu("weekYear", "weekNumber", "weekDay"), Jp = Qu("year", "ordinal"), Xp = /(\d{4})-(\d\d)-(\d\d)/, tc = RegExp(
  `${Ai.source} ?(?:${Ku.source}|(${Xu.source}))?`
), Qp = RegExp(`(?: ${tc.source})?`);
function kr(t, e, n) {
  const r = t[e];
  return Te(r) ? n : Mn(r);
}
function Kp(t, e) {
  return [{
    year: kr(t, e),
    month: kr(t, e + 1, 1),
    day: kr(t, e + 2, 1)
  }, null, e + 3];
}
function Ir(t, e) {
  return [{
    hours: kr(t, e, 0),
    minutes: kr(t, e + 1, 0),
    seconds: kr(t, e + 2, 0),
    milliseconds: xi(t[e + 3])
  }, null, e + 4];
}
function pa(t, e) {
  const n = !t[e] && !t[e + 1], r = us(t[e + 1], t[e + 2]), a = n ? null : Ot.instance(r);
  return [{}, a, e + 3];
}
function ma(t, e) {
  const n = t[e] ? wn.create(t[e]) : null;
  return [{}, n, e + 1];
}
const em = RegExp(`^T?${Ai.source}$`), tm = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function nm(t) {
  const [e, n, r, a, s, i, o, l, u] = t, c = e[0] === "-", d = l && l[0] === "-", p = (m, h = !1) => m !== void 0 && (h || m && c) ? -m : m;
  return [
    {
      years: p(jn(n)),
      months: p(jn(r)),
      weeks: p(jn(a)),
      days: p(jn(s)),
      hours: p(jn(i)),
      minutes: p(jn(o)),
      seconds: p(jn(l), l === "-0"),
      milliseconds: p(xi(u), d)
    }
  ];
}
const rm = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Pi(t, e, n, r, a, s, i) {
  const o = {
    year: e.length === 2 ? ii(Mn(e)) : Mn(e),
    month: ju.indexOf(n) + 1,
    day: Mn(r),
    hour: Mn(a),
    minute: Mn(s)
  };
  return i && (o.second = Mn(i)), t && (o.weekday = t.length > 3 ? qu.indexOf(t) + 1 : zu.indexOf(t) + 1), o;
}
const am = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function sm(t) {
  const [
    ,
    e,
    n,
    r,
    a,
    s,
    i,
    o,
    l,
    u,
    c,
    d
  ] = t, p = Pi(e, a, r, n, s, i, o);
  let m;
  return l ? m = rm[l] : u ? m = 0 : m = us(c, d), [p, new Ot(m)];
}
function im(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const om = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, lm = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, um = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Bo(t) {
  const [, e, n, r, a, s, i, o] = t;
  return [Pi(e, a, r, n, s, i, o), Ot.utcInstance];
}
function cm(t) {
  const [, e, n, r, a, s, i, o] = t;
  return [Pi(e, o, n, r, a, s, i), Ot.utcInstance];
}
const dm = Nr(qp, Ei), fm = Nr(zp, Ei), pm = Nr(Zp, Ei), mm = Nr(ec), nc = Rr(
  Kp,
  Ir,
  pa,
  ma
), hm = Rr(
  Gp,
  Ir,
  pa,
  ma
), vm = Rr(
  Jp,
  Ir,
  pa,
  ma
), ym = Rr(
  Ir,
  pa,
  ma
);
function gm(t) {
  return Vr(
    t,
    [dm, nc],
    [fm, hm],
    [pm, vm],
    [mm, ym]
  );
}
function wm(t) {
  return Vr(im(t), [am, sm]);
}
function bm(t) {
  return Vr(
    t,
    [om, Bo],
    [lm, Bo],
    [um, cm]
  );
}
function km(t) {
  return Vr(t, [tm, nm]);
}
const _m = Rr(Ir);
function Tm(t) {
  return Vr(t, [em, _m]);
}
const Om = Nr(Xp, Qp), Sm = Nr(tc), Dm = Rr(
  Ir,
  pa,
  ma
);
function Cm(t) {
  return Vr(
    t,
    [Om, nc],
    [Sm, Dm]
  );
}
const Wo = "Invalid Duration", rc = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, xm = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...rc
}, Vt = 146097 / 400, cr = 146097 / 4800, Mm = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Vt / 7,
    days: Vt,
    hours: Vt * 24,
    minutes: Vt * 24 * 60,
    seconds: Vt * 24 * 60 * 60,
    milliseconds: Vt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Vt / 28,
    days: Vt / 4,
    hours: Vt * 24 / 4,
    minutes: Vt * 24 * 60 / 4,
    seconds: Vt * 24 * 60 * 60 / 4,
    milliseconds: Vt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: cr / 7,
    days: cr,
    hours: cr * 24,
    minutes: cr * 24 * 60,
    seconds: cr * 24 * 60 * 60,
    milliseconds: cr * 24 * 60 * 60 * 1e3
  },
  ...rc
}, Gn = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Am = Gn.slice(0).reverse();
function Dn(t, e, n = !1) {
  const r = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new Ne(r);
}
function ac(t, e) {
  let n = e.milliseconds ?? 0;
  for (const r of Am.slice(1))
    e[r] && (n += e[r] * t[r].milliseconds);
  return n;
}
function jo(t, e) {
  const n = ac(t, e) < 0 ? -1 : 1;
  Gn.reduceRight((r, a) => {
    if (Te(e[a]))
      return r;
    if (r) {
      const s = e[r] * n, i = t[a][r], o = Math.floor(s / i);
      e[a] += o * n, e[r] -= o * i * n;
    }
    return a;
  }, null), Gn.reduce((r, a) => {
    if (Te(e[a]))
      return r;
    if (r) {
      const s = e[r] % 1;
      e[r] -= s, e[a] += s * t[r][a];
    }
    return a;
  }, null);
}
function Em(t) {
  const e = {};
  for (const [n, r] of Object.entries(t))
    r !== 0 && (e[n] = r);
  return e;
}
class Ne {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    let r = n ? Mm : xm;
    e.matrix && (r = e.matrix), this.values = e.values, this.loc = e.loc || je.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = r, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return Ne.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new vt(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new Ne({
      values: Ha(e, Ne.normalizeUnit),
      loc: je.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (Nn(e))
      return Ne.fromMillis(e);
    if (Ne.isDuration(e))
      return e;
    if (typeof e == "object")
      return Ne.fromObject(e);
    throw new vt(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [r] = km(e);
    return r ? Ne.fromObject(r, n) : Ne.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [r] = Tm(e);
    return r ? Ne.fromObject(r, n) : Ne.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new vt("need to specify a reason the Duration is invalid");
    const r = e instanceof Zt ? e : new Zt(e, n);
    if (tt.throwOnInvalid)
      throw new tp(r);
    return new Ne({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new mu(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? gt.create(this.loc, r).formatDurationFromString(this, e) : Wo;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    if (!this.isValid) return Wo;
    const n = Gn.map((r) => {
      const a = this.values[r];
      return Te(a) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: r.slice(0, -1) }).format(a);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += Mi(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e,
      includeOffset: !1
    }, ke.fromMillis(n, { zone: "UTC" }).toISOTime(e));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? ac(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Ne.fromDurationLike(e), r = {};
    for (const a of Gn)
      (_r(n.values, a) || _r(this.values, a)) && (r[a] = n.get(a) + this.get(a));
    return Dn(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Ne.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = Wu(e(this.values[r], r));
    return Dn(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[Ne.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...Ha(e, Ne.normalizeUnit) };
    return Dn(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: r, matrix: a } = {}) {
    const i = { loc: this.loc.clone({ locale: e, numberingSystem: n }), matrix: a, conversionAccuracy: r };
    return Dn(this, i);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return jo(this.matrix, e), Dn(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const e = Em(this.normalize().shiftToAll().toObject());
    return Dn(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((i) => Ne.normalizeUnit(i));
    const n = {}, r = {}, a = this.toObject();
    let s;
    for (const i of Gn)
      if (e.indexOf(i) >= 0) {
        s = i;
        let o = 0;
        for (const u in r)
          o += this.matrix[u][i] * r[u], r[u] = 0;
        Nn(a[i]) && (o += a[i]);
        const l = Math.trunc(o);
        n[i] = l, r[i] = (o * 1e3 - l * 1e3) / 1e3;
      } else Nn(a[i]) && (r[i] = a[i]);
    for (const i in r)
      r[i] !== 0 && (n[s] += i === s ? r[i] : r[i] / this.matrix[s][i]);
    return jo(this.matrix, n), Dn(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return Dn(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(r, a) {
      return r === void 0 || r === 0 ? a === void 0 || a === 0 : r === a;
    }
    for (const r of Gn)
      if (!n(this.values[r], e.values[r]))
        return !1;
    return !0;
  }
}
const dr = "Invalid Interval";
function Pm(t, e) {
  return !t || !t.isValid ? et.invalid("missing or invalid start") : !e || !e.isValid ? et.invalid("missing or invalid end") : e < t ? et.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class et {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new vt("need to specify a reason the Interval is invalid");
    const r = e instanceof Zt ? e : new Zt(e, n);
    if (tt.throwOnInvalid)
      throw new ep(r);
    return new et({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const r = Yr(e), a = Yr(n), s = Pm(r, a);
    return s ?? new et({
      start: r,
      end: a
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const r = Ne.fromDurationLike(n), a = Yr(e);
    return et.fromDateTimes(a, a.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const r = Ne.fromDurationLike(n), a = Yr(e);
    return et.fromDateTimes(a.minus(r), a);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [r, a] = (e || "").split("/", 2);
    if (r && a) {
      let s, i;
      try {
        s = ke.fromISO(r, n), i = s.isValid;
      } catch {
        i = !1;
      }
      let o, l;
      try {
        o = ke.fromISO(a, n), l = o.isValid;
      } catch {
        l = !1;
      }
      if (i && l)
        return et.fromDateTimes(s, o);
      if (i) {
        const u = Ne.fromISO(a, n);
        if (u.isValid)
          return et.after(s, u);
      } else if (l) {
        const u = Ne.fromISO(r, n);
        if (u.isValid)
          return et.before(o, u);
      }
    }
    return et.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(e = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const r = this.start.startOf(e, n);
    let a;
    return n != null && n.useLocaleWeeks ? a = this.end.reconfigure({ locale: r.locale }) : a = this.end, a = a.startOf(e, n), Math.floor(a.diff(r, e).get(e)) + (a.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? et.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(Yr).filter((i) => this.contains(i)).sort((i, o) => i.toMillis() - o.toMillis()), r = [];
    let { s: a } = this, s = 0;
    for (; a < this.e; ) {
      const i = n[s] || this.e, o = +i > +this.e ? this.e : i;
      r.push(et.fromDateTimes(a, o)), a = o, s += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = Ne.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, a = 1, s;
    const i = [];
    for (; r < this.e; ) {
      const o = this.start.plus(n.mapUnits((l) => l * a));
      s = +o > +this.e ? this.e : o, i.push(et.fromDateTimes(r, s)), r = s, a += 1;
    }
    return i;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, r = this.e < e.e ? this.e : e.e;
    return n >= r ? null : et.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, r = this.e > e.e ? this.e : e.e;
    return et.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, r] = e.sort((a, s) => a.s - s.s).reduce(
      ([a, s], i) => s ? s.overlaps(i) || s.abutsStart(i) ? [a, s.union(i)] : [a.concat([s]), i] : [a, i],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, r = 0;
    const a = [], s = e.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), i = Array.prototype.concat(...s), o = i.sort((l, u) => l.time - u.time);
    for (const l of o)
      r += l.type === "s" ? 1 : -1, r === 1 ? n = l.time : (n && +n != +l.time && a.push(et.fromDateTimes(n, l.time)), n = null);
    return et.merge(a);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return et.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : dr;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = Ba, n = {}) {
    return this.isValid ? gt.create(this.s.loc.clone(n), e).formatInterval(this) : dr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : dr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : dr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : dr;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : dr;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : Ne.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return et.fromDateTimes(e(this.s), e(this.e));
  }
}
class _a {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = tt.defaultZone) {
    const n = ke.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return wn.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return An(e, tt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || je.create(e)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || je.create(e)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: e = null, locObj: n = null } = {}) {
    return (n || je.create(e)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null, outputCalendar: s = "gregory" } = {}) {
    return (a || je.create(n, r, s)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null, outputCalendar: s = "gregory" } = {}) {
    return (a || je.create(n, r, s)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null } = {}) {
    return (a || je.create(n, r, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null } = {}) {
    return (a || je.create(n, r, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return je.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return je.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Yu(), localeWeek: Uu() };
  }
}
function Ho(t, e) {
  const n = (a) => a.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(e) - n(t);
  return Math.floor(Ne.fromMillis(r).as("days"));
}
function Fm(t, e, n) {
  const r = [
    ["years", (l, u) => u.year - l.year],
    ["quarters", (l, u) => u.quarter - l.quarter + (u.year - l.year) * 4],
    ["months", (l, u) => u.month - l.month + (u.year - l.year) * 12],
    [
      "weeks",
      (l, u) => {
        const c = Ho(l, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", Ho]
  ], a = {}, s = t;
  let i, o;
  for (const [l, u] of r)
    n.indexOf(l) >= 0 && (i = l, a[l] = u(t, e), o = s.plus(a), o > e ? (a[l]--, t = s.plus(a), t > e && (o = t, a[l]--, t = s.plus(a))) : t = o);
  return [t, a, o, i];
}
function Nm(t, e, n, r) {
  let [a, s, i, o] = Fm(t, e, n);
  const l = e - a, u = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  u.length === 0 && (i < e && (i = a.plus({ [o]: 1 })), i !== a && (s[o] = (s[o] || 0) + l / (i - a)));
  const c = Ne.fromObject(s, r);
  return u.length > 0 ? Ne.fromMillis(l, r).shiftTo(...u).plus(c) : c;
}
const Rm = "missing Intl.DateTimeFormat.formatToParts support";
function $e(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(Op(n)) };
}
const Vm = " ", sc = `[ ${Vm}]`, ic = new RegExp(sc, "g");
function Im(t) {
  return t.replace(/\./g, "\\.?").replace(ic, sc);
}
function qo(t) {
  return t.replace(/\./g, "").replace(ic, " ").toLowerCase();
}
function jt(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(Im).join("|")),
    deser: ([n]) => t.findIndex((r) => qo(n) === qo(r)) + e
  };
}
function zo(t, e) {
  return { regex: t, deser: ([, n, r]) => us(n, r), groups: e };
}
function Ta(t) {
  return { regex: t, deser: ([e]) => e };
}
function Lm(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $m(t, e) {
  const n = Wt(e), r = Wt(e, "{2}"), a = Wt(e, "{3}"), s = Wt(e, "{4}"), i = Wt(e, "{6}"), o = Wt(e, "{1,2}"), l = Wt(e, "{1,3}"), u = Wt(e, "{1,6}"), c = Wt(e, "{1,9}"), d = Wt(e, "{2,4}"), p = Wt(e, "{4,6}"), m = (g) => ({ regex: RegExp(Lm(g.val)), deser: ([b]) => b, literal: !0 }), O = ((g) => {
    if (t.literal)
      return m(g);
    switch (g.val) {
      case "G":
        return jt(e.eras("short"), 0);
      case "GG":
        return jt(e.eras("long"), 0);
      case "y":
        return $e(u);
      case "yy":
        return $e(d, ii);
      case "yyyy":
        return $e(s);
      case "yyyyy":
        return $e(p);
      case "yyyyyy":
        return $e(i);
      case "M":
        return $e(o);
      case "MM":
        return $e(r);
      case "MMM":
        return jt(e.months("short", !0), 1);
      case "MMMM":
        return jt(e.months("long", !0), 1);
      case "L":
        return $e(o);
      case "LL":
        return $e(r);
      case "LLL":
        return jt(e.months("short", !1), 1);
      case "LLLL":
        return jt(e.months("long", !1), 1);
      case "d":
        return $e(o);
      case "dd":
        return $e(r);
      case "o":
        return $e(l);
      case "ooo":
        return $e(a);
      case "HH":
        return $e(r);
      case "H":
        return $e(o);
      case "hh":
        return $e(r);
      case "h":
        return $e(o);
      case "mm":
        return $e(r);
      case "m":
        return $e(o);
      case "q":
        return $e(o);
      case "qq":
        return $e(r);
      case "s":
        return $e(o);
      case "ss":
        return $e(r);
      case "S":
        return $e(l);
      case "SSS":
        return $e(a);
      case "u":
        return Ta(c);
      case "uu":
        return Ta(o);
      case "uuu":
        return $e(n);
      case "a":
        return jt(e.meridiems(), 0);
      case "kkkk":
        return $e(s);
      case "kk":
        return $e(d, ii);
      case "W":
        return $e(o);
      case "WW":
        return $e(r);
      case "E":
      case "c":
        return $e(n);
      case "EEE":
        return jt(e.weekdays("short", !1), 1);
      case "EEEE":
        return jt(e.weekdays("long", !1), 1);
      case "ccc":
        return jt(e.weekdays("short", !0), 1);
      case "cccc":
        return jt(e.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return zo(new RegExp(`([+-]${o.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return zo(new RegExp(`([+-]${o.source})(${r.source})?`), 2);
      case "z":
        return Ta(/[a-z_+-/]{1,256}?/i);
      case " ":
        return Ta(/[^\S\n\r]/);
      default:
        return m(g);
    }
  })(t) || {
    invalidReason: Rm
  };
  return O.token = t, O;
}
const Ym = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Um(t, e, n) {
  const { type: r, value: a } = t;
  if (r === "literal") {
    const l = /^\s+$/.test(a);
    return {
      literal: !l,
      val: l ? " " : a
    };
  }
  const s = e[r];
  let i = r;
  r === "hour" && (e.hour12 != null ? i = e.hour12 ? "hour12" : "hour24" : e.hourCycle != null ? e.hourCycle === "h11" || e.hourCycle === "h12" ? i = "hour12" : i = "hour24" : i = n.hour12 ? "hour12" : "hour24");
  let o = Ym[i];
  if (typeof o == "object" && (o = o[s]), o)
    return {
      literal: !1,
      val: o
    };
}
function Bm(t) {
  return [`^${t.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, t];
}
function Wm(t, e, n) {
  const r = t.match(e);
  if (r) {
    const a = {};
    let s = 1;
    for (const i in n)
      if (_r(n, i)) {
        const o = n[i], l = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (a[o.token.val[0]] = o.deser(r.slice(s, s + l))), s += l;
      }
    return [r, a];
  } else
    return [r, {}];
}
function jm(t) {
  const e = (s) => {
    switch (s) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return Te(t.z) || (n = wn.create(t.z)), Te(t.Z) || (n || (n = new Ot(t.Z)), r = t.Z), Te(t.q) || (t.M = (t.q - 1) * 3 + 1), Te(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), Te(t.u) || (t.S = xi(t.u)), [Object.keys(t).reduce((s, i) => {
    const o = e(i);
    return o && (s[o] = t[i]), s;
  }, {}), n, r];
}
let Ss = null;
function Hm() {
  return Ss || (Ss = ke.fromMillis(1555555555555)), Ss;
}
function qm(t, e) {
  if (t.literal)
    return t;
  const n = gt.macroTokenToFormatOpts(t.val), r = cc(n, e);
  return r == null || r.includes(void 0) ? t : r;
}
function oc(t, e) {
  return Array.prototype.concat(...t.map((n) => qm(n, e)));
}
class lc {
  constructor(e, n) {
    if (this.locale = e, this.format = n, this.tokens = oc(gt.parseFormat(n), e), this.units = this.tokens.map((r) => $m(r, e)), this.disqualifyingUnit = this.units.find((r) => r.invalidReason), !this.disqualifyingUnit) {
      const [r, a] = Bm(this.units);
      this.regex = RegExp(r, "i"), this.handlers = a;
    }
  }
  explainFromTokens(e) {
    if (this.isValid) {
      const [n, r] = Wm(e, this.regex, this.handlers), [a, s, i] = r ? jm(r) : [null, null, void 0];
      if (_r(r, "a") && _r(r, "H"))
        throw new gr(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: e,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: r,
        result: a,
        zone: s,
        specificOffset: i
      };
    } else
      return { input: e, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function uc(t, e, n) {
  return new lc(t, n).explainFromTokens(e);
}
function zm(t, e, n) {
  const { result: r, zone: a, specificOffset: s, invalidReason: i } = uc(t, e, n);
  return [r, a, s, i];
}
function cc(t, e) {
  if (!t)
    return null;
  const r = gt.create(e, t).dtFormatter(Hm()), a = r.formatToParts(), s = r.resolvedOptions();
  return a.map((i) => Um(i, t, s));
}
const Ds = "Invalid DateTime", Zm = 864e13;
function zr(t) {
  return new Zt("unsupported zone", `the zone "${t.name}" is not supported`);
}
function Cs(t) {
  return t.weekData === null && (t.weekData = Wa(t.c)), t.weekData;
}
function xs(t) {
  return t.localWeekData === null && (t.localWeekData = Wa(
    t.c,
    t.loc.getMinDaysInFirstWeek(),
    t.loc.getStartOfWeek()
  )), t.localWeekData;
}
function Hn(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new ke({ ...n, ...e, old: n });
}
function dc(t, e, n) {
  let r = t - e * 60 * 1e3;
  const a = n.offset(r);
  if (e === a)
    return [r, e];
  r -= (a - e) * 60 * 1e3;
  const s = n.offset(r);
  return a === s ? [r, a] : [t - Math.min(a, s) * 60 * 1e3, Math.max(a, s)];
}
function Oa(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Na(t, e, n) {
  return dc(ls(t), e, n);
}
function Zo(t, e) {
  const n = t.o, r = t.c.year + Math.trunc(e.years), a = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, s = {
    ...t.c,
    year: r,
    month: a,
    day: Math.min(t.c.day, ja(r, a)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, i = Ne.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), o = ls(s);
  let [l, u] = dc(o, n, t.zone);
  return i !== 0 && (l += i, u = t.zone.offset(l)), { ts: l, o: u };
}
function fr(t, e, n, r, a, s) {
  const { setZone: i, zone: o } = n;
  if (t && Object.keys(t).length !== 0 || e) {
    const l = e || o, u = ke.fromObject(t, {
      ...n,
      zone: l,
      specificOffset: s
    });
    return i ? u : u.setZone(o);
  } else
    return ke.invalid(
      new Zt("unparsable", `the input "${a}" can't be parsed as ${r}`)
    );
}
function Sa(t, e, n = !0) {
  return t.isValid ? gt.create(je.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function Ms(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let r = "";
  return n && t.c.year >= 0 && (r += "+"), r += ot(t.c.year, n ? 6 : 4), e ? (r += "-", r += ot(t.c.month), r += "-", r += ot(t.c.day)) : (r += ot(t.c.month), r += ot(t.c.day)), r;
}
function Go(t, e, n, r, a, s) {
  let i = ot(t.c.hour);
  return e ? (i += ":", i += ot(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (i += ":")) : i += ot(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (i += ot(t.c.second), (t.c.millisecond !== 0 || !r) && (i += ".", i += ot(t.c.millisecond, 3))), a && (t.isOffsetFixed && t.offset === 0 && !s ? i += "Z" : t.o < 0 ? (i += "-", i += ot(Math.trunc(-t.o / 60)), i += ":", i += ot(Math.trunc(-t.o % 60))) : (i += "+", i += ot(Math.trunc(t.o / 60)), i += ":", i += ot(Math.trunc(t.o % 60)))), s && (i += "[" + t.zone.ianaName + "]"), i;
}
const fc = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Gm = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Jm = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, pc = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Xm = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Qm = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Km(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new mu(t);
  return e;
}
function Jo(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return Km(t);
  }
}
function eh(t) {
  return Va[t] || (Ra === void 0 && (Ra = tt.now()), Va[t] = t.offset(Ra)), Va[t];
}
function Xo(t, e) {
  const n = An(e.zone, tt.defaultZone);
  if (!n.isValid)
    return ke.invalid(zr(n));
  const r = je.fromObject(e);
  let a, s;
  if (Te(t.year))
    a = tt.now();
  else {
    for (const l of pc)
      Te(t[l]) && (t[l] = fc[l]);
    const i = Lu(t) || $u(t);
    if (i)
      return ke.invalid(i);
    const o = eh(n);
    [a, s] = Na(t, o, n);
  }
  return new ke({ ts: a, zone: n, loc: r, o: s });
}
function Qo(t, e, n) {
  const r = Te(n.round) ? !0 : n.round, a = (i, o) => (i = Mi(i, r || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(i, o)), s = (i) => n.calendary ? e.hasSame(t, i) ? 0 : e.startOf(i).diff(t.startOf(i), i).get(i) : e.diff(t, i).get(i);
  if (n.unit)
    return a(s(n.unit), n.unit);
  for (const i of n.units) {
    const o = s(i);
    if (Math.abs(o) >= 1)
      return a(o, i);
  }
  return a(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function Ko(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
let Ra, Va = {};
class ke {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || tt.defaultZone;
    let r = e.invalid || (Number.isNaN(e.ts) ? new Zt("invalid input") : null) || (n.isValid ? null : zr(n));
    this.ts = Te(e.ts) ? tt.now() : e.ts;
    let a = null, s = null;
    if (!r)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [a, s] = [e.old.c, e.old.o];
      else {
        const o = Nn(e.o) && !e.old ? e.o : n.offset(this.ts);
        a = Oa(this.ts, o), r = Number.isNaN(a.year) ? new Zt("invalid input") : null, a = r ? null : a, s = r ? null : o;
      }
    this._zone = n, this.loc = e.loc || je.create(), this.invalid = r, this.weekData = null, this.localWeekData = null, this.c = a, this.o = s, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new ke({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = Ko(arguments), [r, a, s, i, o, l, u] = n;
    return Xo({ year: r, month: a, day: s, hour: i, minute: o, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = Ko(arguments), [r, a, s, i, o, l, u] = n;
    return e.zone = Ot.utcInstance, Xo({ year: r, month: a, day: s, hour: i, minute: o, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const r = Mp(e) ? e.valueOf() : NaN;
    if (Number.isNaN(r))
      return ke.invalid("invalid input");
    const a = An(n.zone, tt.defaultZone);
    return a.isValid ? new ke({
      ts: r,
      zone: a,
      loc: je.fromObject(n)
    }) : ke.invalid(zr(a));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (Nn(e))
      return e < -864e13 || e > Zm ? ke.invalid("Timestamp out of range") : new ke({
        ts: e,
        zone: An(n.zone, tt.defaultZone),
        loc: je.fromObject(n)
      });
    throw new vt(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (Nn(e))
      return new ke({
        ts: e * 1e3,
        zone: An(n.zone, tt.defaultZone),
        loc: je.fromObject(n)
      });
    throw new vt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const r = An(n.zone, tt.defaultZone);
    if (!r.isValid)
      return ke.invalid(zr(r));
    const a = je.fromObject(n), s = Ha(e, Jo), { minDaysInFirstWeek: i, startOfWeek: o } = Lo(s, a), l = tt.now(), u = Te(n.specificOffset) ? r.offset(l) : n.specificOffset, c = !Te(s.ordinal), d = !Te(s.year), p = !Te(s.month) || !Te(s.day), m = d || p, h = s.weekYear || s.weekNumber;
    if ((m || c) && h)
      throw new gr(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (p && c)
      throw new gr("Can't mix ordinal dates with month/day");
    const O = h || s.weekday && !m;
    let g, b, w = Oa(l, u);
    O ? (g = Xm, b = Gm, w = Wa(w, i, o)) : c ? (g = Qm, b = Jm, w = Os(w)) : (g = pc, b = fc);
    let M = !1;
    for (const k of g) {
      const F = s[k];
      Te(F) ? M ? s[k] = b[k] : s[k] = w[k] : M = !0;
    }
    const T = O ? Dp(s, i, o) : c ? Cp(s) : Lu(s), E = T || $u(s);
    if (E)
      return ke.invalid(E);
    const $ = O ? Vo(s, i, o) : c ? Io(s) : s, [V, Q] = Na($, u, r), W = new ke({
      ts: V,
      zone: r,
      o: Q,
      loc: a
    });
    return s.weekday && m && e.weekday !== W.weekday ? ke.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${s.weekday} and a date of ${W.toISO()}`
    ) : W.isValid ? W : ke.invalid(W.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [r, a] = gm(e);
    return fr(r, a, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [r, a] = wm(e);
    return fr(r, a, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [r, a] = bm(e);
    return fr(r, a, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, r = {}) {
    if (Te(e) || Te(n))
      throw new vt("fromFormat requires an input string and a format");
    const { locale: a = null, numberingSystem: s = null } = r, i = je.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    }), [o, l, u, c] = zm(i, e, n);
    return c ? ke.invalid(c) : fr(o, l, r, `format ${n}`, e, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, r = {}) {
    return ke.fromFormat(e, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [r, a] = Cm(e);
    return fr(r, a, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new vt("need to specify a reason the DateTime is invalid");
    const r = e instanceof Zt ? e : new Zt(e, n);
    if (tt.throwOnInvalid)
      throw new Kf(r);
    return new ke({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, n = {}) {
    const r = cc(e, je.fromObject(n));
    return r ? r.map((a) => a ? a.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, n = {}) {
    return oc(gt.parseFormat(e), je.fromObject(n)).map((a) => a.val).join("");
  }
  static resetCache() {
    Ra = void 0, Va = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Cs(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Cs(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Cs(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? xs(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? xs(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? xs(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Os(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? _a.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? _a.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? _a.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? _a.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const e = 864e5, n = 6e4, r = ls(this.c), a = this.zone.offset(r - e), s = this.zone.offset(r + e), i = this.zone.offset(r - a * n), o = this.zone.offset(r - s * n);
    if (i === o)
      return [this];
    const l = r - i * n, u = r - o * n, c = Oa(l, i), d = Oa(u, o);
    return c.hour === d.hour && c.minute === d.minute && c.second === d.second && c.millisecond === d.millisecond ? [Hn(this, { ts: l }), Hn(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return fa(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return ja(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? br(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? ta(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? ta(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: r, calendar: a } = gt.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: a };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(Ot.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(tt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (e = An(e, tt.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let a = this.ts;
      if (n || r) {
        const s = e.offset(this.ts), i = this.toObject();
        [a] = Na(i, s, e);
      }
      return Hn(this, { ts: a, zone: e });
    } else
      return ke.invalid(zr(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    const a = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: r });
    return Hn(this, { loc: a });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = Ha(e, Jo), { minDaysInFirstWeek: r, startOfWeek: a } = Lo(n, this.loc), s = !Te(n.weekYear) || !Te(n.weekNumber) || !Te(n.weekday), i = !Te(n.ordinal), o = !Te(n.year), l = !Te(n.month) || !Te(n.day), u = o || l, c = n.weekYear || n.weekNumber;
    if ((u || i) && c)
      throw new gr(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && i)
      throw new gr("Can't mix ordinal dates with month/day");
    let d;
    s ? d = Vo(
      { ...Wa(this.c, r, a), ...n },
      r,
      a
    ) : Te(n.ordinal) ? (d = { ...this.toObject(), ...n }, Te(n.day) && (d.day = Math.min(ja(d.year, d.month), d.day))) : d = Io({ ...Os(this.c), ...n });
    const [p, m] = Na(d, this.o, this.zone);
    return Hn(this, { ts: p, o: m });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Ne.fromDurationLike(e);
    return Hn(this, Zo(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Ne.fromDurationLike(e).negate();
    return Hn(this, Zo(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const r = {}, a = Ne.normalizeUnit(e);
    switch (a) {
      case "years":
        r.month = 1;
      case "quarters":
      case "months":
        r.day = 1;
      case "weeks":
      case "days":
        r.hour = 0;
      case "hours":
        r.minute = 0;
      case "minutes":
        r.second = 0;
      case "seconds":
        r.millisecond = 0;
        break;
    }
    if (a === "weeks")
      if (n) {
        const s = this.loc.getStartOfWeek(), { weekday: i } = this;
        i < s && (r.weekNumber = this.weekNumber - 1), r.weekday = s;
      } else
        r.weekday = 1;
    if (a === "quarters") {
      const s = Math.ceil(this.month / 3);
      r.month = (s - 1) * 3 + 1;
    }
    return this.set(r);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e, n) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? gt.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : Ds;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = Ba, n = {}) {
    return this.isValid ? gt.create(this.loc.clone(n), e).formatDateTime(this) : Ds;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? gt.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: a = !0,
    extendedZone: s = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const i = e === "extended";
    let o = Ms(this, i);
    return o += "T", o += Go(this, i, n, r, a, s), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? Ms(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Sa(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: a = !1,
    extendedZone: s = !1,
    format: i = "extended"
  } = {}) {
    return this.isValid ? (a ? "T" : "") + Go(
      this,
      i === "extended",
      n,
      e,
      r,
      s
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Sa(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Sa(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Ms(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let a = "HH:mm:ss.SSS";
    return (n || e) && (r && (a += " "), n ? a += "z" : e && (a += "ZZ")), Sa(this, a, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Ds;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", r = {}) {
    if (!this.isValid || !e.isValid)
      return Ne.invalid("created by diffing an invalid DateTime");
    const a = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, s = Ap(n).map(Ne.normalizeUnit), i = e.valueOf() > this.valueOf(), o = i ? this : e, l = i ? e : this, u = Nm(o, l, s, a);
    return i ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(ke.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? et.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n, r) {
    if (!this.isValid) return !1;
    const a = e.valueOf(), s = this.setZone(e.zone, { keepLocalTime: !0 });
    return s.startOf(n, r) <= a && a <= s.endOf(n, r);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || ke.fromObject({}, { zone: this.zone }), r = e.padding ? this < n ? -e.padding : e.padding : 0;
    let a = ["years", "months", "days", "hours", "minutes", "seconds"], s = e.unit;
    return Array.isArray(e.unit) && (a = e.unit, s = void 0), Qo(n, this.plus(r), {
      ...e,
      numeric: "always",
      units: a,
      unit: s
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? Qo(e.base || ke.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(ke.isDateTime))
      throw new vt("min requires all arguments be DateTimes");
    return $o(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(ke.isDateTime))
      throw new vt("max requires all arguments be DateTimes");
    return $o(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, r = {}) {
    const { locale: a = null, numberingSystem: s = null } = r, i = je.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return uc(i, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, r = {}) {
    return ke.fromFormatExplain(e, n, r);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(e, n = {}) {
    const { locale: r = null, numberingSystem: a = null } = n, s = je.fromOpts({
      locale: r,
      numberingSystem: a,
      defaultToEN: !0
    });
    return new lc(s, e);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(e, n, r = {}) {
    if (Te(e) || Te(n))
      throw new vt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: a = null, numberingSystem: s = null } = r, i = je.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    if (!i.equals(n.locale))
      throw new vt(
        `fromFormatParser called with a locale of ${i}, but the format parser was created for ${n.locale}`
      );
    const { result: o, zone: l, specificOffset: u, invalidReason: c } = n.explainFromTokens(e);
    return c ? ke.invalid(c) : fr(
      o,
      l,
      r,
      `format ${n.format}`,
      e,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Ba;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return hu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return np;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return vu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return yu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return gu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return wu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return bu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return ku;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return _u;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Tu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Ou;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Su;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Du;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return Cu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return xu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Mu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return rp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Au;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Eu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Pu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Fu;
  }
}
function Yr(t) {
  if (ke.isDateTime(t))
    return t;
  if (t && t.valueOf && Nn(t.valueOf()))
    return ke.fromJSDate(t);
  if (t && typeof t == "object")
    return ke.fromObject(t);
  throw new vt(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const th = {
  data() {
    return {
      /**
       * Whether the private event form is loading.
       */
      eventLoading: !1
    };
  },
  computed: {
    /**
     * Concepts with planning pod identifiers defined.
     *
     * @returns {Object}
     */
    conceptsWithEvents() {
      const t = Object.values(this.concepts).filter((n) => n.planning_pod_id), e = {};
      return t.forEach((n) => {
        e[n.slug] = n;
      }), e;
    },
    /**
     * Whether the events form can be displayed.
     *
     * @returns {Boolean}
     */
    canShowEventForm() {
      return this.subject && this.subject.slug == "event-planning" ? this.showConceptField ? this.concept : !0 : !1;
    }
  },
  watch: {
    /**
     * Subject updated watcher.
     *
     * @param {Object} subject
     */
    subject(t) {
      this.eventLoading = !1, t.slug == "event-planning" && (this.showConceptField ? this.eventLoading = !!this.activeConcept : this.eventLoading = !0);
    },
    /**
     * Concept updated watcher.
     *
     * @param {Object} concept
     */
    activeConcept(t) {
      this.eventLoading = t && this.subject && this.subject.slug == "event-planning";
    }
  },
  methods: {
    /**
     * Private event form loaded callback.
     */
    eventFrameLoaded() {
      this.iframeSizer();
    },
    /**
     * Planning Pod iframe resizer.
     *
     * This mess comes from an external Planning Pod script that resizes the
     * iframe height to fit.
     *
     * @link https://d1vpukrd9uvxxk.cloudfront.net/includes/js/plugins/iframesizer.js
     * @link https://michilehr.de/resize-iframe-by-its-content-cross-domain
     */
    iframeSizer() {
      const t = window.addEventListener ? "addEventListener" : "attachEvent", e = window[t], n = t == "attachEvent" ? "onmessage" : "message";
      e(
        n,
        ({ data: r }) => {
          r === parseInt(r) && (document.getElementById("eventFrame").height = r + "px", this.eventLoading = !1);
        },
        !1
      );
    }
  }
}, kn = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, a] of e)
    n[r] = a;
  return n;
}, nh = {
  /**
   * Component properties
   */
  props: {
    // concept data object
    concept: {
      type: Object,
      required: !0
    },
    subject: {
      type: Object,
      default: () => ({})
    },
    // current error message
    error: {
      type: String,
      required: !1,
      default: () => null
    },
    // whether state is success
    success: {
      type: Boolean,
      default: () => !1
    },
    // confirmation message content
    confirmationMessage: {
      type: String,
      default: null
    }
  },
  computed: {
    /**
     * Confirmation message content formatted for display.
     * We use this to workaround some Trix formatting. Sorry.
     *
     * @return string
     */
    confirmationMessageDisplay() {
      let t = this.confirmationMessage;
      if (t)
        return t = t.replace("<h1>", '<p class="pappasForm__feedback__headline">'), t = t.replace("</h1>", "</p>"), t = t.replace("<div>", "<p>"), t = t.replace("</div>", "</p>"), t;
    }
  }
}, rh = { class: "pappasForm__feedback__wrapper" }, ah = {
  key: 0,
  class: "pappasForm__feedback pappasForm__feedback--success"
}, sh = ["innerHTML"], ih = { class: "pappasForm__concept" }, oh = { class: "pappasForm__feedback__actions" }, lh = {
  key: 1,
  class: "pappasForm__feedback pappasForm__feedback--error"
}, uh = ["innerHTML"];
function ch(t, e, n, r, a, s) {
  return v(), x("div", rh, [
    n.success ? (v(), x("div", ah, [
      n.confirmationMessage ? (v(), x("div", {
        key: 0,
        innerHTML: s.confirmationMessageDisplay
      }, null, 8, sh)) : ne(t.$slots, "success", {
        key: 1,
        concept: n.concept,
        subject: n.subject
      }, () => [
        e[3] || (e[3] = C("p", { class: "pappasForm__feedback__headline" }, "Thank You", -1)),
        C("p", null, [
          e[1] || (e[1] = Xe(" Your message has been successfully submitted to the ")),
          C("span", ih, ze(n.concept.name) + " Team", 1),
          e[2] || (e[2] = Xe(". "))
        ])
      ]),
      C("p", oh, [
        ne(t.$slots, "success-actions", {
          reset: t.$parent.reset,
          subject: n.subject
        }, () => [
          C("a", {
            href: "",
            class: "button pappasForm__button pappasForm__button--reset",
            onClick: e[0] || (e[0] = we((...i) => t.$parent.reset && t.$parent.reset(...i), ["prevent"]))
          }, " Reset Form ")
        ])
      ])
    ])) : n.error ? (v(), x("div", lh, [
      C("p", { innerHTML: n.error }, null, 8, uh)
    ])) : I("", !0)
  ]);
}
const dh = /* @__PURE__ */ kn(nh, [["render", ch]]);
var fh = Object.defineProperty, ph = Object.defineProperties, mh = Object.getOwnPropertyDescriptors, el = Object.getOwnPropertySymbols, hh = Object.prototype.hasOwnProperty, vh = Object.prototype.propertyIsEnumerable, tl = (t, e, n) => e in t ? fh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, pr = (t, e) => {
  for (var n in e || (e = {}))
    hh.call(e, n) && tl(t, n, e[n]);
  if (el)
    for (var n of el(e))
      vh.call(e, n) && tl(t, n, e[n]);
  return t;
}, nl = (t, e) => ph(t, mh(e));
const yh = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(t) {
      this.autoscroll && t && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var t;
      const e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
      if (e) {
        const n = this.getDropdownViewport(), { top: r, bottom: a, height: s } = e.getBoundingClientRect();
        if (r < n.top)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
        if (a > n.bottom)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (n.height - s);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, gh = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let t = 0; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    open(t) {
      t && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let t = this.typeAheadPointer - 1; t >= 0; t--)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadDown() {
      for (let t = this.typeAheadPointer + 1; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadSelect() {
      const t = this.filteredOptions[this.typeAheadPointer];
      t && this.selectable(t) && this.select(t);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, wh = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(t) {
      this.mutableLoading = t;
    }
  },
  methods: {
    toggleLoading(t = null) {
      return t == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = t;
    }
  }
}, Fi = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, a] of e)
    n[r] = a;
  return n;
}, bh = {}, kh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, _h = /* @__PURE__ */ C("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), Th = [
  _h
];
function Oh(t, e) {
  return v(), x("svg", kh, Th);
}
const Sh = /* @__PURE__ */ Fi(bh, [["render", Oh]]), Dh = {}, Ch = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, xh = /* @__PURE__ */ C("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), Mh = [
  xh
];
function Ah(t, e) {
  return v(), x("svg", Ch, Mh);
}
const Eh = /* @__PURE__ */ Fi(Dh, [["render", Ah]]), rl = {
  Deselect: Sh,
  OpenIndicator: Eh
}, Ph = {
  mounted(t, { instance: e }) {
    if (e.appendToBody) {
      const {
        height: n,
        top: r,
        left: a,
        width: s
      } = e.$refs.toggle.getBoundingClientRect();
      let i = window.scrollX || window.pageXOffset, o = window.scrollY || window.pageYOffset;
      t.unbindPosition = e.calculatePosition(t, e, {
        width: s + "px",
        left: i + a + "px",
        top: o + r + n + "px"
      }), document.body.appendChild(t);
    }
  },
  unmounted(t, { instance: e }) {
    e.appendToBody && (t.unbindPosition && typeof t.unbindPosition == "function" && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
  }
};
function Fh(t) {
  const e = {};
  return Object.keys(t).sort().forEach((n) => {
    e[n] = t[n];
  }), JSON.stringify(e);
}
let Nh = 0;
function Rh() {
  return ++Nh;
}
const Vh = {
  components: pr({}, rl),
  directives: { appendToBody: Ph },
  mixins: [yh, gh, wh],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (t) => t
    },
    selectable: {
      type: Function,
      default: (t) => !0
    },
    getOptionLabel: {
      type: Function,
      default(t) {
        return typeof t == "object" ? t.hasOwnProperty(this.label) ? t[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(t)}.
https://vue-select.org/api/props.html#getoptionlabel`) : t;
      }
    },
    getOptionKey: {
      type: Function,
      default(t) {
        if (typeof t != "object")
          return t;
        try {
          return t.hasOwnProperty("id") ? t.id : Fh(t);
        } catch (e) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, t, e);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(t, e, n) {
        return (e || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(t, e) {
        return t.filter((n) => {
          let r = this.getOptionLabel(n);
          return typeof r == "number" && (r = r.toString()), this.filterBy(n, r, e);
        });
      }
    },
    createOption: {
      type: Function,
      default(t) {
        return typeof this.optionList[0] == "object" ? { [this.label]: t } : t;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (t) => ["function", "boolean"].includes(typeof t)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: t, multiple: e }) {
        return t && !e;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (t, e) => t
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(t, e, { width: n, top: r, left: a }) {
        t.style.top = r, t.style.left = a, t.style.width = n;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: t, open: e, mutableLoading: n }) {
        return t ? !1 : e && !n;
      }
    },
    uid: {
      type: [String, Number],
      default: () => Rh()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let t = this.modelValue;
      return this.isTrackingValues && (t = this.$data._value), t != null && t !== "" ? [].concat(t) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const t = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: pr({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (e) => this.search = e.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: t,
        listFooter: t,
        header: nl(pr({}, t), { deselect: this.deselect }),
        footer: nl(pr({}, t), { deselect: this.deselect })
      };
    },
    childComponents() {
      return pr(pr({}, rl), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const t = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return t;
      const e = this.search.length ? this.filter(t, this.search, this) : t;
      if (this.taggable && this.search.length) {
        const n = this.createOption(this.search);
        this.optionExists(n) || e.unshift(n);
      }
      return e;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(t, e) {
      const n = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(t, e, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && n() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(t) {
        this.isTrackingValues && this.setInternalValueFromOptions(t);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(t) {
      this.$emit(t ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(t) {
      Array.isArray(t) ? this.$data._value = t.map((e) => this.findOptionFromReducedValue(e)) : this.$data._value = this.findOptionFromReducedValue(t);
    },
    select(t) {
      this.$emit("option:selecting", t), this.isOptionSelected(t) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(t) : (this.taggable && !this.optionExists(t) && (this.$emit("option:created", t), this.pushTag(t)), this.multiple && (t = this.selectedValue.concat(t)), this.updateValue(t), this.$emit("option:selected", t)), this.onAfterSelect(t);
    },
    deselect(t) {
      this.$emit("option:deselecting", t), this.updateValue(this.selectedValue.filter((e) => !this.optionComparator(e, t))), this.$emit("option:deselected", t);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(t) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(t) {
      typeof this.modelValue > "u" && (this.$data._value = t), t !== null && (Array.isArray(t) ? t = t.map((e) => this.reduce(e)) : t = this.reduce(t)), this.$emit("update:modelValue", t);
    },
    toggleDropdown(t) {
      const e = t.target !== this.searchEl;
      e && t.preventDefault();
      const n = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || n.filter(Boolean).some((r) => r.contains(t.target) || r === t.target)) {
        t.preventDefault();
        return;
      }
      this.open && e ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(t) {
      return this.selectedValue.some((e) => this.optionComparator(e, t));
    },
    isOptionDeselectable(t) {
      return this.isOptionSelected(t) && this.deselectFromDropdown;
    },
    optionComparator(t, e) {
      return this.getOptionKey(t) === this.getOptionKey(e);
    },
    findOptionFromReducedValue(t) {
      const e = (r) => JSON.stringify(this.reduce(r)) === JSON.stringify(t), n = [...this.options, ...this.pushedTags].filter(e);
      return n.length === 1 ? n[0] : n.find((r) => this.optionComparator(r, this.$data._value)) || t;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let t = null;
        this.multiple && (t = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(t);
      }
    },
    optionExists(t) {
      return this.optionList.some((e) => this.optionComparator(e, t));
    },
    normalizeOptionForSlot(t) {
      return typeof t == "object" ? t : { [this.label]: t };
    },
    pushTag(t) {
      this.pushedTags.push(t);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: t, multiple: e } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: t, multiple: e }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(t) {
      const e = (a) => (a.preventDefault(), !this.isComposing && this.typeAheadSelect()), n = {
        8: (a) => this.maybeDeleteValue(),
        9: (a) => this.onTab(),
        27: (a) => this.onEscape(),
        38: (a) => (a.preventDefault(), this.typeAheadUp()),
        40: (a) => (a.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((a) => n[a] = e);
      const r = this.mapKeydown(n, this);
      if (typeof r[t.keyCode] == "function")
        return r[t.keyCode](t);
    }
  }
}, Ih = ["dir"], Lh = ["id", "aria-expanded", "aria-owns"], $h = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, Yh = ["disabled", "title", "aria-label", "onClick"], Uh = {
  ref: "actions",
  class: "vs__actions"
}, Bh = ["disabled"], Wh = { class: "vs__spinner" }, jh = ["id"], Hh = ["id", "aria-selected", "onMouseover", "onClick"], qh = {
  key: 0,
  class: "vs__no-options"
}, zh = /* @__PURE__ */ Xe(" Sorry, no matching options. "), Zh = ["id"];
function Gh(t, e, n, r, a, s) {
  const i = Bl("append-to-body");
  return v(), x("div", {
    dir: n.dir,
    class: pe(["v-select", s.stateClasses])
  }, [
    ne(t.$slots, "header", Ye(Ge(s.scope.header))),
    C("div", {
      id: `vs${n.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": s.dropdownOpen.toString(),
      "aria-owns": `vs${n.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: e[1] || (e[1] = (o) => s.toggleDropdown(o))
    }, [
      C("div", $h, [
        (v(!0), x(ve, null, Re(s.selectedValue, (o, l) => ne(t.$slots, "selected-option-container", {
          option: s.normalizeOptionForSlot(o),
          deselect: s.deselect,
          multiple: n.multiple,
          disabled: n.disabled
        }, () => [
          (v(), x("span", {
            key: n.getOptionKey(o),
            class: "vs__selected"
          }, [
            ne(t.$slots, "selected-option", Ye(Ge(s.normalizeOptionForSlot(o))), () => [
              Xe(ze(n.getOptionLabel(o)), 1)
            ]),
            n.multiple ? (v(), x("button", {
              key: 0,
              ref_for: !0,
              ref: (u) => a.deselectButtons[l] = u,
              disabled: n.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${n.getOptionLabel(o)}`,
              "aria-label": `Deselect ${n.getOptionLabel(o)}`,
              onClick: (u) => s.deselect(o)
            }, [
              (v(), fe(Pn(s.childComponents.Deselect)))
            ], 8, Yh)) : I("", !0)
          ]))
        ])), 256)),
        ne(t.$slots, "search", Ye(Ge(s.scope.search)), () => [
          C("input", Be({ class: "vs__search" }, s.scope.search.attributes, fd(s.scope.search.events)), null, 16)
        ])
      ], 512),
      C("div", Uh, [
        _t(C("button", {
          ref: "clearButton",
          disabled: n.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: e[0] || (e[0] = (...o) => s.clearSelection && s.clearSelection(...o))
        }, [
          (v(), fe(Pn(s.childComponents.Deselect)))
        ], 8, Bh), [
          [Fn, s.showClearButton]
        ]),
        ne(t.$slots, "open-indicator", Ye(Ge(s.scope.openIndicator)), () => [
          n.noDrop ? I("", !0) : (v(), fe(Pn(s.childComponents.OpenIndicator), Ye(Be({ key: 0 }, s.scope.openIndicator.attributes)), null, 16))
        ]),
        ne(t.$slots, "spinner", Ye(Ge(s.scope.spinner)), () => [
          _t(C("div", Wh, "Loading...", 512), [
            [Fn, t.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, Lh),
    He(Yn, { name: n.transition }, {
      default: _e(() => [
        s.dropdownOpen ? _t((v(), x("ul", {
          id: `vs${n.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${n.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: e[2] || (e[2] = we((...o) => s.onMousedown && s.onMousedown(...o), ["prevent"])),
          onMouseup: e[3] || (e[3] = (...o) => s.onMouseUp && s.onMouseUp(...o))
        }, [
          ne(t.$slots, "list-header", Ye(Ge(s.scope.listHeader))),
          (v(!0), x(ve, null, Re(s.filteredOptions, (o, l) => (v(), x("li", {
            id: `vs${n.uid}__option-${l}`,
            key: n.getOptionKey(o),
            role: "option",
            class: pe(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": s.isOptionDeselectable(o) && l === t.typeAheadPointer,
              "vs__dropdown-option--selected": s.isOptionSelected(o),
              "vs__dropdown-option--highlight": l === t.typeAheadPointer,
              "vs__dropdown-option--disabled": !n.selectable(o)
            }]),
            "aria-selected": l === t.typeAheadPointer ? !0 : null,
            onMouseover: (u) => n.selectable(o) ? t.typeAheadPointer = l : null,
            onClick: we((u) => n.selectable(o) ? s.select(o) : null, ["prevent", "stop"])
          }, [
            ne(t.$slots, "option", Ye(Ge(s.normalizeOptionForSlot(o))), () => [
              Xe(ze(n.getOptionLabel(o)), 1)
            ])
          ], 42, Hh))), 128)),
          s.filteredOptions.length === 0 ? (v(), x("li", qh, [
            ne(t.$slots, "no-options", Ye(Ge(s.scope.noOptions)), () => [
              zh
            ])
          ])) : I("", !0),
          ne(t.$slots, "list-footer", Ye(Ge(s.scope.listFooter)))
        ], 40, jh)), [
          [i]
        ]) : (v(), x("ul", {
          key: 1,
          id: `vs${n.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, Zh))
      ]),
      _: 3
    }, 8, ["name"]),
    ne(t.$slots, "footer", Ye(Ge(s.scope.footer)))
  ], 10, Ih);
}
const yn = /* @__PURE__ */ Fi(Vh, [["render", Gh]]);
function Yt(t) {
  "@babel/helpers - typeof";
  return Yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yt(t);
}
function ye(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function ce(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function me(t) {
  ce(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || Yt(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function hn(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Gt(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), s = new Date(n.getTime());
  s.setMonth(n.getMonth() + r + 1, 0);
  var i = s.getDate();
  return a >= i ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), a), n);
}
function mc(t, e) {
  if (ce(2, arguments), !e || Yt(e) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = e.years ? ye(e.years) : 0, r = e.months ? ye(e.months) : 0, a = e.weeks ? ye(e.weeks) : 0, s = e.days ? ye(e.days) : 0, i = e.hours ? ye(e.hours) : 0, o = e.minutes ? ye(e.minutes) : 0, l = e.seconds ? ye(e.seconds) : 0, u = me(t), c = r || n ? Gt(u, r + n * 12) : u, d = s || a ? hn(c, s + a * 7) : c, p = o + i * 60, m = l + p * 60, h = m * 1e3, O = new Date(d.getTime() + h);
  return O;
}
function Jh(t, e) {
  ce(2, arguments);
  var n = me(t).getTime(), r = ye(e);
  return new Date(n + r);
}
var Xh = {};
function fn() {
  return Xh;
}
function tr(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = fn(), d = ye((n = (r = (a = (s = e == null ? void 0 : e.weekStartsOn) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = me(t), m = p.getDay(), h = (m < d ? 7 : 0) + m - d;
  return p.setDate(p.getDate() - h), p.setHours(0, 0, 0, 0), p;
}
function qa(t) {
  return ce(1, arguments), tr(t, {
    weekStartsOn: 1
  });
}
function Qh(t) {
  ce(1, arguments);
  var e = me(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = qa(r), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
  var i = qa(s);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= i.getTime() ? n : n - 1;
}
function Kh(t) {
  ce(1, arguments);
  var e = Qh(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = qa(n);
  return r;
}
function za(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function al(t) {
  ce(1, arguments);
  var e = me(t);
  return e.setHours(0, 0, 0, 0), e;
}
var ev = 864e5;
function tv(t, e) {
  ce(2, arguments);
  var n = al(t), r = al(e), a = n.getTime() - za(n), s = r.getTime() - za(r);
  return Math.round((a - s) / ev);
}
function nv(t, e) {
  ce(2, arguments);
  var n = ye(e), r = n * 3;
  return Gt(t, r);
}
function Ni(t, e) {
  ce(2, arguments);
  var n = ye(e);
  return Gt(t, n * 12);
}
var Ri = 6e4, Vi = 36e5, rv = 1e3;
function hc(t) {
  return ce(1, arguments), t instanceof Date || Yt(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Gr(t) {
  if (ce(1, arguments), !hc(t) && typeof t != "number")
    return !1;
  var e = me(t);
  return !isNaN(Number(e));
}
function sl(t) {
  ce(1, arguments);
  var e = me(t), n = Math.floor(e.getMonth() / 3) + 1;
  return n;
}
function vc(t, e) {
  var n;
  ce(1, arguments);
  var r = t || {}, a = me(r.start), s = me(r.end), i = s.getTime();
  if (!(a.getTime() <= i))
    throw new RangeError("Invalid interval");
  var o = [], l = a;
  l.setHours(0, 0, 0, 0);
  var u = Number((n = void 0) !== null && n !== void 0 ? n : 1);
  if (u < 1 || isNaN(u)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= i; )
    o.push(me(l)), l.setDate(l.getDate() + u), l.setHours(0, 0, 0, 0);
  return o;
}
function na(t) {
  ce(1, arguments);
  var e = me(t), n = e.getMonth(), r = n - n % 3;
  return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
}
function av(t) {
  ce(1, arguments);
  var e = t, n = me(e.start), r = me(e.end), a = r.getTime();
  if (!(n.getTime() <= a))
    throw new RangeError("Invalid interval");
  var s = na(n), i = na(r);
  a = i.getTime();
  for (var o = [], l = s; l.getTime() <= a; )
    o.push(me(l)), l = nv(l, 1);
  return o;
}
function sv(t) {
  ce(1, arguments);
  var e = me(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function iv(t) {
  ce(1, arguments);
  var e = me(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function ov(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = fn(), d = ye((n = (r = (a = (s = e == null ? void 0 : e.weekStartsOn) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = me(t), m = p.getDay(), h = (m < d ? -7 : 0) + 6 - (m - d);
  return p.setDate(p.getDate() + h), p.setHours(23, 59, 59, 999), p;
}
function il(t) {
  ce(1, arguments);
  var e = me(t), n = e.getMonth(), r = n - n % 3 + 3;
  return e.setMonth(r, 0), e.setHours(23, 59, 59, 999), e;
}
function yc(t, e) {
  ce(2, arguments);
  var n = ye(e);
  return Jh(t, -n);
}
var lv = 864e5;
function uv(t) {
  ce(1, arguments);
  var e = me(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), a = n - r;
  return Math.floor(a / lv) + 1;
}
function Tr(t) {
  ce(1, arguments);
  var e = 1, n = me(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function gc(t) {
  ce(1, arguments);
  var e = me(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Tr(r), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(n, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var i = Tr(s);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= i.getTime() ? n : n - 1;
}
function cv(t) {
  ce(1, arguments);
  var e = gc(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Tr(n);
  return r;
}
var dv = 6048e5;
function wc(t) {
  ce(1, arguments);
  var e = me(t), n = Tr(e).getTime() - cv(e).getTime();
  return Math.round(n / dv) + 1;
}
function nr(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = fn(), d = ye((n = (r = (a = (s = e == null ? void 0 : e.weekStartsOn) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = me(t), m = p.getUTCDay(), h = (m < d ? 7 : 0) + m - d;
  return p.setUTCDate(p.getUTCDate() - h), p.setUTCHours(0, 0, 0, 0), p;
}
function Ii(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = me(t), d = c.getUTCFullYear(), p = fn(), m = ye((n = (r = (a = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d + 1, 0, m), h.setUTCHours(0, 0, 0, 0);
  var O = nr(h, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, m), g.setUTCHours(0, 0, 0, 0);
  var b = nr(g, e);
  return c.getTime() >= O.getTime() ? d + 1 : c.getTime() >= b.getTime() ? d : d - 1;
}
function fv(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = fn(), d = ye((n = (r = (a = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = Ii(t, e), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(p, 0, d), m.setUTCHours(0, 0, 0, 0);
  var h = nr(m, e);
  return h;
}
var pv = 6048e5;
function bc(t, e) {
  ce(1, arguments);
  var n = me(t), r = nr(n, e).getTime() - fv(n, e).getTime();
  return Math.round(r / pv) + 1;
}
function qe(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var Cn = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return qe(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : qe(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return qe(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return qe(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return qe(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return qe(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return qe(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, a = e.getUTCMilliseconds(), s = Math.floor(a * Math.pow(10, r - 3));
    return qe(s, n.length);
  }
}, mr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, mv = {
  // Era
  G: function(e, n, r) {
    var a = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var a = e.getUTCFullYear(), s = a > 0 ? a : 1 - a;
      return r.ordinalNumber(s, {
        unit: "year"
      });
    }
    return Cn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, a) {
    var s = Ii(e, a), i = s > 0 ? s : 1 - s;
    if (n === "YY") {
      var o = i % 100;
      return qe(o, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : qe(i, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = gc(e);
    return qe(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return qe(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return qe(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return qe(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Cn.M(e, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return qe(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, a) {
    var s = bc(e, a);
    return n === "wo" ? r.ordinalNumber(s, {
      unit: "week"
    }) : qe(s, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var a = wc(e);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : qe(a, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Cn.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var a = uv(e);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : qe(a, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var a = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, a) {
    var s = e.getUTCDay(), i = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return qe(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, a) {
    var s = e.getUTCDay(), i = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return qe(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var a = e.getUTCDay(), s = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(s);
      case "ii":
        return qe(s, n.length);
      case "io":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var a = e.getUTCHours(), s = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var a = e.getUTCHours(), s;
    switch (a === 12 ? s = mr.noon : a === 0 ? s = mr.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var a = e.getUTCHours(), s;
    switch (a >= 17 ? s = mr.evening : a >= 12 ? s = mr.afternoon : a >= 4 ? s = mr.morning : s = mr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var a = e.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Cn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Cn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var a = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : qe(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var a = e.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : qe(a, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Cn.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Cn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Cn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, a) {
    var s = a._originalDate || e, i = s.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return ll(i);
      case "XXXX":
      case "XX":
        return qn(i);
      case "XXXXX":
      case "XXX":
      default:
        return qn(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, a) {
    var s = a._originalDate || e, i = s.getTimezoneOffset();
    switch (n) {
      case "x":
        return ll(i);
      case "xxxx":
      case "xx":
        return qn(i);
      case "xxxxx":
      case "xxx":
      default:
        return qn(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, a) {
    var s = a._originalDate || e, i = s.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ol(i, ":");
      case "OOOO":
      default:
        return "GMT" + qn(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, a) {
    var s = a._originalDate || e, i = s.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ol(i, ":");
      case "zzzz":
      default:
        return "GMT" + qn(i, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, a) {
    var s = a._originalDate || e, i = Math.floor(s.getTime() / 1e3);
    return qe(i, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, a) {
    var s = a._originalDate || e, i = s.getTime();
    return qe(i, n.length);
  }
};
function ol(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), s = r % 60;
  if (s === 0)
    return n + String(a);
  var i = e;
  return n + String(a) + i + qe(s, 2);
}
function ll(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + qe(Math.abs(t) / 60, 2);
  }
  return qn(t, e);
}
function qn(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t), s = qe(Math.floor(a / 60), 2), i = qe(a % 60, 2);
  return r + s + n + i;
}
var ul = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, kc = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, hv = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], a = r[1], s = r[2];
  if (!s)
    return ul(e, n);
  var i;
  switch (a) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", ul(a, n)).replace("{{time}}", kc(s, n));
}, oi = {
  p: kc,
  P: hv
}, vv = ["D", "DD"], yv = ["YY", "YYYY"];
function _c(t) {
  return vv.indexOf(t) !== -1;
}
function Tc(t) {
  return yv.indexOf(t) !== -1;
}
function Za(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var gv = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, wv = function(e, n, r) {
  var a, s = gv[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
function As(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var bv = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, kv = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, _v = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Tv = {
  date: As({
    formats: bv,
    defaultWidth: "full"
  }),
  time: As({
    formats: kv,
    defaultWidth: "full"
  }),
  dateTime: As({
    formats: _v,
    defaultWidth: "full"
  })
}, Ov = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Sv = function(e, n, r, a) {
  return Ov[e];
};
function Ur(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && t.formattingValues) {
      var s = t.defaultFormattingWidth || t.defaultWidth, i = n != null && n.width ? String(n.width) : s;
      a = t.formattingValues[i] || t.formattingValues[s];
    } else {
      var o = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[l] || t.values[o];
    }
    var u = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[u];
  };
}
var Dv = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Cv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Mv = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Av = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ev = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Pv = function(e, n) {
  var r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Fv = {
  ordinalNumber: Pv,
  era: Ur({
    values: Dv,
    defaultWidth: "wide"
  }),
  quarter: Ur({
    values: Cv,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Ur({
    values: xv,
    defaultWidth: "wide"
  }),
  day: Ur({
    values: Mv,
    defaultWidth: "wide"
  }),
  dayPeriod: Ur({
    values: Av,
    defaultWidth: "wide",
    formattingValues: Ev,
    defaultFormattingWidth: "wide"
  })
};
function Br(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], s = e.match(a);
    if (!s)
      return null;
    var i = s[0], o = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? Rv(o, function(d) {
      return d.test(i);
    }) : Nv(o, function(d) {
      return d.test(i);
    }), u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? n.valueCallback(u) : u;
    var c = e.slice(i.length);
    return {
      value: u,
      rest: c
    };
  };
}
function Nv(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function Rv(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Vv(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r) return null;
    var a = r[0], s = e.match(t.parsePattern);
    if (!s) return null;
    var i = t.valueCallback ? t.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var o = e.slice(a.length);
    return {
      value: i,
      rest: o
    };
  };
}
var Iv = /^(\d+)(th|st|nd|rd)?/i, Lv = /\d+/i, $v = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Yv = {
  any: [/^b/i, /^(a|c)/i]
}, Uv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Bv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Wv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, jv = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Hv = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, qv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, zv = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Zv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Gv = {
  ordinalNumber: Vv({
    matchPattern: Iv,
    parsePattern: Lv,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Br({
    matchPatterns: $v,
    defaultMatchWidth: "wide",
    parsePatterns: Yv,
    defaultParseWidth: "any"
  }),
  quarter: Br({
    matchPatterns: Uv,
    defaultMatchWidth: "wide",
    parsePatterns: Bv,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Br({
    matchPatterns: Wv,
    defaultMatchWidth: "wide",
    parsePatterns: jv,
    defaultParseWidth: "any"
  }),
  day: Br({
    matchPatterns: Hv,
    defaultMatchWidth: "wide",
    parsePatterns: qv,
    defaultParseWidth: "any"
  }),
  dayPeriod: Br({
    matchPatterns: zv,
    defaultMatchWidth: "any",
    parsePatterns: Zv,
    defaultParseWidth: "any"
  })
}, Oc = {
  code: "en-US",
  formatDistance: wv,
  formatLong: Tv,
  formatRelative: Sv,
  localize: Fv,
  match: Gv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Jv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Xv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Qv = /^'([^]*?)'?$/, Kv = /''/g, ey = /[a-zA-Z]/;
function Rn(t, e, n) {
  var r, a, s, i, o, l, u, c, d, p, m, h, O, g, b, w, M, T;
  ce(2, arguments);
  var E = String(e), $ = fn(), V = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : $.locale) !== null && r !== void 0 ? r : Oc, Q = ye((s = (i = (o = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (u = n.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && o !== void 0 ? o : $.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = $.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(Q >= 1 && Q <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var W = ye((m = (h = (O = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (b = n.locale) === null || b === void 0 || (w = b.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && O !== void 0 ? O : $.weekStartsOn) !== null && h !== void 0 ? h : (M = $.locale) === null || M === void 0 || (T = M.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(W >= 0 && W <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!V.localize)
    throw new RangeError("locale must contain localize property");
  if (!V.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var k = me(t);
  if (!Gr(k))
    throw new RangeError("Invalid time value");
  var F = za(k), H = yc(k, F), G = {
    firstWeekContainsDate: Q,
    weekStartsOn: W,
    locale: V,
    _originalDate: k
  }, Y = E.match(Xv).map(function(S) {
    var R = S[0];
    if (R === "p" || R === "P") {
      var N = oi[R];
      return N(S, V.formatLong);
    }
    return S;
  }).join("").match(Jv).map(function(S) {
    if (S === "''")
      return "'";
    var R = S[0];
    if (R === "'")
      return ty(S);
    var N = mv[R];
    if (N)
      return !(n != null && n.useAdditionalWeekYearTokens) && Tc(S) && Za(S, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && _c(S) && Za(S, e, String(t)), N(H, S, V.localize, G);
    if (R.match(ey))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + R + "`");
    return S;
  }).join("");
  return Y;
}
function ty(t) {
  var e = t.match(Qv);
  return e ? e[1].replace(Kv, "'") : t;
}
function ny(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function ry(t) {
  ce(1, arguments);
  var e = me(t), n = e.getDay();
  return n;
}
function ay(t) {
  ce(1, arguments);
  var e = me(t), n = e.getFullYear(), r = e.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Jt(t) {
  ce(1, arguments);
  var e = me(t), n = e.getHours();
  return n;
}
var sy = 6048e5;
function iy(t) {
  ce(1, arguments);
  var e = me(t), n = qa(e).getTime() - Kh(e).getTime();
  return Math.round(n / sy) + 1;
}
function un(t) {
  ce(1, arguments);
  var e = me(t), n = e.getMinutes();
  return n;
}
function Fe(t) {
  ce(1, arguments);
  var e = me(t), n = e.getMonth();
  return n;
}
function Or(t) {
  ce(1, arguments);
  var e = me(t), n = e.getSeconds();
  return n;
}
function oy(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = me(t), d = c.getFullYear(), p = fn(), m = ye((n = (r = (a = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setFullYear(d + 1, 0, m), h.setHours(0, 0, 0, 0);
  var O = tr(h, e), g = /* @__PURE__ */ new Date(0);
  g.setFullYear(d, 0, m), g.setHours(0, 0, 0, 0);
  var b = tr(g, e);
  return c.getTime() >= O.getTime() ? d + 1 : c.getTime() >= b.getTime() ? d : d - 1;
}
function ly(t, e) {
  var n, r, a, s, i, o, l, u;
  ce(1, arguments);
  var c = fn(), d = ye((n = (r = (a = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (i = e.locale) === null || i === void 0 || (o = i.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = oy(t, e), m = /* @__PURE__ */ new Date(0);
  m.setFullYear(p, 0, d), m.setHours(0, 0, 0, 0);
  var h = tr(m, e);
  return h;
}
var uy = 6048e5;
function cy(t, e) {
  ce(1, arguments);
  var n = me(t), r = tr(n, e).getTime() - ly(n, e).getTime();
  return Math.round(r / uy) + 1;
}
function Me(t) {
  return ce(1, arguments), me(t).getFullYear();
}
function ra(t, e) {
  ce(2, arguments);
  var n = me(t), r = me(e);
  return n.getTime() > r.getTime();
}
function aa(t, e) {
  ce(2, arguments);
  var n = me(t), r = me(e);
  return n.getTime() < r.getTime();
}
function wr(t, e) {
  ce(2, arguments);
  var n = me(t), r = me(e);
  return n.getTime() === r.getTime();
}
function cl(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function dy(t, e) {
  if (t) {
    if (typeof t == "string") return cl(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? cl(t, e) : void 0;
  }
}
function dl(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = dy(t)) || e) {
      n && (t = n);
      var r = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, i = !0, o = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var u = n.next();
      return i = u.done, u;
    },
    e: function(u) {
      o = !0, s = u;
    },
    f: function() {
      try {
        i || n.return == null || n.return();
      } finally {
        if (o) throw s;
      }
    }
  };
}
function ue(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function li(t, e) {
  return li = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, li(t, e);
}
function Ve(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && li(t, e);
}
function Ga(t) {
  return Ga = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Ga(t);
}
function Sc() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Sc = function() {
    return !!t;
  })();
}
function fy(t, e) {
  if (e && (Yt(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return ue(t);
}
function Ie(t) {
  var e = Sc();
  return function() {
    var n, r = Ga(t);
    if (e) {
      var a = Ga(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else n = r.apply(this, arguments);
    return fy(this, n);
  };
}
function Ee(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function py(t, e) {
  if (Yt(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (Yt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Dc(t) {
  var e = py(t, "string");
  return Yt(e) == "symbol" ? e : e + "";
}
function my(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Dc(r.key), r);
  }
}
function Pe(t, e, n) {
  return e && my(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function oe(t, e, n) {
  return (e = Dc(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var hy = 10, Cc = /* @__PURE__ */ function() {
  function t() {
    Ee(this, t), oe(this, "priority", void 0), oe(this, "subPriority", 0);
  }
  return Pe(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), vy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n(r, a, s, i, o) {
    var l;
    return Ee(this, n), l = e.call(this), l.value = r, l.validateValue = a, l.setValue = s, l.priority = i, o && (l.subPriority = o), l;
  }
  return Pe(n, [{
    key: "validate",
    value: function(a, s) {
      return this.validateValue(a, this.value, s);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return this.setValue(a, s, this.value, i);
    }
  }]), n;
}(Cc), yy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", hy), oe(ue(r), "subPriority", -1), r;
  }
  return Pe(n, [{
    key: "set",
    value: function(a, s) {
      if (s.timestampIsSet)
        return a;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), i.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), i;
    }
  }]), n;
}(Cc), We = /* @__PURE__ */ function() {
  function t() {
    Ee(this, t), oe(this, "incompatibleTokens", void 0), oe(this, "priority", void 0), oe(this, "subPriority", void 0);
  }
  return Pe(t, [{
    key: "run",
    value: function(n, r, a, s) {
      var i = this.parse(n, r, a, s);
      return i ? {
        setter: new vy(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, a) {
      return !0;
    }
  }]), t;
}(), gy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 140), oe(ue(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(a, {
            width: "abbreviated"
          }) || i.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(a, {
            width: "wide"
          }) || i.era(a, {
            width: "abbreviated"
          }) || i.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return s.era = i, a.setUTCFullYear(i, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), rt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, sn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function at(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ke(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function on(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, s = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * Vi + s * Ri + i * rv),
    rest: e.slice(n[0].length)
  };
}
function xc(t) {
  return Ke(rt.anyDigitsSigned, t);
}
function nt(t, e) {
  switch (t) {
    case 1:
      return Ke(rt.singleDigit, e);
    case 2:
      return Ke(rt.twoDigits, e);
    case 3:
      return Ke(rt.threeDigits, e);
    case 4:
      return Ke(rt.fourDigits, e);
    default:
      return Ke(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function Ja(t, e) {
  switch (t) {
    case 1:
      return Ke(rt.singleDigitSigned, e);
    case 2:
      return Ke(rt.twoDigitsSigned, e);
    case 3:
      return Ke(rt.threeDigitsSigned, e);
    case 4:
      return Ke(rt.fourDigitsSigned, e);
    default:
      return Ke(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Li(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Mc(t, e) {
  var n = e > 0, r = n ? e : 1 - e, a;
  if (r <= 50)
    a = t || 100;
  else {
    var s = r + 50, i = Math.floor(s / 100) * 100, o = t >= s % 100;
    a = t + i - (o ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function Ac(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var wy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 130), oe(ue(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      var o = function(u) {
        return {
          year: u,
          isTwoDigitYear: s === "yy"
        };
      };
      switch (s) {
        case "y":
          return at(nt(4, a), o);
        case "yo":
          return at(i.ordinalNumber(a, {
            unit: "year"
          }), o);
        default:
          return at(nt(s.length, a), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      var o = a.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var l = Mc(i.year, o);
        return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var u = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), by = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 130), oe(ue(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      var o = function(u) {
        return {
          year: u,
          isTwoDigitYear: s === "YY"
        };
      };
      switch (s) {
        case "Y":
          return at(nt(4, a), o);
        case "Yo":
          return at(i.ordinalNumber(a, {
            unit: "year"
          }), o);
        default:
          return at(nt(s.length, a), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(a, s, i, o) {
      var l = Ii(a, o);
      if (i.isTwoDigitYear) {
        var u = Mc(i.year, l);
        return a.setUTCFullYear(u, 0, o.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), nr(a, o);
      }
      var c = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return a.setUTCFullYear(c, 0, o.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), nr(a, o);
    }
  }]), n;
}(We), ky = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 130), oe(ue(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s) {
      return Ja(s === "R" ? 4 : s.length, a);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(i, 0, 4), o.setUTCHours(0, 0, 0, 0), Tr(o);
    }
  }]), n;
}(We), _y = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 130), oe(ue(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s) {
      return Ja(s === "u" ? 4 : s.length, a);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCFullYear(i, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Ty = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 120), oe(ue(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "Q":
        case "QQ":
          return nt(s.length, a);
        case "Qo":
          return i.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMonth((i - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Oy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 120), oe(ue(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "q":
        case "qq":
          return nt(s.length, a);
        case "qo":
          return i.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMonth((i - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Sy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), oe(ue(r), "priority", 110), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      var o = function(u) {
        return u - 1;
      };
      switch (s) {
        case "M":
          return at(Ke(rt.month, a), o);
        case "MM":
          return at(nt(2, a), o);
        case "Mo":
          return at(i.ordinalNumber(a, {
            unit: "month"
          }), o);
        case "MMM":
          return i.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(a, {
            width: "wide",
            context: "formatting"
          }) || i.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMonth(i, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Dy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 110), oe(ue(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      var o = function(u) {
        return u - 1;
      };
      switch (s) {
        case "L":
          return at(Ke(rt.month, a), o);
        case "LL":
          return at(nt(2, a), o);
        case "Lo":
          return at(i.ordinalNumber(a, {
            unit: "month"
          }), o);
        case "LLL":
          return i.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(a, {
            width: "wide",
            context: "standalone"
          }) || i.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMonth(i, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We);
function Cy(t, e, n) {
  ce(2, arguments);
  var r = me(t), a = ye(e), s = bc(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - s * 7), r;
}
var xy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 100), oe(ue(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "w":
          return Ke(rt.week, a);
        case "wo":
          return i.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(a, s, i, o) {
      return nr(Cy(a, i, o), o);
    }
  }]), n;
}(We);
function My(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e), a = wc(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var Ay = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 100), oe(ue(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "I":
          return Ke(rt.week, a);
        case "Io":
          return i.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return Tr(My(a, i));
    }
  }]), n;
}(We), Ey = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Py = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Fy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "subPriority", 1), oe(ue(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "d":
          return Ke(rt.date, a);
        case "do":
          return i.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      var i = a.getUTCFullYear(), o = Ac(i), l = a.getUTCMonth();
      return o ? s >= 1 && s <= Py[l] : s >= 1 && s <= Ey[l];
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCDate(i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Ny = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "subpriority", 1), oe(ue(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "D":
        case "DD":
          return Ke(rt.dayOfYear, a);
        case "Do":
          return i.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      var i = a.getUTCFullYear(), o = Ac(i);
      return o ? s >= 1 && s <= 366 : s >= 1 && s <= 365;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMonth(0, i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We);
function $i(t, e, n) {
  var r, a, s, i, o, l, u, c;
  ce(2, arguments);
  var d = fn(), p = ye((r = (a = (s = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && a !== void 0 ? a : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = me(t), h = ye(e), O = m.getUTCDay(), g = h % 7, b = (g + 7) % 7, w = (b < p ? 7 : 0) + h - O;
  return m.setUTCDate(m.getUTCDate() + w), m;
}
var Ry = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(a, s, i, o) {
      return a = $i(a, i, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Vy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i, o) {
      var l = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + o.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "e":
        case "ee":
          return at(nt(s.length, a), l);
        case "eo":
          return at(i.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "eee":
          return i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(a, s, i, o) {
      return a = $i(a, i, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Iy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i, o) {
      var l = function(c) {
        var d = Math.floor((c - 1) / 7) * 7;
        return (c + o.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "c":
        case "cc":
          return at(nt(s.length, a), l);
        case "co":
          return at(i.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "ccc":
          return i.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(a, {
            width: "wide",
            context: "standalone"
          }) || i.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(a, s, i, o) {
      return a = $i(a, i, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We);
function Ly(t, e) {
  ce(2, arguments);
  var n = ye(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = me(t), s = a.getUTCDay(), i = n % 7, o = (i + 7) % 7, l = (o < r ? 7 : 0) + n - s;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var $y = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 90), oe(ue(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      var o = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (s) {
        case "i":
        case "ii":
          return nt(s.length, a);
        case "io":
          return i.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return at(i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiii":
          return at(i.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiiii":
          return at(i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiii":
        default:
          return at(i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 7;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a = Ly(a, i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(We), Yy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 80), oe(ue(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCHours(Li(i), 0, 0, 0), a;
    }
  }]), n;
}(We), Uy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 80), oe(ue(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCHours(Li(i), 0, 0, 0), a;
    }
  }]), n;
}(We), By = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 80), oe(ue(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCHours(Li(i), 0, 0, 0), a;
    }
  }]), n;
}(We), Wy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 70), oe(ue(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "h":
          return Ke(rt.hour12h, a);
        case "ho":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 12;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      var o = a.getUTCHours() >= 12;
      return o && i < 12 ? a.setUTCHours(i + 12, 0, 0, 0) : !o && i === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(We), jy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 70), oe(ue(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "H":
          return Ke(rt.hour23h, a);
        case "Ho":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 23;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(We), Hy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 70), oe(ue(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "K":
          return Ke(rt.hour11h, a);
        case "Ko":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      var o = a.getUTCHours() >= 12;
      return o && i < 12 ? a.setUTCHours(i + 12, 0, 0, 0) : a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(We), qy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 70), oe(ue(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "k":
          return Ke(rt.hour24h, a);
        case "ko":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 1 && s <= 24;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      var o = i <= 24 ? i % 24 : i;
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(We), zy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 60), oe(ue(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "m":
          return Ke(rt.minute, a);
        case "mo":
          return i.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMinutes(i, 0, 0), a;
    }
  }]), n;
}(We), Zy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 50), oe(ue(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s, i) {
      switch (s) {
        case "s":
          return Ke(rt.second, a);
        case "so":
          return i.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return nt(s.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCSeconds(i, 0), a;
    }
  }]), n;
}(We), Gy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 30), oe(ue(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s) {
      var i = function(l) {
        return Math.floor(l * Math.pow(10, -s.length + 3));
      };
      return at(nt(s.length, a), i);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return a.setUTCMilliseconds(i), a;
    }
  }]), n;
}(We), Jy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 10), oe(ue(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s) {
      switch (s) {
        case "X":
          return on(sn.basicOptionalMinutes, a);
        case "XX":
          return on(sn.basic, a);
        case "XXXX":
          return on(sn.basicOptionalSeconds, a);
        case "XXXXX":
          return on(sn.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return on(sn.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return s.timestampIsSet ? a : new Date(a.getTime() - i);
    }
  }]), n;
}(We), Xy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 10), oe(ue(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a, s) {
      switch (s) {
        case "x":
          return on(sn.basicOptionalMinutes, a);
        case "xx":
          return on(sn.basic, a);
        case "xxxx":
          return on(sn.basicOptionalSeconds, a);
        case "xxxxx":
          return on(sn.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return on(sn.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return s.timestampIsSet ? a : new Date(a.getTime() - i);
    }
  }]), n;
}(We), Qy = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 40), oe(ue(r), "incompatibleTokens", "*"), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a) {
      return xc(a);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(We), Ky = /* @__PURE__ */ function(t) {
  Ve(n, t);
  var e = Ie(n);
  function n() {
    var r;
    Ee(this, n);
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(s)), oe(ue(r), "priority", 20), oe(ue(r), "incompatibleTokens", "*"), r;
  }
  return Pe(n, [{
    key: "parse",
    value: function(a) {
      return xc(a);
    }
  }, {
    key: "set",
    value: function(a, s, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(We), eg = {
  G: new gy(),
  y: new wy(),
  Y: new by(),
  R: new ky(),
  u: new _y(),
  Q: new Ty(),
  q: new Oy(),
  M: new Sy(),
  L: new Dy(),
  w: new xy(),
  I: new Ay(),
  d: new Fy(),
  D: new Ny(),
  E: new Ry(),
  e: new Vy(),
  c: new Iy(),
  i: new $y(),
  a: new Yy(),
  b: new Uy(),
  B: new By(),
  h: new Wy(),
  H: new jy(),
  K: new Hy(),
  k: new qy(),
  m: new zy(),
  s: new Zy(),
  S: new Gy(),
  X: new Jy(),
  x: new Xy(),
  t: new Qy(),
  T: new Ky()
}, tg = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ng = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, rg = /^'([^]*?)'?$/, ag = /''/g, sg = /\S/, ig = /[a-zA-Z]/;
function ui(t, e, n, r) {
  var a, s, i, o, l, u, c, d, p, m, h, O, g, b;
  ce(3, arguments);
  var w = String(t), M = String(e), T = fn(), E = (a = (s = void 0) !== null && s !== void 0 ? s : T.locale) !== null && a !== void 0 ? a : Oc;
  if (!E.match)
    throw new RangeError("locale must contain match property");
  var $ = ye((i = (o = (l = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && l !== void 0 ? l : T.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = T.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!($ >= 1 && $ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = ye((p = (m = (h = (O = void 0) !== null && O !== void 0 ? O : void 0) !== null && h !== void 0 ? h : T.weekStartsOn) !== null && m !== void 0 ? m : (g = T.locale) === null || g === void 0 || (b = g.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (M === "")
    return w === "" ? me(n) : /* @__PURE__ */ new Date(NaN);
  var Q = {
    firstWeekContainsDate: $,
    weekStartsOn: V,
    locale: E
  }, W = [new yy()], k = M.match(ng).map(function(z) {
    var A = z[0];
    if (A in oi) {
      var _ = oi[A];
      return _(z, E.formatLong);
    }
    return z;
  }).join("").match(tg), F = [], H = dl(k), G;
  try {
    var Y = function() {
      var A = G.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Tc(A) && Za(A, M, t), !(r != null && r.useAdditionalDayOfYearTokens) && _c(A) && Za(A, M, t);
      var _ = A[0], le = eg[_];
      if (le) {
        var he = le.incompatibleTokens;
        if (Array.isArray(he)) {
          var re = F.find(function(de) {
            return he.includes(de.token) || de.token === _;
          });
          if (re)
            throw new RangeError("The format string mustn't contain `".concat(re.fullToken, "` and `").concat(A, "` at the same time"));
        } else if (le.incompatibleTokens === "*" && F.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(A, "` and any other token at the same time"));
        F.push({
          token: _,
          fullToken: A
        });
        var Ce = le.run(w, A, E.match, Q);
        if (!Ce)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        W.push(Ce.setter), w = Ce.rest;
      } else {
        if (_.match(ig))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + _ + "`");
        if (A === "''" ? A = "'" : _ === "'" && (A = og(A)), w.indexOf(A) === 0)
          w = w.slice(A.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (H.s(); !(G = H.n()).done; ) {
      var S = Y();
      if (Yt(S) === "object") return S.v;
    }
  } catch (z) {
    H.e(z);
  } finally {
    H.f();
  }
  if (w.length > 0 && sg.test(w))
    return /* @__PURE__ */ new Date(NaN);
  var R = W.map(function(z) {
    return z.priority;
  }).sort(function(z, A) {
    return A - z;
  }).filter(function(z, A, _) {
    return _.indexOf(z) === A;
  }).map(function(z) {
    return W.filter(function(A) {
      return A.priority === z;
    }).sort(function(A, _) {
      return _.subPriority - A.subPriority;
    });
  }).map(function(z) {
    return z[0];
  }), N = me(n);
  if (isNaN(N.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var q = yc(N, za(N)), y = {}, f = dl(R), L;
  try {
    for (f.s(); !(L = f.n()).done; ) {
      var B = L.value;
      if (!B.validate(q, Q))
        return /* @__PURE__ */ new Date(NaN);
      var J = B.set(q, y, Q);
      Array.isArray(J) ? (q = J[0], ny(y, J[1])) : q = J;
    }
  } catch (z) {
    f.e(z);
  } finally {
    f.f();
  }
  return q;
}
function og(t) {
  return t.match(rg)[1].replace(ag, "'");
}
function fl(t, e) {
  ce(2, arguments);
  var n = na(t), r = na(e);
  return n.getTime() === r.getTime();
}
function lg(t, e) {
  ce(2, arguments);
  var n = ye(e);
  return hn(t, -n);
}
function ug(t, e) {
  var n;
  ce(1, arguments);
  var r = ye((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = pg(t), s;
  if (a.date) {
    var i = mg(a.date, r);
    s = hg(i.restDateString, i.year);
  }
  if (!s || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var o = s.getTime(), l = 0, u;
  if (a.time && (l = vg(a.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (u = yg(a.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var c = new Date(o + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()), d.setHours(c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()), d;
  }
  return new Date(o + l + u);
}
var Da = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, cg = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, dg = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, fg = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function pg(t) {
  var e = {}, n = t.split(Da.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Da.timeZoneDelimiter.test(e.date) && (e.date = t.split(Da.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var a = Da.timezone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
  }
  return e;
}
function mg(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var a = r[1] ? parseInt(r[1]) : null, s = r[2] ? parseInt(r[2]) : null;
  return {
    year: s === null ? a : s * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function hg(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  var n = t.match(cg);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = Wr(n[1]), s = Wr(n[2]) - 1, i = Wr(n[3]), o = Wr(n[4]), l = Wr(n[5]) - 1;
  if (r)
    return _g(e, o, l) ? gg(e, o, l) : /* @__PURE__ */ new Date(NaN);
  var u = /* @__PURE__ */ new Date(0);
  return !bg(e, s, i) || !kg(e, a) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(e, s, Math.max(a, i)), u);
}
function Wr(t) {
  return t ? parseInt(t) : 1;
}
function vg(t) {
  var e = t.match(dg);
  if (!e) return NaN;
  var n = Es(e[1]), r = Es(e[2]), a = Es(e[3]);
  return Tg(n, r, a) ? n * Vi + r * Ri + a * 1e3 : NaN;
}
function Es(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function yg(t) {
  if (t === "Z") return 0;
  var e = t.match(fg);
  if (!e) return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return Og(r, a) ? n * (r * Vi + a * Ri) : NaN;
}
function gg(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var a = r.getUTCDay() || 7, s = (e - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
var wg = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ec(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function bg(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (wg[e] || (Ec(t) ? 29 : 28));
}
function kg(t, e) {
  return e >= 1 && e <= (Ec(t) ? 366 : 365);
}
function _g(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function Tg(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function Og(t, e) {
  return e >= 0 && e <= 59;
}
function Pc(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e), a = n.getFullYear(), s = n.getDate(), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, r, 15), i.setHours(0, 0, 0, 0);
  var o = ay(i);
  return n.setMonth(r, Math.min(s, o)), n;
}
function Je(t, e) {
  if (ce(2, arguments), Yt(e) !== "object" || e === null)
    throw new RangeError("values parameter must be an object");
  var n = me(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = Pc(n, e.month)), e.date != null && n.setDate(ye(e.date)), e.hours != null && n.setHours(ye(e.hours)), e.minutes != null && n.setMinutes(ye(e.minutes)), e.seconds != null && n.setSeconds(ye(e.seconds)), e.milliseconds != null && n.setMilliseconds(ye(e.milliseconds)), n);
}
function Fc(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return n.setHours(r), n;
}
function Yi(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return n.setMilliseconds(r), n;
}
function Nc(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return n.setMinutes(r), n;
}
function Ui(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return n.setSeconds(r), n;
}
function ln(t, e) {
  ce(2, arguments);
  var n = me(t), r = ye(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function Sr(t, e) {
  ce(2, arguments);
  var n = ye(e);
  return Gt(t, -n);
}
function Sg(t, e) {
  if (ce(2, arguments), !e || Yt(e) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = e.years ? ye(e.years) : 0, r = e.months ? ye(e.months) : 0, a = e.weeks ? ye(e.weeks) : 0, s = e.days ? ye(e.days) : 0, i = e.hours ? ye(e.hours) : 0, o = e.minutes ? ye(e.minutes) : 0, l = e.seconds ? ye(e.seconds) : 0, u = Sr(t, r + n * 12), c = lg(u, s + a * 7), d = o + i * 60, p = l + d * 60, m = p * 1e3, h = new Date(c.getTime() - m);
  return h;
}
function Rc(t, e) {
  ce(2, arguments);
  var n = ye(e);
  return Ni(t, -n);
}
function Lr() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      C("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      C("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      C("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Lr.compatConfig = {
  MODE: 3
};
function Vc() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      C("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Vc.compatConfig = {
  MODE: 3
};
function Bi() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Bi.compatConfig = {
  MODE: 3
};
function Wi() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
Wi.compatConfig = {
  MODE: 3
};
function ji() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      C("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
ji.compatConfig = {
  MODE: 3
};
function Hi() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Hi.compatConfig = {
  MODE: 3
};
function qi() {
  return v(), x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      C("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
qi.compatConfig = {
  MODE: 3
};
function zi(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ic = { exports: {} };
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Ic);
var Dg = Ic.exports, ci = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var a = Number(r);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  t.exports = e.default;
})(ci, ci.exports);
var Cg = ci.exports;
const xg = /* @__PURE__ */ zi(Cg);
var di = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    var a = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return a.setUTCFullYear(r.getFullYear()), r.getTime() - a.getTime();
  }
  t.exports = e.default;
})(di, di.exports);
var Mg = di.exports;
const pl = /* @__PURE__ */ zi(Mg);
function Ag(t, e) {
  var n = Ng(e);
  return n.formatToParts ? Pg(n, t) : Fg(n, t);
}
var Eg = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Pg(t, e) {
  try {
    for (var n = t.formatToParts(e), r = [], a = 0; a < n.length; a++) {
      var s = Eg[n[a].type];
      s >= 0 && (r[s] = parseInt(n[a].value, 10));
    }
    return r;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function Fg(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Ps = {};
function Ng(t) {
  if (!Ps[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Ps[t] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Ps[t];
}
function Zi(t, e, n, r, a, s, i) {
  var o = /* @__PURE__ */ new Date(0);
  return o.setUTCFullYear(t, e, n), o.setUTCHours(r, a, s, i), o;
}
var ml = 36e5, Rg = 6e4, Fs = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Gi(t, e, n) {
  var r, a;
  if (t === "" || (r = Fs.timezoneZ.exec(t), r))
    return 0;
  var s;
  if (r = Fs.timezoneHH.exec(t), r)
    return s = parseInt(r[1], 10), hl(s) ? -(s * ml) : NaN;
  if (r = Fs.timezoneHHMM.exec(t), r) {
    s = parseInt(r[1], 10);
    var i = parseInt(r[2], 10);
    return hl(s, i) ? (a = Math.abs(s) * ml + i * Rg, s > 0 ? -a : a) : NaN;
  }
  if (Lg(t)) {
    e = new Date(e || Date.now());
    var o = n ? e : Vg(e), l = fi(o, t), u = n ? l : Ig(e, l, t);
    return -u;
  }
  return NaN;
}
function Vg(t) {
  return Zi(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function fi(t, e) {
  var n = Ag(t, e), r = Zi(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), a = t.getTime(), s = a % 1e3;
  return a -= s >= 0 ? s : 1e3 + s, r - a;
}
function Ig(t, e, n) {
  var r = t.getTime(), a = r - e, s = fi(new Date(a), n);
  if (e === s)
    return e;
  a -= s - e;
  var i = fi(new Date(a), n);
  return s === i ? s : Math.max(s, i);
}
function hl(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var vl = {};
function Lg(t) {
  if (vl[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), vl[t] = !0, !0;
  } catch {
    return !1;
  }
}
var Lc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Ns = 36e5, yl = 6e4, $g = 2, Tt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Lc
};
function pi(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e || {}, r = n.additionalDigits == null ? $g : xg(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = Yg(t), s = Ug(a.date, r), i = s.year, o = s.restDateString, l = Bg(o, i);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var u = l.getTime(), c = 0, d;
    if (a.time && (c = Wg(a.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || n.timeZone) {
      if (d = Gi(a.timeZone || n.timeZone, new Date(u + c)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = pl(new Date(u + c)), d = pl(new Date(u + c + d));
    return new Date(u + c + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Yg(t) {
  var e = {}, n = Tt.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = Tt.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    var a = Tt.timeZone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timeZone = a[1].trim()) : e.time = r;
  }
  return e;
}
function Ug(t, e) {
  var n = Tt.YYY[e], r = Tt.YYYYY[e], a;
  if (a = Tt.YYYY.exec(t) || r.exec(t), a) {
    var s = a[1];
    return {
      year: parseInt(s, 10),
      restDateString: t.slice(s.length)
    };
  }
  if (a = Tt.YY.exec(t) || n.exec(t), a) {
    var i = a[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: t.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function Bg(t, e) {
  if (e === null)
    return null;
  var n, r, a, s;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (n = Tt.MM.exec(t), n)
    return r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1, wl(e, a) ? (r.setUTCFullYear(e, a), r) : /* @__PURE__ */ new Date(NaN);
  if (n = Tt.DDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0);
    var i = parseInt(n[1], 10);
    return qg(e, i) ? (r.setUTCFullYear(e, 0, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Tt.MMDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1;
    var o = parseInt(n[2], 10);
    return wl(e, a, o) ? (r.setUTCFullYear(e, a, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Tt.Www.exec(t), n)
    return s = parseInt(n[1], 10) - 1, bl(e, s) ? gl(e, s) : /* @__PURE__ */ new Date(NaN);
  if (n = Tt.WwwD.exec(t), n) {
    s = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return bl(e, s, l) ? gl(e, s, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Wg(t) {
  var e, n, r;
  if (e = Tt.HH.exec(t), e)
    return n = parseFloat(e[1].replace(",", ".")), Rs(n) ? n % 24 * Ns : NaN;
  if (e = Tt.HHMM.exec(t), e)
    return n = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), Rs(n, r) ? n % 24 * Ns + r * yl : NaN;
  if (e = Tt.HHMMSS.exec(t), e) {
    n = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var a = parseFloat(e[3].replace(",", "."));
    return Rs(n, r, a) ? n % 24 * Ns + r * yl + a * 1e3 : NaN;
  }
  return null;
}
function gl(t, e, n) {
  e = e || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var a = r.getUTCDay() || 7, s = e * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
var jg = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Hg = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function $c(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function wl(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = $c(t);
    if (r && n > Hg[e] || !r && n > jg[e])
      return !1;
  }
  return !0;
}
function qg(t, e) {
  if (e < 1)
    return !1;
  var n = $c(t);
  return !(n && e > 366 || !n && e > 365);
}
function bl(t, e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function Rs(t, e, n) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
var mi = { exports: {} }, hi = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, a) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var s in a)
      Object.prototype.hasOwnProperty.call(a, s) && (r[s] = a[s]);
    return r;
  }
  t.exports = e.default;
})(hi, hi.exports);
var zg = hi.exports;
(function(t, e) {
  var n = Dg.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(zg);
  function a(s) {
    return (0, r.default)({}, s);
  }
  t.exports = e.default;
})(mi, mi.exports);
var Zg = mi.exports;
const Gg = /* @__PURE__ */ zi(Zg);
function Jg(t, e, n) {
  var r = pi(t, n), a = Gi(e, r, !0), s = new Date(r.getTime() - a), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), i.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), i;
}
function Xg(t, e, n) {
  if (typeof t == "string" && !t.match(Lc)) {
    var r = Gg(n);
    return r.timeZone = e, pi(t, r);
  }
  var a = pi(t, n), s = Zi(
    a.getFullYear(),
    a.getMonth(),
    a.getDate(),
    a.getHours(),
    a.getMinutes(),
    a.getSeconds(),
    a.getMilliseconds()
  ).getTime(), i = Gi(e, new Date(s));
  return new Date(s + i);
}
function kl(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function Qg(t) {
  return (e) => Rn(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "EEEEEE", { locale: t });
}
const Kg = (t, e, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7];
  let a;
  if (t !== null)
    try {
      a = r.map(Qg(t));
    } catch {
      a = r.map(kl(e));
    }
  else
    a = r.map(kl(e));
  const s = a.slice(0, n), i = a.slice(n + 1, a.length);
  return [a[n]].concat(...i).concat(...s);
}, Ji = (t, e) => {
  const n = [];
  for (let r = +t[0]; r <= +t[1]; r++)
    n.push({ value: +r, text: `${r}` });
  return e ? n.reverse() : n;
}, Yc = (t, e, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((s) => {
    const i = s < 10 ? `0${s}` : s;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const s = n === "long" ? "MMMM" : "MMM";
      return r.map((i, o) => {
        const l = Rn(i, s, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const a = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return r.map((s, i) => {
    const o = a.format(s);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: i
    };
  });
}, e0 = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], lt = (t) => {
  const e = D(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, t0 = (t) => Object.assign({ type: "dot" }, t), Uc = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, Xa = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, ut = (t) => t, _l = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, Tl = (t) => t === null, n0 = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, r0 = (t) => {
  const e = [], n = (r) => r.filter((a) => a);
  for (let r = 0; r < t.length; r += 3) {
    const a = [t[r], t[r + 1], t[r + 2]];
    e.push(n(a));
  }
  return e;
}, sa = (t, e, n) => {
  const r = n != null, a = e != null;
  if (!r && !a)
    return !1;
  const s = +n, i = +e;
  return r && a ? +t > s || +t < i : r ? +t > s : a ? +t < i : !1;
}, Dr = (t, e) => r0(t).map((n) => n.map((r) => {
  const { active: a, disabled: s, isBetween: i, highlighted: o } = e(r);
  return {
    ...r,
    active: a,
    disabled: s,
    className: {
      dp__overlay_cell_active: a,
      dp__overlay_cell: !a,
      dp__overlay_cell_disabled: s,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: s && a,
      dp__cell_in_between: i,
      "dp--highlighted": o
    }
  };
})), Vn = (t, e, n = !1) => {
  t && e.allowStopPropagation && (n && t.stopImmediatePropagation(), t.stopPropagation());
}, a0 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function s0(t, e) {
  let n = [...document.querySelectorAll(a0())];
  n = n.filter((a) => !t.contains(a) || a.hasAttribute("data-datepicker-instance"));
  const r = n.indexOf(t);
  if (r >= 0 && (e ? r - 1 >= 0 : r + 1 <= n.length))
    return n[r + (e ? -1 : 1)];
}
const i0 = (t, e) => {
  let n;
  return function(...r) {
    clearTimeout(n), n = setTimeout(() => {
      t(...r);
    }, e);
  };
}, Ol = (t, e, n, r, a) => {
  const s = ui(t, e.slice(0, t.length), /* @__PURE__ */ new Date());
  return Gr(s) && hc(s) ? r || a ? s : Je(s, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, o0 = (t, e, n, r, a) => {
  const s = Array.isArray(n) ? n[0] : n;
  if (typeof e == "string")
    return Ol(t, e, s, r, a);
  if (Array.isArray(e)) {
    let i = null;
    for (const o of e)
      if (i = Ol(t, o, s, r, a), i)
        break;
    return i;
  }
  return typeof e == "function" ? e(t) : null;
}, Z = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), l0 = (t, e, n) => {
  if (e) {
    const a = (t.getMonth() + 1).toString().padStart(2, "0"), s = t.getDate().toString().padStart(2, "0"), i = t.getHours().toString().padStart(2, "0"), o = t.getMinutes().toString().padStart(2, "0"), l = n ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${a}-${s}T${i}:${o}:${l}.000Z`;
  }
  const r = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(r).toISOString();
}, bt = (t) => {
  let e = Z(JSON.parse(JSON.stringify(t)));
  return e = Fc(e, 0), e = Nc(e, 0), e = Ui(e, 0), e = Yi(e, 0), e;
}, In = (t, e, n, r) => {
  let a = t ? Z(t) : Z();
  return (e || e === 0) && (a = Fc(a, +e)), (n || n === 0) && (a = Nc(a, +n)), (r || r === 0) && (a = Ui(a, +r)), Yi(a, 0);
}, ft = (t, e) => !t || !e ? !1 : aa(bt(t), bt(e)), Ue = (t, e) => !t || !e ? !1 : wr(bt(t), bt(e)), wt = (t, e) => !t || !e ? !1 : ra(bt(t), bt(e)), ds = (t, e, n) => t != null && t[0] && t != null && t[1] ? wt(n, t[0]) && ft(n, t[1]) : t != null && t[0] && e ? wt(n, t[0]) && ft(n, e) || ft(n, t[0]) && wt(n, e) : !1, qt = (t) => {
  const e = Je(new Date(t), { date: 1 });
  return bt(e);
}, Vs = (t, e, n) => e && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((r) => r === e ? [r, n] : [r, isNaN(+t[r]) ? void 0 : +t[r]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Xn = (t) => ({
  hours: Jt(t),
  minutes: un(t),
  seconds: Or(t)
}), Bc = (t, e) => {
  if (e) {
    const n = Me(Z(e));
    if (n > t)
      return 12;
    if (n === t)
      return Fe(Z(e));
  }
}, Wc = (t, e) => {
  if (e) {
    const n = Me(Z(e));
    return n < t ? -1 : n === t ? Fe(Z(e)) : void 0;
  }
}, Cr = (t) => {
  if (t)
    return Me(Z(t));
}, Xt = (t, e) => e ? Jg(t, e) : t, jc = (t, e) => e ? Xg(t, e) : t, u0 = (t) => t instanceof Date ? t : ug(t), Hc = (t, e) => {
  const n = wt(t, e) ? e : t, r = wt(e, t) ? e : t;
  return vc({ start: n, end: r });
}, c0 = (t) => {
  const e = Gt(t, 1);
  return { month: Fe(e), year: Me(e) };
}, Ia = (t, e, n) => {
  const r = tr(Xt(t, e), { weekStartsOn: +n }), a = ov(Xt(t, e), { weekStartsOn: +n });
  return [r, a];
}, qc = (t, e) => {
  const n = {
    hours: Jt(Z()),
    minutes: un(Z()),
    seconds: e ? Or(Z()) : 0
  };
  return Object.assign(n, t);
}, En = (t, e, n) => [Je(Z(t), { date: 1 }), Je(Z(), { month: e, year: n, date: 1 })], vn = (t, e, n) => {
  let r = t ? Z(t) : Z();
  return (e || e === 0) && (r = Pc(r, e)), n && (r = ln(r, n)), r;
}, zc = (t, e, n, r, a) => {
  if (!r || a && !e || !a && !n)
    return !1;
  const s = a ? Gt(t, 1) : Sr(t, 1), i = [Fe(s), Me(s)];
  return a ? !f0(...i, e) : !d0(...i, n);
}, d0 = (t, e, n) => ft(...En(n, t, e)) || Ue(...En(n, t, e)), f0 = (t, e, n) => wt(...En(n, t, e)) || Ue(...En(n, t, e)), Zc = (t, e, n, r, a, s, i) => {
  if (typeof e == "function" && !i)
    return e(t);
  const o = n ? { locale: n } : void 0;
  return Array.isArray(t) ? `${Rn(t[0], s, o)}${a && !t[1] ? "" : r}${t[1] ? Rn(t[1], s, o) : ""}` : Rn(t, s, o);
}, hr = (t) => {
  if (t)
    return null;
  throw new Error(Xa.prop("partial-range"));
}, Ca = (t, e) => {
  if (e)
    return t();
  throw new Error(Xa.prop("range"));
}, vi = (t) => Array.isArray(t) ? Gr(t[0]) && (t[1] ? Gr(t[1]) : !0) : t ? Gr(t) : !1, p0 = (t, e) => Je(e ?? Z(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), Is = (t, e, n, r) => {
  if (!t)
    return !0;
  if (r) {
    const a = n === "max" ? aa(t, e) : ra(t, e), s = { seconds: 0, milliseconds: 0 };
    return a || wr(Je(t, s), Je(e, s));
  }
  return n === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, Ls = (t, e, n) => t ? p0(t, e) : Z(n ?? e), Sl = (t, e, n, r, a) => {
  if (Array.isArray(r)) {
    const i = Ls(t, r[0], e), o = Ls(t, r[1], e);
    return Is(r[0], i, n, !!e) && Is(r[1], o, n, !!e) && a;
  }
  const s = Ls(t, r, e);
  return Is(r, s, n, !!e) && a;
}, $s = (t) => Je(Z(), Xn(t)), m0 = (t, e) => Array.isArray(t) ? t.map((n) => Z(n)).filter((n) => Me(Z(n)) === e).map((n) => Fe(n)) : [], Gc = (t, e, n) => typeof t == "function" ? t({ month: e, year: n }) : !!t.months.find((r) => r.month === e && r.year === n), Xi = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), jr = la({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Jc = () => {
  const t = (n) => {
    jr.menuFocused = n;
  }, e = (n) => {
    jr.shiftKeyInMenu !== n && (jr.shiftKeyInMenu = n);
  };
  return {
    control: X(() => ({ shiftKeyInMenu: jr.shiftKeyInMenu, menuFocused: jr.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, Ze = la({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ys = ee(null), xa = ee(!1), Us = ee(!1), Bs = ee(!1), Ws = ee(!1), kt = ee(0), dt = ee(0), Un = () => {
  const t = X(() => xa.value ? [...Ze.selectionGrid, Ze.actionRow].filter((d) => d.length) : Us.value ? [
    ...Ze.timePicker[0],
    ...Ze.timePicker[1],
    Ws.value ? [] : [Ys.value],
    Ze.actionRow
  ].filter((d) => d.length) : Bs.value ? [...Ze.monthPicker, Ze.actionRow] : [Ze.monthYear, ...Ze.calendar, Ze.time, Ze.actionRow].filter((d) => d.length)), e = (d) => {
    kt.value = d ? kt.value + 1 : kt.value - 1;
    let p = null;
    t.value[dt.value] && (p = t.value[dt.value][kt.value]), p || (kt.value = d ? kt.value - 1 : kt.value + 1);
  }, n = (d) => {
    dt.value === 0 && !d || dt.value === t.value.length && d || (dt.value = d ? dt.value + 1 : dt.value - 1, t.value[dt.value] ? t.value[dt.value] && !t.value[dt.value][kt.value] && kt.value !== 0 && (kt.value = t.value[dt.value].length - 1) : dt.value = d ? dt.value - 1 : dt.value + 1);
  }, r = (d) => {
    let p = null;
    t.value[dt.value] && (p = t.value[dt.value][kt.value]), p ? p.focus({ preventScroll: !xa.value }) : kt.value = d ? kt.value - 1 : kt.value + 1;
  }, a = () => {
    e(!0), r(!0);
  }, s = () => {
    e(!1), r(!1);
  }, i = () => {
    n(!1), r(!0);
  }, o = () => {
    n(!0), r(!0);
  }, l = (d, p) => {
    Ze[p] = d;
  }, u = (d, p) => {
    Ze[p] = d;
  }, c = () => {
    kt.value = 0, dt.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (d) => {
      Ys.value = d;
    },
    setSelectionGrid: (d) => {
      xa.value = d, c(), d || (Ze.selectionGrid = []);
    },
    setTimePicker: (d, p = !1) => {
      Us.value = d, Ws.value = p, c(), d || (Ze.timePicker[0] = [], Ze.timePicker[1] = []);
    },
    setTimePickerElements: (d, p = 0) => {
      Ze.timePicker[p] = d;
    },
    arrowRight: a,
    arrowLeft: s,
    arrowUp: i,
    arrowDown: o,
    clearArrowNav: () => {
      Ze.monthYear = [], Ze.calendar = [], Ze.time = [], Ze.actionRow = [], Ze.selectionGrid = [], Ze.timePicker[0] = [], Ze.timePicker[1] = [], xa.value = !1, Us.value = !1, Ws.value = !1, Bs.value = !1, c(), Ys.value = null;
    },
    setMonthPicker: (d) => {
      Bs.value = d, c();
    },
    refSets: Ze
    // exposed for testing
  };
}, Dl = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), h0 = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...t ?? {}
}), Cl = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, v0 = (t) => {
  const e = typeof t == "object" && t, n = {
    static: !0,
    solo: !1
  };
  if (!t)
    return { ...n, count: Cl(!1) };
  const r = e ? t : {}, a = e ? r.count ?? !0 : t, s = Cl(a);
  return Object.assign(n, r, { count: s });
}, y0 = (t, e, n) => t || (typeof n == "string" ? n : e), g0 = (t) => typeof t == "boolean" ? t ? Dl({}) : !1 : Dl(t), w0 = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, b0 = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), k0 = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), _0 = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, T0 = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, ...t ?? {} }), O0 = (t, e, n) => {
  const r = {
    dates: Array.isArray(t) ? t.map((a) => Z(a)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: e,
    options: { highlightDisabled: n }
  };
  return typeof t == "function" ? t : { ...r, ...t ?? {} };
}, S0 = (t) => typeof t == "object" ? {
  type: t.type,
  hideOnOffsetDates: t.hideOnOffsetDates ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, it = (t) => {
  const e = () => {
    const b = t.enableSeconds ? ":ss" : "";
    return t.is24 ? `HH:mm${b}` : `hh:mm${b} aa`;
  }, n = () => t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? "MM/dd/yyyy" : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy", r = (b) => qc(b, t.enableSeconds), a = () => t.range ? t.startTime && Array.isArray(t.startTime) ? [r(t.startTime[0]), r(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? r(t.startTime) : null, s = X(() => v0(t.multiCalendars)), i = X(() => a()), o = X(() => h0(t.ariaLabels)), l = X(() => b0(t.filters)), u = X(() => g0(t.transitions)), c = X(() => k0(t.actionRow)), d = X(
    () => y0(t.previewFormat, t.format, n())
  ), p = X(() => w0(t.textInput)), m = X(() => _0(t.inline)), h = X(() => T0(t.config)), O = X(
    () => O0(t.highlight, t.highlightWeekDays, t.highlightDisabledDays)
  ), g = X(() => S0(t.weekNumbers));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: s,
    defaultedStartTime: i,
    defaultedAriaLabels: o,
    defaultedFilters: l,
    defaultedActionRow: c,
    defaultedPreviewFormat: d,
    defaultedTextInput: p,
    defaultedInline: m,
    defaultedConfig: h,
    defaultedHighlight: O,
    defaultedWeekNumbers: g,
    getDefaultPattern: n,
    getDefaultStartTime: a
  };
}, D0 = (t, e, n) => {
  const r = ee(), { defaultedTextInput: a, getDefaultPattern: s } = it(e), i = ee(""), o = $a(e, "format");
  gn(r, () => {
    t("internal-model-change", r.value);
  }), gn(o, () => {
    Y();
  });
  const l = (f) => jc(f, e.timezone), u = (f) => Xt(f, e.timezone), c = (f, L, B = !1) => Zc(
    f,
    e.format,
    e.formatLocale,
    a.value.rangeSeparator,
    e.modelAuto,
    L ?? s(),
    B
  ), d = (f) => f ? e.modelType ? R(f) : {
    hours: Jt(f),
    minutes: un(f),
    seconds: e.enableSeconds ? Or(f) : 0
  } : null, p = (f) => e.modelType ? R(f) : { month: Fe(f), year: Me(f) }, m = (f) => Array.isArray(f) ? e.multiDates ? f.map((L) => h(L, ln(Z(), L))) : Ca(
    () => [
      ln(Z(), f[0]),
      f[1] ? ln(Z(), f[1]) : hr(e.partialRange)
    ],
    e.range
  ) : ln(Z(), +f), h = (f, L) => (typeof f == "string" || typeof f == "number") && e.modelType ? S(f) : L, O = (f) => Array.isArray(f) ? [
    h(
      f[0],
      In(null, +f[0].hours, +f[0].minutes, f[0].seconds)
    ),
    h(
      f[1],
      In(null, +f[1].hours, +f[1].minutes, f[1].seconds)
    )
  ] : h(f, In(null, f.hours, f.minutes, f.seconds)), g = (f) => Array.isArray(f) ? e.multiDates ? f.map((L) => h(L, vn(null, +L.month, +L.year))) : Ca(
    () => [
      h(f[0], vn(null, +f[0].month, +f[0].year)),
      h(
        f[1],
        f[1] ? vn(null, +f[1].month, +f[1].year) : hr(e.partialRange)
      )
    ],
    e.range
  ) : h(f, vn(null, +f.month, +f.year)), b = (f) => {
    if (Array.isArray(f))
      return f.map((L) => S(L));
    throw new Error(Xa.dateArr("multi-dates"));
  }, w = (f) => {
    if (Array.isArray(f))
      return [Z(f[0]), Z(f[1])];
    throw new Error(Xa.dateArr("week-picker"));
  }, M = (f) => e.modelAuto ? Array.isArray(f) ? [S(f[0]), S(f[1])] : e.autoApply ? [S(f)] : [S(f), null] : Array.isArray(f) ? Ca(
    () => [
      S(f[0]),
      f[1] ? S(f[1]) : hr(e.partialRange)
    ],
    e.range
  ) : S(f), T = () => {
    Array.isArray(r.value) && e.range && r.value.length === 1 && r.value.push(hr(e.partialRange));
  }, E = () => {
    const f = r.value;
    return [
      R(f[0]),
      f[1] ? R(f[1]) : hr(e.partialRange)
    ];
  }, $ = () => r.value[1] ? E() : R(ut(r.value[0])), V = () => (r.value || []).map((f) => R(f)), Q = () => (T(), e.modelAuto ? $() : e.multiDates ? V() : Array.isArray(r.value) ? Ca(() => E(), e.range) : R(ut(r.value))), W = (f) => !f || Array.isArray(f) && !f.length ? null : e.timePicker ? O(ut(f)) : e.monthPicker ? g(ut(f)) : e.yearPicker ? m(ut(f)) : e.multiDates ? b(ut(f)) : e.weekPicker ? w(ut(f)) : M(ut(f)), k = (f) => {
    const L = W(f);
    vi(ut(L)) ? (r.value = ut(L), Y()) : (r.value = null, i.value = "");
  }, F = () => {
    const f = (L) => Rn(L, a.value.format);
    return `${f(r.value[0])} ${a.value.rangeSeparator} ${r.value[1] ? f(r.value[1]) : ""}`;
  }, H = () => n.value && r.value ? Array.isArray(r.value) ? F() : Rn(r.value, a.value.format) : c(r.value), G = () => r.value ? e.multiDates ? r.value.map((f) => c(f)).join("; ") : a.value.enabled && typeof a.value.format == "string" ? H() : c(r.value) : "", Y = () => {
    !e.format || typeof e.format == "string" || a.value.enabled && typeof a.value.format == "string" ? i.value = G() : i.value = e.format(r.value);
  }, S = (f) => {
    if (e.utc) {
      const L = new Date(f);
      return e.utc === "preserve" ? new Date(L.getTime() + L.getTimezoneOffset() * 6e4) : L;
    }
    return e.modelType ? e.modelType === "date" || e.modelType === "timestamp" ? u(new Date(f)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? ui(f, s(), /* @__PURE__ */ new Date()) : u(ui(f, e.modelType, /* @__PURE__ */ new Date())) : u(new Date(f));
  }, R = (f) => f ? e.utc ? l0(f, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +l(f) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? c(l(f)) : c(l(f), e.modelType, !0) : l(f) : "", N = (f, L = !1) => {
    if (t("update:model-value", f), e.emitTimezone && L) {
      const B = Array.isArray(f) ? f.map((J) => Xt(ut(J)), e.emitTimezone) : Xt(ut(f), e.emitTimezone);
      t("update:model-timezone-value", B);
    }
  }, q = (f) => Array.isArray(r.value) ? e.multiDates ? r.value.map((L) => f(L)) : [
    f(r.value[0]),
    r.value[1] ? f(r.value[1]) : hr(e.partialRange)
  ] : f(ut(r.value)), y = (f) => N(ut(q(f)));
  return {
    inputValue: i,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? e.range ? e.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: k,
    formatInputValue: Y,
    emitModelValue: () => (Y(), e.monthPicker ? y(p) : e.timePicker ? y(d) : e.yearPicker ? y(Me) : e.weekPicker ? N(
      r.value.map((f) => R(f)),
      !0
    ) : N(Q(), !0))
  };
}, C0 = (t, e) => {
  const { defaultedFilters: n } = it(t), { validateMonthYearInRange: r } = ir(t), a = (u, c) => {
    let d = u;
    return n.value.months.includes(Fe(d)) ? (d = c ? Gt(u, 1) : Sr(u, 1), a(d, c)) : d;
  }, s = (u, c) => {
    let d = u;
    return n.value.years.includes(Me(d)) ? (d = c ? Ni(u, 1) : Rc(u, 1), s(d, c)) : d;
  }, i = (u, c = !1) => {
    const d = Je(/* @__PURE__ */ new Date(), { month: t.month, year: t.year });
    let p = u ? Gt(d, 1) : Sr(d, 1);
    t.disableYearSelect && (p = ln(p, t.year));
    let m = Fe(p), h = Me(p);
    n.value.months.includes(m) && (p = a(p, u), m = Fe(p), h = Me(p)), n.value.years.includes(h) && (p = s(p, u), h = Me(p)), r(m, h, u, t.preventMinMaxNavigation) && o(m, h, c);
  }, o = (u, c, d) => {
    e("update-month-year", { month: u, year: c, fromNav: d });
  }, l = X(() => (u) => zc(
    Je(/* @__PURE__ */ new Date(), { month: t.month, year: t.year }),
    t.maxDate,
    t.minDate,
    t.preventMinMaxNavigation,
    u
  ));
  return { handleMonthYearChange: i, isDisabled: l, updateMonthYear: o };
};
var yr = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(yr || {}), Ht = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(Ht || {}), zn = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(zn || {}), Qn = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Qn || {}), an = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(an || {});
const x0 = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: n,
  pickerWrapperRef: r,
  inline: a,
  emit: s,
  props: i,
  slots: o
}) => {
  const l = ee({}), u = ee(!1), c = ee({
    top: "0",
    left: "0"
  }), d = ee(!1), p = $a(i, "teleportCenter");
  gn(p, () => {
    c.value = JSON.parse(JSON.stringify({})), T();
  });
  const m = (S) => {
    if (i.teleport) {
      const R = S.getBoundingClientRect();
      return {
        left: R.left + window.scrollX,
        top: R.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, h = (S, R) => {
    c.value.left = `${S + R - l.value.width}px`;
  }, O = (S) => {
    c.value.left = `${S}px`;
  }, g = (S, R) => {
    i.position === yr.left && O(S), i.position === yr.right && h(S, R), i.position === yr.center && (c.value.left = `${S + R / 2 - l.value.width / 2}px`);
  }, b = (S) => {
    const { width: R, height: N } = S.getBoundingClientRect(), { top: q, left: y } = i.altPosition ? i.altPosition(S) : m(S);
    return { top: +q, left: +y, width: R, height: N };
  }, w = () => {
    c.value.left = "50%", c.value.top = "50%", c.value.transform = "translate(-50%, -50%)", c.value.position = "fixed", delete c.value.opacity;
  }, M = () => {
    const S = lt(n), { top: R, left: N, transform: q } = i.altPosition(S);
    c.value = { top: `${R}px`, left: `${N}px`, transform: q ?? "" };
  }, T = (S = !0) => {
    var R;
    if (!a.value.enabled) {
      if (p.value)
        return w();
      if (i.altPosition !== null)
        return M();
      if (S) {
        const N = i.teleport ? (R = e.value) == null ? void 0 : R.$el : t.value;
        N && (l.value = N.getBoundingClientRect()), s("recalculate-position");
      }
      return F();
    }
  }, E = ({ inputEl: S, left: R, width: N }) => {
    window.screen.width > 768 && !u.value && g(R, N), Q(S);
  }, $ = (S) => {
    const { top: R, left: N, height: q, width: y } = b(S);
    c.value.top = `${q + R + +i.offset}px`, d.value = !1, u.value || (c.value.left = `${N + y / 2 - l.value.width / 2}px`), E({ inputEl: S, left: N, width: y });
  }, V = (S) => {
    const { top: R, left: N, width: q } = b(S);
    c.value.top = `${R - +i.offset - l.value.height}px`, d.value = !0, E({ inputEl: S, left: N, width: q });
  }, Q = (S) => {
    if (i.autoPosition) {
      const { left: R, width: N } = b(S), { left: q, right: y } = l.value;
      if (!u.value) {
        if (Math.abs(q) !== Math.abs(y)) {
          if (q <= 0)
            return u.value = !0, O(R);
          if (y >= document.documentElement.clientWidth)
            return u.value = !0, h(R, N);
        }
        return g(R, N);
      }
    }
  }, W = () => {
    const S = lt(n);
    if (S) {
      const { height: R } = l.value, { top: N, height: q } = S.getBoundingClientRect(), y = window.innerHeight - N - q, f = N;
      return R <= y ? zn.bottom : R > y && R <= f ? zn.top : y >= f ? zn.bottom : zn.top;
    }
    return zn.bottom;
  }, k = (S) => W() === zn.bottom ? $(S) : V(S), F = () => {
    const S = lt(n);
    if (S)
      return i.autoPosition ? k(S) : $(S);
  }, H = function(S) {
    if (S) {
      const R = S.scrollHeight > S.clientHeight, N = window.getComputedStyle(S).overflowY.indexOf("hidden") !== -1;
      return R && !N;
    }
    return !0;
  }, G = function(S) {
    return !S || S === document.body || S.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : H(S) ? S : G(S.parentNode);
  }, Y = (S) => {
    if (S)
      switch (i.position) {
        case yr.left:
          return { left: 0, transform: "translateX(0)" };
        case yr.right:
          return { left: `${S.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${S.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: d,
    menuStyle: c,
    xCorrect: u,
    setMenuPosition: T,
    getScrollableParent: G,
    shadowRender: (S, R) => {
      var N, q, y;
      const f = document.createElement("div"), L = (N = lt(n)) == null ? void 0 : N.getBoundingClientRect();
      f.setAttribute("id", "dp--temp-container");
      const B = (q = r.value) != null && q.clientWidth ? r.value : document.body;
      B.append(f);
      const J = Y(L), z = md(
        S,
        {
          ...R,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...J }
        },
        Object.fromEntries(
          Object.keys(o).filter((A) => ["right-sidebar", "left-sidebar"].includes(A)).map((A) => [A, o[A]])
        )
      );
      uo(z, f), l.value = (y = z.el) == null ? void 0 : y.getBoundingClientRect(), uo(null, f), B.removeChild(f);
    }
  };
}, xn = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] }
], M0 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], A0 = {
  all: () => xn,
  monthYear: () => xn.filter((t) => t.use.includes("month-year")),
  input: () => M0,
  timePicker: () => xn.filter((t) => t.use.includes("time")),
  action: () => xn.filter((t) => t.use.includes("action")),
  calendar: () => xn.filter((t) => t.use.includes("calendar")),
  menu: () => xn.filter((t) => t.use.includes("menu")),
  shared: () => xn.filter((t) => t.use.includes("shared")),
  yearMode: () => xn.filter((t) => t.use.includes("year-mode"))
}, At = (t, e, n) => {
  const r = [];
  return A0[e]().forEach((a) => {
    t[a.name] && r.push(a.name);
  }), n != null && n.length && n.forEach((a) => {
    a.slot && r.push(a.slot);
  }), r;
}, ha = (t) => {
  const e = X(() => (r) => t.value ? r ? t.value.open : t.value.close : ""), n = X(() => (r) => t.value ? r ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: n };
}, va = (t, e) => {
  const n = Z(Xt(/* @__PURE__ */ new Date(), t.timezone)), r = ee([{ month: Fe(n), year: Me(n) }]), a = la({
    hours: t.range ? [Jt(n), Jt(n)] : Jt(n),
    minutes: t.range ? [un(n), un(n)] : un(n),
    seconds: t.range ? [0, 0] : 0
  }), s = X({
    get: () => t.internalModelValue,
    set: (l) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", l);
    }
  }), i = X(
    () => (l) => r.value[l] ? r.value[l].month : 0
  ), o = X(
    () => (l) => r.value[l] ? r.value[l].year : 0
  );
  return {
    calendars: r,
    time: a,
    modelValue: s,
    month: i,
    year: o
  };
}, E0 = (t, e) => {
  const { defaultedMultiCalendars: n, defaultedHighlight: r } = it(e), { isDisabled: a, matchDate: s } = ir(e), i = ee(null), o = ee(Z(Xt(/* @__PURE__ */ new Date(), e.timezone))), l = (y) => {
    !y.current && e.hideOffsetDates || (i.value = y.value);
  }, u = () => {
    i.value = null;
  }, c = (y) => Array.isArray(t.value) && e.range && t.value[0] && i.value ? y ? wt(i.value, t.value[0]) : ft(i.value, t.value[0]) : !0, d = (y, f) => {
    const L = () => t.value ? f ? t.value[0] || null : t.value[1] : null, B = t.value && Array.isArray(t.value) ? L() : null;
    return Ue(Z(y.value), B);
  }, p = (y) => {
    const f = Array.isArray(t.value) ? t.value[0] : null;
    return y ? !ft(i.value ?? null, f) : !0;
  }, m = (y, f = !0) => (e.range || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !y.current ? !1 : Ue(Z(y.value), t.value[f ? 0 : 1]) : e.range ? d(y, f) && p(f) || Ue(y.value, Array.isArray(t.value) ? t.value[0] : null) && c(f) : !1, h = (y, f, L) => Array.isArray(t.value) && t.value[0] && t.value.length === 1 ? y ? !1 : L ? wt(t.value[0], f.value) : ft(t.value[0], f.value) : !1, O = (y) => !t.value || e.hideOffsetDates && !y.current ? !1 : e.range ? e.modelAuto && Array.isArray(t.value) ? Ue(y.value, t.value[0] ? t.value[0] : o.value) : !1 : e.multiDates && Array.isArray(t.value) ? t.value.some((f) => Ue(f, y.value)) : Ue(y.value, t.value ? t.value : o.value), g = (y) => {
    if (e.autoRange || e.weekPicker) {
      if (i.value) {
        if (e.hideOffsetDates && !y.current)
          return !1;
        const f = hn(i.value, +e.autoRange), L = Ia(Z(i.value), e.timezone, e.weekStart);
        return e.weekPicker ? Ue(L[1], Z(y.value)) : Ue(f, Z(y.value));
      }
      return !1;
    }
    return !1;
  }, b = (y) => {
    if (e.autoRange || e.weekPicker) {
      if (i.value) {
        const f = hn(i.value, +e.autoRange);
        if (e.hideOffsetDates && !y.current)
          return !1;
        const L = Ia(Z(i.value), e.timezone, e.weekStart);
        return e.weekPicker ? wt(y.value, L[0]) && ft(y.value, L[1]) : wt(y.value, i.value) && ft(y.value, f);
      }
      return !1;
    }
    return !1;
  }, w = (y) => {
    if (e.autoRange || e.weekPicker) {
      if (i.value) {
        if (e.hideOffsetDates && !y.current)
          return !1;
        const f = Ia(Z(i.value), e.timezone, e.weekStart);
        return e.weekPicker ? Ue(f[0], y.value) : Ue(i.value, y.value);
      }
      return !1;
    }
    return !1;
  }, M = (y) => ds(t.value, i.value, y.value), T = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, E = () => e.modelAuto ? Uc(e.internalModelValue) : !0, $ = (y) => {
    if (Array.isArray(t.value) && t.value.length || e.weekPicker)
      return !1;
    const f = e.range ? !m(y) && !m(y, !1) : !0;
    return !a(y.value) && !O(y) && !(!y.current && e.hideOffsetDates) && f;
  }, V = (y) => e.range ? e.modelAuto ? T() && O(y) : !1 : O(y), Q = (y) => {
    var f;
    return r.value ? typeof r.value == "function" ? r.value(y.value) : s(
      y.value,
      (f = e.arrMapValues) != null && f.highlightedDates ? e.arrMapValues.highlightedDates : r.value.dates
    ) : !1;
  }, W = (y) => {
    const f = a(y.value);
    return f && (typeof r.value == "function" ? !r.value(y.value, f) : !r.value.options.highlightDisabled);
  }, k = (y) => {
    var f;
    return typeof r.value == "function" ? r.value(y.value) : (f = r.value.weekdays) == null ? void 0 : f.includes(y.value.getDay());
  }, F = (y) => (e.range || e.weekPicker) && (!(n.value.count > 0) || y.current) && E() && !(!y.current && e.hideOffsetDates) && !O(y) ? M(y) : !1, H = (y) => {
    const { isRangeStart: f, isRangeEnd: L } = S(y), B = e.range ? f || L : !1;
    return {
      dp__cell_offset: !y.current,
      dp__pointer: !e.disabled && !(!y.current && e.hideOffsetDates) && !a(y.value),
      dp__cell_disabled: a(y.value),
      dp__cell_highlight: !W(y) && (Q(y) || k(y)) && !V(y) && !B && !w(y) && !(F(y) && e.weekPicker) && !L,
      dp__cell_highlight_active: !W(y) && (Q(y) || k(y)) && V(y),
      dp__today: !e.noToday && Ue(y.value, o.value) && y.current
    };
  }, G = (y) => ({
    dp__active_date: V(y),
    dp__date_hover: $(y)
  }), Y = (y) => ({
    ...R(y),
    ...N(y),
    dp__range_between_week: F(y) && e.weekPicker
  }), S = (y) => {
    const f = n.value.count > 0 ? y.current && m(y) && E() : m(y) && E(), L = n.value.count > 0 ? y.current && m(y, !1) && E() : m(y, !1) && E();
    return { isRangeStart: f, isRangeEnd: L };
  }, R = (y) => {
    const { isRangeStart: f, isRangeEnd: L } = S(y);
    return {
      dp__range_start: f,
      dp__range_end: L,
      dp__range_between: F(y) && !e.weekPicker,
      dp__date_hover_start: h($(y), y, !0),
      dp__date_hover_end: h($(y), y, !1)
    };
  }, N = (y) => ({
    ...R(y),
    dp__cell_auto_range: b(y),
    dp__cell_auto_range_start: w(y),
    dp__cell_auto_range_end: g(y)
  }), q = (y) => e.range ? e.autoRange ? N(y) : e.modelAuto ? { ...G(y), ...R(y) } : R(y) : e.weekPicker ? Y(y) : G(y);
  return {
    setHoverDate: l,
    clearHoverDate: u,
    getDayClassData: (y) => e.hideOffsetDates && !y.current ? {} : {
      ...H(y),
      ...q(y),
      [e.dayClass ? e.dayClass(y.value) : ""]: !0,
      [e.calendarCellClassName]: !!e.calendarCellClassName
    }
  };
}, ir = (t) => {
  const { defaultedFilters: e, defaultedHighlight: n } = it(t), r = () => {
    if (t.timezone)
      return t.timezone;
    if (t.utc)
      return "UTC";
  }, a = (k) => {
    const F = bt(s(Z(k))).toISOString(), [H] = F.split("T");
    return H;
  }, s = (k) => t.utc === "preserve" ? jc(k, r()) : Xt(k, r()), i = (k) => {
    var F;
    const H = t.maxDate ? wt(k, s(Z(t.maxDate))) : !1, G = t.minDate ? ft(k, s(Z(t.minDate))) : !1, Y = c(
      s(k),
      (F = t.arrMapValues) != null && F.disabledDates ? t.arrMapValues.disabledDates : t.disabledDates
    ), S = e.value.months.map((f) => +f).includes(Fe(k)), R = t.disabledWeekDays.length ? t.disabledWeekDays.some((f) => +f === ry(k)) : !1, N = p(k), q = Me(k), y = q < +t.yearRange[0] || q > +t.yearRange[1];
    return !(H || G || Y || S || y || R || N);
  }, o = (k, F) => ft(...En(t.minDate, k, F)) || Ue(...En(t.minDate, k, F)), l = (k, F) => wt(...En(t.maxDate, k, F)) || Ue(...En(t.maxDate, k, F)), u = (k, F, H) => {
    let G = !1;
    return t.maxDate && H && l(k, F) && (G = !0), t.minDate && !H && o(k, F) && (G = !0), G;
  }, c = (k, F) => k ? F instanceof Map ? !!F.get(a(k)) : Array.isArray(F) ? F.some((H) => Ue(s(Z(H)), k)) : F ? F(Z(JSON.parse(JSON.stringify(k)))) : !1 : !0, d = (k, F, H, G) => {
    let Y = !1;
    return G ? t.minDate && t.maxDate ? Y = u(k, F, H) : (t.minDate && o(k, F) || t.maxDate && l(k, F)) && (Y = !0) : Y = !0, Y;
  }, p = (k) => {
    var F, H, G, Y, S;
    return Array.isArray(t.allowedDates) && !((F = t.allowedDates) != null && F.length) ? !0 : (H = t.arrMapValues) != null && H.allowedDates ? !c(k, (G = t.arrMapValues) == null ? void 0 : G.allowedDates) : (Y = t.allowedDates) != null && Y.length ? !((S = t.allowedDates) != null && S.some(
      (R) => Ue(bt(R), s(bt(k)))
    )) : !1;
  }, m = (k) => !i(k), h = (k) => t.noDisabledRange ? !vc({ start: k[0], end: k[1] }).some((F) => m(F)) : !0, O = (k, F, H = 0) => {
    if (Array.isArray(F) && F[H]) {
      const G = tv(k, F[H]), Y = Hc(F[H], k), S = Y.length === 1 ? 0 : Y.filter((N) => m(N)).length, R = Math.abs(G) - S;
      if (t.minRange && t.maxRange)
        return R >= +t.minRange && R <= +t.maxRange;
      if (t.minRange)
        return R >= +t.minRange;
      if (t.maxRange)
        return R <= +t.maxRange;
    }
    return !0;
  }, g = (k) => new Map(k.map((F) => [a(F), !0])), b = (k) => Array.isArray(k) && k.length > 0, w = () => {
    const k = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return b(t.allowedDates) && (k.allowedDates = g(t.allowedDates)), typeof n.value != "function" && b(n.value.dates) && (k.highlightedDates = g(n.value.dates)), b(t.disabledDates) && (k.disabledDates = g(t.disabledDates)), k;
  }, M = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, T = (k) => Array.isArray(k) ? [k[0] ? $s(k[0]) : null, k[1] ? $s(k[1]) : null] : $s(k), E = (k, F, H) => k.find(
    (G) => +G.hours === Jt(F) && G.minutes === "*" ? !0 : +G.minutes === un(F) && +G.hours === Jt(F)
  ) && H, $ = (k, F, H) => {
    const [G, Y] = k, [S, R] = F;
    return !E(G, S, H) && !E(Y, R, H) && H;
  }, V = (k, F) => {
    const H = Array.isArray(F) ? F : [F];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? $(t.disabledTimes, H, k) : !H.some((G) => E(t.disabledTimes, G, k)) : k;
  }, Q = (k, F) => {
    const H = Array.isArray(F) ? [Xn(F[0]), F[1] ? Xn(F[1]) : void 0] : Xn(F), G = !t.disabledTimes(H);
    return k && G;
  }, W = (k, F) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? V(F, k) : Q(F, k) : F;
  return {
    isDisabled: m,
    validateDate: i,
    validateMonthYearInRange: d,
    isDateRangeAllowed: h,
    checkMinMaxRange: O,
    matchDate: c,
    mapDatesArrToMap: w,
    isValidTime: (k) => {
      let F = !0;
      if (!k || M())
        return !0;
      const H = !t.minDate && !t.maxDate ? T(k) : k;
      return (t.maxTime || t.maxDate) && (F = Sl(
        t.maxTime,
        t.maxDate,
        "max",
        ut(H),
        F
      )), (t.minTime || t.minDate) && (F = Sl(
        t.minTime,
        t.minDate,
        "min",
        ut(H),
        F
      )), W(k, F);
    }
  };
}, fs = () => {
  const t = X(() => (r, a) => r == null ? void 0 : r.includes(a)), e = X(() => (r, a) => r.count ? r.solo ? !0 : a === 0 : !0), n = X(() => (r, a) => r.count ? r.solo ? !0 : a === r.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: n };
}, P0 = (t, e, n) => {
  const r = ee(0), a = la({
    [Qn.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Qn.calendar]: !1,
    [Qn.header]: !1
  }), s = X(() => t.monthPicker), i = (d) => {
    var p;
    if ((p = t.flow) != null && p.length) {
      if (!d && s.value)
        return c();
      a[d] = !0, Object.keys(a).filter((m) => !a[m]).length || c();
    }
  }, o = () => {
    var d;
    (d = t.flow) != null && d.length && r.value !== -1 && (r.value += 1, e("flow-step", r.value), c());
  }, l = () => {
    r.value = -1;
  }, u = (d, p, ...m) => {
    t.flow[r.value] === d && n.value && n.value[p](...m);
  }, c = () => {
    u(an.month, "toggleMonthPicker", !0), u(an.year, "toggleYearPicker", !0), u(an.calendar, "toggleTimePicker", !1, !0), u(an.time, "toggleTimePicker", !0, !0);
    const d = t.flow[r.value];
    (d === an.hours || d === an.minutes || d === an.seconds) && u(d, "toggleTimePicker", !0, !0, d);
  };
  return { childMount: i, updateFlowStep: o, resetFlow: l, flowStep: r };
}, ps = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function, Object],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 }
}, en = {
  ...ps,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  arrMapValues: { type: Object, default: () => ({}) },
  noOverlayFocus: { type: Boolean, default: !1 }
}, F0 = {
  key: 1,
  class: "dp__input_wrap"
}, N0 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], R0 = {
  key: 2,
  class: "dp__clear_icon"
}, V0 = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...ps
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, {
      defaultedTextInput: s,
      defaultedAriaLabels: i,
      defaultedInline: o,
      defaultedConfig: l,
      getDefaultPattern: u,
      getDefaultStartTime: c
    } = it(a), { checkMinMaxRange: d } = ir(a), p = ee(), m = ee(null), h = ee(!1), O = ee(!1), g = X(
      () => ({
        dp__pointer: !a.disabled && !a.readonly && !s.value.enabled,
        dp__disabled: a.disabled,
        dp__input_readonly: !s.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !a.hideInputIcon,
        dp__input_valid: !!a.state,
        dp__input_invalid: a.state === !1,
        dp__input_focus: h.value || a.isMenuOpen,
        dp__input_reg: !s.value.enabled,
        [a.inputClassName]: !!a.inputClassName
      })
    ), b = () => {
      r("set-input-date", null), a.autoApply && (r("set-empty-date"), p.value = null);
    }, w = (Y) => {
      const S = c();
      return o0(
        Y,
        s.value.format ?? u(),
        S ?? qc({}, a.enableSeconds),
        a.inputValue,
        O.value
      );
    }, M = (Y) => {
      const { rangeSeparator: S } = s.value, [R, N] = Y.split(`${S}`);
      if (R) {
        const q = w(R.trim()), y = N ? w(N.trim()) : null, f = q && y ? [q, y] : [q];
        d(y, f, 0) && (p.value = q ? f : null);
      }
    }, T = () => {
      O.value = !0;
    }, E = (Y) => {
      if (a.range)
        M(Y);
      else if (a.multiDates) {
        const S = Y.split(";");
        p.value = S.map((R) => w(R.trim())).filter((R) => R);
      } else
        p.value = w(Y);
    }, $ = (Y) => {
      var S;
      const R = typeof Y == "string" ? Y : (S = Y.target) == null ? void 0 : S.value;
      R !== "" ? (s.value.openMenu && !a.isMenuOpen && r("open"), E(R), r("set-input-date", p.value)) : b(), O.value = !1, r("update:input-value", R);
    }, V = (Y) => {
      s.value.enabled ? (E(Y.target.value), s.value.enterSubmit && vi(p.value) && a.inputValue !== "" ? (r("set-input-date", p.value, !0), p.value = null) : s.value.enterSubmit && a.inputValue === "" && (p.value = null, r("clear"))) : k(Y);
    }, Q = (Y) => {
      s.value.enabled && s.value.tabSubmit && E(Y.target.value), s.value.tabSubmit && vi(p.value) && a.inputValue !== "" ? (r("set-input-date", p.value, !0, !0), p.value = null) : s.value.tabSubmit && a.inputValue === "" && (p.value = null, r("clear", !0));
    }, W = () => {
      var Y;
      h.value = !0, r("focus"), s.value.enabled && s.value.selectOnFocus && ((Y = m.value) == null || Y.select());
    }, k = (Y) => {
      Y.preventDefault(), Vn(Y, l.value, !0), s.value.enabled && s.value.openMenu && !o.value.input && !a.isMenuOpen ? r("open") : s.value.enabled || r("toggle");
    }, F = () => {
      r("real-blur"), h.value = !1, (!a.isMenuOpen || o.value.enabled && o.value.input) && r("blur"), a.autoApply && s.value.enabled && p.value && !a.isMenuOpen && (r("set-input-date", p.value), r("select-date"), p.value = null);
    }, H = (Y) => {
      Vn(Y, l.value, !0), r("clear");
    }, G = (Y) => {
      if (!s.value.enabled) {
        if (Y.code === "Tab")
          return;
        Y.preventDefault();
      }
    };
    return e({
      focusInput: () => {
        var Y;
        (Y = m.value) == null || Y.focus({ preventScroll: !0 });
      },
      setParsedDate: (Y) => {
        p.value = Y;
      }
    }), (Y, S) => {
      var R;
      return v(), x("div", { onClick: k }, [
        Y.$slots.trigger && !Y.$slots["dp-input"] && !D(o).enabled ? ne(Y.$slots, "trigger", { key: 0 }) : I("", !0),
        !Y.$slots.trigger && (!D(o).enabled || D(o).input) ? (v(), x("div", F0, [
          Y.$slots["dp-input"] && !Y.$slots.trigger && !D(o).enabled ? ne(Y.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: $,
            onEnter: V,
            onTab: Q,
            onClear: H,
            onBlur: F,
            onKeypress: G,
            onPaste: T,
            openMenu: () => Y.$emit("open"),
            closeMenu: () => Y.$emit("close"),
            toggleMenu: () => Y.$emit("toggle")
          }) : I("", !0),
          Y.$slots["dp-input"] ? I("", !0) : (v(), x("input", {
            key: 1,
            id: Y.uid ? `dp-input-${Y.uid}` : void 0,
            ref_key: "inputRef",
            ref: m,
            name: Y.name,
            class: pe(g.value),
            inputmode: D(s).enabled ? "text" : "none",
            placeholder: Y.placeholder,
            disabled: Y.disabled,
            readonly: Y.readonly,
            required: Y.required,
            value: t.inputValue,
            autocomplete: Y.autocomplete,
            "aria-label": (R = D(i)) == null ? void 0 : R.input,
            "aria-disabled": Y.disabled || void 0,
            "aria-invalid": Y.state === !1 ? !0 : void 0,
            onInput: $,
            onKeydown: [
              De(V, ["enter"]),
              De(Q, ["tab"]),
              G
            ],
            onBlur: F,
            onFocus: W,
            onKeypress: G,
            onPaste: T
          }, null, 42, N0)),
          C("div", {
            onClick: S[2] || (S[2] = (N) => r("toggle"))
          }, [
            Y.$slots["input-icon"] && !Y.hideInputIcon ? (v(), x("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: S[0] || (S[0] = (N) => r("toggle"))
            }, [
              ne(Y.$slots, "input-icon")
            ])) : I("", !0),
            !Y.$slots["input-icon"] && !Y.hideInputIcon && !Y.$slots["dp-input"] ? (v(), fe(D(Lr), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: S[1] || (S[1] = (N) => r("toggle"))
            })) : I("", !0)
          ]),
          Y.$slots["clear-icon"] && t.inputValue && Y.clearable && !Y.disabled && !Y.readonly ? (v(), x("span", R0, [
            ne(Y.$slots, "clear-icon", { clear: H })
          ])) : I("", !0),
          Y.clearable && !Y.$slots["clear-icon"] && t.inputValue && !Y.disabled && !Y.readonly ? (v(), fe(D(Vc), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: S[3] || (S[3] = we((N) => H(N), ["prevent"]))
          })) : I("", !0)
        ])) : I("", !0)
      ]);
    };
  }
}), I0 = ["title"], L0 = { class: "dp__action_buttons" }, $0 = ["disabled"], Y0 = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...en
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const n = e, r = t, {
      defaultedActionRow: a,
      defaultedPreviewFormat: s,
      defaultedMultiCalendars: i,
      defaultedTextInput: o,
      defaultedInline: l,
      getDefaultPattern: u
    } = it(r), { isValidTime: c } = ir(r), { buildMatrix: d } = Un(), p = ee(null), m = ee(null);
    Dt(() => {
      r.arrowNavigation && d([lt(p), lt(m)], "actionRow");
    });
    const h = X(() => r.range && !r.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), O = X(() => !g.value || !b.value || !h.value), g = X(() => !r.enableTimePicker || r.ignoreTimeValidation ? !0 : c(r.internalModelValue)), b = X(() => r.monthPicker ? r.range && Array.isArray(r.internalModelValue) ? !r.internalModelValue.filter((k) => !Q(k)).length : Q(r.internalModelValue) : !0), w = () => {
      const k = s.value;
      return r.timePicker || r.monthPicker, k(ut(r.internalModelValue));
    }, M = () => {
      const k = r.internalModelValue;
      return i.value.count > 0 ? `${T(k[0])} - ${T(k[1])}` : [T(k[0]), T(k[1])];
    }, T = (k) => Zc(
      k,
      s.value,
      r.formatLocale,
      o.value.rangeSeparator,
      r.modelAuto,
      u()
    ), E = X(() => !r.internalModelValue || !r.menuMount ? "" : typeof s.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? M() : r.multiDates ? r.internalModelValue.map((k) => `${T(k)}`) : r.modelAuto ? `${T(r.internalModelValue[0])}` : `${T(r.internalModelValue[0])} -` : T(r.internalModelValue) : w()), $ = () => r.multiDates ? "; " : " - ", V = X(
      () => Array.isArray(E.value) ? E.value.join($()) : E.value
    ), Q = (k) => {
      if (!r.monthPicker)
        return !0;
      let F = !0;
      const H = Z(qt(k));
      if (r.minDate && r.maxDate) {
        const G = Z(qt(r.minDate)), Y = Z(qt(r.maxDate));
        return wt(H, G) && ft(H, Y) || Ue(H, G) || Ue(H, Y);
      }
      if (r.minDate) {
        const G = Z(qt(r.minDate));
        F = wt(H, G) || Ue(H, G);
      }
      if (r.maxDate) {
        const G = Z(qt(r.maxDate));
        F = ft(H, G) || Ue(H, G);
      }
      return F;
    }, W = () => {
      g.value && b.value && h.value ? n("select-date") : n("invalid-select");
    };
    return (k, F) => (v(), x("div", {
      class: "dp__action_row",
      style: zt(t.calendarWidth ? { width: `${t.calendarWidth}px` } : {})
    }, [
      k.$slots["action-row"] ? ne(k.$slots, "action-row", Ye(Be({ key: 0 }, {
        internalModelValue: k.internalModelValue,
        disabled: O.value,
        selectDate: () => k.$emit("select-date"),
        closePicker: () => k.$emit("close-picker")
      }))) : (v(), x(ve, { key: 1 }, [
        D(a).showPreview ? (v(), x("div", {
          key: 0,
          class: "dp__selection_preview",
          title: V.value
        }, [
          k.$slots["action-preview"] ? ne(k.$slots, "action-preview", {
            key: 0,
            value: k.internalModelValue
          }) : I("", !0),
          k.$slots["action-preview"] ? I("", !0) : (v(), x(ve, { key: 1 }, [
            Xe(ze(V.value), 1)
          ], 64))
        ], 8, I0)) : I("", !0),
        C("div", L0, [
          k.$slots["action-buttons"] ? ne(k.$slots, "action-buttons", {
            key: 0,
            value: k.internalModelValue
          }) : I("", !0),
          k.$slots["action-buttons"] ? I("", !0) : (v(), x(ve, { key: 1 }, [
            !D(l).enabled && D(a).showCancel ? (v(), x("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: F[0] || (F[0] = (H) => k.$emit("close-picker")),
              onKeydown: [
                F[1] || (F[1] = De((H) => k.$emit("close-picker"), ["enter"])),
                F[2] || (F[2] = De((H) => k.$emit("close-picker"), ["space"]))
              ]
            }, ze(k.cancelText), 545)) : I("", !0),
            D(a).showNow ? (v(), x("button", {
              key: 1,
              ref_key: "cancelButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: F[3] || (F[3] = (H) => k.$emit("select-now")),
              onKeydown: [
                F[4] || (F[4] = De((H) => k.$emit("select-now"), ["enter"])),
                F[5] || (F[5] = De((H) => k.$emit("select-now"), ["space"]))
              ]
            }, ze(k.nowButtonLabel), 545)) : I("", !0),
            D(a).showSelect ? (v(), x("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: m,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: O.value,
              onKeydown: [
                De(W, ["enter"]),
                De(W, ["space"])
              ],
              onClick: W
            }, ze(k.selectText), 41, $0)) : I("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), U0 = ["onKeydown"], B0 = { class: "dp__selection_grid_header" }, W0 = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], j0 = ["aria-label"], ya = /* @__PURE__ */ pt({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: n }) {
    const { setSelectionGrid: r, buildMultiLevelMatrix: a, setMonthPicker: s } = Un(), i = n, o = t, { defaultedAriaLabels: l, defaultedTextInput: u, defaultedConfig: c } = it(
      o
    ), { hideNavigationButtons: d } = fs(), p = ee(!1), m = ee(null), h = ee(null), O = ee([]), g = ee(), b = ee(null), w = ee(0), M = ee(null);
    hd(() => {
      m.value = null;
    }), Dt(() => {
      Ln().then(() => F()), o.noOverlayFocus || E(), T(!0);
    }), bi(() => T(!1));
    const T = (y) => {
      var f;
      o.arrowNavigation && ((f = o.headerRefs) != null && f.length ? s(y) : r(y));
    }, E = () => {
      var y;
      const f = lt(h);
      f && (u.value.enabled || (m.value ? (y = m.value) == null || y.focus({ preventScroll: !0 }) : f.focus({ preventScroll: !0 })), p.value = f.clientHeight < f.scrollHeight);
    }, $ = X(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !o.useRelative,
        "dp--overlay-relative": o.useRelative
      })
    ), V = X(
      () => o.useRelative ? { height: `${o.height}px`, width: "260px" } : void 0
    ), Q = X(() => ({
      dp__overlay_col: !0
    })), W = X(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: p.value,
        dp__button_bottom: o.isLast
      })
    ), k = X(() => {
      var y, f;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((y = o.items) == null ? void 0 : y.length) <= 6,
        dp__container_block: ((f = o.items) == null ? void 0 : f.length) > 6
      };
    });
    gn(
      () => o.items,
      () => F(),
      { deep: !0 }
    );
    const F = () => {
      Ln().then(() => {
        const y = lt(m), f = lt(h), L = lt(b), B = lt(M), J = L ? L.getBoundingClientRect().height : 0;
        f && (f.getBoundingClientRect().height ? w.value = f.getBoundingClientRect().height - J : w.value = c.value.modeHeight - J), y && B && (B.scrollTop = y.offsetTop - B.offsetTop - (w.value / 2 - y.getBoundingClientRect().height) - J);
      });
    }, H = (y) => {
      y.disabled || i("selected", y.value);
    }, G = () => {
      i("toggle"), i("reset-flow");
    }, Y = () => {
      o.escClose && G();
    }, S = (y, f, L, B) => {
      y && ((f.active || f.value === o.focusValue) && (m.value = y), o.arrowNavigation && (Array.isArray(O.value[L]) ? O.value[L][B] = y : O.value[L] = [y], R()));
    }, R = () => {
      var y, f;
      const L = (y = o.headerRefs) != null && y.length ? [o.headerRefs].concat(O.value) : O.value.concat([o.skipButtonRef ? [] : [b.value]]);
      a(ut(L), (f = o.headerRefs) != null && f.length ? "monthPicker" : "selectionGrid");
    }, N = (y) => {
      o.arrowNavigation || Vn(y, c.value, !0);
    }, q = (y) => {
      g.value = y, i("hover-value", y);
    };
    return e({ focusGrid: E }), (y, f) => {
      var L;
      return v(), x("div", {
        ref_key: "gridWrapRef",
        ref: h,
        class: pe($.value),
        style: zt(V.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          De(we(Y, ["prevent"]), ["esc"]),
          f[0] || (f[0] = De(we((B) => N(B), ["prevent"]), ["left"])),
          f[1] || (f[1] = De(we((B) => N(B), ["prevent"]), ["up"])),
          f[2] || (f[2] = De(we((B) => N(B), ["prevent"]), ["down"])),
          f[3] || (f[3] = De(we((B) => N(B), ["prevent"]), ["right"]))
        ]
      }, [
        C("div", {
          ref_key: "containerRef",
          ref: M,
          class: pe(k.value),
          role: "grid",
          style: zt({ height: `${w.value}px` })
        }, [
          C("div", B0, [
            ne(y.$slots, "header")
          ]),
          y.$slots.overlay ? ne(y.$slots, "overlay", { key: 0 }) : (v(!0), x(ve, { key: 1 }, Re(y.items, (B, J) => (v(), x("div", {
            key: J,
            class: pe(["dp__overlay_row", { dp__flex_row: y.items.length >= 3 }]),
            role: "row"
          }, [
            (v(!0), x(ve, null, Re(B, (z, A) => (v(), x("div", {
              key: z.value,
              ref_for: !0,
              ref: (_) => S(_, z, J, A),
              role: "gridcell",
              class: pe(Q.value),
              "aria-selected": z.active,
              "aria-disabled": z.disabled || void 0,
              tabindex: "0",
              onClick: (_) => H(z),
              onKeydown: [
                De(we((_) => H(z), ["prevent"]), ["enter"]),
                De(we((_) => H(z), ["prevent"]), ["space"])
              ],
              onMouseover: (_) => q(z.value)
            }, [
              C("div", {
                class: pe(z.className)
              }, [
                y.$slots.item ? ne(y.$slots, "item", {
                  key: 0,
                  item: z
                }) : I("", !0),
                y.$slots.item ? I("", !0) : (v(), x(ve, { key: 1 }, [
                  Xe(ze(z.text), 1)
                ], 64))
              ], 2)
            ], 42, W0))), 128))
          ], 2))), 128))
        ], 6),
        y.$slots["button-icon"] ? _t((v(), x("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: b,
          type: "button",
          "aria-label": (L = D(l)) == null ? void 0 : L.toggleOverlay,
          class: pe(W.value),
          tabindex: "0",
          onClick: G,
          onKeydown: [
            De(G, ["enter"]),
            De(G, ["tab"])
          ]
        }, [
          ne(y.$slots, "button-icon")
        ], 42, j0)), [
          [Fn, !D(d)(y.hideNavigation, y.type)]
        ]) : I("", !0)
      ], 46, U0);
    };
  }
}), ms = /* @__PURE__ */ pt({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean }
  },
  setup(t) {
    const e = t, n = X(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), r = X(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (a, s) => (v(), x("div", {
      class: pe({
        dp__menu_inner: !a.stretch,
        "dp--menu--inner-stretched": a.stretch,
        dp__flex_display: a.multiCalendars > 0
      })
    }, [
      (v(!0), x(ve, null, Re(n.value, (i, o) => (v(), x("div", {
        key: i,
        class: pe(r.value)
      }, [
        ne(a.$slots, "default", {
          instance: i,
          index: o
        })
      ], 2))), 128))
    ], 2));
  }
}), H0 = ["aria-label", "aria-disabled"], Jr = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const n = e, r = ee(null);
    return Dt(() => n("set-ref", r)), (a, s) => (v(), x("button", {
      ref_key: "elRef",
      ref: r,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": a.ariaLabel,
      "aria-disabled": a.disabled || void 0,
      onClick: s[0] || (s[0] = (i) => a.$emit("activate")),
      onKeydown: [
        s[1] || (s[1] = De(we((i) => a.$emit("activate"), ["prevent"]), ["enter"])),
        s[2] || (s[2] = De(we((i) => a.$emit("activate"), ["prevent"]), ["space"]))
      ]
    }, [
      C("span", {
        class: pe(["dp__inner_nav", { dp__inner_nav_disabled: a.disabled }])
      }, [
        ne(a.$slots, "default")
      ], 2)
    ], 40, H0));
  }
}), q0 = { class: "dp--year-mode-picker" }, z0 = ["aria-label"], Xc = /* @__PURE__ */ pt({
  __name: "YearModePicker",
  props: {
    ...en,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const n = e, r = t, { showRightIcon: a, showLeftIcon: s } = fs(), { defaultedConfig: i, defaultedMultiCalendars: o, defaultedAriaLabels: l, defaultedTransitions: u } = it(r), { showTransition: c, transitionName: d } = ha(u), p = (O = !1, g) => {
      n("toggle-year-picker", { flow: O, show: g });
    }, m = (O) => {
      n("year-select", O);
    }, h = (O = !1) => {
      n("handle-year", O);
    };
    return (O, g) => {
      var b, w, M;
      return v(), x("div", q0, [
        D(s)(D(o), t.instance) ? (v(), fe(Jr, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (b = D(l)) == null ? void 0 : b.prevYear,
          disabled: t.isDisabled(!1),
          onActivate: g[0] || (g[0] = (T) => h(!1))
        }, {
          default: _e(() => [
            O.$slots["arrow-left"] ? ne(O.$slots, "arrow-left", { key: 0 }) : I("", !0),
            O.$slots["arrow-left"] ? I("", !0) : (v(), fe(D(Bi), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : I("", !0),
        C("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (w = D(l)) == null ? void 0 : w.openYearsOverlay,
          onClick: g[1] || (g[1] = () => p(!1)),
          onKeydown: g[2] || (g[2] = De(() => p(!1), ["enter"]))
        }, [
          O.$slots.year ? ne(O.$slots, "year", {
            key: 0,
            year: t.year
          }) : I("", !0),
          O.$slots.year ? I("", !0) : (v(), x(ve, { key: 1 }, [
            Xe(ze(t.year), 1)
          ], 64))
        ], 40, z0),
        D(a)(D(o), t.instance) ? (v(), fe(Jr, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (M = D(l)) == null ? void 0 : M.nextYear,
          disabled: t.isDisabled(!0),
          onActivate: g[3] || (g[3] = (T) => h(!0))
        }, {
          default: _e(() => [
            O.$slots["arrow-right"] ? ne(O.$slots, "arrow-right", { key: 0 }) : I("", !0),
            O.$slots["arrow-right"] ? I("", !0) : (v(), fe(D(Wi), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : I("", !0),
        He(Yn, {
          name: D(d)(t.showYearPicker),
          css: D(c)
        }, {
          default: _e(() => [
            t.showYearPicker ? (v(), fe(ya, {
              key: 0,
              items: t.items,
              "text-input": O.textInput,
              "esc-close": O.escClose,
              config: O.config,
              "is-last": O.autoApply && !D(i).keepActionRow,
              "hide-navigation": O.hideNavigation,
              type: "year",
              onToggle: p,
              onSelected: g[4] || (g[4] = (T) => m(T))
            }, St({
              "button-icon": _e(() => [
                O.$slots["calendar-icon"] ? ne(O.$slots, "calendar-icon", { key: 0 }) : I("", !0),
                O.$slots["calendar-icon"] ? I("", !0) : (v(), fe(D(Lr), { key: 1 }))
              ]),
              _: 2
            }, [
              O.$slots["year-overlay-value"] ? {
                name: "item",
                fn: _e(({ item: T }) => [
                  ne(O.$slots, "year-overlay-value", {
                    text: T.text,
                    value: T.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation"])) : I("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Qi = (t, e, n) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((r) => Ue(t, r))) {
      const r = e.value.filter((a) => !Ue(a, t));
      e.value = r.length ? r : null;
    } else
      (n && +n > e.value.length || !n) && e.value.push(t);
  else
    e.value = [t];
}, Ki = (t, e, n) => {
  let r = t.value ? t.value.slice() : [];
  return r.length === 2 && r[1] !== null && (r = []), r.length ? ft(e, r[0]) ? (r.unshift(e), n("range-start", r[0]), n("range-start", r[1])) : (r[1] = e, n("range-end", e)) : (r = [e], n("range-start", e)), t.value = r, r;
}, hs = (t, e, n, r) => {
  t[0] && t[1] && n && e("auto-apply"), t[0] && !t[1] && r && n && e("auto-apply");
}, Qc = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => Xt(Z(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = Xt(Z(t.value), t.timezone));
}, Kc = ({
  multiCalendars: t,
  highlight: e,
  calendars: n,
  modelValue: r,
  props: a,
  year: s,
  month: i,
  emit: o
}) => {
  const l = X(() => Ji(a.yearRange, a.reverseYears)), u = ee([!1]), c = X(() => (T, E) => {
    const $ = Je(qt(/* @__PURE__ */ new Date()), {
      month: i.value(T),
      year: s.value(T)
    });
    return zc($, a.maxDate, a.minDate, a.preventMinMaxNavigation, E);
  }), d = () => {
    for (let T = 0; T < t.value.count; T++)
      if (T === 0)
        n.value[T] = n.value[0];
      else {
        const E = Je(Z(), n.value[T - 1]);
        n.value[T] = { month: Fe(E), year: Me(Ni(E, 1)) };
      }
  }, p = (T) => {
    if (!T)
      return d();
    const E = Je(Z(), n.value[T]);
    return n.value[0].year = Me(Rc(E, t.value.count - 1)), d();
  }, m = (T) => a.focusStartDate ? T[0] : T[1] ? T[1] : T[0], h = () => {
    if (r.value) {
      const T = Array.isArray(r.value) ? m(r.value) : r.value;
      n.value[0] = { month: Fe(T), year: Me(T) };
    }
  };
  Dt(() => {
    h(), t.value.count && d();
  });
  const O = (T, E) => {
    n.value[E].year = T, t.value.count && !t.value.solo && p(E);
  }, g = X(() => (T) => Dr(l.value, (E) => {
    const $ = s.value(T) === E.value, V = sa(E.value, Cr(a.minDate), Cr(a.maxDate)), Q = Xi(e.value, E.value);
    return { active: $, disabled: V, highlighted: Q };
  })), b = (T, E) => {
    O(T, E), M(E);
  }, w = (T, E = !1) => {
    if (!c.value(T, E)) {
      const $ = E ? s.value(T) + 1 : s.value(T) - 1;
      O($, T);
    }
  }, M = (T, E = !1, $) => {
    E || o("reset-flow"), $ !== void 0 ? u.value[T] = $ : u.value[T] = !u.value[T], u.value || o("overlay-closed");
  };
  return {
    isDisabled: c,
    groupedYears: g,
    showYearPicker: u,
    selectYear: O,
    toggleYearPicker: M,
    handleYearSelect: b,
    handleYear: w
  };
}, Z0 = (t, e) => {
  const { defaultedMultiCalendars: n, defaultedAriaLabels: r, defaultedTransitions: a, defaultedConfig: s, defaultedHighlight: i } = it(t), { modelValue: o, year: l, month: u, calendars: c } = va(t, e), d = X(() => Yc(t.formatLocale, t.locale, t.monthNameFormat)), p = ee(null), {
    selectYear: m,
    groupedYears: h,
    showYearPicker: O,
    toggleYearPicker: g,
    handleYearSelect: b,
    handleYear: w,
    isDisabled: M
  } = Kc({
    modelValue: o,
    multiCalendars: n,
    highlight: i,
    calendars: c,
    year: l,
    month: u,
    props: t,
    emit: e
  });
  Dt(() => {
    t.startDate && (o.value && t.focusStartDate || !o.value) && m(Me(Z(t.startDate)), 0);
  });
  const T = (N) => N ? { month: Fe(N), year: Me(N) } : { month: null, year: null }, E = () => o.value ? Array.isArray(o.value) ? o.value.map((N) => T(N)) : T(o.value) : T(), $ = (N, q) => {
    const y = c.value[N], f = E();
    return Array.isArray(f) ? f.some((L) => L.year === (y == null ? void 0 : y.year) && L.month === q) : (y == null ? void 0 : y.year) === f.year && q === f.month;
  }, V = (N, q, y) => {
    var f, L;
    const B = E();
    return Array.isArray(B) ? l.value(q) === ((f = B[y]) == null ? void 0 : f.year) && N === ((L = B[y]) == null ? void 0 : L.month) : !1;
  }, Q = (N, q) => {
    if (t.range) {
      const y = E();
      if (Array.isArray(o.value) && Array.isArray(y)) {
        const f = V(N, q, 0) || V(N, q, 1), L = vn(qt(Z()), N, l.value(q));
        return ds(o.value, p.value, L) && !f;
      }
      return !1;
    }
    return !1;
  }, W = X(() => (N) => Dr(d.value, (q) => {
    const y = $(N, q.value), f = sa(
      q.value,
      Bc(l.value(N), t.minDate),
      Wc(l.value(N), t.maxDate)
    ) || m0(t.disabledDates, l.value(N)).includes(q.value), L = Q(q.value, N), B = Gc(i.value, q.value, l.value(N));
    return { active: y, disabled: f, isBetween: L, highlighted: B };
  })), k = (N, q) => vn(qt(Z()), N, l.value(q)), F = (N, q) => {
    const y = o.value ? o.value : qt(/* @__PURE__ */ new Date());
    o.value = vn(y, N, l.value(q)), e("auto-apply");
  }, H = (N, q) => {
    const y = Ki(o, k(N, q), e);
    hs(y, e, t.autoApply, t.modelAuto);
  }, G = (N, q) => {
    Qi(k(N, q), o, t.multiDatesLimit), e("auto-apply", !0);
  }, Y = (N, q) => (c.value[q].month = N, R(q, c.value[q].year, N), t.multiDates ? G(N, q) : t.range ? H(N, q) : F(N, q)), S = (N, q) => {
    m(N, q), R(q, N, null);
  }, R = (N, q, y) => {
    let f = y;
    if (!f && f !== 0) {
      const L = E();
      f = Array.isArray(L) ? L[N].month : L.month;
    }
    e("update-month-year", { instance: N, year: q, month: f });
  };
  return {
    groupedMonths: W,
    groupedYears: h,
    year: l,
    isDisabled: M,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: r,
    defaultedTransitions: a,
    defaultedConfig: s,
    showYearPicker: O,
    modelValue: o,
    presetDate: (N, q) => {
      Qc({ value: N, modelValue: o, range: t.range, timezone: q ? void 0 : t.timezone }), e("auto-apply");
    },
    setHoverDate: (N, q) => {
      p.value = k(N, q);
    },
    selectMonth: Y,
    selectYear: S,
    toggleYearPicker: g,
    handleYearSelect: b,
    handleYear: w,
    getModelMonthYear: E
  };
}, G0 = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...en
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "mount"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = ar(), s = At(a, "yearMode"), i = t;
    Dt(() => {
      i.shadow || r("mount", null);
    });
    const {
      groupedMonths: o,
      groupedYears: l,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: d,
      defaultedConfig: p,
      showYearPicker: m,
      modelValue: h,
      presetDate: O,
      setHoverDate: g,
      selectMonth: b,
      selectYear: w,
      toggleYearPicker: M,
      handleYearSelect: T,
      handleYear: E,
      getModelMonthYear: $
    } = Z0(i, r);
    return e({ getSidebarProps: () => ({
      modelValue: h,
      year: u,
      getModelMonthYear: $,
      selectMonth: b,
      selectYear: w,
      handleYear: E
    }), presetDate: O, toggleYearPicker: (V) => M(0, V) }), (V, Q) => (v(), fe(ms, {
      "multi-calendars": D(d).count,
      stretch: ""
    }, {
      default: _e(({ instance: W }) => [
        V.$slots["month-year"] ? ne(V.$slots, "month-year", Ye(Be({ key: 0 }, {
          year: D(u),
          months: D(o)(W),
          years: D(l)(W),
          selectMonth: D(b),
          selectYear: D(w),
          instance: W
        }))) : (v(), fe(ya, {
          key: 1,
          items: D(o)(W),
          "arrow-navigation": V.arrowNavigation,
          "is-last": V.autoApply && !D(p).keepActionRow,
          "esc-close": V.escClose,
          height: D(p).modeHeight,
          config: V.config,
          "no-overlay-focus": !!(V.noOverlayFocus || V.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (k) => D(b)(k, W),
          onHoverValue: (k) => D(g)(k, W)
        }, {
          header: _e(() => [
            He(Xc, Be(V.$props, {
              items: D(l)(W),
              instance: W,
              "show-year-picker": D(m)[W],
              year: D(u)(W),
              "is-disabled": (k) => D(c)(W, k),
              onHandleYear: (k) => D(E)(W, k),
              onYearSelect: (k) => D(T)(k, W),
              onToggleYearPicker: (k) => D(M)(W, k == null ? void 0 : k.flow, k == null ? void 0 : k.show)
            }), St({ _: 2 }, [
              Re(D(s), (k, F) => ({
                name: k,
                fn: _e((H) => [
                  ne(V.$slots, k, Ye(Ge(H)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), J0 = (t, e) => {
  const { modelValue: n } = va(t, e), r = ee(null), { defaultedHighlight: a, defaultedFilters: s } = it(t), i = ee();
  Dt(() => {
    t.startDate && (n.value && t.focusStartDate || !n.value) && (i.value = Me(Z(t.startDate)));
  });
  const o = (d) => Array.isArray(n.value) ? n.value.some((p) => Me(p) === d) : n.value ? Me(n.value) === d : !1, l = (d) => t.range && Array.isArray(n.value) ? ds(n.value, r.value, c(d)) : !1, u = X(() => Dr(Ji(t.yearRange, t.reverseYears), (d) => {
    const p = o(d.value), m = sa(d.value, Cr(t.minDate), Cr(t.maxDate)) || s.value.years.includes(d.value), h = l(d.value) && !p, O = Xi(a.value, d.value);
    return { active: p, disabled: m, isBetween: h, highlighted: O };
  })), c = (d) => ln(qt(/* @__PURE__ */ new Date()), d);
  return {
    groupedYears: u,
    modelValue: n,
    focusYear: i,
    setHoverValue: (d) => {
      r.value = ln(qt(/* @__PURE__ */ new Date()), d);
    },
    selectYear: (d) => {
      var p;
      if (t.multiDates)
        return n.value ? Array.isArray(n.value) && (((p = n.value) == null ? void 0 : p.map((m) => Me(m))).includes(d) ? n.value = n.value.filter((m) => Me(m) !== d) : n.value.push(ln(bt(Z()), d))) : n.value = [ln(bt(Z()), d)], e("auto-apply", !0);
      if (t.range) {
        const m = Ki(n, c(d), e);
        return hs(m, e, t.autoApply, t.modelAuto);
      }
      n.value = c(d), e("auto-apply");
    }
  };
}, X0 = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...en
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, { groupedYears: s, modelValue: i, focusYear: o, selectYear: l, setHoverValue: u } = J0(a, r), { defaultedConfig: c } = it(a);
    return e({ getSidebarProps: () => ({
      modelValue: i,
      selectYear: l
    }) }), (d, p) => (v(), x("div", null, [
      d.$slots["month-year"] ? ne(d.$slots, "month-year", Ye(Be({ key: 0 }, {
        years: D(s),
        selectYear: D(l)
      }))) : (v(), fe(ya, {
        key: 1,
        items: D(s),
        "is-last": d.autoApply && !D(c).keepActionRow,
        height: D(c).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": D(o),
        type: "year",
        "use-relative": "",
        onSelected: D(l),
        onHoverValue: D(u)
      }, St({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: _e(({ item: m }) => [
            ne(d.$slots, "year-overlay-value", {
              text: m.text,
              value: m.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), Q0 = {
  key: 0,
  class: "dp__time_input"
}, K0 = ["aria-label", "onKeydown", "onClick"], ew = /* @__PURE__ */ C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), tw = /* @__PURE__ */ C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), nw = ["aria-label", "disabled", "onKeydown", "onClick"], rw = ["aria-label", "onKeydown", "onClick"], aw = /* @__PURE__ */ C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), sw = /* @__PURE__ */ C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), iw = { key: 0 }, ow = ["aria-label", "onKeydown"], lw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...en
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, { setTimePickerElements: s, setTimePickerBackRef: i } = Un(), { defaultedAriaLabels: o, defaultedTransitions: l, defaultedFilters: u, defaultedConfig: c } = it(a), { transitionName: d, showTransition: p } = ha(l), m = la({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), h = ee("AM"), O = ee(null), g = ee([]);
    Dt(() => {
      r("mounted");
    });
    const b = (_) => Je(/* @__PURE__ */ new Date(), {
      hours: _.hours,
      minutes: _.minutes,
      seconds: a.enableSeconds ? _.seconds : 0,
      milliseconds: 0
    }), w = X(
      () => (_) => Y(_, a[_]) || T(_, a[_])
    ), M = X(() => ({ hours: a.hours, minutes: a.minutes, seconds: a.seconds })), T = (_, le) => a.range && !a.disableTimeRangeValidation ? !a.validateTime(_, le) : !1, E = (_, le) => {
      if (a.range && !a.disableTimeRangeValidation) {
        const he = le ? +a[`${_}Increment`] : -+a[`${_}Increment`], re = a[_] + he;
        return !a.validateTime(_, re);
      }
      return !1;
    }, $ = X(() => (_) => !R(+a[_] + +a[`${_}Increment`], _) || E(_, !0)), V = X(() => (_) => !R(+a[_] - +a[`${_}Increment`], _) || E(_, !1)), Q = (_, le) => mc(Je(Z(), _), le), W = (_, le) => Sg(Je(Z(), _), le), k = X(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !a.timePickerInline,
        dp__time_col_reg_block: !a.enableSeconds && a.is24 && !a.timePickerInline,
        dp__time_col_reg_inline: !a.enableSeconds && a.is24 && a.timePickerInline,
        dp__time_col_reg_with_button: !a.enableSeconds && !a.is24,
        dp__time_col_sec: a.enableSeconds && a.is24,
        dp__time_col_sec_with_button: a.enableSeconds && !a.is24
      })
    ), F = X(() => {
      const _ = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return a.enableSeconds ? _.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : _;
    }), H = X(() => F.value.filter((_) => !_.separator)), G = X(() => (_) => {
      if (_ === "hours") {
        const le = L(+a.hours);
        return { text: le < 10 ? `0${le}` : `${le}`, value: le };
      }
      return { text: a[_] < 10 ? `0${a[_]}` : `${a[_]}`, value: a[_] };
    }), Y = (_, le) => {
      var he;
      if (!a.disabledTimesConfig)
        return !1;
      const re = a.disabledTimesConfig(a.order, _ === "hours" ? le : void 0);
      return re[_] ? !!((he = re[_]) != null && he.includes(le)) : !0;
    }, S = (_) => {
      const le = a.is24 ? 24 : 12, he = _ === "hours" ? le : 60, re = +a[`${_}GridIncrement`], Ce = _ === "hours" && !a.is24 ? re : 0, de = [];
      for (let j = Ce; j < he; j += re)
        de.push({ value: j, text: j < 10 ? `0${j}` : `${j}` });
      return _ === "hours" && !a.is24 && de.push({ value: 0, text: "12" }), Dr(de, (j) => ({ active: !1, disabled: u.value.times[_].includes(j.value) || !R(j.value, _) || Y(_, j.value) || T(_, j.value) }));
    }, R = (_, le) => {
      const he = a.minTime ? b(Vs(a.minTime)) : null, re = a.maxTime ? b(Vs(a.maxTime)) : null, Ce = b(Vs(M.value, le, _));
      return he && re ? (aa(Ce, re) || wr(Ce, re)) && (ra(Ce, he) || wr(Ce, he)) : he ? ra(Ce, he) || wr(Ce, he) : re ? aa(Ce, re) || wr(Ce, re) : !0;
    }, N = (_) => a[`no${_[0].toUpperCase() + _.slice(1)}Overlay`], q = (_) => {
      N(_) || (m[_] = !m[_], m[_] || r("overlay-closed"));
    }, y = (_) => _ === "hours" ? Jt : _ === "minutes" ? un : Or, f = (_, le = !0) => {
      const he = le ? Q : W, re = le ? +a[`${_}Increment`] : -+a[`${_}Increment`];
      R(+a[_] + re, _) && r(
        `update:${_}`,
        y(_)(he({ [_]: +a[_] }, { [_]: +a[`${_}Increment`] }))
      );
    }, L = (_) => a.is24 ? _ : (_ >= 12 ? h.value = "PM" : h.value = "AM", e0(_)), B = () => {
      h.value === "PM" ? (h.value = "AM", r("update:hours", a.hours - 12)) : (h.value = "PM", r("update:hours", a.hours + 12)), r("am-pm-change", h.value);
    }, J = (_) => {
      m[_] = !0;
    }, z = (_, le, he) => {
      if (_ && a.arrowNavigation) {
        Array.isArray(g.value[le]) ? g.value[le][he] = _ : g.value[le] = [_];
        const re = g.value.reduce(
          (Ce, de) => de.map((j, te) => [...Ce[te] || [], de[te]]),
          []
        );
        i(a.closeTimePickerBtn), O.value && (re[1] = re[1].concat(O.value)), s(re, a.order);
      }
    }, A = (_, le) => (q(_), _ === "hours" && !a.is24 ? r(`update:${_}`, h.value === "PM" ? le + 12 : le) : r(`update:${_}`, le));
    return e({ openChildCmp: J }), (_, le) => {
      var he;
      return _.disabled ? I("", !0) : (v(), x("div", Q0, [
        (v(!0), x(ve, null, Re(F.value, (re, Ce) => {
          var de, j, te;
          return v(), x("div", {
            key: Ce,
            class: pe(k.value)
          }, [
            re.separator ? (v(), x(ve, { key: 0 }, [
              Xe(" : ")
            ], 64)) : (v(), x(ve, { key: 1 }, [
              C("button", {
                ref_for: !0,
                ref: (Oe) => z(Oe, Ce, 0),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !_.timePickerInline,
                  dp__inc_dec_button_inline: _.timePickerInline,
                  dp__tp_inline_btn_top: _.timePickerInline,
                  dp__inc_dec_button_disabled: $.value(re.type)
                }),
                "aria-label": (de = D(o)) == null ? void 0 : de.incrementValue(re.type),
                tabindex: "0",
                onKeydown: [
                  De(we((Oe) => f(re.type), ["prevent"]), ["enter"]),
                  De(we((Oe) => f(re.type), ["prevent"]), ["space"])
                ],
                onClick: (Oe) => f(re.type)
              }, [
                a.timePickerInline ? (v(), x(ve, { key: 1 }, [
                  ew,
                  tw
                ], 64)) : (v(), x(ve, { key: 0 }, [
                  _.$slots["arrow-up"] ? ne(_.$slots, "arrow-up", { key: 0 }) : I("", !0),
                  _.$slots["arrow-up"] ? I("", !0) : (v(), fe(D(Hi), { key: 1 }))
                ], 64))
              ], 42, K0),
              C("button", {
                ref_for: !0,
                ref: (Oe) => z(Oe, Ce, 1),
                type: "button",
                "aria-label": (j = D(o)) == null ? void 0 : j.openTpOverlay(re.type),
                class: pe({
                  dp__time_display: !0,
                  dp__time_display_block: !_.timePickerInline,
                  dp__time_display_inline: _.timePickerInline,
                  "dp--time-invalid": w.value(re.type),
                  "dp--time-overlay-btn": !w.value(re.type)
                }),
                disabled: N(re.type),
                tabindex: "0",
                onKeydown: [
                  De(we((Oe) => q(re.type), ["prevent"]), ["enter"]),
                  De(we((Oe) => q(re.type), ["prevent"]), ["space"])
                ],
                onClick: (Oe) => q(re.type)
              }, [
                _.$slots[re.type] ? ne(_.$slots, re.type, {
                  key: 0,
                  text: G.value(re.type).text,
                  value: G.value(re.type).value
                }) : I("", !0),
                _.$slots[re.type] ? I("", !0) : (v(), x(ve, { key: 1 }, [
                  Xe(ze(G.value(re.type).text), 1)
                ], 64))
              ], 42, nw),
              C("button", {
                ref_for: !0,
                ref: (Oe) => z(Oe, Ce, 2),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !_.timePickerInline,
                  dp__inc_dec_button_inline: _.timePickerInline,
                  dp__tp_inline_btn_bottom: _.timePickerInline,
                  dp__inc_dec_button_disabled: V.value(re.type)
                }),
                "aria-label": (te = D(o)) == null ? void 0 : te.decrementValue(re.type),
                tabindex: "0",
                onKeydown: [
                  De(we((Oe) => f(re.type, !1), ["prevent"]), ["enter"]),
                  De(we((Oe) => f(re.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (Oe) => f(re.type, !1)
              }, [
                a.timePickerInline ? (v(), x(ve, { key: 1 }, [
                  aw,
                  sw
                ], 64)) : (v(), x(ve, { key: 0 }, [
                  _.$slots["arrow-down"] ? ne(_.$slots, "arrow-down", { key: 0 }) : I("", !0),
                  _.$slots["arrow-down"] ? I("", !0) : (v(), fe(D(qi), { key: 1 }))
                ], 64))
              ], 42, rw)
            ], 64))
          ], 2);
        }), 128)),
        _.is24 ? I("", !0) : (v(), x("div", iw, [
          _.$slots["am-pm-button"] ? ne(_.$slots, "am-pm-button", {
            key: 0,
            toggle: B,
            value: h.value
          }) : I("", !0),
          _.$slots["am-pm-button"] ? I("", !0) : (v(), x("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: O,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (he = D(o)) == null ? void 0 : he.amPmButton,
            tabindex: "0",
            onClick: B,
            onKeydown: [
              De(we(B, ["prevent"]), ["enter"]),
              De(we(B, ["prevent"]), ["space"])
            ]
          }, ze(h.value), 41, ow))
        ])),
        (v(!0), x(ve, null, Re(H.value, (re, Ce) => (v(), fe(Yn, {
          key: Ce,
          name: D(d)(m[re.type]),
          css: D(p)
        }, {
          default: _e(() => [
            m[re.type] ? (v(), fe(ya, {
              key: 0,
              items: S(re.type),
              "is-last": _.autoApply && !D(c).keepActionRow,
              "esc-close": _.escClose,
              type: re.type,
              "text-input": _.textInput,
              config: _.config,
              "arrow-navigation": _.arrowNavigation,
              onSelected: (de) => A(re.type, de),
              onToggle: (de) => q(re.type),
              onResetFlow: le[0] || (le[0] = (de) => _.$emit("reset-flow"))
            }, St({
              "button-icon": _e(() => [
                _.$slots["clock-icon"] ? ne(_.$slots, "clock-icon", { key: 0 }) : I("", !0),
                _.$slots["clock-icon"] ? I("", !0) : (v(), fe(Pn(_.timePickerInline ? D(Lr) : D(ji)), { key: 1 }))
              ]),
              _: 2
            }, [
              _.$slots[`${re.type}-overlay-value`] ? {
                name: "item",
                fn: _e(({ item: de }) => [
                  ne(_.$slots, `${re.type}-overlay-value`, {
                    text: de.text,
                    value: de.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "onSelected", "onToggle"])) : I("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), uw = { class: "dp--tp-wrap" }, cw = ["aria-label", "tabindex"], dw = ["tabindex"], fw = ["aria-label"], ed = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...en
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, { buildMatrix: s, setTimePicker: i } = Un(), o = ar(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: d } = it(a), { transitionName: p, showTransition: m } = ha(l), { hideNavigationButtons: h } = fs(), O = ee(null), g = ee(null), b = ee([]), w = ee(null);
    Dt(() => {
      r("mount"), !a.timePicker && a.arrowNavigation ? s([lt(O.value)], "time") : i(!0, a.timePicker);
    });
    const M = X(() => a.range && a.modelAuto ? Uc(a.internalModelValue) : !0), T = ee(!1), E = (S) => ({
      hours: Array.isArray(a.hours) ? a.hours[S] : a.hours,
      minutes: Array.isArray(a.minutes) ? a.minutes[S] : a.minutes,
      seconds: Array.isArray(a.seconds) ? a.seconds[S] : a.seconds
    }), $ = X(() => {
      const S = [];
      if (a.range)
        for (let R = 0; R < 2; R++)
          S.push(E(R));
      else
        S.push(E(0));
      return S;
    }), V = (S, R = !1, N = "") => {
      R || r("reset-flow"), T.value = S, r(S ? "overlay-opened" : "overlay-closed"), a.arrowNavigation && i(S), Ln(() => {
        N !== "" && b.value[0] && b.value[0].openChildCmp(N);
      });
    }, Q = X(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: a.autoApply && !d.value.keepActionRow
    })), W = At(o, "timePicker"), k = (S, R, N) => a.range ? R === 0 ? [S, $.value[1][N]] : [$.value[0][N], S] : S, F = (S) => {
      r("update:hours", S);
    }, H = (S) => {
      r("update:minutes", S);
    }, G = (S) => {
      r("update:seconds", S);
    }, Y = () => {
      if (w.value && !c.value.enabled && !a.noOverlayFocus) {
        const S = n0(w.value);
        S && S.focus({ preventScroll: !0 });
      }
    };
    return e({ toggleTimePicker: V }), (S, R) => {
      var N;
      return v(), x("div", uw, [
        !S.timePicker && !S.timePickerInline ? _t((v(), x("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: O,
          type: "button",
          class: pe(Q.value),
          "aria-label": (N = D(u)) == null ? void 0 : N.openTimePicker,
          tabindex: S.noOverlayFocus ? void 0 : 0,
          onKeydown: [
            R[0] || (R[0] = De((q) => V(!0), ["enter"])),
            R[1] || (R[1] = De((q) => V(!0), ["space"]))
          ],
          onClick: R[2] || (R[2] = (q) => V(!0))
        }, [
          S.$slots["clock-icon"] ? ne(S.$slots, "clock-icon", { key: 0 }) : I("", !0),
          S.$slots["clock-icon"] ? I("", !0) : (v(), fe(D(ji), { key: 1 }))
        ], 42, cw)), [
          [Fn, !D(h)(S.hideNavigation, "time")]
        ]) : I("", !0),
        He(Yn, {
          name: D(p)(T.value),
          css: D(m) && !S.timePickerInline
        }, {
          default: _e(() => {
            var q;
            return [
              T.value || S.timePicker || S.timePickerInline ? (v(), x("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: w,
                class: pe({
                  dp__overlay: !S.timePickerInline,
                  "dp--overlay-absolute": !a.timePicker && !S.timePickerInline,
                  "dp--overlay-relative": a.timePicker
                }),
                style: zt(S.timePicker ? { height: `${D(d).modeHeight}px` } : void 0),
                tabindex: S.timePickerInline ? void 0 : 0
              }, [
                C("div", {
                  class: pe(
                    S.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  S.$slots["time-picker-overlay"] ? ne(S.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: F,
                    setMinutes: H,
                    setSeconds: G
                  }) : I("", !0),
                  S.$slots["time-picker-overlay"] ? I("", !0) : (v(), x("div", {
                    key: 1,
                    class: pe(S.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (v(!0), x(ve, null, Re($.value, (y, f) => _t((v(), fe(lw, Be({ key: f }, {
                      ...S.$props,
                      order: f,
                      hours: y.hours,
                      minutes: y.minutes,
                      seconds: y.seconds,
                      closeTimePickerBtn: g.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: f === 0 ? S.fixedStart : S.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "validate-time": (L, B) => t.validateTime(L, k(B, f, L)),
                      "onUpdate:hours": (L) => F(k(L, f, "hours")),
                      "onUpdate:minutes": (L) => H(k(L, f, "minutes")),
                      "onUpdate:seconds": (L) => G(k(L, f, "seconds")),
                      onMounted: Y,
                      onOverlayClosed: Y,
                      onAmPmChange: R[3] || (R[3] = (L) => S.$emit("am-pm-change", L))
                    }), St({ _: 2 }, [
                      Re(D(W), (L, B) => ({
                        name: L,
                        fn: _e((J) => [
                          ne(S.$slots, L, Ye(Ge(J)))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Fn, f === 0 ? !0 : M.value]
                    ])), 128))
                  ], 2)),
                  !S.timePicker && !S.timePickerInline ? _t((v(), x("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: g,
                    type: "button",
                    class: pe(Q.value),
                    "aria-label": (q = D(u)) == null ? void 0 : q.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      R[4] || (R[4] = De((y) => V(!1), ["enter"])),
                      R[5] || (R[5] = De((y) => V(!1), ["space"]))
                    ],
                    onClick: R[6] || (R[6] = (y) => V(!1))
                  }, [
                    S.$slots["calendar-icon"] ? ne(S.$slots, "calendar-icon", { key: 0 }) : I("", !0),
                    S.$slots["calendar-icon"] ? I("", !0) : (v(), fe(D(Lr), { key: 1 }))
                  ], 42, fw)), [
                    [Fn, !D(h)(S.hideNavigation, "time")]
                  ]) : I("", !0)
                ], 2)
              ], 14, dw)) : I("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), td = (t, e, n, r) => {
  const a = (b, w) => Array.isArray(e[b]) ? e[b][w] : e[b], s = (b) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[b] : e.seconds : 0, i = (b, w) => b ? w !== void 0 ? In(b, a("hours", w), a("minutes", w), s(w)) : In(b, e.hours, e.minutes, s()) : Ui(Z(), s(w)), o = (b, w) => {
    e[b] = w;
  }, l = (b, w) => {
    const M = Object.fromEntries(
      Object.keys(e).map((T) => T === b ? [T, w] : [T, e[T]].slice())
    );
    if (t.range && !t.disableTimeRangeValidation) {
      const T = ($) => n.value ? In(
        n.value[$],
        M.hours[$],
        M.minutes[$],
        M.seconds[$]
      ) : null, E = ($) => Yi(n.value[$], 0);
      return !(Ue(T(0), T(1)) && (ra(T(0), E(1)) || aa(T(1), E(0))));
    }
    return !0;
  }, u = (b, w) => {
    l(b, w) && (o(b, w), r && r());
  }, c = (b) => {
    u("hours", b);
  }, d = (b) => {
    u("minutes", b);
  }, p = (b) => {
    u("seconds", b);
  }, m = (b, w, M, T) => {
    w && c(b), !w && !M && d(b), M && p(b), n.value && T(n.value);
  }, h = (b) => {
    if (b) {
      const w = Array.isArray(b), M = w ? [+b[0].hours, +b[1].hours] : +b.hours, T = w ? [+b[0].minutes, +b[1].minutes] : +b.minutes, E = w ? [+b[0].seconds, +b[1].seconds] : +b.seconds;
      o("hours", M), o("minutes", T), t.enableSeconds && o("seconds", E);
    }
  }, O = (b, w) => {
    const M = {
      hours: Array.isArray(e.hours) ? e.hours[b] : e.hours,
      disabledArr: []
    };
    return (w || w === 0) && (M.hours = w), Array.isArray(t.disabledTimes) && (M.disabledArr = t.range && Array.isArray(t.disabledTimes[b]) ? t.disabledTimes[b] : t.disabledTimes), M;
  }, g = X(() => (b, w) => {
    var M;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: T, hours: E } = O(b, w), $ = T.filter((V) => +V.hours === E);
      return ((M = $[0]) == null ? void 0 : M.minutes) === "*" ? { hours: [E], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: ($ == null ? void 0 : $.map((V) => +V.minutes)) ?? [],
        seconds: ($ == null ? void 0 : $.map((V) => V.seconds ? +V.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: o,
    updateHours: c,
    updateMinutes: d,
    updateSeconds: p,
    getSetDateTime: i,
    updateTimeValues: m,
    getSecondsValue: s,
    assignStartTime: h,
    validateTime: l,
    disabledTimesConfig: g
  };
}, pw = (t, e) => {
  const { modelValue: n, time: r } = va(t, e), { defaultedStartTime: a } = it(t), { updateTimeValues: s, getSetDateTime: i, setTime: o, assignStartTime: l, disabledTimesConfig: u, validateTime: c } = td(t, r, n), d = (w) => {
    const { hours: M, minutes: T, seconds: E } = w;
    return { hours: +M, minutes: +T, seconds: E ? +E : 0 };
  }, p = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const M = d(t.startTime[0]), T = d(t.startTime[1]);
        return [Je(Z(), M), Je(Z(), T)];
      }
      const w = d(t.startTime);
      return Je(Z(), w);
    }
    return t.range ? [null, null] : null;
  }, m = () => {
    if (t.range) {
      const [w, M] = p();
      n.value = [i(w, 0), i(M, 1)];
    } else
      n.value = i(p());
  }, h = (w) => Array.isArray(w) ? [Xn(Z(w[0])), Xn(Z(w[1]))] : [Xn(w ?? Z())], O = (w, M, T) => {
    o("hours", w), o("minutes", M), o("seconds", t.enableSeconds ? T : 0);
  }, g = () => {
    const [w, M] = h(n.value);
    return t.range ? O(
      [w.hours, M.hours],
      [w.minutes, M.minutes],
      [w.seconds, M.minutes]
    ) : O(w.hours, w.minutes, w.seconds);
  };
  Dt(() => {
    if (!t.shadow)
      return l(a.value), n.value ? g() : m();
  });
  const b = () => {
    Array.isArray(n.value) ? n.value = n.value.map((w, M) => w && i(w, M)) : n.value = i(n.value), e("time-update");
  };
  return {
    modelValue: n,
    time: r,
    disabledTimesConfig: u,
    updateTime: (w, M = !0, T = !1) => {
      s(w, M, T, b);
    },
    validateTime: c
  };
}, mw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...en
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, s = ar(), i = At(s, "timePicker"), { time: o, modelValue: l, disabledTimesConfig: u, updateTime: c, validateTime: d } = pw(a, r);
    return e({ getSidebarProps: () => ({
      modelValue: l,
      time: o,
      updateTime: c
    }) }), (p, m) => (v(), fe(ms, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: _e(() => [
        He(ed, Be(p.$props, {
          hours: D(o).hours,
          minutes: D(o).minutes,
          seconds: D(o).seconds,
          "internal-model-value": p.internalModelValue,
          "disabled-times-config": D(u),
          "validate-time": D(d),
          "onUpdate:hours": m[0] || (m[0] = (h) => D(c)(h)),
          "onUpdate:minutes": m[1] || (m[1] = (h) => D(c)(h, !1)),
          "onUpdate:seconds": m[2] || (m[2] = (h) => D(c)(h, !1, !0)),
          onAmPmChange: m[3] || (m[3] = (h) => p.$emit("am-pm-change", h))
        }), St({ _: 2 }, [
          Re(D(i), (h, O) => ({
            name: h,
            fn: _e((g) => [
              ne(p.$slots, h, Ye(Ge(g)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), hw = { class: "dp__month_year_row" }, vw = ["aria-label", "onClick", "onKeydown"], yw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...en
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, {
      defaultedTransitions: s,
      defaultedAriaLabels: i,
      defaultedMultiCalendars: o,
      defaultedFilters: l,
      defaultedConfig: u,
      defaultedHighlight: c
    } = it(a), { transitionName: d, showTransition: p } = ha(s), { buildMatrix: m } = Un(), { handleMonthYearChange: h, isDisabled: O, updateMonthYear: g } = C0(a, r), { showLeftIcon: b, showRightIcon: w } = fs(), M = ee(!1), T = ee(!1), E = ee([null, null, null, null]);
    Dt(() => {
      r("mount");
    });
    const $ = (f) => ({
      get: () => a[f],
      set: (L) => {
        const B = f === Ht.month ? Ht.year : Ht.month;
        r("update-month-year", { [f]: L, [B]: a[B] }), f === Ht.month ? Y(!0) : S(!0);
      }
    }), V = X($(Ht.month)), Q = X($(Ht.year)), W = X(() => (f) => ({
      month: a.month,
      year: a.year,
      items: f === Ht.month ? a.months : a.years,
      instance: a.instance,
      updateMonthYear: g,
      toggle: f === Ht.month ? Y : S
    })), k = X(() => a.months.find((L) => L.value === a.month) || { text: "", value: 0 }), F = X(() => Dr(a.months, (f) => {
      const L = a.month === f.value, B = sa(
        f.value,
        Bc(a.year, a.minDate),
        Wc(a.year, a.maxDate)
      ) || l.value.months.includes(f.value), J = Gc(c.value, f.value, a.year);
      return { active: L, disabled: B, highlighted: J };
    })), H = X(() => Dr(a.years, (f) => {
      const L = a.year === f.value, B = sa(f.value, Cr(a.minDate), Cr(a.maxDate)) || l.value.years.includes(f.value), J = Xi(c.value, f.value);
      return { active: L, disabled: B, highlighted: J };
    })), G = (f, L) => {
      L !== void 0 ? f.value = L : f.value = !f.value, f.value || r("overlay-closed");
    }, Y = (f = !1, L) => {
      R(f), G(M, L);
    }, S = (f = !1, L) => {
      R(f), G(T, L);
    }, R = (f) => {
      f || r("reset-flow");
    }, N = (f, L) => {
      a.arrowNavigation && (E.value[L] = lt(f), m(E.value, "monthYear"));
    }, q = X(() => {
      var f, L;
      return [
        {
          type: Ht.month,
          index: 1,
          toggle: Y,
          modelValue: V.value,
          updateModelValue: (B) => V.value = B,
          text: k.value.text,
          showSelectionGrid: M.value,
          items: F.value,
          ariaLabel: (f = i.value) == null ? void 0 : f.openMonthsOverlay
        },
        {
          type: Ht.year,
          index: 2,
          toggle: S,
          modelValue: Q.value,
          updateModelValue: (B) => Q.value = B,
          text: a.year,
          showSelectionGrid: T.value,
          items: H.value,
          ariaLabel: (L = i.value) == null ? void 0 : L.openYearsOverlay
        }
      ];
    }), y = X(() => a.disableYearSelect ? [q.value[0]] : a.yearFirst ? [...q.value].reverse() : q.value);
    return e({
      toggleMonthPicker: Y,
      toggleYearPicker: S,
      handleMonthYearChange: h
    }), (f, L) => {
      var B, J, z;
      return v(), x("div", hw, [
        f.$slots["month-year"] ? ne(f.$slots, "month-year", Ye(Be({ key: 0 }, { month: t.month, year: t.year, months: t.months, years: t.years, updateMonthYear: D(g), handleMonthYearChange: D(h), instance: t.instance }))) : (v(), x(ve, { key: 1 }, [
          D(b)(D(o), t.instance) && !f.vertical ? (v(), fe(Jr, {
            key: 0,
            "aria-label": (B = D(i)) == null ? void 0 : B.prevMonth,
            disabled: D(O)(!1),
            onActivate: L[0] || (L[0] = (A) => D(h)(!1, !0)),
            onSetRef: L[1] || (L[1] = (A) => N(A, 0))
          }, {
            default: _e(() => [
              f.$slots["arrow-left"] ? ne(f.$slots, "arrow-left", { key: 0 }) : I("", !0),
              f.$slots["arrow-left"] ? I("", !0) : (v(), fe(D(Bi), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : I("", !0),
          C("div", {
            class: pe(["dp__month_year_wrap", {
              dp__year_disable_select: f.disableYearSelect
            }])
          }, [
            (v(!0), x(ve, null, Re(y.value, (A, _) => (v(), x(ve, {
              key: A.type
            }, [
              C("button", {
                ref_for: !0,
                ref: (le) => N(le, _ + 1),
                type: "button",
                class: "dp__btn dp__month_year_select",
                tabindex: "0",
                "aria-label": A.ariaLabel,
                onClick: A.toggle,
                onKeydown: [
                  De(we(A.toggle, ["prevent"]), ["enter"]),
                  De(we(A.toggle, ["prevent"]), ["space"])
                ]
              }, [
                f.$slots[A.type] ? ne(f.$slots, A.type, {
                  key: 0,
                  text: A.text,
                  value: a[A.type]
                }) : I("", !0),
                f.$slots[A.type] ? I("", !0) : (v(), x(ve, { key: 1 }, [
                  Xe(ze(A.text), 1)
                ], 64))
              ], 40, vw),
              He(Yn, {
                name: D(d)(A.showSelectionGrid),
                css: D(p)
              }, {
                default: _e(() => [
                  A.showSelectionGrid ? (v(), fe(ya, {
                    key: 0,
                    items: A.items,
                    "arrow-navigation": f.arrowNavigation,
                    "hide-navigation": f.hideNavigation,
                    "is-last": f.autoApply && !D(u).keepActionRow,
                    "skip-button-ref": !1,
                    config: f.config,
                    type: A.type,
                    "header-refs": [],
                    "esc-close": f.escClose,
                    "text-input": f.textInput,
                    onSelected: A.updateModelValue,
                    onToggle: A.toggle
                  }, St({
                    "button-icon": _e(() => [
                      f.$slots["calendar-icon"] ? ne(f.$slots, "calendar-icon", { key: 0 }) : I("", !0),
                      f.$slots["calendar-icon"] ? I("", !0) : (v(), fe(D(Lr), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    f.$slots[`${A.type}-overlay-value`] ? {
                      name: "item",
                      fn: _e(({ item: le }) => [
                        ne(f.$slots, `${A.type}-overlay-value`, {
                          text: le.text,
                          value: le.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    f.$slots[`${A.type}-overlay`] ? {
                      name: "overlay",
                      fn: _e(() => [
                        ne(f.$slots, `${A.type}-overlay`, Ye(Ge(W.value(A.type))))
                      ]),
                      key: "1"
                    } : void 0,
                    f.$slots[`${A.type}-overlay-header`] ? {
                      name: "header",
                      fn: _e(() => [
                        ne(f.$slots, `${A.type}-overlay-header`, {
                          toggle: A.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : I("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          D(b)(D(o), t.instance) && f.vertical ? (v(), fe(Jr, {
            key: 1,
            "aria-label": (J = D(i)) == null ? void 0 : J.prevMonth,
            disabled: D(O)(!1),
            onActivate: L[2] || (L[2] = (A) => D(h)(!1, !0))
          }, {
            default: _e(() => [
              f.$slots["arrow-up"] ? ne(f.$slots, "arrow-up", { key: 0 }) : I("", !0),
              f.$slots["arrow-up"] ? I("", !0) : (v(), fe(D(Hi), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : I("", !0),
          D(w)(D(o), t.instance) ? (v(), fe(Jr, {
            key: 2,
            ref: "rightIcon",
            disabled: D(O)(!0),
            "aria-label": (z = D(i)) == null ? void 0 : z.nextMonth,
            onActivate: L[3] || (L[3] = (A) => D(h)(!0, !0)),
            onSetRef: L[4] || (L[4] = (A) => N(A, f.disableYearSelect ? 2 : 3))
          }, {
            default: _e(() => [
              f.$slots[f.vertical ? "arrow-down" : "arrow-right"] ? ne(f.$slots, f.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : I("", !0),
              f.$slots[f.vertical ? "arrow-down" : "arrow-right"] ? I("", !0) : (v(), fe(Pn(f.vertical ? D(qi) : D(Wi)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label"])) : I("", !0)
        ], 64))
      ]);
    };
  }
}), gw = ["aria-label"], ww = {
  class: "dp__calendar_header",
  role: "row"
}, bw = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, kw = /* @__PURE__ */ C("div", { class: "dp__calendar_header_separator" }, null, -1), _w = ["aria-label"], Tw = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, Ow = { class: "dp__cell_inner" }, Sw = ["id", "aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], Dw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...en
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, { buildMultiLevelMatrix: s } = Un(), {
      defaultedTransitions: i,
      defaultedConfig: o,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c
    } = it(a), d = ee(null), p = ee({
      bottom: "",
      left: "",
      transform: ""
    }), m = ee([]), h = ee(null), O = ee(!0), g = ee(""), b = ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), w = ee([]), M = ee({ left: "50%" }), T = X(() => a.calendar ? a.calendar(a.mappedDates) : a.mappedDates), E = X(() => a.dayNames ? Array.isArray(a.dayNames) ? a.dayNames : a.dayNames(a.locale, +a.weekStart) : Kg(a.formatLocale, a.locale, +a.weekStart));
    Dt(() => {
      r("mount", { cmp: "calendar", refs: m }), o.value.noSwipe || h.value && (h.value.addEventListener("touchstart", S, { passive: !1 }), h.value.addEventListener("touchend", R, { passive: !1 }), h.value.addEventListener("touchmove", N, { passive: !1 })), a.monthChangeOnScroll && h.value && h.value.addEventListener("wheel", f, { passive: !1 });
    });
    const $ = (A) => A ? a.vertical ? "vNext" : "next" : a.vertical ? "vPrevious" : "previous", V = (A, _) => {
      if (a.transitions) {
        const le = bt(vn(Z(), a.month, a.year));
        g.value = wt(bt(vn(Z(), A, _)), le) ? i.value[$(!0)] : i.value[$(!1)], O.value = !1, Ln(() => {
          O.value = !0;
        });
      }
    }, Q = X(
      () => ({
        [a.calendarClassName]: !!a.calendarClassName
      })
    ), W = X(() => (A) => {
      const _ = t0(A);
      return {
        dp__marker_dot: _.type === "dot",
        dp__marker_line: _.type === "line"
      };
    }), k = X(() => (A) => Ue(A, d.value)), F = X(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && a.instance !== 0
    })), H = X(() => (A) => a.hideOffsetDates ? A.current : !0), G = async (A, _, le) => {
      var he, re;
      if (r("set-hover-date", A), (re = (he = A.marker) == null ? void 0 : he.tooltip) != null && re.length) {
        const Ce = lt(m.value[_][le]);
        if (Ce) {
          const { width: de, height: j } = Ce.getBoundingClientRect();
          d.value = A.value;
          let te = { left: `${de / 2}px` }, Oe = -50;
          if (await Ln(), w.value[0]) {
            const { left: ae, width: Le } = w.value[0].getBoundingClientRect();
            ae < 0 && (te = { left: "0" }, Oe = 0, M.value.left = `${de / 2}px`), window.innerWidth < ae + Le && (te = { right: "0" }, Oe = 0, M.value.left = `${Le - de / 2}px`);
          }
          p.value = {
            bottom: `${j}px`,
            ...te,
            transform: `translateX(${Oe}%)`
          }, r("tooltip-open", A.marker);
        }
      }
    }, Y = (A) => {
      d.value && (d.value = null, p.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", A.marker));
    }, S = (A) => {
      b.value.startX = A.changedTouches[0].screenX, b.value.startY = A.changedTouches[0].screenY;
    }, R = (A) => {
      b.value.endX = A.changedTouches[0].screenX, b.value.endY = A.changedTouches[0].screenY, q();
    }, N = (A) => {
      a.vertical && !a.inline && A.preventDefault();
    }, q = () => {
      const A = a.vertical ? "Y" : "X";
      Math.abs(b.value[`start${A}`] - b.value[`end${A}`]) > 10 && r("handle-swipe", b.value[`start${A}`] > b.value[`end${A}`] ? "right" : "left");
    }, y = (A, _, le) => {
      A && (Array.isArray(m.value[_]) ? m.value[_][le] = A : m.value[_] = [A]), a.arrowNavigation && s(m.value, "calendar");
    }, f = (A) => {
      a.monthChangeOnScroll && (A.preventDefault(), r("handle-scroll", A));
    }, L = (A) => c.value.type === "local" ? cy(A.value, { weekStartsOn: +a.weekStart }) : c.value.type === "iso" ? iy(A.value) : typeof c.value.type == "function" ? c.value.type(A.value) : "", B = (A) => {
      const _ = A[0];
      return c.value.hideOnOffsetDates ? A.some((le) => le.current) ? L(_) : "" : L(_);
    }, J = (A, _) => {
      Vn(A, o.value), r("select-date", _);
    }, z = (A) => {
      Vn(A, o.value);
    };
    return e({ triggerTransition: V }), (A, _) => {
      var le;
      return v(), x("div", {
        class: pe(F.value)
      }, [
        C("div", {
          ref_key: "calendarWrapRef",
          ref: h,
          role: "grid",
          class: pe(Q.value),
          "aria-label": (le = D(l)) == null ? void 0 : le.calendarWrap
        }, [
          (v(), x(ve, { key: 0 }, [
            C("div", ww, [
              A.weekNumbers ? (v(), x("div", bw, ze(A.weekNumName), 1)) : I("", !0),
              (v(!0), x(ve, null, Re(E.value, (he, re) => (v(), x("div", {
                key: re,
                class: "dp__calendar_header_item",
                role: "gridcell"
              }, [
                A.$slots["calendar-header"] ? ne(A.$slots, "calendar-header", {
                  key: 0,
                  day: he,
                  index: re
                }) : I("", !0),
                A.$slots["calendar-header"] ? I("", !0) : (v(), x(ve, { key: 1 }, [
                  Xe(ze(he), 1)
                ], 64))
              ]))), 128))
            ]),
            kw,
            He(Yn, {
              name: g.value,
              css: !!A.transitions
            }, {
              default: _e(() => {
                var he;
                return [
                  O.value ? (v(), x("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "rowgroup",
                    "aria-label": ((he = D(l)) == null ? void 0 : he.calendarDays) || void 0
                  }, [
                    (v(!0), x(ve, null, Re(T.value, (re, Ce) => (v(), x("div", {
                      key: Ce,
                      class: "dp__calendar_row",
                      role: "row"
                    }, [
                      A.weekNumbers ? (v(), x("div", Tw, [
                        C("div", Ow, ze(B(re.days)), 1)
                      ])) : I("", !0),
                      (v(!0), x(ve, null, Re(re.days, (de, j) => {
                        var te, Oe, ae;
                        return v(), x("div", {
                          id: de.value.toISOString().split("T")[0],
                          ref_for: !0,
                          ref: (Le) => y(Le, Ce, j),
                          key: j + Ce,
                          role: "gridcell",
                          class: "dp__calendar_item",
                          "aria-selected": de.classData.dp__active_date || de.classData.dp__range_start || de.classData.dp__range_start,
                          "aria-disabled": de.classData.dp__cell_disabled || void 0,
                          "aria-label": (Oe = (te = D(l)) == null ? void 0 : te.day) == null ? void 0 : Oe.call(te, de),
                          tabindex: "0",
                          onClick: we((Le) => J(Le, de), ["prevent"]),
                          onKeydown: [
                            De((Le) => A.$emit("select-date", de), ["enter"]),
                            De((Le) => A.$emit("handle-space", de), ["space"])
                          ],
                          onMouseenter: (Le) => G(de, Ce, j),
                          onMouseleave: (Le) => Y(de)
                        }, [
                          C("div", {
                            class: pe(["dp__cell_inner", de.classData])
                          }, [
                            A.$slots.day && H.value(de) ? ne(A.$slots, "day", {
                              key: 0,
                              day: +de.text,
                              date: de.value
                            }) : I("", !0),
                            A.$slots.day ? I("", !0) : (v(), x(ve, { key: 1 }, [
                              Xe(ze(de.text), 1)
                            ], 64)),
                            de.marker && H.value(de) ? (v(), x(ve, { key: 2 }, [
                              A.$slots.marker ? ne(A.$slots, "marker", {
                                key: 0,
                                marker: de.marker,
                                day: +de.text,
                                date: de.value
                              }) : (v(), x("div", {
                                key: 1,
                                class: pe(W.value(de.marker)),
                                style: zt(de.marker.color ? { backgroundColor: de.marker.color } : {})
                              }, null, 6))
                            ], 64)) : I("", !0),
                            k.value(de.value) ? (v(), x("div", {
                              key: 3,
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: w,
                              class: "dp__marker_tooltip",
                              style: zt(p.value)
                            }, [
                              (ae = de.marker) != null && ae.tooltip ? (v(), x("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: z
                              }, [
                                (v(!0), x(ve, null, Re(de.marker.tooltip, (Le, mt) => (v(), x("div", {
                                  key: mt,
                                  class: "dp__tooltip_text"
                                }, [
                                  A.$slots["marker-tooltip"] ? ne(A.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: Le,
                                    day: de.value
                                  }) : I("", !0),
                                  A.$slots["marker-tooltip"] ? I("", !0) : (v(), x(ve, { key: 1 }, [
                                    C("div", {
                                      class: "dp__tooltip_mark",
                                      style: zt(Le.color ? { backgroundColor: Le.color } : {})
                                    }, null, 4),
                                    C("div", null, ze(Le.text), 1)
                                  ], 64))
                                ]))), 128)),
                                C("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: zt(M.value)
                                }, null, 4)
                              ])) : I("", !0)
                            ], 4)) : I("", !0)
                          ], 2)
                        ], 40, Sw);
                      }), 128))
                    ]))), 128))
                  ], 8, _w)) : I("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 10, gw)
      ], 2);
    };
  }
}), xl = (t) => Array.isArray(t), Cw = (t, e, n, r) => {
  const a = ee([]), { modelValue: s, calendars: i, time: o } = va(t, e), { defaultedMultiCalendars: l, defaultedStartTime: u } = it(t), { validateMonthYearInRange: c, isDisabled: d, isDateRangeAllowed: p, checkMinMaxRange: m } = ir(t), { updateTimeValues: h, getSetDateTime: O, setTime: g, assignStartTime: b, validateTime: w, disabledTimesConfig: M } = td(t, o, s, r), T = X(
    () => (P) => i.value[P] ? i.value[P].month : 0
  ), E = X(
    () => (P) => i.value[P] ? i.value[P].year : 0
  ), $ = (P, K, ge) => {
    var Ae, Qe;
    i.value[P] || (i.value[P] = { month: 0, year: 0 }), i.value[P].month = Tl(K) ? (Ae = i.value[P]) == null ? void 0 : Ae.month : K, i.value[P].year = Tl(ge) ? (Qe = i.value[P]) == null ? void 0 : Qe.year : ge;
  }, V = () => {
    t.autoApply && e("select-date");
  };
  gn(s, (P, K) => {
    JSON.stringify(P) !== JSON.stringify(K) && k();
  }), Dt(() => {
    t.shadow || (s.value || (f(), u.value && b(u.value)), k(!0), t.focusStartDate && t.startDate && f());
  });
  const Q = X(() => {
    var P;
    return (P = t.flow) != null && P.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), W = () => {
    t.autoApply && Q.value && e("auto-apply", t.partialFlow);
  }, k = (P = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (a.value = s.value, R(P)) : H(s.value, P);
    if (l.value.count && P && !t.startDate)
      return F(Z(), P);
  }, F = (P, K = !1) => {
    if ((!l.value.count || !l.value.static || K) && $(0, Fe(P), Me(P)), l.value.count && (!l.value.solo || !s.value))
      for (let ge = 1; ge < l.value.count; ge++) {
        const Ae = Je(Z(), { month: T.value(ge - 1), year: E.value(ge - 1) }), Qe = mc(Ae, { months: 1 });
        i.value[ge] = { month: Fe(Qe), year: Me(Qe) };
      }
  }, H = (P, K) => {
    F(P), g("hours", Jt(P)), g("minutes", un(P)), g("seconds", Or(P)), l.value.count && K && y();
  }, G = (P) => {
    if (l.value.count) {
      if (l.value.solo)
        return 0;
      const K = Fe(P[0]), ge = Fe(P[1]);
      return Math.abs(ge - K) < l.value.count ? 0 : 1;
    }
    return 1;
  }, Y = (P, K) => {
    P[1] && t.showLastInRange ? F(P[G(P)], K) : F(P[0], K);
    const ge = (Ae, Qe) => [
      Ae(P[0]),
      P[1] ? Ae(P[1]) : o[Qe][1]
    ];
    g("hours", ge(Jt, "hours")), g("minutes", ge(un, "minutes")), g("seconds", ge(Or, "seconds"));
  }, S = (P, K) => {
    if ((t.range || t.weekPicker) && !t.multiDates)
      return Y(P, K);
    if (t.multiDates && K) {
      const ge = P[P.length - 1];
      return H(ge, K);
    }
  }, R = (P) => {
    const K = s.value;
    S(K, P), l.value.count && l.value.solo && y();
  }, N = (P, K) => {
    const ge = Je(Z(), { month: T.value(K), year: E.value(K) }), Ae = P < 0 ? Gt(ge, 1) : Sr(ge, 1);
    c(Fe(Ae), Me(Ae), P < 0, t.preventMinMaxNavigation) && ($(K, Fe(Ae), Me(Ae)), e("update-month-year", { instance: K, month: Fe(Ae), year: Me(Ae) }), l.value.count && !l.value.solo && q(K), n());
  }, q = (P) => {
    for (let K = P - 1; K >= 0; K--) {
      const ge = Sr(Je(Z(), { month: T.value(K + 1), year: E.value(K + 1) }), 1);
      $(K, Fe(ge), Me(ge));
    }
    for (let K = P + 1; K <= l.value.count - 1; K++) {
      const ge = Gt(Je(Z(), { month: T.value(K - 1), year: E.value(K - 1) }), 1);
      $(K, Fe(ge), Me(ge));
    }
  }, y = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const P = Z(
        Z(s.value[1] ? s.value[1] : Gt(s.value[0], 1))
      ), [K, ge] = [Fe(s.value[0]), Me(s.value[0])], [Ae, Qe] = [Fe(s.value[1]), Me(s.value[1])];
      (K !== Ae || K === Ae && ge !== Qe) && l.value.solo && $(1, Fe(P), Me(P));
    } else
      s.value && !Array.isArray(s.value) && ($(0, Fe(s.value), Me(s.value)), F(Z()));
  }, f = () => {
    t.startDate && ($(0, Fe(Z(t.startDate)), Me(Z(t.startDate))), l.value.count && q(0));
  }, L = i0((P, K) => {
    t.monthChangeOnScroll && N(t.monthChangeOnScroll !== "inverse" ? -P.deltaY : P.deltaY, K);
  }, 50), B = (P, K, ge = !1) => {
    t.monthChangeOnArrows && t.vertical === ge && J(P, K);
  }, J = (P, K) => {
    N(P === "right" ? -1 : 1, K);
  }, z = (P) => t.markers.find(
    (K) => Ue(u0(P.value), Xt(Z(K.date), t.timezone))
  ), A = (P, K) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [P == 0, !0];
      case "fair":
        return [P == 0 || K > P, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, _ = (P, K, ge, Ae) => {
    if (t.sixWeeks && P.length < 6) {
      const Qe = 6 - P.length, nn = (K.getDay() + 7 - Ae) % 7, On = 6 - (ge.getDay() + 7 - Ae) % 7, [ie, Se] = A(nn, On);
      for (let be = 1; be <= Qe; be++)
        if (Se ? !!(be % 2) == ie : ie) {
          const Rt = P[0].days[0], mn = le(hn(Rt.value, -7), Fe(K));
          P.unshift({ days: mn });
        } else {
          const Rt = P[P.length - 1], mn = Rt.days[Rt.days.length - 1], ys = le(hn(mn.value, 1), Fe(K));
          P.push({ days: ys });
        }
    }
    return P;
  }, le = (P, K) => {
    const ge = Z(P), Ae = [];
    for (let Qe = 0; Qe < 7; Qe++) {
      const nn = hn(ge, Qe), On = Fe(nn) !== K;
      Ae.push({
        text: t.hideOffsetDates && On ? "" : nn.getDate(),
        value: nn,
        current: !On,
        classData: {}
      });
    }
    return Ae;
  }, he = (P, K) => {
    const ge = [], Ae = new Date(K, P), Qe = new Date(K, P + 1, 0), nn = t.weekStart, On = tr(Ae, { weekStartsOn: nn }), ie = (Se) => {
      const be = le(Se, P);
      if (ge.push({ days: be }), !ge[ge.length - 1].days.some(
        (Rt) => Ue(bt(Rt.value), bt(Qe))
      )) {
        const Rt = hn(Se, 7);
        ie(Rt);
      }
    };
    return ie(On), _(ge, Ae, Qe, nn);
  }, re = (P) => (s.value = Ia(Z(P.value), t.timezone, t.weekStart), e("date-update", P.value), W()), Ce = (P) => {
    const K = In(Z(P.value), o.hours, o.minutes, _n());
    e("date-update", K), t.multiDates ? Qi(K, s, t.multiDatesLimit) : s.value = K, r(), Ln().then(() => {
      W();
    });
  }, de = (P) => t.noDisabledRange ? Hc(a.value[0], P).some((K) => d(K)) : !1, j = () => {
    a.value = s.value ? s.value.slice() : [], a.value.length === 2 && !(t.fixedStart || t.fixedEnd) && (a.value = []);
  }, te = (P, K) => {
    const ge = [Z(P.value), hn(Z(P.value), +t.autoRange)];
    p(ge) ? (K && Oe(P.value), a.value = ge) : e("invalid-date", P.value);
  }, Oe = (P) => {
    const K = Fe(Z(P)), ge = Me(Z(P));
    if ($(0, K, ge), l.value.count > 0)
      for (let Ae = 1; Ae < l.value.count; Ae++) {
        const Qe = c0(
          Je(Z(P), { year: T.value(Ae - 1), month: E.value(Ae - 1) })
        );
        $(Ae, Qe.month, Qe.year);
      }
  }, ae = (P) => Array.isArray(s.value) && s.value.length === 2 ? t.fixedStart && (wt(P, s.value[0]) || Ue(P, s.value[0])) ? [s.value[0], P] : t.fixedEnd && (ft(P, s.value[1]) || Ue(P, s.value[1])) ? [P, s.value[1]] : (e("invalid-fixed-range", P), s.value) : [], Le = (P) => {
    if (de(P.value) || !m(P.value, s.value, t.fixedStart ? 0 : 1))
      return e("invalid-date", P.value);
    a.value = ae(Z(P.value));
  }, mt = (P, K) => {
    if (j(), t.autoRange)
      return te(P, K);
    if (t.fixedStart || t.fixedEnd)
      return Le(P);
    a.value[0] ? m(Z(P.value), s.value) && !de(P.value) ? ft(Z(P.value), Z(a.value[0])) ? (a.value.unshift(Z(P.value)), e("range-end", a.value[0])) : (a.value[1] = Z(P.value), e("range-end", a.value[1])) : (t.autoApply && e("auto-apply-invalid", P.value), e("invalid-date", P.value)) : (a.value[0] = Z(P.value), e("range-start", a.value[0]));
  }, _n = (P = !0) => t.enableSeconds ? Array.isArray(o.seconds) ? P ? o.seconds[0] : o.seconds[1] : o.seconds : 0, tn = (P) => {
    a.value[P] = In(
      a.value[P],
      o.hours[P],
      o.minutes[P],
      _n(P !== 1)
    );
  }, Nt = () => {
    var P, K;
    a.value[0] && a.value[1] && +((P = a.value) == null ? void 0 : P[0]) > +((K = a.value) == null ? void 0 : K[1]) && (a.value.reverse(), e("range-start", a.value[0]), e("range-end", a.value[1]));
  }, pn = () => {
    a.value.length && (a.value[0] && !a.value[1] ? tn(0) : (tn(0), tn(1), r()), Nt(), s.value = a.value.slice(), hs(a.value, e, t.autoApply, t.modelAuto));
  }, or = (P, K = !1) => {
    if (d(P.value) || !P.current && t.hideOffsetDates)
      return e("invalid-date", P.value);
    if (t.weekPicker)
      return re(P);
    if (!t.range)
      return Ce(P);
    xl(o.hours) && xl(o.minutes) && !t.multiDates && (mt(P, K), pn());
  }, Tn = (P, K) => {
    var ge;
    $(P, K.month, K.year), l.value.count && !l.value.solo && q(P), e("update-month-year", { instance: P, month: K.month, year: K.year }), n(l.value.solo ? P : void 0);
    const Ae = (ge = t.flow) != null && ge.length ? t.flow[t.flowStep] : void 0;
    !K.fromNav && (Ae === an.month || Ae === an.year) && r();
  }, ht = (P, K) => {
    Qc({ value: P, modelValue: s, range: t.range, timezone: K ? void 0 : t.timezone }), V(), t.multiCalendars && Ln().then(() => k(!0));
  }, lr = () => {
    t.range ? s.value && Array.isArray(s.value) && s.value[0] ? s.value = ft(Z(), s.value[0]) ? [Z(), s.value[0]] : [s.value[0], Z()] : s.value = [Z()] : s.value = Z(), V();
  }, ur = () => {
    if (Array.isArray(s.value))
      if (t.multiDates) {
        const P = Wn();
        s.value[s.value.length - 1] = O(P);
      } else
        s.value = s.value.map((P, K) => P && O(P, K));
    else
      s.value = O(s.value);
    e("time-update");
  }, Wn = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: i,
    modelValue: s,
    month: T,
    year: E,
    time: o,
    disabledTimesConfig: M,
    validateTime: w,
    getCalendarDays: he,
    getMarker: z,
    handleScroll: L,
    handleSwipe: J,
    handleArrow: B,
    selectDate: or,
    updateMonthYear: Tn,
    presetDate: ht,
    selectCurrentDate: lr,
    updateTime: (P, K = !0, ge = !1) => {
      h(P, K, ge, ur);
    }
  };
}, xw = { key: 0 }, Mw = /* @__PURE__ */ pt({
  __name: "DatePicker",
  props: {
    ...en
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, {
      calendars: s,
      month: i,
      year: o,
      modelValue: l,
      time: u,
      disabledTimesConfig: c,
      validateTime: d,
      getCalendarDays: p,
      getMarker: m,
      handleArrow: h,
      handleScroll: O,
      handleSwipe: g,
      selectDate: b,
      updateMonthYear: w,
      presetDate: M,
      selectCurrentDate: T,
      updateTime: E
    } = Cw(a, r, y, f), $ = ar(), { setHoverDate: V, getDayClassData: Q, clearHoverDate: W } = E0(l, a), { defaultedMultiCalendars: k } = it(a), F = ee([]), H = ee([]), G = ee(null), Y = At($, "calendar"), S = At($, "monthYear"), R = At($, "timePicker"), N = (B) => {
      a.shadow || r("mount", B);
    };
    gn(
      s,
      () => {
        a.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const q = X(() => (B) => p(i.value(B), o.value(B)).map((J) => ({
      ...J,
      days: J.days.map((z) => (z.marker = m(z), z.classData = Q(z), z))
    })));
    function y(B) {
      var J;
      B || B === 0 ? (J = H.value[B]) == null || J.triggerTransition(i.value(B), o.value(B)) : H.value.forEach((z, A) => z.triggerTransition(i.value(A), o.value(A)));
    }
    function f() {
      r("update-flow-step");
    }
    const L = (B, J = !1) => {
      b(B, J), a.spaceConfirm && r("select-date");
    };
    return e({
      clearHoverDate: W,
      presetDate: M,
      selectCurrentDate: T,
      toggleMonthPicker: (B, J, z = 0) => {
        var A;
        (A = F.value[z]) == null || A.toggleMonthPicker(B, J);
      },
      toggleYearPicker: (B, J, z = 0) => {
        var A;
        (A = F.value[z]) == null || A.toggleYearPicker(B, J);
      },
      toggleTimePicker: (B, J, z) => {
        var A;
        (A = G.value) == null || A.toggleTimePicker(B, J, z);
      },
      handleArrow: h,
      updateMonthYear: w,
      getSidebarProps: () => ({
        modelValue: l,
        month: i,
        year: o,
        time: u,
        updateTime: E,
        updateMonthYear: w,
        selectDate: b,
        presetDate: M
      })
    }), (B, J) => (v(), x(ve, null, [
      He(ms, {
        "multi-calendars": D(k).count
      }, {
        default: _e(({ instance: z, index: A }) => [
          B.disableMonthYearSelect ? I("", !0) : (v(), fe(yw, Be({
            key: 0,
            ref: (_) => {
              _ && (F.value[A] = _);
            },
            months: D(Yc)(B.formatLocale, B.locale, B.monthNameFormat),
            years: D(Ji)(B.yearRange, B.reverseYears),
            month: D(i)(z),
            year: D(o)(z),
            instance: z
          }, B.$props, {
            onMount: J[0] || (J[0] = (_) => N(D(Qn).header)),
            onResetFlow: J[1] || (J[1] = (_) => B.$emit("reset-flow")),
            onUpdateMonthYear: (_) => D(w)(z, _),
            onOverlayClosed: J[2] || (J[2] = (_) => B.$emit("focus-menu"))
          }), St({ _: 2 }, [
            Re(D(S), (_, le) => ({
              name: _,
              fn: _e((he) => [
                ne(B.$slots, _, Ye(Ge(he)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          He(Dw, Be({
            ref: (_) => {
              _ && (H.value[A] = _);
            },
            "mapped-dates": q.value(z),
            month: D(i)(z),
            year: D(o)(z),
            instance: z
          }, B.$props, {
            onSelectDate: (_) => D(b)(_, z !== 1),
            onHandleSpace: (_) => L(_, z !== 1),
            onSetHoverDate: J[3] || (J[3] = (_) => D(V)(_)),
            onHandleScroll: (_) => D(O)(_, z),
            onHandleSwipe: (_) => D(g)(_, z),
            onMount: J[4] || (J[4] = (_) => N(D(Qn).calendar)),
            onResetFlow: J[5] || (J[5] = (_) => B.$emit("reset-flow")),
            onTooltipOpen: J[6] || (J[6] = (_) => B.$emit("tooltip-open", _)),
            onTooltipClose: J[7] || (J[7] = (_) => B.$emit("tooltip-close", _))
          }), St({ _: 2 }, [
            Re(D(Y), (_, le) => ({
              name: _,
              fn: _e((he) => [
                ne(B.$slots, _, Ye(Ge({ ...he })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars"]),
      B.enableTimePicker ? (v(), x("div", xw, [
        B.$slots["time-picker"] ? ne(B.$slots, "time-picker", Ye(Be({ key: 0 }, { time: D(u), updateTime: D(E) }))) : (v(), fe(ed, Be({
          key: 1,
          ref_key: "timePickerRef",
          ref: G
        }, B.$props, {
          hours: D(u).hours,
          minutes: D(u).minutes,
          seconds: D(u).seconds,
          "internal-model-value": B.internalModelValue,
          "disabled-times-config": D(c),
          "validate-time": D(d),
          onMount: J[8] || (J[8] = (z) => N(D(Qn).timePicker)),
          "onUpdate:hours": J[9] || (J[9] = (z) => D(E)(z)),
          "onUpdate:minutes": J[10] || (J[10] = (z) => D(E)(z, !1)),
          "onUpdate:seconds": J[11] || (J[11] = (z) => D(E)(z, !1, !0)),
          onResetFlow: J[12] || (J[12] = (z) => B.$emit("reset-flow")),
          onOverlayClosed: J[13] || (J[13] = (z) => B.$emit("time-picker-close")),
          onOverlayOpened: J[14] || (J[14] = (z) => B.$emit("time-picker-open", z)),
          onAmPmChange: J[15] || (J[15] = (z) => B.$emit("am-pm-change", z))
        }), St({ _: 2 }, [
          Re(D(R), (z, A) => ({
            name: z,
            fn: _e((_) => [
              ne(B.$slots, z, Ye(Ge(_)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : I("", !0)
    ], 64));
  }
}), Aw = (t, e) => {
  const n = ee(), { defaultedMultiCalendars: r, defaultedConfig: a, defaultedHighlight: s } = it(t), { modelValue: i, year: o, month: l, calendars: u } = va(t, e), { isDisabled: c } = ir(t), { selectYear: d, groupedYears: p, showYearPicker: m, isDisabled: h, toggleYearPicker: O, handleYearSelect: g, handleYear: b } = Kc({
    modelValue: i,
    multiCalendars: r,
    highlight: s,
    calendars: u,
    month: l,
    year: o,
    props: t,
    emit: e
  }), w = (W, k) => [W, k].map((F) => Rn(F, "MMMM", { locale: t.formatLocale })).join("-"), M = X(() => (W) => i.value ? Array.isArray(i.value) ? i.value.some((k) => fl(W, k)) : fl(i.value, W) : !1), T = (W) => {
    if (t.range) {
      if (Array.isArray(i.value)) {
        const k = Ue(W, i.value[0]) || Ue(W, i.value[1]);
        return ds(i.value, n.value, W) && !k;
      }
      return !1;
    }
    return !1;
  }, E = X(() => (W) => {
    const k = Je(/* @__PURE__ */ new Date(), { year: o.value(W) });
    return av({
      start: iv(k),
      end: sv(k)
    }).map((F) => {
      const H = na(F), G = il(F), Y = c(F), S = T(H), R = typeof s.value == "function" ? s.value({ quarter: sl(H), year: Me(H) }) : !!s.value.quarters.find(
        (N) => N.quarter === sl(H) && N.year === Me(H)
      );
      return {
        text: w(H, G),
        value: H,
        active: M.value(H),
        highlighted: R,
        disabled: Y,
        isBetween: S
      };
    });
  }), $ = (W) => {
    Qi(W, i, t.multiDatesLimit), e("auto-apply", !0);
  }, V = (W) => {
    const k = Ki(i, W, e);
    hs(k, e, t.autoApply, t.modelAuto);
  }, Q = (W) => {
    i.value = W, e("auto-apply");
  };
  return {
    defaultedConfig: a,
    defaultedMultiCalendars: r,
    groupedYears: p,
    year: o,
    isDisabled: h,
    quarters: E,
    showYearPicker: m,
    modelValue: i,
    setHoverDate: (W) => {
      n.value = W;
    },
    selectYear: d,
    selectQuarter: (W, k, F) => {
      if (!F)
        return u.value[k].month = Fe(il(W)), t.multiDates ? $(W) : t.range ? V(W) : Q(W);
    },
    toggleYearPicker: O,
    handleYearSelect: g,
    handleYear: b
  };
}, Ew = { class: "dp--quarter-items" }, Pw = ["disabled", "onClick", "onMouseover"], Fw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...en
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, s = ar(), i = At(s, "yearMode"), {
      defaultedMultiCalendars: o,
      defaultedConfig: l,
      groupedYears: u,
      year: c,
      isDisabled: d,
      quarters: p,
      modelValue: m,
      showYearPicker: h,
      setHoverDate: O,
      selectQuarter: g,
      toggleYearPicker: b,
      handleYearSelect: w,
      handleYear: M
    } = Aw(a, r);
    return e({ getSidebarProps: () => ({
      modelValue: m,
      year: c,
      selectQuarter: g,
      handleYearSelect: w,
      handleYear: M
    }) }), (T, E) => (v(), fe(ms, {
      "multi-calendars": D(o).count,
      stretch: ""
    }, {
      default: _e(({ instance: $ }) => [
        C("div", {
          class: "dp-quarter-picker-wrap",
          style: zt({ minHeight: `${D(l).modeHeight}px` })
        }, [
          C("div", null, [
            He(Xc, Be(T.$props, {
              items: D(u)($),
              instance: $,
              "show-year-picker": D(h)[$],
              year: D(c)($),
              "is-disabled": (V) => D(d)($, V),
              onHandleYear: (V) => D(M)($, V),
              onYearSelect: (V) => D(w)(V, $),
              onToggleYearPicker: (V) => D(b)($, V == null ? void 0 : V.flow, V == null ? void 0 : V.show)
            }), St({ _: 2 }, [
              Re(D(i), (V, Q) => ({
                name: V,
                fn: _e((W) => [
                  ne(T.$slots, V, Ye(Ge(W)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          C("div", Ew, [
            (v(!0), x(ve, null, Re(D(p)($), (V, Q) => (v(), x("div", { key: Q }, [
              C("button", {
                type: "button",
                class: pe(["dp--qr-btn", {
                  "dp--qr-btn-active": V.active,
                  "dp--qr-btn-between": V.isBetween,
                  "dp--qr-btn-disabled": V.disabled,
                  "dp--highlighted": V.highlighted
                }]),
                disabled: V.disabled,
                onClick: (W) => D(g)(V.value, $, V.disabled),
                onMouseover: (W) => D(O)(V.value)
              }, [
                T.$slots.quarter ? ne(T.$slots, "quarter", {
                  key: 0,
                  value: V.value,
                  text: V.text
                }) : (v(), x(ve, { key: 1 }, [
                  Xe(ze(V.text), 1)
                ], 64))
              ], 42, Pw)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), Nw = ["id"], Rw = {
  key: 0,
  class: "dp__sidebar_left"
}, Vw = {
  key: 1,
  class: "dp--preset-dates"
}, Iw = ["onClick", "onKeydown"], Lw = {
  key: 2,
  class: "dp__sidebar_right"
}, $w = {
  key: 3,
  class: "dp__action_extra"
}, Ml = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...ps,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) },
    noOverlayFocus: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, s = X(() => {
      const { openOnTop: j, ...te } = a;
      return {
        ...te,
        flowStep: Q.value,
        noOverlayFocus: a.noOverlayFocus
      };
    }), { setMenuFocused: i, setShiftKey: o, control: l } = Jc(), u = ar(), { defaultedTextInput: c, defaultedInline: d, defaultedConfig: p } = it(a), m = ee(null), h = ee(0), O = ee(null), g = ee(null), b = ee(!1), w = ee(null);
    Dt(() => {
      if (!a.shadow) {
        b.value = !0, M(), window.addEventListener("resize", M);
        const j = lt(O);
        if (j && !c.value.enabled && !d.value.enabled && (i(!0), G()), j) {
          const te = (Oe) => {
            p.value.allowPreventDefault && Oe.preventDefault(), Vn(Oe, p.value, !0);
          };
          j.addEventListener("pointerdown", te), j.addEventListener("mousedown", te);
        }
      }
    }), bi(() => {
      window.removeEventListener("resize", M);
    });
    const M = () => {
      const j = lt(g);
      j && (h.value = j.getBoundingClientRect().width);
    }, { arrowRight: T, arrowLeft: E, arrowDown: $, arrowUp: V } = Un(), { flowStep: Q, updateFlowStep: W, childMount: k, resetFlow: F } = P0(a, r, w), H = X(() => a.monthPicker ? G0 : a.yearPicker ? X0 : a.timePicker ? mw : a.quarterPicker ? Fw : Mw), G = () => {
      const j = lt(O);
      j && j.focus({ preventScroll: !0 });
    }, Y = X(() => {
      var j;
      return ((j = w.value) == null ? void 0 : j.getSidebarProps()) || {};
    }), S = () => {
      a.openOnTop && r("recalculate-position");
    }, R = At(u, "action"), N = X(() => a.monthPicker || a.yearPicker ? At(u, "monthYear") : a.timePicker ? At(u, "timePicker") : At(u, "shared")), q = X(() => a.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), y = X(() => ({
      dp__menu_disabled: a.disabled,
      dp__menu_readonly: a.readonly
    })), f = X(
      () => ({
        dp__menu: !0,
        dp__menu_index: !d.value.enabled,
        dp__relative: d.value.enabled,
        [a.menuClassName]: !!a.menuClassName
      })
    ), L = (j) => {
      Vn(j, p.value, !0);
    }, B = () => {
      a.escClose && r("close-picker");
    }, J = (j) => {
      if (a.arrowNavigation) {
        if (j === "up")
          return V();
        if (j === "down")
          return $();
        if (j === "left")
          return E();
        if (j === "right")
          return T();
      } else
        j === "left" || j === "up" ? he("handleArrow", "left", 0, j === "up") : he("handleArrow", "right", 0, j === "down");
    }, z = (j) => {
      o(j.shiftKey), !a.disableMonthYearSelect && j.code === "Tab" && j.target.classList.contains("dp__menu") && l.value.shiftKeyInMenu && (j.preventDefault(), Vn(j, p.value, !0), r("close-picker"));
    }, A = () => {
      G(), r("time-picker-close");
    }, _ = (j) => {
      var te, Oe, ae;
      (te = w.value) == null || te.toggleTimePicker(!1, !1), (Oe = w.value) == null || Oe.toggleMonthPicker(!1, !1, j), (ae = w.value) == null || ae.toggleYearPicker(!1, !1, j);
    }, le = (j, te = 0) => {
      var Oe, ae, Le;
      return j === "month" ? (Oe = w.value) == null ? void 0 : Oe.toggleMonthPicker(!1, !0, te) : j === "year" ? (ae = w.value) == null ? void 0 : ae.toggleYearPicker(!1, !0, te) : j === "time" ? (Le = w.value) == null ? void 0 : Le.toggleTimePicker(!0, !1) : _(te);
    }, he = (j, ...te) => {
      var Oe, ae;
      (Oe = w.value) != null && Oe[j] && ((ae = w.value) == null || ae[j](...te));
    }, re = () => {
      he("selectCurrentDate");
    }, Ce = (j, te) => {
      he("presetDate", j, te);
    }, de = () => {
      he("clearHoverDate");
    };
    return e({
      updateMonthYear: (j, te) => {
        he("updateMonthYear", j, te);
      },
      switchView: le
    }), (j, te) => {
      var Oe;
      return v(), x("div", {
        id: j.uid ? `dp-menu-${j.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: O,
        tabindex: "0",
        role: "dialog",
        class: pe(f.value),
        onMouseleave: de,
        onClick: L,
        onKeydown: [
          De(B, ["esc"]),
          te[18] || (te[18] = De(we((ae) => J("left"), ["prevent"]), ["left"])),
          te[19] || (te[19] = De(we((ae) => J("up"), ["prevent"]), ["up"])),
          te[20] || (te[20] = De(we((ae) => J("down"), ["prevent"]), ["down"])),
          te[21] || (te[21] = De(we((ae) => J("right"), ["prevent"]), ["right"])),
          z
        ]
      }, [
        (j.disabled || j.readonly) && D(d).enabled ? (v(), x("div", {
          key: 0,
          class: pe(y.value)
        }, null, 2)) : I("", !0),
        !D(d).enabled && !j.teleportCenter ? (v(), x("div", {
          key: 1,
          class: pe(q.value)
        }, null, 2)) : I("", !0),
        C("div", {
          ref_key: "innerMenuRef",
          ref: g,
          class: pe({
            dp__menu_content_wrapper: ((Oe = j.presetDates) == null ? void 0 : Oe.length) || !!j.$slots["left-sidebar"] || !!j.$slots["right-sidebar"]
          }),
          style: zt({ "--dp-menu-width": `${h.value}px` })
        }, [
          j.$slots["left-sidebar"] ? (v(), x("div", Rw, [
            ne(j.$slots, "left-sidebar", Ye(Ge(Y.value)))
          ])) : I("", !0),
          j.presetDates.length ? (v(), x("div", Vw, [
            (v(!0), x(ve, null, Re(j.presetDates, (ae, Le) => (v(), x(ve, { key: Le }, [
              ae.slot ? ne(j.$slots, ae.slot, {
                key: 0,
                presetDate: Ce,
                label: ae.label,
                value: ae.value
              }) : (v(), x("button", {
                key: 1,
                type: "button",
                style: zt(ae.style || {}),
                class: "dp__btn dp--preset-range",
                onClick: we((mt) => Ce(ae.value, ae.noTz), ["prevent"]),
                onKeydown: [
                  De(we((mt) => Ce(ae.value, ae.noTz), ["prevent"]), ["enter"]),
                  De(we((mt) => Ce(ae.value, ae.noTz), ["prevent"]), ["space"])
                ]
              }, ze(ae.label), 45, Iw))
            ], 64))), 128))
          ])) : I("", !0),
          C("div", {
            ref_key: "calendarWrapperRef",
            ref: m,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (v(), fe(Pn(H.value), Be({
              ref_key: "dynCmpRef",
              ref: w
            }, s.value, {
              "flow-step": D(Q),
              onMount: D(k),
              onUpdateFlowStep: D(W),
              onResetFlow: D(F),
              onFocusMenu: G,
              onSelectDate: te[0] || (te[0] = (ae) => j.$emit("select-date")),
              onDateUpdate: te[1] || (te[1] = (ae) => j.$emit("date-update", ae)),
              onTooltipOpen: te[2] || (te[2] = (ae) => j.$emit("tooltip-open", ae)),
              onTooltipClose: te[3] || (te[3] = (ae) => j.$emit("tooltip-close", ae)),
              onAutoApply: te[4] || (te[4] = (ae) => j.$emit("auto-apply", ae)),
              onRangeStart: te[5] || (te[5] = (ae) => j.$emit("range-start", ae)),
              onRangeEnd: te[6] || (te[6] = (ae) => j.$emit("range-end", ae)),
              onInvalidFixedRange: te[7] || (te[7] = (ae) => j.$emit("invalid-fixed-range", ae)),
              onTimeUpdate: te[8] || (te[8] = (ae) => j.$emit("time-update")),
              onAmPmChange: te[9] || (te[9] = (ae) => j.$emit("am-pm-change", ae)),
              onTimePickerOpen: te[10] || (te[10] = (ae) => j.$emit("time-picker-open", ae)),
              onTimePickerClose: A,
              onRecalculatePosition: S,
              onUpdateMonthYear: te[11] || (te[11] = (ae) => j.$emit("update-month-year", ae)),
              onAutoApplyInvalid: te[12] || (te[12] = (ae) => j.$emit("auto-apply-invalid", ae)),
              onInvalidDate: te[13] || (te[13] = (ae) => j.$emit("invalid-date", ae)),
              "onUpdate:internalModelValue": te[14] || (te[14] = (ae) => j.$emit("update:internal-model-value", ae))
            }), St({ _: 2 }, [
              Re(N.value, (ae, Le) => ({
                name: ae,
                fn: _e((mt) => [
                  ne(j.$slots, ae, Ye(Ge({ ...mt })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          j.$slots["right-sidebar"] ? (v(), x("div", Lw, [
            ne(j.$slots, "right-sidebar", Ye(Ge(Y.value)))
          ])) : I("", !0),
          j.$slots["action-extra"] ? (v(), x("div", $w, [
            j.$slots["action-extra"] ? ne(j.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: re
            }) : I("", !0)
          ])) : I("", !0)
        ], 6),
        !j.autoApply || D(p).keepActionRow ? (v(), fe(Y0, Be({
          key: 2,
          "menu-mount": b.value
        }, s.value, {
          "calendar-width": h.value,
          onClosePicker: te[15] || (te[15] = (ae) => j.$emit("close-picker")),
          onSelectDate: te[16] || (te[16] = (ae) => j.$emit("select-date")),
          onInvalidSelect: te[17] || (te[17] = (ae) => j.$emit("invalid-select")),
          onSelectNow: re
        }), St({ _: 2 }, [
          Re(D(R), (ae, Le) => ({
            name: ae,
            fn: _e((mt) => [
              ne(j.$slots, ae, Ye(Ge({ ...mt })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : I("", !0)
      ], 42, Nw);
    };
  }
}), Yw = typeof window < "u" ? window : void 0, js = () => {
}, Uw = (t) => vd() ? (yd(t), !0) : !1, Bw = (t, e, n, r) => {
  if (!t)
    return js;
  let a = js;
  const s = gn(
    () => D(t),
    (o) => {
      a(), o && (o.addEventListener(e, n, r), a = () => {
        o.removeEventListener(e, n, r), a = js;
      });
    },
    { immediate: !0, flush: "post" }
  ), i = () => {
    s(), a();
  };
  return Uw(i), i;
}, Ww = (t, e, n, r = {}) => {
  const { window: a = Yw, event: s = "pointerdown" } = r;
  return a ? Bw(a, s, (i) => {
    const o = lt(t), l = lt(e);
    !o || !l || o === i.target || i.composedPath().includes(o) || i.composedPath().includes(l) || n(i);
  }, { passive: !0 }) : void 0;
}, jw = /* @__PURE__ */ pt({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...ps
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, a = t, s = ar(), i = ee(!1), o = $a(a, "modelValue"), l = $a(a, "timezone"), u = ee(null), c = ee(null), d = ee(null), p = ee(!1), m = ee(null), h = ee(!1), O = ee(!1), { setMenuFocused: g, setShiftKey: b } = Jc(), { clearArrowNav: w } = Un(), { mapDatesArrToMap: M, validateDate: T, isValidTime: E } = ir(a), { defaultedTransitions: $, defaultedTextInput: V, defaultedInline: Q, defaultedConfig: W } = it(a), { menuTransition: k, showTransition: F } = ha($);
    Dt(() => {
      J(a.modelValue), Ln().then(() => {
        if (!Q.value.enabled) {
          const ie = y(m.value);
          ie == null || ie.addEventListener("scroll", j), window == null || window.addEventListener("resize", te);
        }
      }), Q.value.enabled && (i.value = !0), window == null || window.addEventListener("keyup", Oe), window == null || window.addEventListener("keydown", ae);
    });
    const H = X(() => M());
    bi(() => {
      if (!Q.value.enabled) {
        const ie = y(m.value);
        ie == null || ie.removeEventListener("scroll", j), window == null || window.removeEventListener("resize", te);
      }
      window == null || window.removeEventListener("keyup", Oe), window == null || window.removeEventListener("keydown", ae);
    });
    const G = At(s, "all", a.presetDates), Y = At(s, "input");
    gn(
      [o, l],
      () => {
        J(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: S, menuStyle: R, xCorrect: N, setMenuPosition: q, getScrollableParent: y, shadowRender: f } = x0({
      menuRef: u,
      menuRefInner: c,
      inputRef: d,
      pickerWrapperRef: m,
      inline: Q,
      emit: r,
      props: a,
      slots: s
    }), {
      inputValue: L,
      internalModelValue: B,
      parseExternalModelValue: J,
      emitModelValue: z,
      formatInputValue: A,
      checkBeforeEmit: _
    } = D0(r, a, p), le = X(
      () => ({
        dp__main: !0,
        dp__theme_dark: a.dark,
        dp__theme_light: !a.dark,
        dp__flex_display: Q.value.enabled,
        dp__flex_display_with_input: Q.value.input
      })
    ), he = X(() => a.dark ? "dp__theme_dark" : "dp__theme_light"), re = X(() => ({
      to: typeof a.teleport == "boolean" ? "body" : a.teleport,
      disabled: !a.teleport || Q.value.enabled
    })), Ce = X(() => ({ class: "dp__outer_menu_wrap" })), de = X(() => Q.value.enabled && (a.timePicker || a.monthPicker || a.yearPicker || a.quarterPicker)), j = () => {
      i.value && (W.value.closeOnScroll ? ht() : q());
    }, te = () => {
      i.value && q();
    }, Oe = (ie) => {
      ie.key === "Tab" && !Q.value.enabled && !a.teleport && W.value.tabOutClosesMenu && (m.value.contains(document.activeElement) || ht()), O.value = ie.shiftKey;
    }, ae = (ie) => {
      O.value = ie.shiftKey;
    }, Le = () => {
      !a.disabled && !a.readonly && (f(Ml, a), q(!1), i.value = !0, i.value && r("open"), i.value || Tn(), J(a.modelValue));
    }, mt = () => {
      var ie;
      L.value = "", Tn(), (ie = d.value) == null || ie.setParsedDate(null), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), W.value.closeOnClearValue && ht();
    }, _n = () => {
      const ie = B.value;
      return !ie || !Array.isArray(ie) && T(ie) ? !0 : Array.isArray(ie) ? a.multiDates || ie.length === 2 && T(ie[0]) && T(ie[1]) ? !0 : a.partialRange && !a.timePicker ? T(ie[0]) : !1 : !1;
    }, tn = () => {
      _() && _n() ? (z(), ht()) : r("invalid-select", B.value);
    }, Nt = (ie) => {
      pn(), z(), W.value.closeOnAutoApply && !ie && ht();
    }, pn = () => {
      d.value && V.value.enabled && d.value.setParsedDate(B.value);
    }, or = (ie = !1) => {
      a.autoApply && E(B.value) && _n() && (a.range && Array.isArray(B.value) ? (a.partialRange || B.value.length === 2) && Nt(ie) : Nt(ie));
    }, Tn = () => {
      V.value.enabled || (B.value = null);
    }, ht = () => {
      Q.value.enabled || (i.value && (i.value = !1, N.value = !1, g(!1), b(!1), w(), r("closed"), L.value && J(o.value)), Tn(), r("blur"));
    }, lr = (ie, Se, be = !1) => {
      if (!ie) {
        B.value = null;
        return;
      }
      const Rt = Array.isArray(ie) ? !ie.some((ys) => !T(ys)) : T(ie), mn = E(ie);
      Rt && mn && (B.value = ie, Se && (h.value = be, tn(), r("text-submit")));
    }, ur = () => {
      a.autoApply && E(B.value) && z(), pn();
    }, Wn = () => i.value ? ht() : Le(), P = (ie) => {
      B.value = ie;
    }, K = () => {
      V.value.enabled && (p.value = !0, A()), r("focus");
    }, ge = () => {
      if (V.value.enabled && (p.value = !1, J(a.modelValue), h.value)) {
        const ie = s0(m.value, O.value);
        ie == null || ie.focus();
      }
      r("blur");
    }, Ae = (ie) => {
      c.value && c.value.updateMonthYear(0, {
        month: _l(ie.month),
        year: _l(ie.year)
      });
    }, Qe = (ie) => {
      J(ie ?? a.modelValue);
    }, nn = (ie, Se) => {
      var be;
      (be = c.value) == null || be.switchView(ie, Se);
    }, On = (ie) => W.value.onClickOutside ? W.value.onClickOutside(ie) : ht();
    return Ww(u, d, () => On(_n)), e({
      closeMenu: ht,
      selectDate: tn,
      clearValue: mt,
      openMenu: Le,
      onScroll: j,
      formatInputValue: A,
      // exposed for testing purposes
      updateInternalModelValue: P,
      // modify internal modelValue
      setMonthYear: Ae,
      parseModel: Qe,
      switchView: nn,
      toggleMenu: Wn
    }), (ie, Se) => (v(), x("div", {
      ref_key: "pickerWrapperRef",
      ref: m,
      class: pe(le.value),
      "data-datepicker-instance": ""
    }, [
      He(V0, Be({
        ref_key: "inputRef",
        ref: d,
        "input-value": D(L),
        "onUpdate:inputValue": Se[0] || (Se[0] = (be) => lo(L) ? L.value = be : null),
        "is-menu-open": i.value
      }, ie.$props, {
        onClear: mt,
        onOpen: Le,
        onSetInputDate: lr,
        onSetEmptyDate: D(z),
        onSelectDate: tn,
        onToggle: Wn,
        onClose: ht,
        onFocus: K,
        onBlur: ge,
        onRealBlur: Se[1] || (Se[1] = (be) => p.value = !1)
      }), St({ _: 2 }, [
        Re(D(Y), (be, Rt) => ({
          name: be,
          fn: _e((mn) => [
            ne(ie.$slots, be, Ye(Ge(mn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      He(pd, Ye(Ge(re.value)), {
        default: _e(() => [
          He(Yn, {
            name: D(k)(D(S)),
            css: D(F) && !D(Q).enabled
          }, {
            default: _e(() => [
              i.value ? (v(), x("div", Be({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, Ce.value, {
                class: { "dp--menu-wrapper": !D(Q).enabled },
                style: D(Q).enabled ? void 0 : D(R)
              }), [
                He(Ml, Be({
                  ref_key: "dpMenuRef",
                  ref: c
                }, ie.$props, {
                  "internal-model-value": D(B),
                  "onUpdate:internalModelValue": Se[2] || (Se[2] = (be) => lo(B) ? B.value = be : null),
                  class: { [he.value]: !0, "dp--menu-wrapper": ie.teleport },
                  "open-on-top": D(S),
                  "arr-map-values": H.value,
                  "no-overlay-focus": de.value,
                  onClosePicker: ht,
                  onSelectDate: tn,
                  onAutoApply: or,
                  onTimeUpdate: ur,
                  onFlowStep: Se[3] || (Se[3] = (be) => ie.$emit("flow-step", be)),
                  onUpdateMonthYear: Se[4] || (Se[4] = (be) => ie.$emit("update-month-year", be)),
                  onInvalidSelect: Se[5] || (Se[5] = (be) => ie.$emit("invalid-select", D(B))),
                  onAutoApplyInvalid: Se[6] || (Se[6] = (be) => ie.$emit("invalid-select", be)),
                  onInvalidFixedRange: Se[7] || (Se[7] = (be) => ie.$emit("invalid-fixed-range", be)),
                  onRecalculatePosition: D(q),
                  onTooltipOpen: Se[8] || (Se[8] = (be) => ie.$emit("tooltip-open", be)),
                  onTooltipClose: Se[9] || (Se[9] = (be) => ie.$emit("tooltip-close", be)),
                  onTimePickerOpen: Se[10] || (Se[10] = (be) => ie.$emit("time-picker-open", be)),
                  onTimePickerClose: Se[11] || (Se[11] = (be) => ie.$emit("time-picker-close", be)),
                  onAmPmChange: Se[12] || (Se[12] = (be) => ie.$emit("am-pm-change", be)),
                  onRangeStart: Se[13] || (Se[13] = (be) => ie.$emit("range-start", be)),
                  onRangeEnd: Se[14] || (Se[14] = (be) => ie.$emit("range-end", be)),
                  onDateUpdate: Se[15] || (Se[15] = (be) => ie.$emit("date-update", be)),
                  onInvalidDate: Se[16] || (Se[16] = (be) => ie.$emit("invalid-date", be))
                }), St({ _: 2 }, [
                  Re(D(G), (be, Rt) => ({
                    name: be,
                    fn: _e((mn) => [
                      ne(ie.$slots, be, Ye(Ge({ ...mn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "arr-map-values", "no-overlay-focus", "onRecalculatePosition"])
              ], 16)) : I("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), eo = /* @__PURE__ */ (() => {
  const t = jw;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), Hw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eo
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(Hw).forEach(([t, e]) => {
  t !== "default" && (eo[t] = e);
});
const qw = {
  __name: "SelectInput",
  props: {
    label: { type: String, default: "label" },
    name: { type: String, required: !0 },
    options: { type: Array, required: !0 },
    searchable: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    modelValue: { default: null },
    disabled: { type: Boolean, default: !1 },
    placeholder: { type: String, default: null }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = e, r = $n("leadsFormOptions"), s = ee(t.modelValue);
    function i(o) {
      let l = o;
      o.constructor.name == "Object" && (l = o.code), n("update:modelValue", l);
    }
    return (o, l) => (v(), fe(D(yn), Be({
      label: t.label,
      name: t.name,
      options: t.options,
      searchable: t.searchable,
      clearable: t.clearable,
      modelValue: s.value,
      "onUpdate:modelValue": l[0] || (l[0] = (u) => s.value = u),
      disabled: t.disabled,
      placeholder: t.placeholder,
      components: D(r).vSelectComponents || {}
    }, D(r).vSelectProps, {
      "select-on-key-codes": [13],
      "onUpdate:modelValue": i
    }), null, 16, ["label", "name", "options", "searchable", "clearable", "modelValue", "disabled", "placeholder", "components"]));
  }
}, zw = { class: "timepicker-input-wrapper" }, Zw = { class: "timepicker-input-col timepicker-input-col-hours" }, Gw = { class: "timepicker-input-col timepicker-input-col-minutes" }, Jw = { class: "timepicker-input-col timepicker-input-col-meridiem" }, Xw = {
  __name: "Timepicker",
  props: {
    name: { type: String, required: !0 },
    disabled: { type: Boolean, default: !1 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "input"],
  setup(t, { emit: e }) {
    const n = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], r = ["00", 15, 30, 45], a = ["am", "pm"], s = $n("leadsFormOptions"), i = e, o = ee(""), l = ee("00"), u = ee("pm"), c = X(() => {
      if (!o.value || !l.value || !o.value > 0)
        return null;
      const p = o.value + ":" + l.value + " " + u.value, m = ke.fromFormat(p, "h:mm a");
      return m.isValid ? m.toLocaleString(ke.TIME_24_SIMPLE) : null;
    });
    function d(p) {
      i("input", c.value), i("update:modelValue", c.value);
    }
    return (p, m) => (v(), x("div", zw, [
      C("div", Zw, [
        He(D(yn), {
          placeholder: "",
          disabled: t.disabled,
          modelValue: o.value,
          "onUpdate:modelValue": m[0] || (m[0] = (h) => o.value = h),
          options: n,
          clearable: !1,
          "onOption:selected": d,
          components: D(s).vSelectComponents || {}
        }, null, 8, ["disabled", "modelValue", "components"])
      ]),
      m[3] || (m[3] = C("div", { class: "timepicker-input-col timepicker-input-col-sep" }, ":", -1)),
      C("div", Gw, [
        He(D(yn), {
          placeholder: "",
          searchable: !1,
          disabled: t.disabled,
          modelValue: l.value,
          "onUpdate:modelValue": m[1] || (m[1] = (h) => l.value = h),
          options: r,
          clearable: !1,
          "onOption:selected": d,
          components: D(s).vSelectComponents || {}
        }, null, 8, ["disabled", "modelValue", "components"])
      ]),
      C("div", Jw, [
        He(D(yn), {
          placeholder: "",
          disabled: t.disabled,
          modelValue: u.value,
          "onUpdate:modelValue": m[2] || (m[2] = (h) => u.value = h),
          options: a,
          clearable: !1,
          "onOption:selected": d,
          components: D(s).vSelectComponents || {}
        }, null, 8, ["disabled", "modelValue", "components"])
      ])
    ]));
  }
};
/*! maska v2.1.11 | (c) Alexander Shabunevich | Released under the MIT license */
var Qw = Object.defineProperty, Kw = (t, e, n) => e in t ? Qw(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Xr = (t, e, n) => (Kw(t, typeof e != "symbol" ? e + "" : e, n), n);
const Al = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
};
class El {
  constructor(e = {}) {
    Xr(this, "opts", {}), Xr(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...e };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...Al, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = new RegExp(r.pattern));
    } else
      n.tokens = Al;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, a) => r.length - a.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(e) {
    return this.process(e, this.findMask(e));
  }
  unmasked(e) {
    return this.process(e, this.findMask(e), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(e) {
    const n = this.findMask(e);
    if (this.opts.mask == null || n == null)
      return !1;
    const r = this.process(e, n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : typeof this.opts.mask == "function" ? r >= n.length : this.opts.mask.filter((a) => r >= a.length).length === this.opts.mask.length;
  }
  findMask(e) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(e);
    const r = this.process(e, n.slice(-1).pop() ?? "", !1);
    return n.find((a) => this.process(e, a, !1).length >= r.length) ?? "";
  }
  escapeMask(e) {
    const n = [], r = [];
    return e.split("").forEach((a, s) => {
      a === "!" && e[s - 1] !== "!" ? r.push(s - r.length) : n.push(a);
    }), { mask: n.join(""), escaped: r };
  }
  process(e, n, r = !0) {
    if (n == null)
      return e;
    const a = `value=${e},mask=${n},masked=${r ? 1 : 0}`;
    if (this.memo.has(a))
      return this.memo.get(a);
    const { mask: s, escaped: i } = this.escapeMask(n), o = [], l = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, c = this.isReversed() ? "unshift" : "push", d = this.isReversed() ? 0 : s.length - 1, p = this.isReversed() ? () => g > -1 && b > -1 : () => g < s.length && b < e.length, m = (M) => !this.isReversed() && M <= d || this.isReversed() && M >= d;
    let h, O = -1, g = this.isReversed() ? s.length - 1 : 0, b = this.isReversed() ? e.length - 1 : 0, w = !1;
    for (; p(); ) {
      const M = s.charAt(g), T = l[M], E = (T == null ? void 0 : T.transform) != null ? T.transform(e.charAt(b)) : e.charAt(b);
      if (!i.includes(g) && T != null ? (E.match(T.pattern) != null ? (o[c](E), T.repeated ? (O === -1 ? O = g : g === d && g !== O && (g = O - u), d === O && (g -= u)) : T.multiple && (w = !0, g -= u), g += u) : T.multiple ? w && (g += u, b -= u, w = !1) : E === h ? h = void 0 : T.optional && (g += u, b -= u), b += u) : (r && !this.isEager() && o[c](M), E === M && !this.isEager() ? b += u : h = M, this.isEager() || (g += u)), this.isEager())
        for (; m(g) && (l[s.charAt(g)] == null || i.includes(g)); )
          r ? o[c](s.charAt(g)) : s.charAt(g) === e.charAt(b) && (b += u), g += u;
    }
    return this.memo.set(a, o.join("")), this.memo.get(a);
  }
}
const nd = (t) => JSON.parse(t.replaceAll("'", '"')), Pl = (t, e = {}) => {
  const n = { ...e };
  return t.dataset.maska != null && t.dataset.maska !== "" && (n.mask = eb(t.dataset.maska)), t.dataset.maskaEager != null && (n.eager = Hs(t.dataset.maskaEager)), t.dataset.maskaReversed != null && (n.reversed = Hs(t.dataset.maskaReversed)), t.dataset.maskaTokensReplace != null && (n.tokensReplace = Hs(t.dataset.maskaTokensReplace)), t.dataset.maskaTokens != null && (n.tokens = tb(t.dataset.maskaTokens)), n;
}, Hs = (t) => t !== "" ? !!JSON.parse(t) : !0, eb = (t) => t.startsWith("[") && t.endsWith("]") ? nd(t) : t, tb = (t) => {
  if (t.startsWith("{") && t.endsWith("}"))
    return nd(t);
  const e = {};
  return t.split("|").forEach((n) => {
    const r = n.split(":");
    e[r[0]] = {
      pattern: new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), e;
};
class nb {
  constructor(e, n = {}) {
    Xr(this, "items", /* @__PURE__ */ new Map()), Xr(this, "beforeinputEvent", (r) => {
      const a = r.target, s = this.items.get(a);
      s.isEager() && "inputType" in r && r.inputType.startsWith("delete") && s.unmasked(a.value).length <= 1 && this.setMaskedValue(a, "");
    }), Xr(this, "inputEvent", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && r.detail != null && typeof r.detail == "object" && "masked" in r.detail)
        return;
      const a = r.target, s = this.items.get(a), i = a.value, o = a.selectionStart, l = a.selectionEnd;
      let u = i;
      if (s.isEager()) {
        const c = s.masked(i), d = s.unmasked(i);
        d === "" && "data" in r && r.data != null ? u = r.data : d !== s.unmasked(c) && (u = d);
      }
      if (this.setMaskedValue(a, u), "inputType" in r && (r.inputType.startsWith("delete") || o != null && o < i.length))
        try {
          a.setSelectionRange(o, l);
        } catch {
        }
    }), this.options = n, typeof e == "string" ? this.init(
      Array.from(document.querySelectorAll(e)),
      this.getMaskOpts(n)
    ) : this.init(
      "length" in e ? Array.from(e) : [e],
      this.getMaskOpts(n)
    );
  }
  destroy() {
    for (const e of this.items.keys())
      e.removeEventListener("input", this.inputEvent), e.removeEventListener("beforeinput", this.beforeinputEvent);
    this.items.clear();
  }
  needUpdateOptions(e, n) {
    const r = this.items.get(e), a = new El(Pl(e, this.getMaskOpts(n)));
    return JSON.stringify(r.opts) !== JSON.stringify(a.opts);
  }
  needUpdateValue(e) {
    const n = e.dataset.maskaValue;
    return n == null && e.value !== "" || n != null && n !== e.value;
  }
  getMaskOpts(e) {
    const { onMaska: n, preProcess: r, postProcess: a, ...s } = e;
    return s;
  }
  init(e, n) {
    for (const r of e) {
      const a = new El(Pl(r, n));
      this.items.set(r, a), r.value !== "" && this.setMaskedValue(r, r.value), r.addEventListener("input", this.inputEvent), r.addEventListener("beforeinput", this.beforeinputEvent);
    }
  }
  setMaskedValue(e, n) {
    const r = this.items.get(e);
    this.options.preProcess != null && (n = this.options.preProcess(n));
    const a = r.masked(n), s = r.unmasked(r.isEager() ? a : n), i = r.completed(n), o = { masked: a, unmasked: s, completed: i };
    n = a, this.options.postProcess != null && (n = this.options.postProcess(n)), e.value = n, e.dataset.maskaValue = n, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((l) => l(o)) : this.options.onMaska(o)), e.dispatchEvent(new CustomEvent("maska", { detail: o })), e.dispatchEvent(new CustomEvent("input", { detail: o }));
  }
}
const yi = /* @__PURE__ */ new WeakMap(), rb = (t) => {
  setTimeout(() => {
    var e;
    ((e = yi.get(t)) == null ? void 0 : e.needUpdateValue(t)) === !0 && t.dispatchEvent(new CustomEvent("input"));
  });
}, ab = (t, e) => {
  const n = t instanceof HTMLInputElement ? t : t.querySelector("input"), r = { ...e.arg };
  if (n == null || (n == null ? void 0 : n.type) === "file")
    return;
  rb(n);
  const a = yi.get(n);
  if (a != null) {
    if (!a.needUpdateOptions(n, r))
      return;
    a.destroy();
  }
  if (e.value != null) {
    const s = e.value, i = (o) => {
      s.masked = o.masked, s.unmasked = o.unmasked, s.completed = o.completed;
    };
    r.onMaska = r.onMaska == null ? i : Array.isArray(r.onMaska) ? [...r.onMaska, i] : [r.onMaska, i];
  }
  yi.set(n, new nb(n, r));
}, sb = {
  phone: {
    mask: "(###) ###-####",
    eager: !0
  },
  number: {
    mask: "9",
    tokens: {
      9: {
        pattern: /[0-9]/,
        multiple: !0
      }
    }
  },
  integer: {
    mask: "9",
    tokens: {
      9: {
        pattern: /[0-9]/,
        multiple: !0
      }
    }
  },
  currency: {
    mask: "0.99",
    tokens: {
      0: {
        pattern: /[0-9]/,
        multiple: !0
      },
      9: {
        pattern: /[0-9]/,
        optional: !0
      }
    }
  }
};
function qs(t) {
  const e = ["Bytes", "KB", "MB", "GB", "TB"];
  if (t === 0) return "n/a";
  const n = parseInt(Math.floor(Math.log(t) / Math.log(1024)), 10);
  return n === 0 ? `${t} ${e[n]})` : `${(t / 1024 ** n).toFixed(1)} ${e[n]}`;
}
const ib = { class: "images-input" }, ob = ["accept"], lb = { class: "images-input-dropzone-text" }, ub = { class: "images-input-restrictions" }, cb = {
  key: 1,
  class: "images-input-feedback"
}, db = {
  key: 0,
  class: "images-input-feedback-list images-input-notices"
}, fb = ["innerHTML"], pb = {
  key: 2,
  class: "images-input-preview"
}, mb = { class: "images-input-preview-item-inner" }, hb = { class: "images-input-preview-item-image" }, vb = ["src"], yb = { class: "images-input-preview-item-toolbar" }, gb = { class: "images-input-preview-item-info" }, wb = ["onClick"], bb = ["name", "onUpdate:modelValue"], kb = {
  __name: "ImagesInput",
  props: {
    name: { type: String, required: !0 },
    disabled: { type: Boolean, default: !1 },
    maxFileSize: { type: Number, default: 3145728 },
    // 3MB
    maxFiles: { type: Number, default: 3 },
    acceptedExtensions: { type: Array, default: () => [".jpg", ".jpeg", ".png", ".bmp", ".gif", ".tif", ".tiff"] },
    acceptedTypes: { type: Array, default: () => ["image/jpeg", "image/png", "image/bmp", "image/gif", "image/tiff"] }
  },
  emits: ["input", "update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, a = ee([]), s = ee([]), i = ee([]), o = ee(!1), l = ee(null);
    function u(g) {
      i.value = [];
      const b = g.type == "drop" ? g.dataTransfer.files : l.value.files;
      for (let w = 0; w < b.length; w++) {
        const M = b[w];
        a.value.length >= n.maxFiles ? i.value.push("<strong>" + M.name + "</strong> was not uploaded. Maximum of " + n.maxFiles + " uploads reached.") : n.acceptedTypes.includes(M.type) ? M.size > n.maxFilesize ? i.value.push("<strong>" + M.name + "</strong> was not uploaded. Maximum filesize of " + qs(n.maxFileSize) + " exceeded.") : (a.value.push(M), c()) : i.value.push("<strong>" + M.name + "</strong> was not uploaded. Invalid filetype. <span>Allowed: " + n.acceptedExtensions.join(", ") + "</span>");
      }
      g.type == "drop" && (o.value = !1);
    }
    function c() {
      const g = a.value, b = [];
      for (let w = 0; w < g.length; w++) {
        const M = g[w], T = new FileReader();
        T.onload = (E) => d(w, E.target.result), T.readAsDataURL(M);
      }
      r("input", b);
    }
    function d(g, b) {
      a.value[g].image = b, s.value[g] = b;
    }
    function p() {
      l.value.click();
    }
    function m(g) {
      g.preventDefault(), o.value = !0;
    }
    function h() {
      o.value = !1;
    }
    function O(g) {
      const b = a.value.findIndex((w) => w == g);
      a.value.splice(b, 1), c();
    }
    return (g, b) => (v(), x("div", ib, [
      a.value.length < t.maxFiles ? (v(), x("div", {
        key: 0,
        class: pe(["images-input-dropzone", { "images-input-dropzone-hover": o.value }]),
        onDragover: m,
        onDragleave: h,
        onDrop: we(u, ["prevent"])
      }, [
        C("div", null, [
          C("input", {
            type: "file",
            multiple: "",
            ref_key: "input",
            ref: l,
            onInput: u,
            class: "images-input-input",
            accept: t.acceptedExtensions.join(",")
          }, null, 40, ob),
          C("div", lb, [
            C("a", {
              href: "",
              onClick: we(p, ["prevent"])
            }, "Select files"),
            b[0] || (b[0] = Xe(" or drop files here "))
          ]),
          C("div", ub, [
            C("small", null, "Max filesize: " + ze(D(qs)(t.maxFileSize)), 1),
            C("small", null, "Max files: " + ze(t.maxFiles), 1)
          ])
        ])
      ], 34)) : I("", !0),
      i.value.length ? (v(), x("div", cb, [
        i.value.length ? (v(), x("div", db, [
          (v(!0), x(ve, null, Re(i.value, (w) => (v(), x("div", {
            class: "images-input-feedback-item images-input-notice",
            innerHTML: w
          }, null, 8, fb))), 256))
        ])) : I("", !0)
      ])) : I("", !0),
      a.value.length ? (v(), x("div", pb, [
        (v(!0), x(ve, null, Re(a.value, (w, M) => (v(), x("div", {
          class: "images-input-preview-item",
          key: w.name
        }, [
          C("div", mb, [
            C("div", hb, [
              C("img", {
                src: s.value[M]
              }, null, 8, vb)
            ]),
            C("div", yb, [
              C("div", gb, ze(D(qs)(w.size)), 1)
            ]),
            C("a", {
              href: "",
              onClick: we((T) => O(w), ["prevent"]),
              class: "images-input-preview-item-remove"
            }, b[1] || (b[1] = [
              C("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                C("path", {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  "stroke-width": "3",
                  d: "M6 18 18 6M6 6l12 12"
                })
              ], -1)
            ]), 8, wb),
            _t(C("input", {
              type: "hidden",
              name: t.name + "[" + M + "]",
              "onUpdate:modelValue": (T) => s.value[M] = T
            }, null, 8, bb), [
              [Zs, s.value[M]]
            ])
          ])
        ]))), 128))
      ])) : I("", !0)
    ]));
  }
}, _b = {
  /** @type {Object} child components */
  components: {
    DatePicker: eo,
    Timepicker: Xw,
    vSelect: yn,
    SelectInput: qw,
    ImagesInput: kb
  },
  inject: ["leadsFormOptions"],
  directives: { maska: ab },
  /** @type {Object} static properties manifests */
  props: {
    /** @type {String} input name */
    name: {
      type: String,
      required: !0
    },
    /** @type {Object} field options */
    options: {
      type: [Object, Array],
      default: () => ({ type: "text" })
    },
    /** @type {String} field value */
    modelValue: {
      default: () => ""
    },
    /** @type {Boolean} field disabled state */
    disabled: {
      type: Boolean,
      default: () => !1
    },
    subjectType: {
      type: String,
      required: !0
    },
    vid: {
      type: String
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    search: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    useBootstrap: {
      type: Boolean,
      default: !1
    },
    /** @type {String|null} field error message  */
    error: {
      type: String,
      default: null
    }
  },
  /**
   * Dynamic properties
   *
   * @return {Object}
   */
  data() {
    return {
      /**
       * Whether to show the example modal.
       *
       * @type {Boolean}
       */
      showExample: !1,
      innerValue: "",
      /** @type {Object} mask mapping */
      masks: sb
    };
  },
  /** @type {Object} computed properties manifest */
  computed: {
    /**
     * Determine the field's label
     * @return {String} label text
     */
    label() {
      return this.options.label === !1 ? !1 : this.options.label ? this.options.label : this.name.toLowerCase().replace(/([-_])/g, " ").replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, (e) => e.toUpperCase());
    },
    /**
     * Get the currently active form type
     * @return {String}
     */
    type() {
      return this.options.type ? this.options.type : "text";
    },
    choices() {
      return this.type != "select" ? [] : this.options.conditional_choices && this.options.conditional_choices.target ? this.conditionalChoices : this.options.choices;
    },
    conditionalChoices() {
      const t = this.options.conditional_choices.target, e = this.$parent.$parent.values[t];
      return this.options.conditional_choices.choices[e];
    },
    /**
     * The mask manifest to apply.
     */
    mask() {
      return this.options.mask ? this.masks[this.options.mask] : null;
    }
  },
  watch: {
    innerValue(t) {
      this.$emit("update:modelValue", t);
    },
    modelValue(t) {
      this.innerValue = t;
    }
  },
  /**
   * Instance created lifecycle hook
   */
  created() {
    this.modelValue && (this.innerValue = this.modelValue);
  },
  mounted() {
    this.type == "select" && this.options.choices.length == 1 && (this.innerValue = this.options.choices[0]), this.setActiveLocation();
  },
  /** @type {Object} component methods */
  methods: {
    /**
     * Set the active location if one is defined.
     */
    setActiveLocation() {
      this.name == "location" && (this.innerValue = this.choices.find((t) => t.active));
    }
  }
}, Tb = ["id"], Ob = ["for"], Sb = {
  key: 0,
  class: "req"
}, Db = { key: 0 }, Cb = { class: "pappasField__input" }, xb = ["name", "disabled"], Mb = ["name", "value", "disabled"], Ab = ["innerHTML"], Eb = ["name", "disabled", "id"], Pb = ["for"], Fb = ["name", "disabled"], Nb = ["type", "name", "disabled"], Rb = {
  key: 0,
  class: "pappasField__info"
}, Vb = ["innerHTML"], Ib = {
  key: 1,
  class: "pappasField__error"
}, Lb = { class: "pappasField__example" }, $b = { class: "pappasField__example__image" }, Yb = ["src", "alt"];
function Ub(t, e, n, r, a, s) {
  var d;
  const i = ct("SelectInput"), o = ct("date-picker"), l = ct("Timepicker"), u = ct("ImagesInput"), c = Bl("maska");
  return v(), x("div", {
    class: pe(["pappasField", "pappasField--" + s.type]),
    id: "field-" + n.name
  }, [
    C("label", {
      for: n.name,
      class: "pappasField__label"
    }, [
      s.label ? (v(), x(ve, { key: 0 }, [
        C("span", null, [
          Xe(ze(s.label) + " ", 1),
          n.options.validate && n.options.validate.includes("required") ? (v(), x("span", Sb, "*")) : I("", !0)
        ]),
        n.options.example ? (v(), x("div", Db, [
          C("a", {
            href: "",
            onClick: e[0] || (e[0] = we((p) => a.showExample = !0, ["prevent"]))
          }, "See example")
        ])) : I("", !0)
      ], 64)) : I("", !0)
    ], 8, Ob),
    C("div", {
      class: pe({ "is-invalid": n.error })
    }, [
      C("div", Cb, [
        s.type == "textarea" ? _t((v(), x("textarea", Be({
          name: n.name,
          key: n.subjectType + "-inputtextarea-" + n.name
        }, Object.assign({}, n.options.attrs), {
          "onUpdate:modelValue": e[1] || (e[1] = (p) => a.innerValue = p),
          rows: "4",
          class: { "form-control": n.useBootstrap },
          disabled: n.disabled
        }), null, 16, xb)), [
          [Zs, a.innerValue]
        ]) : s.type == "radio" ? (v(!0), x(ve, { key: 1 }, Re(n.options.choices, (p) => {
          var m;
          return v(), x("label", {
            key: "choice-" + p
          }, [
            (m = s.leadsFormOptions.inputComponents) != null && m.radio ? (v(), fe(Pn(s.leadsFormOptions.inputComponents.radio), {
              key: 0,
              name: n.name,
              value: p,
              modelValue: a.innerValue,
              "onUpdate:modelValue": e[2] || (e[2] = (h) => a.innerValue = h),
              disabled: n.disabled,
              label: p
            }, null, 8, ["name", "value", "modelValue", "disabled", "label"])) : (v(), x(ve, { key: 1 }, [
              _t(C("input", {
                type: "radio",
                name: n.name,
                value: p,
                "onUpdate:modelValue": e[3] || (e[3] = (h) => a.innerValue = h),
                disabled: n.disabled
              }, null, 8, Mb), [
                [gd, a.innerValue]
              ]),
              C("span", { innerHTML: p }, null, 8, Ab)
            ], 64))
          ]);
        }), 128)) : s.type == "checkbox-fullwidth" ? (v(), x("div", {
          key: 2,
          class: pe(["checkbox", { "form-check": n.useBootstrap }])
        }, [
          (d = s.leadsFormOptions.inputComponents) != null && d.checkbox ? (v(), fe(Pn(s.leadsFormOptions.inputComponents.checkbox), {
            key: 0,
            name: n.name,
            value: 1,
            modelValue: a.innerValue,
            "onUpdate:modelValue": e[4] || (e[4] = (p) => a.innerValue = p),
            disabled: n.disabled,
            id: "checkbox-" + n.name,
            label: s.label
          }, null, 8, ["name", "modelValue", "disabled", "id", "label"])) : (v(), x(ve, { key: 1 }, [
            _t(C("input", {
              type: "checkbox",
              name: n.name,
              value: 1,
              "onUpdate:modelValue": e[5] || (e[5] = (p) => a.innerValue = p),
              disabled: n.disabled,
              class: pe({ "form-check-input": n.useBootstrap }),
              id: "checkbox-" + n.name
            }, null, 10, Eb), [
              [wd, a.innerValue]
            ]),
            C("label", {
              for: "checkbox-" + n.name,
              class: pe({ "form-check-label": n.useBootstrap })
            }, ze(s.label), 11, Pb)
          ], 64))
        ], 2)) : s.type == "select" ? (v(), fe(i, {
          key: 3,
          name: n.name,
          label: n.options.choice_label || "label",
          modelValue: a.innerValue,
          "onUpdate:modelValue": e[6] || (e[6] = (p) => a.innerValue = p),
          class: pe({ "form-vselect": n.useBootstrap }),
          options: s.choices,
          searchable: n.search,
          clearable: n.clearable,
          disabled: n.disabled
        }, null, 8, ["name", "label", "modelValue", "class", "options", "searchable", "clearable", "disabled"])) : n.options.mask ? _t((v(), x("input", Be({
          type: "text",
          "onUpdate:modelValue": e[7] || (e[7] = (p) => a.innerValue = p),
          name: n.name,
          key: n.subjectType + "-inputmask-" + n.name
        }, Object.assign({}, n.options.attrs), {
          disabled: n.disabled,
          class: { "form-control": n.useBootstrap }
        }), null, 16, Fb)), [
          [Zs, a.innerValue],
          [c, void 0, s.mask]
        ]) : s.type == "datepicker" ? (v(), fe(o, Be({
          name: n.name,
          key: n.subjectType + "-inputdatepicker-" + n.name,
          modelValue: a.innerValue,
          "onUpdate:modelValue": e[8] || (e[8] = (p) => a.innerValue = p),
          format: "M/d/yyyy",
          "value-type": "YYYY-MM-DD",
          "auto-apply": !0
        }, Object.assign({ "enable-time-picker": !1 }, n.options.attrs)), null, 16, ["name", "modelValue"])) : s.type == "timepicker" ? (v(), fe(l, Be({
          name: n.name,
          key: n.subjectType + "-inputtimepicker-" + n.name,
          disabled: n.disabled,
          modelValue: a.innerValue,
          "onUpdate:modelValue": e[9] || (e[9] = (p) => a.innerValue = p)
        }, Object.assign({}, n.options.attrs)), null, 16, ["name", "disabled", "modelValue"])) : s.type == "images" ? (v(), fe(u, Be({
          name: n.name,
          key: n.subjectType + "-imagesinput-" + n.name,
          disabled: n.disabled
        }, Object.assign({}, n.options.attrs)), null, 16, ["name", "disabled"])) : _t((v(), x("input", Be({
          type: s.type ? s.type : "text",
          name: n.name,
          key: n.subjectType + "-inputtext-" + n.name
        }, Object.assign({}, n.options.attrs), {
          "onUpdate:modelValue": e[10] || (e[10] = (p) => a.innerValue = p),
          class: { "form-control": n.useBootstrap },
          disabled: n.disabled
        }), null, 16, Nb)), [
          [bd, a.innerValue]
        ])
      ]),
      n.options.info ? (v(), x("p", Rb, [
        C("em", {
          innerHTML: n.options.info
        }, null, 8, Vb)
      ])) : I("", !0),
      n.error ? (v(), x("div", Ib, ze(n.error), 1)) : I("", !0)
    ], 2),
    He(Yn, { name: "example--fade" }, {
      default: _e(() => [
        _t(C("div", Lb, [
          e[13] || (e[13] = C("div", { class: "pappasField__example__overlay" }, null, -1)),
          C("div", {
            class: "pappasField__example__inner",
            onClick: e[12] || (e[12] = we((p) => a.showExample = !1, ["prevent"]))
          }, [
            C("div", $b, [
              C("button", {
                type: "button",
                onClick: e[11] || (e[11] = we((p) => a.showExample = !1, ["prevent"]))
              }, "×"),
              C("img", {
                src: n.options.example,
                alt: s.label
              }, null, 8, Yb)
            ])
          ])
        ], 512), [
          [Fn, a.showExample]
        ])
      ]),
      _: 1
    })
  ], 10, Tb);
}
const Bb = /* @__PURE__ */ kn(_b, [["render", Ub]]), Wb = {
  props: {
    content: {
      type: String,
      required: !0
    }
  }
}, jb = ["innerHTML"];
function Hb(t, e, n, r, a, s) {
  return v(), x("div", {
    class: "pappasField pappasField--info",
    innerHTML: n.content
  }, null, 8, jb);
}
const qb = /* @__PURE__ */ kn(Wb, [["render", Hb]]), zb = {}, Zb = { class: "pappasForm__initializing" };
function Gb(t, e, n, r, a, s) {
  return v(), x("div", Zb, e[0] || (e[0] = [
    C("div", { class: "pappasForm__loader" }, [
      C("div")
    ], -1)
  ]));
}
const Jb = /* @__PURE__ */ kn(zb, [["render", Gb]]), Xb = {
  props: {
    location: {
      type: Object,
      default: () => ({})
    },
    buttonClass: {
      type: [String, Array],
      default: () => []
    }
  },
  computed: {
    isSpotOn() {
      return !!this.location.spoton_id;
    },
    isOpenTable() {
      return !!this.location.opentable_url;
    },
    buttonClassList() {
      const t = ["reserveButton"];
      let e = [];
      return typeof this.buttonClass == "string" ? e = this.buttonClass.split(" ") : e = this.buttonClass, t.concat(e).join(" ");
    }
  },
  watch: {
    location(t) {
      this.isSpotOn && this.injectSpoton();
    }
  },
  mounted() {
    this.isSpotOn && this.injectSpoton();
  },
  methods: {
    injectSpoton() {
      this.$refs.spoton.innerHTML = "", this.$refs.spoton.append(document.createElement("script"));
      const t = this.$refs.spoton.querySelector("script");
      t.dataset.restaurantId = this.location.spoton_id, t.dataset.apiKey = "lTNqTG5U0g14NrRdoDQ5saWs7RD5itPF5IndrpVE", t.dataset.containerCss = "reserveButton__container", t.dataset.buttonCss = this.buttonClassList, t.setAttribute("src", "https://sdk.seatninja.com/web/sn2.js");
    }
  }
}, Qb = { class: "pappasField pappasField--reservations" }, Kb = { key: 0 }, e1 = { ref: "spoton" }, t1 = { key: 1 }, n1 = ["href"];
function r1(t, e, n, r, a, s) {
  return v(), x("div", Qb, [
    s.isSpotOn ? (v(), x("div", Kb, [
      C("div", e1, null, 512)
    ])) : s.isOpenTable ? (v(), x("div", t1, [
      C("a", {
        href: n.location.opentable_url,
        class: pe(s.buttonClassList),
        target: "_blank",
        rel: "noopener"
      }, " Book Reservation ", 10, n1)
    ])) : I("", !0)
  ]);
}
const a1 = /* @__PURE__ */ kn(Xb, [["render", r1]]), s1 = { class: "pappasCateringFlow__intro" }, i1 = { class: "pappasFlow__actions" }, o1 = { class: "pappasFlow__choices" }, l1 = {
  __name: "CateringIntro",
  emits: ["show:cateringView"],
  setup(t, { emit: e }) {
    const n = e, r = $n("buttonClass");
    return (a, s) => (v(), x("div", s1, [
      s[3] || (s[3] = C("p", { class: "pappasFlow__label" }, [
        Xe(" Thank you for your interest in booking your event with Pappas Catering! "),
        C("br"),
        Xe(" We can’t wait to start planning with you. ")
      ], -1)),
      s[4] || (s[4] = C("p", null, "At Pappas Catering:", -1)),
      s[5] || (s[5] = C("ul", null, [
        C("li", null, "We offer full-service buffet style catering"),
        C("li", null, "On-site food preparation and cooking is our specialty"),
        C("li", null, "Our menus require a 40-guest minimum")
      ], -1)),
      C("div", i1, [
        s[2] || (s[2] = C("p", { class: "pappasFlow__label pappasFlow__actionLabel" }, "Does Pappas Catering match your event vision?", -1)),
        C("div", o1, [
          C("button", {
            type: "button",
            class: pe(["pappasForm__button pappasForm__button--choice", D(r)]),
            onClick: s[0] || (s[0] = we((i) => n("show:cateringView", "confirm"), ["prevent"]))
          }, "Yes", 2),
          C("button", {
            type: "button",
            class: pe(["pappasForm__button pappasForm__button--choice", D(r)]),
            onClick: s[1] || (s[1] = we((i) => n("show:cateringView", "alternatives"), ["prevent"]))
          }, "No", 2)
        ])
      ])
    ]));
  }
}, u1 = { class: "pappasCateringFlow__accordionItem__body" }, c1 = { class: "pappasCateringFlow__accordionItem__bodyInner" }, zs = {
  __name: "CateringAlternativesAccordionItem",
  props: {
    id: { type: String, required: !0 },
    label: { type: String, required: !0 }
  },
  emits: ["update:accordionActive"],
  setup(t, { emit: e }) {
    const n = e, r = t, a = $n("active");
    function s() {
      n("update:accordionActive", a.value == r.id ? null : r.id);
    }
    return (i, o) => (v(), x("div", {
      class: pe(["pappasCateringFlow__accordionItem", { "pappasCateringFlow__accordionItem--active": D(a) == t.id }])
    }, [
      C("div", {
        class: "pappasCateringFlow__accordionItem__header",
        onClick: we(s, ["prevent"])
      }, [
        C("span", null, ze(t.label), 1),
        o[0] || (o[0] = C("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "14",
          height: "10",
          role: "presentation",
          class: "vs__open-indicator"
        }, [
          C("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" })
        ], -1))
      ]),
      C("div", u1, [
        C("div", c1, [
          ne(i.$slots, "default")
        ])
      ])
    ], 2));
  }
}, d1 = { class: "pappasCateringFlow__accordion" }, f1 = { class: "pappasCateringFlow__accordionItem__buttonWrap" }, p1 = { class: "pappasFlow__logoGrid" }, m1 = ["href"], h1 = ["src", "alt"], v1 = { class: "pappasFlow__logoGrid" }, y1 = ["href"], g1 = ["src", "alt"], w1 = {
  __name: "CateringAlternativesAccordion",
  setup(t) {
    const e = ee(null);
    Wl("active", e);
    const n = $n("concepts"), r = $n("buttonClass"), a = ["pappadeaux", "pappasitos", "pappas-bbq", "pappas-bros", "pappas-seafood", "pappas-delta-blues"], s = ["pappadeaux", "pappasitos", "pappas-bbq", "pappas-bros", "pappas-seafood", "pappas-delta-blues", "pappas-burger", "dot-coffee"], i = X(() => {
      const l = {};
      return a.forEach((u) => {
        l[u] = n.find((c) => c.slug == u);
      }), l;
    }), o = X(() => {
      const l = {};
      return s.forEach((u) => {
        l[u] = n.find((c) => c.slug == u);
      }), l;
    });
    return (l, u) => (v(), x("div", d1, [
      He(zs, {
        id: "delivery",
        label: "Pappas Delivery – Perfect for Bulk Delivery",
        "onUpdate:accordionActive": u[0] || (u[0] = (c) => e.value = c)
      }, {
        default: _e(() => [
          u[3] || (u[3] = C("p", null, "At Pappas Delivery, our professional drivers deliver and setup your order buffet-style in disposable containers, making cleanup a breeze.", -1)),
          u[4] || (u[4] = C("p", null, "Available in Houston, Dallas, Austin & San Antonio.", -1)),
          C("p", f1, [
            C("a", {
              href: "https://pappasdelivery.com",
              target: "_blank",
              rel: "noopener",
              class: pe(D(r))
            }, "Learn More", 2)
          ]),
          u[5] || (u[5] = C("p", null, [
            C("small", null, "$150 delivery minimum. We kindly ask that you place your order 48 hours in advance.")
          ], -1))
        ]),
        _: 1
      }),
      He(zs, {
        id: "private-event",
        label: "Private Event – Book a Banquet Room",
        "onUpdate:accordionActive": u[1] || (u[1] = (c) => e.value = c)
      }, {
        default: _e(() => [
          u[6] || (u[6] = C("p", { class: "pappasCateringFlow__label" }, "For groups large and small, our private dinning spaces allow you and your guests to gather and dine at our restaurants with a preset menu and wait staff dedicated to your event.", -1)),
          u[7] || (u[7] = C("p", null, "Select Your Favorite Restaurant to Start the Booking Process", -1)),
          C("div", p1, [
            (v(!0), x(ve, null, Re(i.value, (c) => (v(), x("div", {
              key: "event-item-" + c.slug,
              class: "pappasFlow__logoGrid__item"
            }, [
              C("a", {
                href: c.events_form_url,
                target: "_blank",
                rel: "noopener"
              }, [
                C("img", {
                  src: c.logo_url,
                  alt: c.name,
                  class: pe(["pappasFlow__logoGrid__logo", "pappasFlow__logoGrid__logo--" + c.slug])
                }, null, 10, h1)
              ], 8, m1)
            ]))), 128))
          ]),
          u[8] || (u[8] = C("p", null, [
            C("small", null, "For groups of 10 or more. One check per event.")
          ], -1))
        ]),
        _: 1
      }),
      He(zs, {
        id: "togo",
        label: "To-Go – Order Pickup",
        "onUpdate:accordionActive": u[2] || (u[2] = (c) => e.value = c)
      }, {
        default: _e(() => [
          u[9] || (u[9] = C("p", null, "From individual meals to party packs, a to-go order can be ready in as little as 15 minutes.", -1)),
          u[10] || (u[10] = C("p", null, "Select the Restaurant You Wish to Place an Online Order", -1)),
          C("div", v1, [
            (v(!0), x(ve, null, Re(o.value, (c) => (v(), x("div", {
              key: "togo-item-" + c.slug,
              class: "pappasFlow__logoGrid__item"
            }, [
              C("a", {
                href: c.order_online_url,
                target: "_blank",
                rel: "noopener"
              }, [
                C("img", {
                  src: c.logo_url,
                  alt: c.name,
                  class: pe(["pappasFlow__logoGrid__logo", "pappasFlow__logoGrid__logo--" + c.slug])
                }, null, 10, g1)
              ], 8, y1)
            ]))), 128))
          ])
        ]),
        _: 1
      })
    ]));
  }
}, b1 = { class: "pappasCateringFlow__alternatives" }, k1 = {
  __name: "CateringAlternatives",
  setup(t) {
    return (e, n) => (v(), x("div", b1, [
      n[0] || (n[0] = C("p", { class: "pappasFlow__label" }, "One of our other services may be for you!", -1)),
      He(w1)
    ]));
  }
}, _1 = { class: "pappasCateringFlow__confirm" }, T1 = { class: "pappasFlow__choices pappasFlow__actions" }, O1 = {
  __name: "CateringConfirm",
  emits: ["show:cateringView", "confirm:catering"],
  setup(t, { emit: e }) {
    const n = e, r = $n("buttonClass");
    return (a, s) => (v(), x("div", _1, [
      s[1] || (s[1] = C("p", { class: "pappasFlow__label" }, "Thank you for your interest in booking with Pappas Catering! We can’t wait to hear more about your event.", -1)),
      s[2] || (s[2] = C("p", null, "Please continue to our contact form so an event specialist may reach out. We will contact you within 1-2 business days.", -1)),
      C("div", T1, [
        C("button", {
          type: "button",
          class: pe(["pappasForm__button pappasForm__button--choice", D(r)]),
          onClick: s[0] || (s[0] = we((i) => n("confirm:catering"), ["prevent"]))
        }, "Continue", 2)
      ])
    ]));
  }
}, S1 = { class: "pappasFlow pappasCateringFlow" }, D1 = {
  __name: "Catering",
  props: {
    concepts: { type: Object, default: () => ({}) },
    modelValue: { type: String, required: !0 }
  },
  emits: ["confirm:catering", "update:modelValue"],
  setup(t, { emit: e }) {
    Wl("concepts", t.concepts);
    const r = e;
    function a(s) {
      r("update:modelValue", s);
    }
    return (s, i) => (v(), x("div", S1, [
      t.modelValue == "intro" ? (v(), fe(l1, {
        key: 0,
        "onShow:cateringView": a
      })) : I("", !0),
      t.modelValue == "alternatives" ? (v(), fe(k1, {
        key: 1,
        "onShow:cateringView": a
      })) : I("", !0),
      t.modelValue == "confirm" ? (v(), fe(O1, {
        key: 2,
        "onShow:cateringView": a,
        "onConfirm:catering": i[0] || (i[0] = (o) => r("confirm:catering", o))
      })) : I("", !0)
    ]));
  }
}, C1 = { class: "pappasConceptField" }, x1 = { class: "pappasField" }, M1 = { class: "pappasField__input" }, A1 = {
  key: 0,
  class: "pappasField__error"
}, E1 = {
  __name: "ConceptField",
  props: /* @__PURE__ */ kd({
    // input name attribute
    name: { type: String, default: "concept" },
    // available concepts
    concepts: { type: Object, required: !0 },
    // whether the form loading state is active
    loading: { type: Boolean, required: !0 },
    // error message
    error: { type: String, default: null },
    // whether bootstrap should be utilised
    useBootstrap: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Object, default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = _d(t, "modelValue"), n = t, r = X(() => Object.values(n.concepts));
    return (a, s) => (v(), x("div", C1, [
      C("div", x1, [
        s[1] || (s[1] = C("label", { class: "pappasField__label" }, [
          C("span", null, [
            Xe(" Concept "),
            C("span", { class: "req" }, "*")
          ])
        ], -1)),
        C("div", {
          class: pe({ "is-invalid": t.error })
        }, [
          C("div", M1, [
            He(D(yn), {
              class: pe({ "form-vselect": t.useBootstrap }),
              label: "name",
              options: r.value,
              placeholder: "Select a Concept",
              clearable: !1,
              searchable: !1,
              modelValue: e.value,
              "onUpdate:modelValue": s[0] || (s[0] = (i) => e.value = i),
              disabled: t.loading,
              "reset-on-options-change": !0
            }, null, 8, ["class", "options", "modelValue", "disabled"])
          ]),
          t.error ? (v(), x("div", A1, "The location field is required.")) : I("", !0)
        ], 2)
      ])
    ]));
  }
}, Qa = {
  props: {
    useBootstrap: {
      type: Boolean,
      default: !1
    }
  }
};
var xt = "top", Ut = "bottom", Bt = "right", Mt = "left", to = "auto", ga = [xt, Ut, Bt, Mt], xr = "start", ia = "end", P1 = "clippingParents", rd = "viewport", Hr = "popper", F1 = "reference", Fl = /* @__PURE__ */ ga.reduce(function(t, e) {
  return t.concat([e + "-" + xr, e + "-" + ia]);
}, []), ad = /* @__PURE__ */ [].concat(ga, [to]).reduce(function(t, e) {
  return t.concat([e, e + "-" + xr, e + "-" + ia]);
}, []), N1 = "beforeRead", R1 = "read", V1 = "afterRead", I1 = "beforeMain", L1 = "main", $1 = "afterMain", Y1 = "beforeWrite", U1 = "write", B1 = "afterWrite", W1 = [N1, R1, V1, I1, L1, $1, Y1, U1, B1];
function dn(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Ft(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function rr(t) {
  var e = Ft(t).Element;
  return t instanceof e || t instanceof Element;
}
function $t(t) {
  var e = Ft(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function no(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Ft(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function j1(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, a = e.attributes[n] || {}, s = e.elements[n];
    !$t(s) || !dn(s) || (Object.assign(s.style, r), Object.keys(a).forEach(function(i) {
      var o = a[i];
      o === !1 ? s.removeAttribute(i) : s.setAttribute(i, o === !0 ? "" : o);
    }));
  });
}
function H1(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var a = e.elements[r], s = e.attributes[r] || {}, i = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), o = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !$t(a) || !dn(a) || (Object.assign(a.style, o), Object.keys(s).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const q1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: j1,
  effect: H1,
  requires: ["computeStyles"]
};
function cn(t) {
  return t.split("-")[0];
}
var Kn = Math.max, Ka = Math.min, Mr = Math.round;
function gi() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function sd() {
  return !/^((?!chrome|android).)*safari/i.test(gi());
}
function Ar(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), a = 1, s = 1;
  e && $t(t) && (a = t.offsetWidth > 0 && Mr(r.width) / t.offsetWidth || 1, s = t.offsetHeight > 0 && Mr(r.height) / t.offsetHeight || 1);
  var i = rr(t) ? Ft(t) : window, o = i.visualViewport, l = !sd() && n, u = (r.left + (l && o ? o.offsetLeft : 0)) / a, c = (r.top + (l && o ? o.offsetTop : 0)) / s, d = r.width / a, p = r.height / s;
  return {
    width: d,
    height: p,
    top: c,
    right: u + d,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function ro(t) {
  var e = Ar(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function id(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && no(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function bn(t) {
  return Ft(t).getComputedStyle(t);
}
function z1(t) {
  return ["table", "td", "th"].indexOf(dn(t)) >= 0;
}
function Bn(t) {
  return ((rr(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function vs(t) {
  return dn(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (no(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Bn(t)
  );
}
function Nl(t) {
  return !$t(t) || // https://github.com/popperjs/popper-core/issues/837
  bn(t).position === "fixed" ? null : t.offsetParent;
}
function Z1(t) {
  var e = /firefox/i.test(gi()), n = /Trident/i.test(gi());
  if (n && $t(t)) {
    var r = bn(t);
    if (r.position === "fixed")
      return null;
  }
  var a = vs(t);
  for (no(a) && (a = a.host); $t(a) && ["html", "body"].indexOf(dn(a)) < 0; ) {
    var s = bn(a);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function wa(t) {
  for (var e = Ft(t), n = Nl(t); n && z1(n) && bn(n).position === "static"; )
    n = Nl(n);
  return n && (dn(n) === "html" || dn(n) === "body" && bn(n).position === "static") ? e : n || Z1(t) || e;
}
function ao(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Qr(t, e, n) {
  return Kn(t, Ka(e, n));
}
function G1(t, e, n) {
  var r = Qr(t, e, n);
  return r > n ? n : r;
}
function od() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ld(t) {
  return Object.assign({}, od(), t);
}
function ud(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var J1 = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, ld(typeof e != "number" ? e : ud(e, ga));
};
function X1(t) {
  var e, n = t.state, r = t.name, a = t.options, s = n.elements.arrow, i = n.modifiersData.popperOffsets, o = cn(n.placement), l = ao(o), u = [Mt, Bt].indexOf(o) >= 0, c = u ? "height" : "width";
  if (!(!s || !i)) {
    var d = J1(a.padding, n), p = ro(s), m = l === "y" ? xt : Mt, h = l === "y" ? Ut : Bt, O = n.rects.reference[c] + n.rects.reference[l] - i[l] - n.rects.popper[c], g = i[l] - n.rects.reference[l], b = wa(s), w = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, M = O / 2 - g / 2, T = d[m], E = w - p[c] - d[h], $ = w / 2 - p[c] / 2 + M, V = Qr(T, $, E), Q = l;
    n.modifiersData[r] = (e = {}, e[Q] = V, e.centerOffset = V - $, e);
  }
}
function Q1(t) {
  var e = t.state, n = t.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = e.elements.popper.querySelector(a), !a) || id(e.elements.popper, a) && (e.elements.arrow = a));
}
const K1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: X1,
  effect: Q1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Er(t) {
  return t.split("-")[1];
}
var ek = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function tk(t, e) {
  var n = t.x, r = t.y, a = e.devicePixelRatio || 1;
  return {
    x: Mr(n * a) / a || 0,
    y: Mr(r * a) / a || 0
  };
}
function Rl(t) {
  var e, n = t.popper, r = t.popperRect, a = t.placement, s = t.variation, i = t.offsets, o = t.position, l = t.gpuAcceleration, u = t.adaptive, c = t.roundOffsets, d = t.isFixed, p = i.x, m = p === void 0 ? 0 : p, h = i.y, O = h === void 0 ? 0 : h, g = typeof c == "function" ? c({
    x: m,
    y: O
  }) : {
    x: m,
    y: O
  };
  m = g.x, O = g.y;
  var b = i.hasOwnProperty("x"), w = i.hasOwnProperty("y"), M = Mt, T = xt, E = window;
  if (u) {
    var $ = wa(n), V = "clientHeight", Q = "clientWidth";
    if ($ === Ft(n) && ($ = Bn(n), bn($).position !== "static" && o === "absolute" && (V = "scrollHeight", Q = "scrollWidth")), $ = $, a === xt || (a === Mt || a === Bt) && s === ia) {
      T = Ut;
      var W = d && $ === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        $[V]
      );
      O -= W - r.height, O *= l ? 1 : -1;
    }
    if (a === Mt || (a === xt || a === Ut) && s === ia) {
      M = Bt;
      var k = d && $ === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        $[Q]
      );
      m -= k - r.width, m *= l ? 1 : -1;
    }
  }
  var F = Object.assign({
    position: o
  }, u && ek), H = c === !0 ? tk({
    x: m,
    y: O
  }, Ft(n)) : {
    x: m,
    y: O
  };
  if (m = H.x, O = H.y, l) {
    var G;
    return Object.assign({}, F, (G = {}, G[T] = w ? "0" : "", G[M] = b ? "0" : "", G.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + O + "px)" : "translate3d(" + m + "px, " + O + "px, 0)", G));
  }
  return Object.assign({}, F, (e = {}, e[T] = w ? O + "px" : "", e[M] = b ? m + "px" : "", e.transform = "", e));
}
function nk(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, s = n.adaptive, i = s === void 0 ? !0 : s, o = n.roundOffsets, l = o === void 0 ? !0 : o, u = {
    placement: cn(e.placement),
    variation: Er(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: a,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Rl(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Rl(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const rk = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: nk,
  data: {}
};
var Ma = {
  passive: !0
};
function ak(t) {
  var e = t.state, n = t.instance, r = t.options, a = r.scroll, s = a === void 0 ? !0 : a, i = r.resize, o = i === void 0 ? !0 : i, l = Ft(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, Ma);
  }), o && l.addEventListener("resize", n.update, Ma), function() {
    s && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, Ma);
    }), o && l.removeEventListener("resize", n.update, Ma);
  };
}
const sk = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ak,
  data: {}
};
var ik = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function La(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return ik[e];
  });
}
var ok = {
  start: "end",
  end: "start"
};
function Vl(t) {
  return t.replace(/start|end/g, function(e) {
    return ok[e];
  });
}
function so(t) {
  var e = Ft(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function io(t) {
  return Ar(Bn(t)).left + so(t).scrollLeft;
}
function lk(t, e) {
  var n = Ft(t), r = Bn(t), a = n.visualViewport, s = r.clientWidth, i = r.clientHeight, o = 0, l = 0;
  if (a) {
    s = a.width, i = a.height;
    var u = sd();
    (u || !u && e === "fixed") && (o = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: o + io(t),
    y: l
  };
}
function uk(t) {
  var e, n = Bn(t), r = so(t), a = (e = t.ownerDocument) == null ? void 0 : e.body, s = Kn(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = Kn(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), o = -r.scrollLeft + io(t), l = -r.scrollTop;
  return bn(a || n).direction === "rtl" && (o += Kn(n.clientWidth, a ? a.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: o,
    y: l
  };
}
function oo(t) {
  var e = bn(t), n = e.overflow, r = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function cd(t) {
  return ["html", "body", "#document"].indexOf(dn(t)) >= 0 ? t.ownerDocument.body : $t(t) && oo(t) ? t : cd(vs(t));
}
function Kr(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = cd(t), a = r === ((n = t.ownerDocument) == null ? void 0 : n.body), s = Ft(r), i = a ? [s].concat(s.visualViewport || [], oo(r) ? r : []) : r, o = e.concat(i);
  return a ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(Kr(vs(i)))
  );
}
function wi(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function ck(t, e) {
  var n = Ar(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Il(t, e, n) {
  return e === rd ? wi(lk(t, n)) : rr(e) ? ck(e, n) : wi(uk(Bn(t)));
}
function dk(t) {
  var e = Kr(vs(t)), n = ["absolute", "fixed"].indexOf(bn(t).position) >= 0, r = n && $t(t) ? wa(t) : t;
  return rr(r) ? e.filter(function(a) {
    return rr(a) && id(a, r) && dn(a) !== "body";
  }) : [];
}
function fk(t, e, n, r) {
  var a = e === "clippingParents" ? dk(t) : [].concat(e), s = [].concat(a, [n]), i = s[0], o = s.reduce(function(l, u) {
    var c = Il(t, u, r);
    return l.top = Kn(c.top, l.top), l.right = Ka(c.right, l.right), l.bottom = Ka(c.bottom, l.bottom), l.left = Kn(c.left, l.left), l;
  }, Il(t, i, r));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function dd(t) {
  var e = t.reference, n = t.element, r = t.placement, a = r ? cn(r) : null, s = r ? Er(r) : null, i = e.x + e.width / 2 - n.width / 2, o = e.y + e.height / 2 - n.height / 2, l;
  switch (a) {
    case xt:
      l = {
        x: i,
        y: e.y - n.height
      };
      break;
    case Ut:
      l = {
        x: i,
        y: e.y + e.height
      };
      break;
    case Bt:
      l = {
        x: e.x + e.width,
        y: o
      };
      break;
    case Mt:
      l = {
        x: e.x - n.width,
        y: o
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = a ? ao(a) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (s) {
      case xr:
        l[u] = l[u] - (e[c] / 2 - n[c] / 2);
        break;
      case ia:
        l[u] = l[u] + (e[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function oa(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = r === void 0 ? t.placement : r, s = n.strategy, i = s === void 0 ? t.strategy : s, o = n.boundary, l = o === void 0 ? P1 : o, u = n.rootBoundary, c = u === void 0 ? rd : u, d = n.elementContext, p = d === void 0 ? Hr : d, m = n.altBoundary, h = m === void 0 ? !1 : m, O = n.padding, g = O === void 0 ? 0 : O, b = ld(typeof g != "number" ? g : ud(g, ga)), w = p === Hr ? F1 : Hr, M = t.rects.popper, T = t.elements[h ? w : p], E = fk(rr(T) ? T : T.contextElement || Bn(t.elements.popper), l, c, i), $ = Ar(t.elements.reference), V = dd({
    reference: $,
    element: M,
    strategy: "absolute",
    placement: a
  }), Q = wi(Object.assign({}, M, V)), W = p === Hr ? Q : $, k = {
    top: E.top - W.top + b.top,
    bottom: W.bottom - E.bottom + b.bottom,
    left: E.left - W.left + b.left,
    right: W.right - E.right + b.right
  }, F = t.modifiersData.offset;
  if (p === Hr && F) {
    var H = F[a];
    Object.keys(k).forEach(function(G) {
      var Y = [Bt, Ut].indexOf(G) >= 0 ? 1 : -1, S = [xt, Ut].indexOf(G) >= 0 ? "y" : "x";
      k[G] += H[S] * Y;
    });
  }
  return k;
}
function pk(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = n.boundary, s = n.rootBoundary, i = n.padding, o = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? ad : l, c = Er(r), d = c ? o ? Fl : Fl.filter(function(h) {
    return Er(h) === c;
  }) : ga, p = d.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  p.length === 0 && (p = d);
  var m = p.reduce(function(h, O) {
    return h[O] = oa(t, {
      placement: O,
      boundary: a,
      rootBoundary: s,
      padding: i
    })[cn(O)], h;
  }, {});
  return Object.keys(m).sort(function(h, O) {
    return m[h] - m[O];
  });
}
function mk(t) {
  if (cn(t) === to)
    return [];
  var e = La(t);
  return [Vl(t), e, Vl(e)];
}
function hk(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var a = n.mainAxis, s = a === void 0 ? !0 : a, i = n.altAxis, o = i === void 0 ? !0 : i, l = n.fallbackPlacements, u = n.padding, c = n.boundary, d = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, h = m === void 0 ? !0 : m, O = n.allowedAutoPlacements, g = e.options.placement, b = cn(g), w = b === g, M = l || (w || !h ? [La(g)] : mk(g)), T = [g].concat(M).reduce(function(z, A) {
      return z.concat(cn(A) === to ? pk(e, {
        placement: A,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: O
      }) : A);
    }, []), E = e.rects.reference, $ = e.rects.popper, V = /* @__PURE__ */ new Map(), Q = !0, W = T[0], k = 0; k < T.length; k++) {
      var F = T[k], H = cn(F), G = Er(F) === xr, Y = [xt, Ut].indexOf(H) >= 0, S = Y ? "width" : "height", R = oa(e, {
        placement: F,
        boundary: c,
        rootBoundary: d,
        altBoundary: p,
        padding: u
      }), N = Y ? G ? Bt : Mt : G ? Ut : xt;
      E[S] > $[S] && (N = La(N));
      var q = La(N), y = [];
      if (s && y.push(R[H] <= 0), o && y.push(R[N] <= 0, R[q] <= 0), y.every(function(z) {
        return z;
      })) {
        W = F, Q = !1;
        break;
      }
      V.set(F, y);
    }
    if (Q)
      for (var f = h ? 3 : 1, L = function(A) {
        var _ = T.find(function(le) {
          var he = V.get(le);
          if (he)
            return he.slice(0, A).every(function(re) {
              return re;
            });
        });
        if (_)
          return W = _, "break";
      }, B = f; B > 0; B--) {
        var J = L(B);
        if (J === "break") break;
      }
    e.placement !== W && (e.modifiersData[r]._skip = !0, e.placement = W, e.reset = !0);
  }
}
const vk = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: hk,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ll(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function $l(t) {
  return [xt, Bt, Ut, Mt].some(function(e) {
    return t[e] >= 0;
  });
}
function yk(t) {
  var e = t.state, n = t.name, r = e.rects.reference, a = e.rects.popper, s = e.modifiersData.preventOverflow, i = oa(e, {
    elementContext: "reference"
  }), o = oa(e, {
    altBoundary: !0
  }), l = Ll(i, r), u = Ll(o, a, s), c = $l(l), d = $l(u);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const gk = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: yk
};
function wk(t, e, n) {
  var r = cn(t), a = [Mt, xt].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, i = s[0], o = s[1];
  return i = i || 0, o = (o || 0) * a, [Mt, Bt].indexOf(r) >= 0 ? {
    x: o,
    y: i
  } : {
    x: i,
    y: o
  };
}
function bk(t) {
  var e = t.state, n = t.options, r = t.name, a = n.offset, s = a === void 0 ? [0, 0] : a, i = ad.reduce(function(c, d) {
    return c[d] = wk(d, e.rects, s), c;
  }, {}), o = i[e.placement], l = o.x, u = o.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[r] = i;
}
const kk = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: bk
};
function _k(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = dd({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Tk = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: _k,
  data: {}
};
function Ok(t) {
  return t === "x" ? "y" : "x";
}
function Sk(t) {
  var e = t.state, n = t.options, r = t.name, a = n.mainAxis, s = a === void 0 ? !0 : a, i = n.altAxis, o = i === void 0 ? !1 : i, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, d = n.padding, p = n.tether, m = p === void 0 ? !0 : p, h = n.tetherOffset, O = h === void 0 ? 0 : h, g = oa(e, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), b = cn(e.placement), w = Er(e.placement), M = !w, T = ao(b), E = Ok(T), $ = e.modifiersData.popperOffsets, V = e.rects.reference, Q = e.rects.popper, W = typeof O == "function" ? O(Object.assign({}, e.rects, {
    placement: e.placement
  })) : O, k = typeof W == "number" ? {
    mainAxis: W,
    altAxis: W
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, W), F = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, H = {
    x: 0,
    y: 0
  };
  if ($) {
    if (s) {
      var G, Y = T === "y" ? xt : Mt, S = T === "y" ? Ut : Bt, R = T === "y" ? "height" : "width", N = $[T], q = N + g[Y], y = N - g[S], f = m ? -Q[R] / 2 : 0, L = w === xr ? V[R] : Q[R], B = w === xr ? -Q[R] : -V[R], J = e.elements.arrow, z = m && J ? ro(J) : {
        width: 0,
        height: 0
      }, A = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : od(), _ = A[Y], le = A[S], he = Qr(0, V[R], z[R]), re = M ? V[R] / 2 - f - he - _ - k.mainAxis : L - he - _ - k.mainAxis, Ce = M ? -V[R] / 2 + f + he + le + k.mainAxis : B + he + le + k.mainAxis, de = e.elements.arrow && wa(e.elements.arrow), j = de ? T === "y" ? de.clientTop || 0 : de.clientLeft || 0 : 0, te = (G = F == null ? void 0 : F[T]) != null ? G : 0, Oe = N + re - te - j, ae = N + Ce - te, Le = Qr(m ? Ka(q, Oe) : q, N, m ? Kn(y, ae) : y);
      $[T] = Le, H[T] = Le - N;
    }
    if (o) {
      var mt, _n = T === "x" ? xt : Mt, tn = T === "x" ? Ut : Bt, Nt = $[E], pn = E === "y" ? "height" : "width", or = Nt + g[_n], Tn = Nt - g[tn], ht = [xt, Mt].indexOf(b) !== -1, lr = (mt = F == null ? void 0 : F[E]) != null ? mt : 0, ur = ht ? or : Nt - V[pn] - Q[pn] - lr + k.altAxis, Wn = ht ? Nt + V[pn] + Q[pn] - lr - k.altAxis : Tn, P = m && ht ? G1(ur, Nt, Wn) : Qr(m ? ur : or, Nt, m ? Wn : Tn);
      $[E] = P, H[E] = P - Nt;
    }
    e.modifiersData[r] = H;
  }
}
const Dk = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Sk,
  requiresIfExists: ["offset"]
};
function Ck(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function xk(t) {
  return t === Ft(t) || !$t(t) ? so(t) : Ck(t);
}
function Mk(t) {
  var e = t.getBoundingClientRect(), n = Mr(e.width) / t.offsetWidth || 1, r = Mr(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Ak(t, e, n) {
  n === void 0 && (n = !1);
  var r = $t(e), a = $t(e) && Mk(e), s = Bn(e), i = Ar(t, a, n), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((dn(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  oo(s)) && (o = xk(e)), $t(e) ? (l = Ar(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = io(s))), {
    x: i.left + o.scrollLeft - l.x,
    y: i.top + o.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function Ek(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(s) {
    e.set(s.name, s);
  });
  function a(s) {
    n.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(o) {
      if (!n.has(o)) {
        var l = e.get(o);
        l && a(l);
      }
    }), r.push(s);
  }
  return t.forEach(function(s) {
    n.has(s.name) || a(s);
  }), r;
}
function Pk(t) {
  var e = Ek(t);
  return W1.reduce(function(n, r) {
    return n.concat(e.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Fk(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function Nk(t) {
  var e = t.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var Yl = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ul() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Rk(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, a = e.defaultOptions, s = a === void 0 ? Yl : a;
  return function(o, l, u) {
    u === void 0 && (u = s);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Yl, s),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, m = {
      state: c,
      setOptions: function(b) {
        var w = typeof b == "function" ? b(c.options) : b;
        O(), c.options = Object.assign({}, s, c.options, w), c.scrollParents = {
          reference: rr(o) ? Kr(o) : o.contextElement ? Kr(o.contextElement) : [],
          popper: Kr(l)
        };
        var M = Pk(Nk([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = M.filter(function(T) {
          return T.enabled;
        }), h(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var b = c.elements, w = b.reference, M = b.popper;
          if (Ul(w, M)) {
            c.rects = {
              reference: Ak(w, wa(M), c.options.strategy === "fixed"),
              popper: ro(M)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(k) {
              return c.modifiersData[k.name] = Object.assign({}, k.data);
            });
            for (var T = 0; T < c.orderedModifiers.length; T++) {
              if (c.reset === !0) {
                c.reset = !1, T = -1;
                continue;
              }
              var E = c.orderedModifiers[T], $ = E.fn, V = E.options, Q = V === void 0 ? {} : V, W = E.name;
              typeof $ == "function" && (c = $({
                state: c,
                options: Q,
                name: W,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Fk(function() {
        return new Promise(function(g) {
          m.forceUpdate(), g(c);
        });
      }),
      destroy: function() {
        O(), p = !0;
      }
    };
    if (!Ul(o, l))
      return m;
    m.setOptions(u).then(function(g) {
      !p && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function h() {
      c.orderedModifiers.forEach(function(g) {
        var b = g.name, w = g.options, M = w === void 0 ? {} : w, T = g.effect;
        if (typeof T == "function") {
          var E = T({
            state: c,
            name: b,
            instance: m,
            options: M
          }), $ = function() {
          };
          d.push(E || $);
        }
      });
    }
    function O() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return m;
  };
}
var Vk = [sk, Tk, rk, q1, kk, vk, Dk, K1, gk], Ik = /* @__PURE__ */ Rk({
  defaultModifiers: Vk
});
function Lk() {
  return { withPopperPositioning: (e, n, { width: r }) => {
    e.style.width = r;
    const a = Ik(n.$refs.toggle, e, {
      placement: "bottom",
      modifiers: [
        {
          name: "offset",
          options: { offset: [0, -1] }
        },
        {
          name: "toggleClass",
          enabled: !0,
          phase: "write",
          function({ state: s }) {
            n.$el.classList.toggle("drop-up", s.placement === "top");
          }
        }
      ]
    });
    return () => a.destroy();
  } };
}
const $k = {
  mixins: [Qa],
  inject: ["leadsFormOptions"],
  components: {
    vSelect: yn
  },
  props: {
    /**
     * Additional button classes
     */
    buttonClass: {
      type: [String, Array, Object],
      default: null
    },
    concept: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      // current page to display
      page: 0,
      loading: !1,
      locationCode: this.concept.slug,
      selectedTimeframe: null,
      selectedTimeOfDay: null,
      selectedLocation: null,
      banquetUrls: this.concept.banquet_urls,
      timeframes: {
        monthurs: "Monday - Thursday",
        fri: "Friday",
        sat: "Saturday",
        sun: "Sunday"
      },
      timeOfDay: {
        lunch: "Lunch",
        dinner: "Dinner"
      }
    };
  },
  watch: {
    selectedTimeOfDay() {
      this.selectedLocation = null;
    },
    selectedTimeframe() {
      this.selectedLocation = null;
    }
  },
  computed: {
    availableLocations() {
      return this.isTripleSeatConcept ? this.tripleSeatLocations() : !this.selectedTimeOfDay || !this.selectedTimeframe ? [] : this.concept.active_locations.filter((t) => {
        const e = "banquet_availability_" + this.selectedTimeOfDay.value;
        return t.events && t[e] && t[e].includes(this.selectedTimeframe.value);
      }).map((t) => ({ label: t.name, value: t.location }));
    },
    /**
     * Whether the current concept supports TripleSeat booking.
     */
    isTripleSeatConcept() {
      return this.concept.slug == "pappasitos";
    }
  },
  setup() {
    const { withPopperPositioning: t } = Lk();
    return { withPopperPositioning: t };
  },
  mounted() {
    this.locationCode = this.concept.slug;
  },
  methods: {
    /**
     * Broadcast a finalising event.
     */
    broadcast(t) {
      this.$emit(t), this.reset();
    },
    /**
     * Does this concept need to be routed
     * to special links for private events?
     */
    conceptNeedsRouting() {
      if (!this.banquetUrls)
        return !1;
      const t = Object.values(this.banquetUrls);
      let e = [];
      return t.forEach((n) => e.push(...Object.values(n))), e = e.filter((n) => !!n), e.length;
    },
    /**
     * Get the events-enabled locations with a tripleseat_id value.
     */
    tripleSeatLocations() {
      return this.concept.active_locations.filter((t) => t.events && t.tripleseat_id).map((t) => ({ label: t.name, value: t }));
    },
    /**
     * Go to the private event url.
     */
    gotoPrivateEventUrl() {
      window.open(this.getLinkFromTimeSelections(this.selectedTimeOfDay, this.selectedTimeframe), "_blank");
    },
    /**
     * Go to the tripleseat form url.
     */
    gotoTripleSeatUrl() {
      window.open("https://pappasrestaurants.tripleseat.com/party_request/" + this.selectedLocation.value.tripleseat_id, "_blank");
    },
    /**
     * Get the select options for the given object.
     */
    getSelectOptions(t) {
      return Object.keys(t).map((e) => ({
        label: t[e],
        value: e
      }));
    },
    setSelectedLocation(t) {
      this.selectedLocation = t.value;
    },
    setTimeOfDay(t) {
      this.selectedTimeOfDay = t.value;
    },
    setTimeframe(t) {
      this.selectedTimeframe = t.value;
    },
    /**
     * Get the link for the given time of day and timeframe.
     */
    getLinkFromTimeSelections(t, e) {
      return !e || !t ? null : this.banquetUrls[t.value][e.value];
    },
    /**
     * Resets the component.
     */
    reset() {
      this.page = 0;
    }
  }
}, Yk = { class: "pappasFlow pappasEventConfirm" }, Uk = {
  key: 0,
  class: "pappasEventConfirm__partySize"
}, Bk = { class: "pappasFlow__choices pappasEventConfirm__choices" }, Wk = {
  key: 1,
  class: "pappasEventConfirm-2"
}, jk = { key: 1 }, Hk = {
  key: 2,
  id: "privateEventDetailsWrapper"
}, qk = { class: "pappasForm__tripleseat" }, zk = { class: "pappasForm__tripleseat__option" }, Zk = { class: "pappasForm__tripleseat__option" }, Gk = {
  key: 3,
  id: "privateEventDetailsWrapper"
}, Jk = { class: "pappasBanquetField" }, Xk = { class: "pappasField" }, Qk = {
  key: 0,
  class: "pappasBanquetField"
}, Kk = { class: "pappasField" }, e_ = { key: 1 }, t_ = { class: "pappasField" };
function n_(t, e, n, r, a, s) {
  const i = ct("v-select");
  return v(), x("div", Yk, [
    a.page ? I("", !0) : (v(), x("div", Uk, [
      e[7] || (e[7] = C("div", { class: "pappasFlow__label pappasEventConfirm__label" }, "Is your party more than 10 people?", -1)),
      C("div", Bk, [
        C("button", {
          type: "button",
          class: pe(["pappasForm__button pappasForm__button--choice", n.buttonClass]),
          onClick: e[0] || (e[0] = we((o) => a.page = 1, ["prevent"]))
        }, "Yes", 2),
        C("button", {
          type: "button",
          class: pe(["pappasForm__button pappasForm__button--choice", n.buttonClass]),
          onClick: e[1] || (e[1] = we((o) => s.broadcast("abort"), ["prevent"]))
        }, "No", 2)
      ])
    ])),
    a.page === 1 ? (v(), x("div", Wk, [
      ne(t.$slots, "confirm-step-two", {}, () => [
        e[8] || (e[8] = C("p", { class: "pappasEventConfirm__label" }, [
          Xe(" Thank you for your interest in booking your event with us! "),
          C("br"),
          Xe(" We can’t wait to start planning. ")
        ], -1)),
        e[9] || (e[9] = C("p", null, "To reserve one of our private dining rooms, we will require:", -1)),
        e[10] || (e[10] = C("ul", null, [
          C("li", null, "Preset menu selection"),
          C("li", null, "Signed contract"),
          C("li", null, "Minimum expenditure for food and beverage"),
          C("li", null, "Separate checks are not available")
        ], -1))
      ]),
      s.conceptNeedsRouting() ? I("", !0) : (v(), x("button", {
        key: 0,
        type: "button",
        class: pe(["pappasForm__button pappasForm__button--confirm", n.buttonClass]),
        onClick: e[2] || (e[2] = we((o) => s.broadcast("confirm"), ["prevent"]))
      }, "Continue", 2)),
      s.conceptNeedsRouting() || s.isTripleSeatConcept ? (v(), x("hr", jk)) : I("", !0),
      s.isTripleSeatConcept ? (v(), x("div", Hk, [
        C("div", qk, [
          C("div", zk, [
            C("a", {
              href: "https://portal.tripleseat.com/direct_bookings/gfv7dzth4m4",
              target: "_blank",
              class: pe(["pappasForm__button pappasForm__button--confirm", n.buttonClass])
            }, " Book Online Now ", 2),
            e[11] || (e[11] = C("p", null, " To plan and secure your event, select BOOK ONLINE NOW. A 25% deposit is required upon submitting your request. ", -1))
          ]),
          C("div", Zk, [
            C("a", {
              href: "https://pappasrestaurants.tripleseat.com/party_request/38484",
              target: "_blank",
              class: pe(["pappasForm__button pappasForm__button--confirm", n.buttonClass])
            }, " Contact a Specialist ", 2),
            e[12] || (e[12] = C("p", null, " Select CONTACT A SPECIALIST to complete our form so a team member can contact you within 1-2 business days. ", -1))
          ])
        ])
      ])) : s.conceptNeedsRouting() ? (v(), x("div", Gk, [
        C("div", Jk, [
          e[13] || (e[13] = C("div", { class: "pappasEventConfirm__label" }, "What time of day would you like to book?", -1)),
          C("div", Xk, [
            He(i, Be({
              class: { "form-vselect": t.useBootstrap },
              options: s.getSelectOptions(a.timeOfDay),
              placeholder: "Select a Time of Day",
              clearable: !1,
              searchable: !1,
              components: s.leadsFormOptions.vSelectComponents || {}
            }, s.leadsFormOptions.vSelectProps, {
              modelValue: a.selectedTimeOfDay,
              "onUpdate:modelValue": e[3] || (e[3] = (o) => a.selectedTimeOfDay = o),
              onInput: s.setTimeOfDay,
              "append-to-body": "",
              "calculate-position": r.withPopperPositioning
            }), null, 16, ["class", "options", "components", "modelValue", "onInput", "calculate-position"])
          ])
        ]),
        a.selectedTimeOfDay ? (v(), x("div", Qk, [
          e[14] || (e[14] = C("div", { class: "pappasEventConfirm__label" }, "Which day would you like to book?", -1)),
          C("div", Kk, [
            He(i, Be({
              class: { "form-vselect": t.useBootstrap },
              label: "label",
              options: s.getSelectOptions(a.timeframes),
              placeholder: "Select a Timeframe",
              clearable: !1,
              searchable: !1,
              disabled: !a.selectedTimeOfDay,
              components: s.leadsFormOptions.vSelectComponents || {}
            }, s.leadsFormOptions.vSelectProps, {
              modelValue: a.selectedTimeframe,
              "onUpdate:modelValue": e[4] || (e[4] = (o) => a.selectedTimeframe = o),
              onInput: s.setTimeframe,
              "append-to-body": "",
              "calculate-position": r.withPopperPositioning
            }), null, 16, ["class", "options", "disabled", "components", "modelValue", "onInput", "calculate-position"])
          ])
        ])) : I("", !0),
        a.selectedTimeOfDay && a.selectedTimeframe ? (v(), x("div", e_, [
          e[15] || (e[15] = C("div", { class: "pappasEventConfirm__label" }, "Which location would you like to book?", -1)),
          C("div", t_, [
            He(i, Be({
              class: { "form-vselect": t.useBootstrap },
              label: "label",
              options: s.availableLocations,
              placeholder: "Select a Location",
              clearable: !1,
              searchable: !1,
              disabled: !a.selectedTimeframe,
              components: s.leadsFormOptions.vSelectComponents || {}
            }, s.leadsFormOptions.vSelectProps, {
              modelValue: a.selectedLocation,
              "onUpdate:modelValue": e[5] || (e[5] = (o) => a.selectedLocation = o),
              onInput: s.setSelectedLocation,
              "append-to-body": "",
              "calculate-position": r.withPopperPositioning
            }), null, 16, ["class", "options", "disabled", "components", "modelValue", "onInput", "calculate-position"])
          ])
        ])) : I("", !0),
        _t(C("button", {
          type: "button",
          class: pe(["pappasForm__button pappasForm__button--confirm", n.buttonClass]),
          onClick: e[6] || (e[6] = we((o) => s.gotoPrivateEventUrl(), ["prevent"]))
        }, " Continue ", 2), [
          [Fn, a.selectedTimeframe != null && a.selectedTimeOfDay != null && a.selectedLocation != null]
        ])
      ])) : I("", !0)
    ])) : I("", !0)
  ]);
}
const r_ = /* @__PURE__ */ kn($k, [["render", n_]]), a_ = {
  mixins: [Qa],
  components: { vSelect: yn },
  inject: ["leadsFormOptions"],
  props: {
    /**
     * Input value, used for v-model.
     */
    modelValue: {
      type: Object,
      default: null
    },
    /**
     * Field options from manifest.
     */
    options: {
      type: Object,
      required: !0
    },
    /**
     * Whether the loading state is active on the form.
     */
    loading: {
      type: Boolean,
      required: !0
    },
    /**
     * The input name.
     */
    name: {
      type: String,
      default: "location"
    },
    /**
     * Currently active lead type.
     */
    type: {
      type: String,
      default: "general"
    },
    error: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      location: this.modelValue,
      label: this.options.label,
      additional: [],
      showAdditional: !1
    };
  },
  computed: {
    /**
     * Whether additional locations can be added.
     *
     * @return {boolean}
     */
    canAddAdditional() {
      return this.type == "event" && this.options.choices.length > 1;
    },
    /**
     * Whether additional locations have been choosen.
     *
     * @return {boolean}
     */
    hasAdditional() {
      return this.additional.length;
    },
    /**
     * Maximum number of additional locations.
     *
     * @return {number}
     */
    maxAdditional() {
      const t = this.options.choices.length - 1;
      return t < 3 ? t : 3;
    },
    /**
     * Whether there is only a single location.
     *
     * @return {Boolean}
     */
    isSingleLocation() {
      return this.options && this.options.choices && this.options.choices.length === 1;
    },
    /**
     * The locations dropdown choices, sorted.
     */
    choices() {
      return this.options.choices.sort((t, e) => this.optionLabel(t).localeCompare(this.optionLabel(e)));
    }
  },
  watch: {
    additional(t) {
      let e = this.additional.map((n) => n.astute_id ? n.astute_id : null);
      e = e.filter((n) => n), this.$emit("locations", e);
    }
  },
  created() {
    this.isSingleLocation && (this.location = this.options.choices[0], this.$emit("update:modelValue", this.location));
  },
  methods: {
    appendAdditional() {
      this.additional.push({});
    },
    removeAdditional(t) {
      this.additional.splice(t, 1);
    },
    /**
     * The computed dropdown option label.
     * 
     * @param loc 
     */
    optionLabel(t) {
      if (!t.state)
        return t.name;
      let e = `${t.state} - ${t.city}`;
      return t.city != t.short_name && (e += " - " + t.short_name), e;
    }
  }
}, s_ = { class: "pappasLocationField" }, i_ = {
  key: 0,
  class: "pappasField"
}, o_ = { class: "pappasField__label" }, l_ = {
  key: 0,
  class: "req"
}, u_ = { class: "pappasField__input" }, c_ = {
  key: 0,
  class: "pappasAdditionalLocations__toggle"
}, d_ = {
  key: 1,
  class: "pappasField__info"
}, f_ = ["innerHTML"], p_ = {
  key: 2,
  class: "pappasField__error"
}, m_ = {
  key: 1,
  class: "pappasField"
}, h_ = { class: "pappasAdditionalLocations" }, v_ = ["onClick"], y_ = {
  key: 0,
  class: "pappasAdditionalLocations__actions"
};
function g_(t, e, n, r, a, s) {
  const i = ct("v-select");
  return v(), x("div", s_, [
    s.isSingleLocation ? I("", !0) : (v(), x("div", i_, [
      C("label", o_, [
        C("span", null, [
          Xe(ze(a.label) + " ", 1),
          n.options.validate && n.options.validate.includes("required") ? (v(), x("span", l_, "*")) : I("", !0)
        ])
      ]),
      C("div", {
        class: pe({ "is-invalid": n.error })
      }, [
        C("div", u_, [
          He(i, Be({
            class: { "form-vselect": t.useBootstrap },
            getOptionLabel: s.optionLabel,
            options: s.choices,
            placeholder: n.options.placeholder || "Select a Location",
            clearable: !1,
            searchable: n.options.searchable || !1,
            modelValue: a.location,
            "onUpdate:modelValue": e[0] || (e[0] = (o) => a.location = o),
            disabled: n.loading,
            components: s.leadsFormOptions.vSelectComponents || {}
          }, s.leadsFormOptions.vSelectProps, {
            "reset-on-options-change": !0,
            "onUpdate:modelValue": e[1] || (e[1] = (o) => t.$emit("update:modelValue", a.location))
          }), null, 16, ["class", "getOptionLabel", "options", "placeholder", "searchable", "modelValue", "disabled", "components"])
        ]),
        a.location && s.canAddAdditional && !s.hasAdditional ? (v(), x("div", c_, [
          e[4] || (e[4] = Xe(" Interested in room availability at other locations? ")),
          C("div", null, [
            C("a", {
              href: "",
              onClick: e[2] || (e[2] = we((...o) => s.appendAdditional && s.appendAdditional(...o), ["prevent"]))
            }, "Add more locations.")
          ])
        ])) : I("", !0),
        n.options.info ? (v(), x("p", d_, [
          C("em", {
            innerHTML: n.options.info
          }, null, 8, f_)
        ])) : I("", !0),
        n.error ? (v(), x("div", p_, "The location field is required.")) : I("", !0)
      ], 2)
    ])),
    !s.isSingleLocation && s.canAddAdditional && s.hasAdditional ? (v(), x("div", m_, [
      e[5] || (e[5] = C("label", { class: "pappasField__label" }, "Additional Locations", -1)),
      C("div", null, [
        C("div", h_, [
          (v(!0), x(ve, null, Re(a.additional, (o, l) => (v(), x("div", {
            key: "additionalLocation-" + l,
            class: "pappasAdditionalLocations__item"
          }, [
            He(i, {
              label: "name",
              options: n.options.choices,
              placeholder: n.options.placeholder || "Select a Location",
              clearable: !1,
              searchable: n.options.searchable || !1,
              modelValue: a.additional[l],
              "onUpdate:modelValue": (u) => a.additional[l] = u,
              disabled: n.loading,
              "reset-on-options-change": !0
            }, null, 8, ["options", "placeholder", "searchable", "modelValue", "onUpdate:modelValue", "disabled"]),
            C("a", {
              href: "",
              onClick: we((u) => s.removeAdditional(l), ["prevent"])
            }, "✕", 8, v_)
          ]))), 128)),
          a.additional.length < s.maxAdditional ? (v(), x("div", y_, [
            C("a", {
              href: "",
              class: "pappasAdditionalLocations__add",
              onClick: e[3] || (e[3] = we((...o) => s.appendAdditional && s.appendAdditional(...o), ["prevent"]))
            }, " + Add Another ")
          ])) : I("", !0)
        ])
      ])
    ])) : I("", !0)
  ]);
}
const w_ = /* @__PURE__ */ kn(a_, [["render", g_]]), b_ = {
  key: 0,
  class: "pappasField__sectionHeadline"
}, k_ = {
  key: 1,
  class: "pappasField__sectionContent"
}, __ = {
  __name: "SectionField",
  props: { options: { type: Object, required: !0 } },
  setup(t) {
    return (e, n) => (v(), x("div", {
      class: pe(["pappasField pappasField--section", t.options.class])
    }, [
      t.options.headline ? (v(), x("div", b_, [
        C("span", null, ze(t.options.headline), 1)
      ])) : I("", !0),
      t.options.content ? (v(), x("div", k_, ze(t.options.content), 1)) : I("", !0)
    ], 2));
  }
}, T_ = {
  key: 0,
  class: "pappasField"
}, O_ = { class: "pappasField__input" }, S_ = {
  __name: "SubjectField",
  props: {
    ...Qa.props,
    modelValue: { type: Object, default: null },
    subjects: { type: Array, required: !0 },
    loading: { type: Boolean, required: !0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = e, r = t, a = $n("leadsFormOptions"), s = ee(r.modelValue);
    return gn(
      () => r.modelValue,
      (i) => {
        s.value = i;
      }
    ), (i, o) => t.subjects.length > 1 ? (v(), x("div", T_, [
      o[2] || (o[2] = C("label", {
        for: "subject",
        class: "pappasField__label"
      }, "Subject", -1)),
      C("div", null, [
        C("div", O_, [
          He(D(yn), Be({
            class: { "form-vselect": D(Qa) },
            label: "name",
            options: t.subjects,
            placeholder: "Choose One",
            clearable: !1,
            searchable: !1,
            modelValue: s.value,
            "onUpdate:modelValue": o[0] || (o[0] = (l) => s.value = l),
            disabled: t.loading,
            components: D(a).vSelectComponents || {}
          }, D(a).vSelectProps, {
            "onUpdate:modelValue": o[1] || (o[1] = (l) => n("update:modelValue", l))
          }), null, 16, ["class", "options", "modelValue", "disabled", "components"])
        ])
      ])
    ])) : I("", !0);
  }
}, D_ = {}, C_ = { class: "pappasForm__feedback__wrapper" }, x_ = { class: "pappasForm__feedback pappasForm__feedback--notice" };
function M_(t, e) {
  return v(), x("div", C_, [
    C("div", x_, [
      ne(t.$slots, "default", {}, () => [
        e[0] || (e[0] = C("p", { class: "pappasForm__feedback__headline" }, "Private Events are for parties 10 and up.", -1)),
        e[1] || (e[1] = C("p", null, "For parties under 10, please reserve a table in our main dining room.", -1))
      ])
    ])
  ]);
}
const A_ = /* @__PURE__ */ kn(D_, [["render", M_]]), E_ = {
  mixins: [th],
  /**
   * Child components
   */
  components: {
    FormFeedback: dh,
    FormField: Bb,
    EventConfirmField: r_,
    SectionField: __,
    SubjectField: S_,
    LocationField: w_,
    InfoResponse: qb,
    ReservationsResponse: a1,
    Loader: Jb,
    ConceptField: E1,
    CateringFlow: D1,
    EventAbortNotice: A_
  },
  /**
   * Component properties
   */
  props: {
    /**
     * Concept slug as defined in Pappas Dashboard.
     */
    concept: {
      type: String,
      required: !0
    },
    /**
     * API endpoint base
     */
    apiBase: {
      type: String,
      default: "https://dashboard.pappas.com/api"
    },
    /**
     * Additional default button class to apply to form buttons.
     */
    buttonClass: {
      type: [String, Array, Object],
      default: null
    },
    /**
     * Whether to dynamically include the base stylesheet.
     */
    includeStyles: {
      type: Boolean,
      default: !0
    },
    /**
     * URL of the stylesheet to automatically
     * include if `includeStyles` is true.
     */
    stylesheetUrl: {
      type: String,
      default: "https://pappas-cdn.sfo3.cdn.digitaloceanspaces.com/leads/pappas-leads.css"
    },
    /**
     * Text label for the form's submit button.
     */
    submitLabel: {
      type: String,
      default: "Send"
    },
    /**
     * Class(es) to add to the spoton button.
     */
    reservationsButtonClass: {
      type: [String, Array],
      default: () => []
    },
    /**
     * Active location astute id.
     */
    location: {
      type: [String, Number],
      default: null
    },
    /**
     * Explicitly set a single subject and disable the dropdown.
     */
    singleSubject: {
      type: String,
      default: null
    },
    /**
     * Subject slugs to exclude from display.
     */
    excludeSubjects: {
      type: [String, Array],
      default: null
    },
    /**
     * Concept slugs to exclude from display.
     * At present, the concept field is only displayed on the corporate form.
     */
    excludeConcepts: {
      type: [String, Array],
      default: ["fuddruckers", "pappas-gift-card", "pappas-corporate"]
    },
    /**
     * Whether to use future features. 
     * 
     * At present this enables the new api endpoints.
     */
    futureFeatures: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether to add bootstrap classes to inputs.
     */
    useBootstrap: {
      type: Boolean,
      default: !1
    },
    /**
     * Send in test mode.
     */
    testMode: {
      type: Boolean,
      default: !1
    },
    /**
     * Callback to run at the end of the initialization process.
     */
    initializedCb: {
      type: Function,
      default: null
    },
    /**
     * The dashboard api token.
     */
    dashboardToken: {
      type: String,
      default: null
    }
  },
  /**
   * Dynamic component properties
   *
   * @return {Object}
   */
  data() {
    return {
      // initialization state
      initialized: !1,
      // concept data object
      conceptObj: {},
      // info-type response html
      infoResponses: {},
      // form subject value
      subject: null,
      // available subjects
      subjects: [],
      // active type slug
      activeType: this.subject ? this.subject.type : !1,
      // form field values datastore
      values: {},
      // fields manifest
      fields: {},
      // all concepts – used for pappas corp
      concepts: {},
      // active concept - used for pappas corp
      activeConcept: null,
      // currently selected location
      selectedLocation: null,
      // additional selected locations - used for event leads
      additionalSelectedLocations: [],
      // loading state status
      loading: !1,
      // success state status
      success: !1,
      // form-level error message
      error: "",
      // field-level error message bag
      errorBag: {},
      // form feedback success confirmation message
      confirmationMessage: null,
      // event type-specific feedback success confirmation message
      eventConfirmationMessage: null,
      showEventAbortNotice: !1,
      // form feedback messages
      feedbackMessages: {
        form_error: "Sorry, we have encountered an error in your submission. Please update the highlighted fields below and submit the form again.",
        unknown_error: "Sorry, we've encountered an unknown error in your submission. Please try again."
      },
      // whether to submit in test mode
      testModeModel: this.testMode,
      // whether a location field error is present
      locationError: !1,
      // whether an event type lead has confirmed party size
      eventConfirmed: !1,
      // whether a catering lead has confirmed the flow
      cateringConfirmed: !1,
      // catering subject concepts
      cateringConcepts: {},
      // current catering flow view
      cateringView: "intro"
    };
  },
  provide() {
    return {
      buttonClass: this.buttonClass,
      cateringConcepts: this.cateringConcepts
    };
  },
  /**
   * Computed component properties
   */
  computed: {
    /**
     * Currently active types.
     */
    types() {
      const t = [];
      return this.subjects.forEach((e) => {
        t.includes(e.type) || t.push(e.type);
      }), t;
    },
    // currently active fields
    activeFields() {
      return this.subject && this.subject.fields ? this.subject.fields : this.activeType ? this.fields[this.activeType] : {};
    },
    /**
     * Currently active fields to render in the loop.
     *
     * @return {Array}
     */
    iterableFields() {
      return Object.keys(this.activeFields || {}).filter((t) => t != "location" && t != "catering-flow").reduce((t, e) => (t[e] = this.activeFields[e], t), {});
    },
    // api request data payload
    requestPayload() {
      if (!this.subject || !this.subject.id)
        return;
      const t = Object.assign(this.values, { subject: this.subject.id, location: this.selectedLocation });
      return t.location && (t.location = {
        astute_id: t.location.astute_id,
        name: t.location.name
      }), this.additionalSelectedLocations.length && (t.additional_locations = this.additionalSelectedLocations), t.mode = this.testModeModel ? "test" : "live", t;
    },
    // form initialization api endpoint
    initializationEndpoint() {
      return this.apiBase + "/concepts/" + this.concept + "/leads/config";
    },
    // form store request api endpoint
    storeEndpoint() {
      return this.apiBase + "/concepts/" + this.concept + "/leads";
    },
    /**
     * Wehther the form should display the fields.
     *
     * @return {Boolean}
     */
    canShowFields() {
      return !(!this.activeType || !this.activeFields || this.activeType == "event" && !this.eventConfirmed || this.activeType == "catering" && !this.cateringConfirmed || this.showConceptField && !this.activeConcept);
    },
    /**
     * Determines if the form should display a submit button.
     *
     * @return {boolean}  True if able to submit, False otherwise.
     */
    canSubmit() {
      return this.activeType && !["info", "reservations"].includes(this.activeType);
    },
    /**
     * Gets the selected subject's info response if available.
     *
     * @return {String} The info response html.
     */
    infoResponse() {
      return this.activeType == "info" ? this.infoResponses[this.subject.slug] : null;
    },
    /**
     * Get all available locations
     *
     * @return {Array}
     */
    allLocations() {
      const t = [];
      return Object.values(this.fields).forEach((e) => {
        e.location && e.location.choices.forEach((n) => {
          t.find((r) => r.id == n.id) || t.push(n);
        });
      }), t;
    },
    /**
     * Determine which confirmation message to use.
     *
     * @return {String}
     */
    computedConfirmationMessage() {
      return this.activeType == "event" && this.hasEventConfirmationMessage ? this.eventConfirmationMessage : this.confirmationMessage;
    },
    /**
     * Determine if a event type-specific confirmation message exists and is not empty.
     *
     * @return {Boolean}
     */
    hasEventConfirmationMessage() {
      return this.eventConfirmationMessage && this.eventConfirmationMessage.replace(/(<([^>]+)>)/gi, "");
    },
    /**
     * Whether to show the concept field.
     *
     * @return {Boolean}
     */
    showConceptField() {
      return !Object.values(this.concepts).length && this.subject || this.activeType == "catering" ? !1 : this.activeFields && this.activeFields.location;
    },
    subjectsFiltered() {
      let t = this.subjects, e = this.excludeSubjects;
      return e && (Array.isArray(e) || (e = [e]), t = t.filter((n) => !e.includes(n.slug))), t;
    },
    showCateringFlow() {
      return this.subject && this.subject.slug == "catering-inquiry";
    },
    /**
     * Available concepts, determined by the active subject
     */
    availableConcepts() {
      return this.concepts;
    }
  },
  /**
   * Property watchers
   */
  watch: {
    // watches for subject changes and adjusts the type accordingly
    subject(t) {
      if (!t || !t.type) {
        this.activeType = !1;
        return;
      }
      this.activeType = t.type ? t.type : "general", this.error = "", this.errorBag = {};
    },
    // watches for changes in active state
    activeType(t, e) {
      this.clearValues();
    },
    activeConcept(t) {
      this.activeFields.location.choices = t.locations;
    }
  },
  /**
   * Instance created lifecycle hook
   */
  created() {
    this.includeStyles && this.addStylesheet(), this.initialize();
  },
  methods: {
    /**
     * Performs the form initialization.
     */
    initialize() {
      st.post(this.initializationEndpoint, null, this.axiosConfig).then(({ data: t }) => {
        this.subjects = t.subjects, this.fields = t.fields, this.infoResponses = t.info_responses, this.conceptObj = t.concept, this.confirmationMessage = t.confirmation_message, this.eventConfirmationMessage = t.events_confirmation_message, this.initialized = !0, t.catering_concepts && (this.cateringConcepts = t.catering_concepts), "concepts" in t && Object.values(t.concepts).length && (this.concepts = this.filterConcepts(t.concepts)), this.setLocationFromUrl(), this.location && (this.selectedLocation = this.getLocationByAstuteId(this.location)), this.setInitialSubject(), this.$nextTick(() => {
          this.setSubjectFromUrl(), this.setGiftCardSubjectFromUrl(), this.initializedCb && this.initializedCb();
        });
      }).catch((t) => {
        console.error("error", t);
      });
    },
    /**
     * Submits the form
     */
    async submit() {
      this.canSubmit && (this.error = null, this.errorBag = {}, this.loading = !0, st.post(this.storeEndpoint, this.requestPayload, this.axiosConfig).then((t) => {
        this.success = !0, setTimeout(() => {
          document.querySelector(".pappasForm").scrollIntoView({ behavior: "smooth" });
        });
      }).catch((t) => {
        this.handleSubmitError(t);
      }).then((t) => {
        this.loading = !1;
      }));
    },
    /**
     * Clears out any unused input values.
     */
    clearValues() {
      const t = {}, e = Object.assign({}, this.values);
      !this.activeType || !this.fields[this.activeType] || (Object.keys(this.fields[this.activeType]).forEach((n) => {
        t[n] = e[n] ? e[n] : "";
      }), t.subject = this.subject, t.location = this.selectedLocation, this.eventConfirmed = !1, this.cateringConfirmed = !1, this.cateringView = "intro", this.values = t);
    },
    /**
     * Resets the form to a blank slate.
     */
    reset() {
      this.activeType = !1, this.success = !1, this.error = "", this.errorBag = {}, this.subject = {}, this.activeConcept = null, this.selectedLocation = null, this.values = {};
    },
    setInitialSubject() {
      this.singleSubject ? this.subject = this.getSubjectBySlug(this.singleSubject) : this.subjects && this.subjects.length === 1 && (this.subject = this.subjects[0]);
    },
    /**
     * Determine and set the form subject based on URL hash or param values.
     */
    setSubjectFromUrl() {
      let t = this.getTypeFromUrlHash();
      if (t || (t = this.getTypeFromUrlParam()), t) {
        let e = this.getFirstSubjectWithType(t);
        t == "general" && (e = this.subjects.find((n) => n.name == "General Question")), this.subject = e, setTimeout(() => {
          const n = new Event("contactFormsInit");
          window.dispatchEvent(n);
        }, 10);
      }
    },
    getSubjectBySlug(t) {
      return this.subjects.find((e) => e.slug == t);
    },
    /**
     * Determine the targetted type by URL hash value.
     *
     * @return string|null
     */
    getTypeFromUrlHash() {
      const t = window.location.hash.replace("#", "");
      if (!(!t || !this.types.includes(t)))
        return t;
    },
    /**
     * Determine the targetted type by URL param value.
     *
     * @return string|null
     */
    getTypeFromUrlParam() {
      const e = new URL(window.location).searchParams.get("show");
      if (!(!e || !this.types.includes(e)))
        return e;
    },
    /**
     * Get the first subject with a given type.
     *
     * @return Object
     */
    getFirstSubjectWithType(t) {
      return this.subjects.find((e) => e.type == t);
    },
    /**
     * Dynamically add the stylesheet from CDN.
     */
    addStylesheet() {
      const t = document.createElement("link");
      t.setAttribute("rel", "stylesheet"), t.setAttribute("href", this.stylesheetUrl), document.head.appendChild(t);
    },
    /**
     * Retrieves a location object by its astute id
     *
     * @param  {String|Number}  id
     * @return {Object}
     */
    getLocationByAstuteId(t) {
      if (!t)
        return null;
      const e = this.allLocations.find((n) => n.astute_id == t);
      return e || null;
    },
    additionalLocationsSelected(t) {
      this.additionalSelectedLocations = t;
    },
    /**
     * Sets the location from a URL parameter
     */
    setLocationFromUrl() {
      const e = new URL(window.location).searchParams.get("location");
      e && (this.location = e);
    },
    /**
     * Sets the gift card subject and type from the url.
     */
    setGiftCardSubjectFromUrl() {
      const e = new URL(window.location).searchParams.get("gc");
      e && (this.subject = this.getFirstSubjectWithType("gift-card"), this.values.gift_card_subject = e, document.querySelector(".pappasForm").scrollIntoView({ behavior: "smooth" }));
    },
    /**
     * Filter the concepts data, handling exclusions.
     *
     * @param {Object} data
     */
    filterConcepts(t) {
      if (!this.excludeConcepts)
        return t;
      const e = Array.isArray(this.excludeConcepts) ? this.excludeConcepts : [this.excludeConcepts], n = {};
      return Object.values(t).forEach((r) => {
        e.includes(r.slug) || (n[r.slug] = r);
      }), n;
    },
    /**
     * Handle a private event confiration abort.
     */
    handleEventConfirmAbort() {
      if (this.conceptObj.slug == "pappas-corporate") {
        window.location = "/reservations";
        return;
      }
      const t = this.subjects.find(function(e) {
        return e.slug == "reserve";
      });
      t && t.id && (this.subject = t), this.showEventAbortNotice = !0;
    },
    /**
     * Handle a form submission error.
     */
    handleSubmitError(t) {
      let e = "unknown_error";
      t.response && t.response.status == 422 && t.response.data.errors && (this.errorBag = t.response.data.errors, e = "form_error"), this.triggerError(e);
    },
    /**
     * Get a field's error from the error bag.
     *
     * @return {String|null}
     */
    getFieldError(t) {
      return this.errorBag[t] ? this.errorBag[t][0] : null;
    },
    /**
     * Triggers an error of a given type.
     *
     * @param {String} type
     */
    triggerError(t) {
      this.success = !1, this.error = this.feedbackMessages[t], document.querySelector(".pappasForm").scrollIntoView({ behavior: "smooth" });
    },
    /**
     * Fills the form with passed data
     *
     * @param {Object}  data
     */
    fill(t) {
      this.subject = t.subject, this.activeLocation = t.location || {}, this.$forceUpdate(), this.values = t;
    }
  }
}, P_ = {
  key: 1,
  class: "pappasForm__inner"
}, F_ = { class: "pappasForm__header" }, N_ = {
  key: 3,
  class: "col pappasForm__fields"
}, R_ = ["id"], V_ = ["src"], I_ = {
  key: 7,
  class: "pappasField pappasField--submit"
}, L_ = ["disabled"], $_ = ["innerHTML"], Y_ = {
  key: 0,
  class: "pappasForm__loader"
};
function U_(t, e, n, r, a, s) {
  const i = ct("loader"), o = ct("FormFeedback"), l = ct("EventAbortNotice"), u = ct("subject-field"), c = ct("event-confirm-field"), d = ct("concept-field"), p = ct("CateringFlow"), m = ct("location-field"), h = ct("section-field"), O = ct("form-field"), g = ct("info-response"), b = ct("reservations-response");
  return v(), x("section", {
    id: "pappas-contact-form",
    class: pe(["pappasForm", { "pappasForm--success": a.success }]),
    ref: "formWrapper"
  }, [
    a.initialized ? (v(), x("div", P_, [
      C("div", F_, [
        ne(t.$slots, "header", {
          type: a.activeType,
          subject: a.subject,
          location: a.selectedLocation
        })
      ])
    ])) : (v(), fe(i, { key: 0 })),
    He(o, {
      error: a.error,
      success: a.success,
      concept: a.conceptObj,
      confirmationMessage: s.computedConfirmationMessage,
      subject: a.subject
    }, {
      success: _e(({ concept: w, subject: M }) => [
        ne(t.$slots, "success", {
          concept: a.conceptObj,
          subject: M
        })
      ]),
      "success-actions": _e(({ reset: w, subject: M }) => [
        ne(t.$slots, "success-actions", {
          reset: w,
          subject: M
        })
      ]),
      _: 3
    }, 8, ["error", "success", "concept", "confirmationMessage", "subject"]),
    a.showEventAbortNotice && !a.success && !a.error && a.activeType == "event" ? (v(), fe(l, { key: 2 }, {
      default: _e(() => [
        ne(t.$slots, "event-abort-notice")
      ]),
      _: 3
    })) : I("", !0),
    a.success ? I("", !0) : (v(), x("div", N_, [
      C("form", {
        method: "post",
        action: "",
        onSubmit: e[9] || (e[9] = we((...w) => s.submit && s.submit(...w), ["prevent"])),
        id: "form-" + a.activeType,
        novalidate: ""
      }, [
        n.singleSubject ? I("", !0) : (v(), fe(u, {
          key: 0,
          modelValue: a.subject,
          "onUpdate:modelValue": [
            e[0] || (e[0] = (w) => a.subject = w),
            e[1] || (e[1] = (w) => a.subject = w)
          ],
          subjects: s.subjectsFiltered,
          loading: a.loading,
          "use-bootstrap": n.useBootstrap
        }, null, 8, ["modelValue", "subjects", "loading", "use-bootstrap"])),
        t.canShowEventForm && n.concept != "pappas-bros" ? (v(), x(ve, { key: 1 }, [
          a.activeType == "event" && !s.canShowFields && (s.showConceptField && a.activeConcept || !s.showConceptField) ? (v(), fe(c, {
            key: 0,
            "button-class": n.buttonClass,
            concept: a.conceptObj,
            onAbort: s.handleEventConfirmAbort,
            onConfirm: e[2] || (e[2] = (w) => a.eventConfirmed = !0)
          }, {
            "confirm-step-two": _e(() => [
              ne(t.$slots, "event-confirm-step-two")
            ]),
            _: 3
          }, 8, ["button-class", "concept", "onAbort"])) : I("", !0),
          t.eventLoading && a.eventConfirmed ? (v(), fe(i, {
            key: 1,
            class: "pappasForm__eventInitializing"
          })) : I("", !0),
          a.eventConfirmed ? (v(), x("iframe", {
            key: 2,
            id: "eventFrame",
            src: "https://app2.planningpod.com/index.cfm?fuseaction=leads.interestForm&ssid=" + a.conceptObj.planning_pod_id,
            width: "100%",
            frameborder: "0",
            onLoad: e[3] || (e[3] = (...w) => t.eventFrameLoaded && t.eventFrameLoaded(...w))
          }, null, 40, V_)) : I("", !0)
        ], 64)) : (v(), x(ve, { key: 2 }, [
          s.showConceptField ? (v(), fe(d, {
            key: 0,
            modelValue: a.activeConcept,
            "onUpdate:modelValue": e[4] || (e[4] = (w) => a.activeConcept = w),
            concepts: s.availableConcepts,
            loading: a.loading,
            "use-bootstrap": n.useBootstrap
          }, null, 8, ["modelValue", "concepts", "loading", "use-bootstrap"])) : I("", !0),
          s.showCateringFlow && !a.cateringConfirmed ? (v(), fe(p, {
            key: 1,
            modelValue: a.cateringView,
            "onUpdate:modelValue": e[5] || (e[5] = (w) => a.cateringView = w),
            concepts: a.cateringConcepts,
            "onConfirm:catering": e[6] || (e[6] = (w) => a.cateringConfirmed = !0)
          }, null, 8, ["modelValue", "concepts"])) : I("", !0),
          a.activeType == "event" && !s.canShowFields && (s.showConceptField && a.activeConcept || !s.showConceptField) ? (v(), fe(c, {
            key: 2,
            "button-class": n.buttonClass,
            concept: a.conceptObj,
            onAbort: s.handleEventConfirmAbort,
            onConfirm: e[7] || (e[7] = (w) => a.eventConfirmed = !0)
          }, {
            "confirm-step-two": _e(() => [
              ne(t.$slots, "event-confirm-step-two", {}, () => [
                e[10] || (e[10] = Xe("test"))
              ])
            ]),
            _: 3
          }, 8, ["button-class", "concept", "onAbort"])) : I("", !0),
          s.activeFields && s.activeFields.location && s.canShowFields ? (v(), fe(m, {
            key: 3,
            type: a.activeType,
            modelValue: a.selectedLocation,
            "onUpdate:modelValue": e[8] || (e[8] = (w) => a.selectedLocation = w),
            "use-bootstrap": n.useBootstrap,
            options: s.activeFields.location,
            loading: a.loading,
            error: s.getFieldError("location"),
            onLocations: s.additionalLocationsSelected
          }, null, 8, ["type", "modelValue", "use-bootstrap", "options", "loading", "error", "onLocations"])) : I("", !0),
          s.canShowFields ? (v(!0), x(ve, { key: 4 }, Re(s.iterableFields, (w, M) => (v(), x(ve, null, [
            w.type == "section" ? (v(), fe(h, {
              key: "field-" + M,
              options: w
            }, null, 8, ["options"])) : (v(), fe(O, {
              name: M,
              options: w,
              "subject-type": a.activeType,
              key: "form-field-" + M,
              vid: M,
              modelValue: a.values[M],
              "onUpdate:modelValue": (T) => a.values[M] = T,
              disabled: a.loading,
              placeholder: w.placeholder,
              search: w.search,
              "use-bootstrap": n.useBootstrap,
              error: s.getFieldError(M)
            }, null, 8, ["name", "options", "subject-type", "vid", "modelValue", "onUpdate:modelValue", "disabled", "placeholder", "search", "use-bootstrap", "error"]))
          ], 64))), 256)) : I("", !0),
          a.activeType == "info" ? (v(), fe(g, {
            key: 5,
            content: s.infoResponse
          }, null, 8, ["content"])) : I("", !0),
          a.activeType == "reservations" && a.selectedLocation ? (v(), fe(b, {
            key: 6,
            location: a.selectedLocation,
            "button-class": n.reservationsButtonClass
          }, null, 8, ["location", "button-class"])) : I("", !0),
          s.canSubmit && s.canShowFields ? (v(), x("div", I_, [
            C("button", {
              type: "submit",
              class: pe(["button pappasForm__button pappasForm__button--submit", [a.loading ? "pappasForm__button--loading" : null, n.buttonClass]]),
              disabled: a.loading
            }, [
              C("span", { innerHTML: n.submitLabel }, null, 8, $_)
            ], 10, L_),
            a.loading ? (v(), x("div", Y_, e[11] || (e[11] = [
              C("div", null, null, -1)
            ]))) : I("", !0)
          ])) : I("", !0)
        ], 64))
      ], 40, R_)
    ]))
  ], 2);
}
const B_ = /* @__PURE__ */ kn(E_, [["render", U_]]), j_ = {
  install: (t, e = {}) => {
    t.component("pappas-leads-form", B_), t.provide("leadsFormOptions", e);
  }
};
export {
  j_ as default
};
//# sourceMappingURL=pappas-leads-form.es.js.map
